import { useEffect } from 'react';
import './SpecialWordsManager.css';

export default function SpecialWordsManager({ specialWords, setSpecialWords }) {
  // Pre-populate with your special words here
  const defaultSpecialWords = [
    { key: 'kandhamal', value: 'କନ୍ଧମାଳ', regex: false },
    { key: 'krushna', value: 'କୃଷ୍ଣ', regex: false },
    { key: 'sarapanch', value: 'ସରପଞ୍ଚ', regex: false },
    { key: 'kritangia', value: 'କ୍ରିଟାଙ୍ଗିଆ', regex: false },
    { key: 'lamungia', value: 'ଲାମୁଙ୍ଗିଆ', regex: false },
    { key: 'nayak', value: 'ନାୟକ', regex: false },
    { key: 'kalumaha', value: 'କାଲୁମାହା', regex: false },
    { key: 'boudh', value: 'ବୌଦ୍ଧ', regex: false },
    { key: 'samipesu', value: 'ସମୀପେଷୁ', regex: false },
    { key: 'sri', value: 'ଶ୍ରୀ', regex: false },
    { key: 'jukta', value: 'ଯୁକ୍ତ', regex: false },
    { key: 'gosthi', value: 'ଗୋଷ୍ଠୀ', regex: false },
    { key: 'unnayan', value: 'ଉନ୍ନୟନ', regex: false },
    { key: 'adhikari', value: 'ଅଧିକାରୀ', regex: false },
    { key: 'adhina', value: 'ଅଧିନ', regex: false },
    { key: 'punjab', value: 'ପଞ୍ଜାବ', regex: false },
    { key: 'sindhu', value: 'ସିନ୍ଧୁ', regex: false },
    { key: 'maratha', value: 'ମରାଠା', regex: false },
    { key: 'bindhya', value: ' ବିନ୍ଧ୍ୟ', regex: false },
    { key: 'himachala', value: 'ହିମାଚଳ', regex: false },
    { key: 'yamuna', value: 'ଜମୁନା', regex: false },
    { key: 'jamuna', value: 'ଜମୁନା', regex: false },
    { key: 'ganga', value: 'ଗଙ୍ଗା', regex: false },
    { key: 'drabida', value: 'ଦ୍ରାବିଡ଼', regex: false },
    { key: 'banga', value: 'ବଙ୍ଗ', regex: false },
    { key: 'uchhala', value: 'ଉଚ୍ଛଳ', regex: false },
    { key: 'jaladhi', value: 'ଜଳଧି', regex: false },
    { key: 'taranga', value: 'ତରଙ୍ଗ', regex: false },
    { key: 'taba', value: 'ତବ', regex: false },
    { key: 'shubha', value: 'ଶୁଭ', regex: false },
    { key: 'name', value: 'ନାମେ', regex: false },
    { key: 'ashisa', value: 'ଆଶିଷ', regex: false },
    { key: 'mangala', value: 'ମଙ୍ଗଳ', regex: false },
    { key: 'didrabadi', value: 'ଡିଡ୍ରବାଡ଼ି', regex: false },
    { key: 'burbi', value: 'ବୁର୍ବି', regex: false },
    { key: 'salangia', value: 'ସଲାଙ୍ଗିଆ', regex: false },
    { key: 'malangpanga', value: 'ମାଲାଙ୍ଗପାଙ୍ଗା', regex: false },
    { key: 'bigyapita', value: 'ବିଜ୍ଞାପିତ', regex: false },
    { key: 'shramika', value: 'ଶ୍ରମିକ', regex: false },
    { key: 'dhana', value: 'ଧାନ', regex: false },
    { key: 'maka', value: 'ମକା', regex: false },
    { key: 'china', value: 'ଚିନା', regex: false },
    { key: 'badam', value: 'ବାଦମ', regex: false },
    { key: 'mandia', value: 'ମାଣ୍ଡିଆ  ', regex: false },
    { key: 'kapa', value: 'କପା', regex: false },
    { key: 'harada', value: 'ହରଡ଼', regex: false },
    { key: 'khariph', value: 'ଖରିଫ', regex: false },
    { key: 'shorisa', value: 'ଶୋରିଷ', regex: false },
    { key: 'niantu', value: 'ନିଅନ୍ତୁ', regex: false },    
    { key: 'bahulya', value: 'ବାହୁଲ୍ୟ', regex: false },    
    { key: 'adombar', value: 'ଆଡ଼ମ୍ବର', regex: false },    
    { key: 'laghu', value: 'ଲଘୁ', regex: false },    
    { key: 'kali puja', value: 'କାଳି ପୂଜା', regex: false },
    { key: 'kali parba', value: 'କାଳି ପର୍ବ', regex: false },
    { key: 'kali mandir', value: 'କାଳି ମନ୍ଦିର', regex: false },
    { key: 'kali debota', value: 'କାଳି ଦେବତା', regex: false },
    { key: 'maa kali', value: 'ମାଁ କାଳି', regex: false },
    { key: 'maa durga', value: 'ମାଁ ଦୁର୍ଗା', regex: false },
    { key: 'maa banadurga', value: 'ମାଁ ବନଦୁର୍ଗା', regex: false },
    { key: 'maa balunkeswar', value: 'ମାଁ ବାଲୁଙ୍କେଶ୍ୱର', regex: false },
    { key: 'maa biraja', value: 'ମାଁ ବିରଜା', regex: false },    
    { key: 'maa bimala', value: 'ମାଁ ବିମଳା', regex: false },
    { key: 'maa sarala', value: 'ମାଁ ଶାରଳା', regex: false },
    { key: 'maa hinguli', value: 'ମାଁ ହିଙ୍ଗୁଳି', regex: false },
    { key: 'maa khambeswari', value: 'ମାଁ ଖମ୍ବେଶ୍ବରୀ', regex: false },
    { key: 'khambeswari', value: 'ଖମ୍ବେଶ୍ବରୀ', regex: false },
    { key: 'stambeswari', value: 'ସ୍ତମ୍ବେଶ୍ବରୀ', regex: false },
    { key: 'maa samaleswari', value: 'ମାଁ ସମଲେଶ୍ବରୀ', regex: false },
    { key: 'maa bighnabinasini', value: 'ମାଁ ବିଘ୍ନବିନାସିନି', regex: false },
    { key: 'maa tara tarini', value: 'ମାଁ ତାରା ତାରିଣୀ', regex: false },    
    { key: 'peetha', value: 'ପିଠ', regex: false },
    { key: 'stana', value: 'ସ୍ତନ', regex: false },
    { key: 'mahaprasad', value: 'ମହାପ୍ରସାଦ', regex: false },    
    { key: 'balunkeswar', value: 'ବାଲୁଙ୍କେଶ୍ୱର', regex: false },
    { key: 'kalucharan', value: 'କାଳୁଚରଣ', regex: false },
    { key: 'kelucharan', value: 'କେଳୁଚରଣ', regex: false },
    { key: 'shiva', value: 'ଶିବ', regex: false },
    { key: 'balarama', value: 'ବଳରାମ', regex: false },
    { key: 'balabhadra', value: 'ବଳଭଦ୍ର', regex: false },
    { key: 'subhadra', value: 'ସୁଭଦ୍ରା', regex: false },
    { key: 'sudarshan', value: 'ସୁଦର୍ଶନ', regex: false },  
    { key: 'mahodaya', value: 'ମହୋଦୟ', regex: false },
    { key: 'barsh', value: 'ବର୍ଷ', regex: false },
    { key: 'khura', value: 'ଖୁରା', regex: false },
    { key: 'khuna', value: 'ଖୁଣ', regex: false },
    { key: 'samiti', value: 'ସମିତି', regex: false },
    { key: 'panchayat', value: 'ପଞ୍ଚାୟତ', regex: false },
    { key: 'phulbani', value: 'ଫୁଲବାଣୀ', regex: false },
    { key: 'sudrukumpa', value: 'ସୁଡୃକୁମ୍ପା', regex: false },
    { key: 'katingia', value: 'କାଟିଙ୍ଗିଆ', regex: false },
    { key: 'kotingia', value: 'କତିଙ୍ଗିଆ', regex: false },
    { key: 'bearpanga', value: 'ବିଅରପାଙ୍ଗ', regex: false },
    { key: 'prangamaha', value: 'ପ୍ରାଙ୍ଗାମାହା', regex: false },
    { key: 'gudruguda', value: 'ଗୁଡୃଗୁଡ଼ା ', regex: false },
    { key: 'udayagiri', value: 'ଉଦୟଗିରି', regex: false },
    { key: 'kalingia', value: 'କଳିଙ୍ଗିଆ', regex: false },
    { key: 'krushak', value: 'କୃଷକ', regex: false },
    { key: 'asila', value: 'ଆସିଲା', regex: false },
    { key: 'akhi', value: 'ଆଖି', regex: false }, 
    { key: 'aA', value: 'ଅ', regex: false },
    { key: 'rice', value: 'ଗ୍ଭଉଳ', regex: false },
    { key: 'chaula', value: 'ଗ୍ଭଉଳ', regex: false },
    { key: 'parameshwar', value: 'ପରମେଶ୍ୱର', regex: false },
    { key: 'konta', value: 'କଣ୍ଟା', regex: false },
    { key: 'partamaha', value: 'ପର୍ତ୍ତମାହା', regex: false },
    { key: 'rameswar', value: 'ରାମେଶ୍ୱର', regex: false },
    { key: 'samaj', value: 'ସମାଜ', regex: false },
    { key: 'samast', value: 'ସମସ୍ତ', regex: false },
    { key: 'puri', value: 'ପୁରୀ', regex: false },
    { key: 'khurdha', value: 'ଖୋର୍ଦ୍ଧା', regex: false },
    { key: 'nayagada', value: 'ନୟାଗଡ଼', regex: false },
    { key: 'cuttack', value: 'କଟକ', regex: false },
    { key: 'jagatsinghpur', value: 'ଜଗତସିଂହପୁର', regex: false },
    { key: 'kendrapada', value: 'କେନ୍ଦ୍ରାପଡ଼ା', regex: false },
    { key: 'jajpur', value: 'ଯାଜପୁର', regex: false },
    { key: 'baleswar', value: 'ବାଲେଶ୍ୱର', regex: false },
    { key: 'bhadrak', value: 'ଭଦ୍ରକ', regex: false },
    { key: 'mayurbhanj', value: 'ମୟୂରଭଞ୍ଜ', regex: false },
    { key: 'keunjhar', value: 'କେଉଁଝର', regex: false },
    { key: 'sambalpur', value: 'ସମ୍ବଲପୁର', regex: false },
    { key: 'debagarh', value: 'ଦେବଗଡ଼', regex: false },
    { key: 'jharsuguda', value: 'ଝାରସୁଗୁଡ଼ା', regex: false },
    { key: 'baragada', value: 'ବରଗଡ଼', regex: false },
    { key: 'sonepur', value: 'ସୋନପୁର', regex: false },
    { key: 'kalahandi', value: 'କଳାହାଣ୍ଡି', regex: false },
    { key: 'nuapada', value: 'ନୂଆପଡ଼ା', regex: false },
    { key: 'koraput', value: 'କୋରାପୁଟ', regex: false },
    { key: 'nabarangpur', value: 'ନବରଙ୍ଗପୁର', regex: false },
    { key: 'malkanagiri', value: 'ମାଲକାନିଗିର', regex: false },
    { key: 'rayagada', value: 'ରାୟଗଡ଼ା', regex: false },
    { key: 'ganjam', value: 'ଗଞ୍ଜାମ', regex: false },
    { key: 'gajapati', value: 'ଗଜପତି', regex: false },
    { key: 'boudh', value: 'ବୌଦ୍ଧ', regex: false },
    { key: 'dhenknal', value: 'ଢ଼େଙ୍କାନାଳ', regex: false },
    { key: 'anugal', value: 'ଅନୁଗୋଳ', regex: false },
    { key: 'kandabada', value: 'କାଣ୍ଡାବାଡ଼ା', regex: false },
    { key: 'beredakia', value: 'ବେରେଡ଼ାକିଆ', regex: false },
    { key: 'mandakia', value: 'ମଣ୍ଡାକିଆ', regex: false },
    { key: 'gouri', value: 'ଗୌରୀ', regex: false },
    { key: 'bisaya', value: 'ବିଷୟ', regex: false },
    { key: 'grama', value: 'ଗ୍ରାମ', regex: false },
    { key: 'bharatbasi', value: 'ଭାରତବାସୀ', regex: false },
    { key: 'gapi', value: 'ଗପି', regex: false },
    { key: 'rahul', value: 'ରାହୁଲ', regex: false },
    { key: 'parampara', value: 'ପରମ୍ପରା', regex: false },
    { key: 'ananga', value: 'ଅନଙ୍ଗ', regex: false },
    { key: 'mayukh', value: 'ମୟୁଖ', regex: false },
    { key: 'congress', value: 'କଂଗ୍ରେସ', regex: false },
    { key: 'Lanjigarh', value: 'ଲାଞ୍ଜିଗଡ଼', regex: false },
    { key: 'junagarh', value: 'ଜୁନାଗଡ଼', regex: false },    
    { key: 'dharmagarh', value: 'ଧର୍ମଗଡ଼', regex: false },    
    { key: 'bhawanipatna', value: 'ଭବାନୀପାଟଣା', regex: false },    
    { key: 'narla', value: 'ନର୍ଲା', regex: false },    
    { key: 'khariar', value: 'ଖରିଆର', regex: false },    
    { key: 'padampur', value: 'ପଦ୍ମପୁର', regex: false },    
    { key: 'bijepur', value: 'ବିଜେପୁର', regex: false },    
    { key: 'attabira', value: 'ଅଟାବିରା', regex: false },    
    { key: 'bhatli', value: 'ଭାଟଲି', regex: false },
    { key: 'brajrajnagar', value: 'ବ୍ରଜରାଜନଗର', regex: false },
    { key: 'Jharsuguda', value: 'ଝାରସୁଗୁଡ଼ା', regex: false },
    { key: 'Sundargarh', value: 'ସୁନ୍ଦରଗଡ଼', regex: false },
    { key: 'talasara', value: 'ତଳସରା', regex: false },
    { key: 'biramitrapur', value: 'ବୀରମିତ୍ରପୁର', regex: false },
    { key: 'raghunathpali', value: 'ରଘୁନାଥପାଲି', regex: false },
    { key: 'bonia', value: 'ବଣିଆ', regex: false },
    { key: 'rengali', value: 'ରେଙ୍ଗାଲି', regex: false },
    { key: 'chhendipada', value: 'ଛେଣ୍ଡିପଦା', regex: false },
    { key: 'athamallik', value: 'ଆଠମଲ୍ଲିକ', regex: false },
    { key: 'rairakhol', value: 'ରେଢ଼ାଖୋଲ', regex: false },
    { key: 'deogarh', value: 'ଦେବଗଡ଼', regex: false },
    { key: 'Telkoi', value: 'ତେଲକୋଈ', regex: false },
    { key: 'ghasipura', value: 'ଘସିପୁରା', regex: false },
    { key: 'anandapur', value: 'ଆନନ୍ଦପୁର', regex: false },
    { key: 'patna', value: 'ପାଟଣା', regex: false },
    { key: 'karanjia', value: 'କରଞ୍ଜିଆ', regex: false },
    { key: 'champua', value: 'ଚମ୍ପୁଆ', regex: false },
    { key: 'jashipur', value: 'ଯଶିପୁର', regex: false },
    { key: 'saraskana', value: 'ସାରସକଣା', regex: false },
    { key: 'rairangpur', value: 'ରାଇରଙ୍ଗପୁର', regex: false },
    { key: 'bangriposi', value: 'ବାଙ୍ଗିରିପୋଷି', regex: false },
    { key: 'baripada', value: 'ବାରିପଦା', regex: false },
    { key: 'morada', value: 'ମୋରଡ଼ା', regex: false },
    { key: 'udala', value: 'ଉଦଳ', regex: false },
    { key: 'balasore', value: 'ବାଲେଶ୍ୱର', regex: false },
    { key: 'bhograi', value: 'ଭୋଗରାଇ', regex: false },
    { key: 'basta', value: 'ବସ୍ତା', regex: false },
    { key: 'remuna', value: 'ରେମୁଣା', regex: false },
    { key: 'nilgiri', value: 'ନୀଳଗିରି', regex: false },
    { key: 'soro', value: 'ସୋରୋ', regex: false },
    { key: 'simulia', value: 'ସିମୁଳିଆ', regex: false },
    { key: 'dhamnagar', value: 'ଧାମନଗର', regex: false },
    { key: 'chandabali', value: 'ଚାନ୍ଦବାଲି', regex: false },
    { key: 'hindol', value: 'ହିନ୍ଦୋଳ', regex: false },
    { key: 'kamakshyanagar', value: 'କାମାକ୍ଷାନଗର', regex: false },
    { key: 'parjang', value: 'ପରଜଙ୍ଗ', regex: false },
    { key: 'pallahar', value: 'ପାଲାହାର', regex: false },
    { key: 'talcher', value: 'ତାଳଚେର', regex: false },
    { key: 'angul', value: 'ଅନୁଗୁଳ', regex: false },
    { key: 'loisingha', value: 'ଲୋଇସିଂହ', regex: false },
    { key: 'garh', value: 'ଗଡ଼', regex: false },
    { key: 'patna', value: 'ପାଟଣା', regex: false },
    { key: 'mananiya', value: 'ମାନନୀୟ', regex: false },
    { key: 'jwara', value: 'ଜ୍ବର', regex: false },
    { key: 'mahasaya', value: 'ମହାଶୟ', regex: false },
    { key: 'nibedanara', value: 'ନିବେଦନର', regex: false },
//{ key: 'je', value: 'ଯେ', regex: false },
{ key: 'apohruta', value: 'ଅପହୃତ', regex: false },
{ key: 'Abahela', value: 'ଅବହେଳା', regex: false },
{ key: 'Abarana', value: 'ଆବରଣ', regex: false },
{ key: 'Abasthana', value: 'ଅବସ୍ଥାନ', regex: false },
{ key: 'Abatarana', value: 'ଅବତରଣ', regex: false },
{ key: 'Abedana', value: 'ଆବେଦନ', regex: false },
{ key: 'Abhaba', value: 'ଅଭାବ', regex: false },
{ key: 'Abhibadana', value: 'ଅଭିବାଦନ', regex: false },
{ key: 'Abhinaya', value: 'ଅଭିନୟ', regex: false },
{ key: 'Abhiyoga', value: 'ଅଭିଯୋଗ', regex: false },
{ key: 'Abiskara', value: 'ଆବିଷ୍କାର', regex: false },
{ key: 'Abrutta', value: 'ଆବୃତ୍ତ', regex: false },
{ key: 'Acharana', value: 'ଆଚରଣ', regex: false },
{ key: 'Ador', value: 'ଆଦର', regex: false },
{ key: 'aadhar', value: 'ଆଧାର', regex: false },
{ key: 'Adesha', value: 'ଆଦେଶ', regex: false },
{ key: 'Adhik', value: 'ଅଧିକ', regex: false },
{ key: 'Adhikar', value: 'ଅଧିକାର', regex: false },
{ key: 'Adrushya', value: 'ଅଦୃଶ୍ୟ', regex: false },
{ key: 'Agaiba', value: 'ଆଗେଇବା', regex: false },
{ key: 'Agaku', value: 'ଆଗକୁ', regex: false },
{ key: 'Aghata', value: 'ଆଘାତ', regex: false },
{ key: 'Ahwana', value: 'ଆହ୍ୱାନ', regex: false },
{ key: 'Akalana', value: 'ଆକଳନ', regex: false },
{ key: 'Akarshita', value: 'ଆକର୍ଷିତ', regex: false },
{ key: 'Bulaiba', value: 'ବୁଲାଇବା', regex: false },
{ key: 'Pichhula', value: 'ପିଛୁଳା', regex: false },
{ key: 'Akramana', value: 'ଆକ୍ରମଣ', regex: false },
{ key: 'Alaga', value: 'ଅଲଗା', regex: false },
{ key: 'Alia', value: 'ଅଳିଆ', regex: false },
{ key: 'Alingana', value: 'ଆଲିଙ୍ଗନ', regex: false },
{ key: 'Alochana', value: 'ଆଲୋଚନା', regex: false },
{ key: 'Alokita', value: 'ଆଲୋକିତ', regex: false },
{ key: 'Amadani', value: 'ଆମଦାନୀ', regex: false },
{ key: 'Amantrana', value: 'ଆମନ୍ତ୍ରଣ', regex: false },
{ key: 'Aniba', value: 'ଆଣିବ', regex: false },
{ key: 'Ankana', value: 'ଅଙ୍କନ', regex: false },
{ key: 'Anshagrahana', value: 'ଅଂଶଗ୍ରହଣ', regex: false },
{ key: 'Antarbhukta', value: 'ଅନ୍ତର୍ଭୁକ୍ତ', regex: false },
{ key: 'Anthu Madi', value: 'ଆଣ୍ଠୁ ମାଡ଼ି', regex: false },
{ key: 'Anubhava', value: 'ଅନୁଭବ', regex: false },
{ key: 'Anugraha', value: 'ଅନୁଗ୍ରହ', regex: false },
{ key: 'Anumana', value: 'ଅନୁମାନ', regex: false },
{ key: 'Anumati', value: 'ଅନୁମତି', regex: false },
{ key: 'Potr', value: 'ପତ୍ର', regex: false },
{ key: 'Anumodana', value: 'ଅନୁମୋଦନ', regex: false },
{ key: 'Anupranita', value: 'ଅନୁପ୍ରାଣିତ', regex: false },
{ key: 'Anurodha', value: 'ଅନୁରୋଧ', regex: false },
{ key: 'Anusandhana', value: 'ଅନୁସନ୍ଧାନ', regex: false },
{ key: 'Anusarana', value: 'ଅନୁସରଣ', regex: false },
{ key: 'Apamana', value: 'ଅପମାନ', regex: false },
{ key: 'Apamanita', value: 'ଅପମାନିତ', regex: false },
{ key: 'Apasarana', value: 'ଅପସାରଣ', regex: false },
{ key: 'Apatti', value: 'ଆପତ୍ତି', regex: false },
{ key: 'Arambha', value: 'ଆରମ୍ଭ', regex: false },
{ key: 'Arogya', value: 'ଆରୋଗ୍ୟ', regex: false },
{ key: 'Arohana', value: 'ଆରୋହଣ', regex: false },
{ key: 'Aropa', value: 'ଆରୋପ', regex: false },
{ key: 'Artha', value: 'ଅର୍ଥ', regex: false },
{ key: 'subidha', value: 'ସୁବିଧା', regex: false },
{ key: 'asubidha', value: 'ଅସୁବିଧା', regex: false },
{ key: 'prerana', value: 'ପ୍ରେରଣା', regex: false },
{ key: 'khuntia', value: 'ଖୁଣ୍ଟିଆ', regex: false },
{ key: 'glad', value: 'ଗ୍ଲାଡ', regex: false },
{ key: 'sito', value: 'ଶୀତ', regex: false },
{ key: 'probaho', value: 'ପ୍ରବାହ', regex: false },
{ key: '.', value: ' ।', regex: false },
{ key: 'shoilu', value: 'ଶୋଇଲୁ', regex: false },
{ key: 'bortoman', value: 'ବର୍ତ୍ତମାନ', regex: false },
{ key: 'bortoman', value: 'ବର୍ତ୍ତମାନ', regex: false },
{ key: 'website', value: 'ଓ୍ୱେବସାଇଟ', regex: false },
{ key: 'paristithi', value: 'ପରିସ୍ଥିତି', regex: false },
{ key: 'konark', value: 'କୋଣାର୍କ', regex: false },
{ key: 'Asahamata', value: 'ଅସହମତ', regex: false },
{ key: 'Ascharya', value: 'ଆଶ୍ଚର୍ଯ୍ୟ', regex: false },
{ key: 'Asha', value: 'ଆଶା', regex: false },
{ key: 'Ashirbada', value: 'ଆଶୀର୍ବାଦ', regex: false },
{ key: 'Asib', value: 'ଆସିବ', regex: false },
{ key: 'Astitwa', value: 'ଅସ୍ତିତ୍ୱ', regex: false },
{ key: 'Aswikara', value: 'ଅସ୍ୱୀକାର', regex: false },
{ key: 'Atakaiba', value: 'ଅଟକାଇବା', regex: false },
{ key: 'Atikrama', value: 'ଅତିକ୍ରମ', regex: false },
{ key: 'Aujiba', value: 'ଆଉଜିବା', regex: false },
{ key: 'Bachhiba', value: 'ବାଛିବା', regex: false },
{ key: 'Badalaiba', value: 'ବଦଳାଇବା', regex: false },
{ key: 'Badeiba', value: 'ବାଡ଼େଇବା', regex: false },
{ key: 'Badha', value: 'ବାଧା', regex: false },
{ key: 'Badhaiba', value: 'ବଢ଼ାଇବା', regex: false },
{ key: 'Badhiba', value: 'ବଢ଼ିବା', regex: false },
{ key: 'Badhya', value: 'ବାଧ୍ୟ', regex: false },
{ key: 'Bahana', value: 'ବହନ', regex: false },
{ key: 'Bahara', value: 'ବାହାର', regex: false },
{ key: 'Baharaku', value: 'ବାହାରକୁ', regex: false },
{ key: 'Bahariba', value: 'ବାହାରିବା', regex: false },
{ key: 'Bajaya', value: 'ବଜାୟ', regex: false },
{ key: 'Baji', value: 'ବାଜି', regex: false },
{ key: 'Bajiba', value: 'ବାଜିବା', regex: false },
{ key: 'sindur', value: 'ସିନ୍ଦୁର', regex: false },
{ key: 'samabaya', value: 'ସମବାୟ', regex: false },
{ key: 'bank', value: 'ବ୍ୟାଙ୍କ', regex: false },
{ key: 'adibasi', value: 'ଆଦିବାସୀ', regex: false },
{ key: 'sakha', value: 'ଶାଖା', regex: false },
{ key: 'mulaka', value: 'ମୂଳକ', regex: false },
{ key: 'dhika', value: 'ଧିକ', regex: false },
{ key: 'Bakruta', value: 'ବକୃତା', regex: false },
{ key: 'sansara', value: 'ସଂସାର', regex: false },
{ key: 'jib', value: 'ଯିବ', regex: false },
{ key: 'jekehi', value: 'ଯେକେହି', regex: false },
{ key: 'tome', value: 'ତମେ', regex: false },
{ key: 'phalib', value: 'ଫଳିବ', regex: false },
{ key: 'bandhib', value: 'ବାନ୍ଧିବ', regex: false },
{ key: 'prashant', value: 'ପ୍ରଶାନ୍ତ', regex: false },
{ key: 'rutu', value: 'ଋତୁ', regex: false },
{ key: 'akhu', value: 'ଆଖୁ', regex: false },
{ key: 'peda', value: 'ପେଡ଼ା', regex: false },
{ key: 'olot', value: 'ଓଲଟ', regex: false },
{ key: 'soto', value: 'ସତ', regex: false },
{ key: 'joban', value: 'ଜବାବ', regex: false },
{ key: 'jawan', value: 'ଯଓ୍ୱାନ', regex: false },
{ key: 'sudan', value: 'ସୁଦନ', regex: false },
{ key: 'Bolo', value: 'ବଳ', regex: false },
{ key: 'bala', value: 'ବାଲା', regex: false },
{ key: 'balo', value: 'ବାଳ', regex: false },
{ key: 'bachh', value: 'ବାଛ', regex: false },
{ key: 'munda', value: 'ମୁଣ୍ଡ', regex: false },
{ key: 'purbaka', value: 'ପୂର୍ବକ', regex: false },
{ key: 'chipudile', value: 'ଚିପୁଡ଼ିଲେ', regex: false },
{ key: 'lembu', value: 'ଲେମ୍ବୁ', regex: false },
{ key: 'lage', value: 'ଲାଗେ', regex: false },
{ key: 'rahi', value: 'ରହି', regex: false },
{ key: 'iiti', value: 'ଈତି', regex: false },
{ key: 'janonti', value: 'ଜାଣନ୍ତି', regex: false },
{ key: 'aga', value: 'ଆଗ', regex: false },
{ key: 'besha', value: 'ବେଶ', regex: false },
{ key: 'achha', value: 'ଆଛା', regex: false },
{ key: 'tae', value: 'ଟାଏ', regex: false },
{ key: 'Banchiba', value: 'ବଞ୍ଚିବା', regex: false },
{ key: 'Banchi', value: 'ବଞ୍ଚି', regex: false },
{ key: 'jiba', value: 'ଯିବା', regex: false },
{ key: 'Band', value: 'ବନ୍ଦ', regex: false },
{ key: 'Bandhani', value: 'ବନ୍ଧନୀ', regex: false },
{ key: 'Bandhiba', value: 'ବାନ୍ଧିବା', regex: false },
{ key: 'Bankiba', value: 'ବାଙ୍କିବା', regex: false },
{ key: 'Bantana', value: 'ବଣ୍ଟନ', regex: false },
{ key: 'Barakhasta', value: 'ବରଖାସ୍ତ', regex: false },
{ key: 'darakhasta', value: 'ଦରଖାସ୍ତ', regex: false },
//{ key: 'st', value: 'ସ୍ତ', regex: false },
{ key: 'Barnana', value: 'ବର୍ଣ୍ଣନା', regex: false },
{ key: 'Bandhiba', value: 'ବାନ୍ଧିବା', regex: false },
{ key: 'Basa', value: 'ବାସ', regex: false },
{ key: 'Basabas', value: 'ବସବାସ', regex: false },
{ key: 'Bastra Pindhaiba', value: 'ବସ୍ତ୍ର ପିନ୍ଧାଇବା', regex: false },
{ key: 'Bata', value: 'ବାଟ', regex: false },
{ key: 'Batil', value: 'ବାତିଲ', regex: false },
{ key: 'Bhabiba', value: 'ଭାବିବା', regex: false },
{ key: 'Bhoda', value: 'ଭଡ଼ା', regex: false },
{ key: 'Bhago', value: 'ଭାଗ', regex: false },
{ key: 'Bhajiba', value: 'ଭାଜିବା', regex: false },
{ key: 'Bhala', value: 'ଭଲ', regex: false },
{ key: 'Bhangi', value: 'ଭାଙ୍ଗି', regex: false },
{ key: 'Bhangiba', value: 'ଭାଙ୍ଗିବା', regex: false },
{ key: 'Bhangijiba', value: 'ଭାଙ୍ଗିଯିବା', regex: false },
{ key: 'Bhara', value: 'ଭାର', regex: false },
{ key: 'Bharti', value: 'ଭର୍ତ୍ତି', regex: false },
{ key: 'Bhasiba', value: 'ଭାସିବା', regex: false },
{ key: 'Bhaya', value: 'ଭୟ', regex: false },
{ key: 'Bhetiba', value: 'ଭେଟିବା', regex: false },
{ key: 'Bhida', value: 'ଭିଡ଼', regex: false },
{ key: 'Bhikhya', value: 'ଭିକ୍ଷା', regex: false },
//{ key: 'Bhinna', value: 'ଭିନ୍ନ', regex: false },
{ key: 'Bhitaraku', value: 'ଭିତରକୁ', regex: false },
{ key: 'Bhulijiba', value: 'ଭୁଲିଯିବା', regex: false },
{ key: 'Bhumi Re', value: 'ଭୂମିରେ', regex: false },
{ key: 'Bhumika', value: 'ଭୂମିକା', regex: false },
{ key: 'Bhushudi', value: 'ଭୁଶୁଡ଼ି', regex: false },
{ key: 'Bibaha', value: 'ବିବାହ', regex: false },
{ key: 'Bibhajana', value: 'ବିଭାଜନ', regex: false },
{ key: 'Bichara', value: 'ବିଚାର', regex: false },
{ key: 'Bidyamaana', value: 'ବିଦ୍ୟମାନ', regex: false },
{ key: 'Bikasa', value: 'ବିକାଶ', regex: false },
{ key: 'Bilamba', value: 'ବିଳମ୍ବ', regex: false },
{ key: 'Bima', value: 'ବୀମା', regex: false },
{ key: 'Binimaya', value: 'ବିନିମୟ', regex: false },
{ key: 'Biniyoga', value: 'ବିନିଯୋଗ', regex: false },
{ key: 'Biphala', value: 'ବିଫଳ', regex: false },
{ key: 'Birakta', value: 'ବିରକ୍ତ', regex: false },
{ key: 'Birata', value: 'ବିରତ', regex: false },
{ key: 'Bishleshana', value: 'ବିଶ୍ଲେଷଣ', regex: false },
{ key: 'Bisphorana', value: 'ବିସ୍ଫୋରଣ', regex: false },
{ key: 'Bistara', value: 'ବିସ୍ତାର', regex: false },
{ key: 'Bistarita', value: 'ବିସ୍ତାରିତ', regex: false },
{ key: 'Biswasa', value: 'ବିଶ୍ୱାସ', regex: false },
{ key: 'Bitadita', value: 'ବିତାଡ଼ିତ', regex: false },
{ key: 'Bohiba', value: 'ବୋହିବା', regex: false },
{ key: 'Bojha', value: 'ବୋଝ', regex: false },
{ key: 'Book', value: 'ବୁକ୍', regex: false },
{ key: 'Bruddhi', value: 'ବୃଦ୍ଧି', regex: false },
{ key: 'Budi', value: 'ବୁଡ଼ି', regex: false },
{ key: 'Budiba', value: 'ବୁଡ଼ିବା', regex: false },
{ key: 'Bujhaiba', value: 'ବୁଝାଇବା', regex: false },
{ key: 'Bujhiba', value: 'ବୁଝିବା', regex: false },
{ key: 'Buniba', value: 'ବୁଣିବା', regex: false },
{ key: 'Byabahar', value: 'ବ୍ୟବହାର', regex: false },
{ key: 'Byabastha', value: 'ବ୍ୟବସ୍ଥା', regex: false },
{ key: 'Byaghata', value: 'ବ୍ୟାଘାତ', regex: false },
{ key: 'Byakhya', value: 'ବ୍ୟାଖ୍ୟା', regex: false },
{ key: 'Camp', value: 'କ୍ୟାମ୍ପ', regex: false },
{ key: 'Chadhiba', value: 'ଚଢ଼ିବା', regex: false },
{ key: 'Chahiba', value: 'ଚାହିଁବା', regex: false },
{ key: 'Chakiri', value: 'ଗ୍ଭକିରି', regex: false },
{ key: 'Chali', value: 'ଚାଲି', regex: false },
{ key: 'Chalu', value: 'ଚାଲୁ', regex: false },
{ key: 'Chamkiba', value: 'ଚମକିବା', regex: false },
{ key: 'Charge', value: 'ଚାର୍ଜ', regex: false },
{ key: 'Chasa', value: 'ଗ୍ଭଷ', regex: false },
{ key: 'Chatiba', value: 'ଚାଟିବା', regex: false },
{ key: 'Cheshta', value: 'ଚେଷ୍ଟା', regex: false },
{ key: 'Chhadaei', value: 'ଛଡ଼ାଇ', regex: false },
{ key: 'Chhadiba', value: 'ଛାଡ଼ିବ', regex: false },
{ key: 'Chhadideba', value: 'ଛାଡ଼ିଦେବ', regex: false },
{ key: 'Chihnata', value: 'ଚିହ୍ନଟ', regex: false },
{ key: 'Chihniba', value: 'ଚିହ୍ନିବ', regex: false },
{ key: 'Chinta', value: 'ଚିନ୍ତା', regex: false },
{ key: 'Chiriba', value: 'ଚିରିବ', regex: false },
{ key: 'Chitkara', value: 'ଚିତ୍କାର', regex: false },
{ key: 'Chitra', value: 'ଚିତ୍ର', regex: false },
{ key: 'Chitrana', value: 'ଚିତ୍ରଣ', regex: false },
{ key: 'Chobaib', value: 'ଚୋବାଇବ', regex: false },
{ key: 'Chukti', value: 'ଚୁକ୍ତି', regex: false },
{ key: 'Chumbana', value: 'ଚୁମ୍ବନ', regex: false },
{ key: 'Dabi', value: 'ଦାବି', regex: false },
{ key: 'Daga', value: 'ଦାଗ', regex: false },
{ key: 'Dakare', value: 'ଡାକରେ', regex: false },
{ key: 'Dakhala', value: 'ଦଖଲ', regex: false },
{ key: 'Dakib', value: 'ଡାକିବ', regex: false },
{ key: 'Dalil', value: 'ଦଲିଲ୍', regex: false },
{ key: 'Daraib', value: 'ଡରାଇବ', regex: false },
{ key: 'Darakara', value: 'ଦରକାର', regex: false },
{ key: 'Darib', value: 'ଡରିବ', regex: false },
{ key: 'Darshaib', value: 'ଦର୍ଶାଇବ', regex: false },
{ key: 'Deba', value: 'ଦେବା', regex: false },
{ key: 'Deinb', value: 'ଡେଇଁବ', regex: false },
{ key: 'Dekhaib', value: 'ଦେଖାଇବ', regex: false },
{ key: 'Dekhajib', value: 'ଦେଖାଯିବ', regex: false },
{ key: 'Dekhib', value: 'ଦେଖିବ', regex: false },
{ key: 'Delivery', value: 'ଡେଲିଭରି', regex: false },
{ key: 'Design', value: 'ଡିଜାଇନ୍', regex: false },
{ key: 'Dhairjya', value: 'ଧୈର୍ଯ୍ୟ', regex: false },
{ key: 'Dhakka', value: 'ଧକ୍କା', regex: false },
{ key: 'Dhalib', value: 'ଢଳିବ', regex: false },
{ key: 'Dhankib', value: 'ଢାଙ୍କିବ', regex: false },
{ key: 'Dhara', value: 'ଧାର', regex: false },
{ key: 'Dharib', value: 'ଧରିବ', regex: false },
{ key: 'Dharineb', value: 'ଧରିନେବ', regex: false },
{ key: 'Dheere', value: 'ଧୀରେ', regex: false },
{ key: 'Dhwasna', value: 'ଧ୍ୱଂସ', regex: false },
{ key: 'Dhyana', value: 'ଧ୍ୟାନ', regex: false },
{ key: 'Dianmarib', value: 'ଡିଆଁମାରିବ', regex: false },
{ key: 'Dosha', value: 'ଦୋଷ', regex: false },
{ key: 'Doshee', value: 'ଦୋଷୀ', regex: false },
{ key: 'Drushyamana', value: 'ଦୃଶ୍ୟମାନ', regex: false },
{ key: 'Druta', value: 'ଦ୍ରୁତ', regex: false },
{ key: 'Dub', value: 'ଡୁବ', regex: false },
{ key: 'dura', value: 'ଦୂର', regex: false },
{ key: 'Durabhasha', value: 'ଦୂରଭାଷ', regex: false },
{ key: 'Durei', value: 'ଦୂରେଇ', regex: false },
{ key: 'Durghatana', value: 'ଦୁର୍ଘଟଣା', regex: false },
{ key: 'Edaib', value: 'ଏଡ଼ାଇବ', regex: false },
{ key: 'Eka', value: 'ଏକା', regex: false },
{ key: 'Ekagra', value: 'ଏକାଗ୍ର', regex: false },
{ key: 'Ekatra', value: 'ଏକତ୍ର', regex: false },
{ key: 'Ekatrita', value: 'ଏକତ୍ରିତ', regex: false },
{ key: 'Feri', value: 'ଫେରି', regex: false },
{ key: 'Fit', value: 'ଫିଟ୍', regex: false },
{ key: 'Frame', value: 'ଫ୍ରେମ୍', regex: false },
{ key: 'Gabeshana', value: 'ଗବେଷଣା', regex: false },
{ key: 'Gadhib', value: 'ଗଢ଼ିବ', regex: false },
{ key: 'Gadhoyib', value: 'ଗାଧୋଇବ', regex: false },
{ key: 'Gadi', value: 'ଗାଡ଼ି', regex: false },
{ key: 'catholic', value: 'କାଥଲିକ', regex: false },
{ key: 'Ganib', value: 'ଗଣିବ', regex: false },
{ key: 'Garama', value: 'ଗରମ', regex: false },
{ key: 'Garba', value: 'ଗର୍ବ', regex: false },
{ key: 'Gathana', value: 'ଗଠନ', regex: false },
{ key: 'Gathita', value: 'ଗଠିତ', regex: false },
{ key: 'Ghataiba', value: 'ଘଟାଇବା', regex: false },
{ key: 'Ghatib', value: 'ଘଟିବ', regex: false },
{ key: 'Gheri', value: 'ଘେରି', regex: false },
{ key: 'Ghoshana', value: 'ଘୋଷଣା', regex: false },
{ key: 'Ghruna', value: 'ଘୃଣା', regex: false },
{ key: 'Ghuribulib', value: 'ଘୁରିବୁଲିବ', regex: false },
{ key: 'Girafa', value: 'ଗିରଫ', regex: false },
{ key: 'Godaib', value: 'ଗୋଡ଼ାଇବ', regex: false },
{ key: 'Goitha', value: 'ଗୋଇଠା', regex: false },
{ key: 'Golaib', value: 'ଗୋଳାଇବ', regex: false },
{ key: 'Golamala', value: 'ଗୋଳମାଳ', regex: false },
{ key: 'Golijib', value: 'ଗୋଳିଯିବ', regex: false },
{ key: 'Grahana', value: 'ଗ୍ରହଣ', regex: false },
{ key: 'Griddle', value: 'ଗ୍ରିଡ଼ଲ୍', regex: false },
{ key: 'Guarantee', value: 'ଗ୍ୟାରେଣ୍ଟି', regex: false },
{ key: 'Gudia', value: 'ଗୁଡ଼ିଆ', regex: false },
{ key: 'Guli', value: 'ଗୁଳି', regex: false },
{ key: 'Gunda', value: 'ଗୁଣ୍ଡ', regex: false },
{ key: 'Gurutwa', value: 'ଗୁରୁତ୍ୱ', regex: false },
{ key: 'Halachal', value: 'ହଲଚଲ୍', regex: false },
{ key: 'Halib', value: 'ହଲିବ', regex: false },
{ key: 'Harai', value: 'ହରାଇ', regex: false },
{ key: 'Haraib', value: 'ହରାଇବ', regex: false },
{ key: 'Hasala', value: 'ହାସଲ', regex: false },
{ key: 'Hasib', value: 'ହସିବ', regex: false },
{ key: 'Hasta', value: 'ହସ୍ତ', regex: false },
{ key: 'khepa', value: 'କ୍ଷେପ', regex: false },
{ key: 'Hata', value: 'ହାତ', regex: false },
{ key: 'Hatudi', value: 'ହତୁଡ଼ି', regex: false },
{ key: 'Hatya', value: 'ହତ୍ୟା', regex: false },
{ key: 'Heba', value: 'ହେବା', regex: false },
{ key: 'Hensa', value: 'ହେଁସା', regex: false },
{ key: 'Hera', value: 'ହେର', regex: false },
{ key: 'phera', value: 'ଫେର', regex: false },
{ key: 'Hoipar', value: 'ହୋଇପାର', regex: false },
{ key: 'Hrasa', value: 'ହ୍ରାସ', regex: false },
{ key: 'Ichha', value: 'ଇଚ୍ଛା', regex: false },
{ key: 'Injection', value: 'ଇଞ୍ଜେକ୍ସନ', regex: false },
{ key: 'Install', value: 'ଇନଷ୍ଟଲ୍', regex: false },
{ key: 'Irsha', value: 'ଇର୍ଷା', regex: false },
{ key: 'Istri', value: 'ଇସ୍ତ୍ରୀ', regex: false },
{ key: 'Jabudi', value: 'ଜାବୁଡ଼ି', regex: false },
{ key: 'Jadita', value: 'ଜଡ଼ିତ', regex: false },
{ key: 'Jae', value: 'ଯାଏ', regex: false },
{ key: 'Jai', value: 'ଯାଇ', regex: false },
{ key: 'prahari', value: 'ପ୍ରହରୀ', regex: false },
{ key: 'pachaku', value: 'ପଛକୁ', regex: false },
{ key: 'Jagrata', value: 'ଜାଗ୍ରତ', regex: false },
{ key: 'Jail', value: 'ଜେଲ୍', regex: false },
{ key: 'Jala', value: 'ଜାଲ', regex: false },
{ key: 'Jolaib', value: 'ଜଳାଇବ', regex: false },
{ key: 'trupti', value: 'ତୃପ୍ତି', regex: false },
{ key: 'abasada', value: 'ଅବସାଦ', regex: false },
{ key: 'rastrapati', value: 'ରାଷ୍ଟ୍ରପତି', regex: false },
{ key: 'donald', value: 'ଡୋନାଲ୍ଡ', regex: false },
{ key: 'panchanana', value: 'ପଞ୍ଚାନନ', regex: false },
{ key: 'Jalib', value: 'ଜାଳିବ', regex: false },
{ key: 'Jolib', value: 'ଜଳିବ', regex: false },
{ key: 'Jama', value: 'ଜମା', regex: false },
{ key: 'Jamaib', value: 'ଜମାଇବ', regex: false },
{ key: 'Jamata', value: 'ଜମାଟ', regex: false },
{ key: 'Janaib', value: 'ଜଣାଇବ', regex: false },
{ key: 'Jani', value: 'ଜାଣି', regex: false },
{ key: 'Janma', value: 'ଜନ୍ମ', regex: false },
{ key: 'Jari', value: 'ଜାରି', regex: false },
{ key: 'Jay', value: 'ଜୟ', regex: false },
{ key: 'Jazz', value: 'ଜାଜ୍', regex: false },
{ key: 'Jeep', value: 'ଜିପ୍', regex: false },
{ key: 'Jhataka', value: 'ଝଟକା', regex: false },
{ key: 'Jiba', value: 'ଯିବ', regex: false },
{ key: 'Jid', value: 'ଜିଦ୍', regex: false },
{ key: 'Jyana', value: 'ଜ୍ଞାନ', regex: false },
{ key: 'police', value: 'ପୋଲିସ', regex: false },
{ key: 'Jodib', value: 'ଯୋଡ଼ିବ', regex: false },
{ key: 'Jorre', value: 'ଜୋରରେ', regex: false },
{ key: 'Jua', value: 'ଜୁଆ', regex: false },
{ key: 'Juggle', value: 'ଜଗଲ୍', regex: false },
{ key: 'Kabu', value: 'କାବୁ', regex: false },
{ key: 'Kalpana', value: 'କଳ୍ପନା', regex: false },
{ key: 'Kom', value: 'କମ୍', regex: false },
{ key: 'Kamana', value: 'କାମନା', regex: false },
{ key: 'Kamudiba', value: 'କାମୁଡ଼ିବା', regex: false },
{ key: 'Kandiba', value: 'କାନ୍ଦିବା', regex: false },
{ key: 'Karagarare', value: 'କାରାଗାରରେ', regex: false },
{ key: 'Karan', value: 'କାରଣ', regex: false },
{ key: 'ethor', value: 'ଏଥର', regex: false },
{ key: 'drabya', value: 'ଦ୍ରବ୍ୟ', regex: false },
{ key: 'Karib', value: 'କରିବ', regex: false },
{ key: 'Karya', value: 'କାର୍ଯ୍ୟ', regex: false },
{ key: 'Karyakari', value: 'କାର୍ଯ୍ୟକାରୀ', regex: false },
{ key: 'Kashiba', value: 'କାଶିବା', regex: false },
{ key: 'Kashta', value: 'କଷ୍ଟ', regex: false },
{ key: 'Kathina', value: 'କଠିନ', regex: false },
{ key: 'Katiba', value: 'କାଟିବା', regex: false },
{ key: 'Khaiba', value: 'ଖାଇବା', regex: false },
{ key: 'Khali', value: 'ଖାଲି', regex: false },
{ key: 'pad', value: 'ପାଦ', regex: false },
{ key: 'dekhil', value: 'ଦେଖିଲ', regex: false },
{ key: 'pokad', value: 'ପୋକଡ଼', regex: false },
{ key: 'prashansa', value: 'ପ୍ରଶଂସା', regex: false },
{ key: 'Kholi', value: 'ଖଲି', regex: false },
{ key: 'Khanda', value: 'ଖଣ୍ଡ', regex: false },
{ key: 'Khani', value: 'ଖଣି', regex: false },
{ key: 'Kharap', value: 'ଖରାପ', regex: false },
{ key: 'Kharcha', value: 'ଖର୍ଚ୍ଚ', regex: false },
{ key: 'Khasijiba', value: 'ଖସିଯିବା', regex: false },
{ key: 'Khhasaiba', value: 'ଖସାଇବା', regex: false },
{ key: 'Khoji', value: 'ଖୋଜି', regex: false },
{ key: 'Kholiba', value: 'ଖୋଳିବା', regex: false },
{ key: 'Khuaiba', value: 'ଖୁଆଇବା', regex: false },
{ key: 'Khusi', value: 'ଖୁସି', regex: false },
{ key: 'Kiniba', value: 'କିଣିବା', regex: false },
{ key: 'Kinibaku', value: 'କିଣିବାକୁ', regex: false },
{ key: 'Khyot', value: 'କ୍ଷତ', regex: false },
{ key: 'Kshyama', value: 'କ୍ଷମା', regex: false },
{ key: 'Kudiba', value: 'କୁଦିବା', regex: false },
{ key: 'Label', value: 'ଲେବଲ୍', regex: false },
{ key: 'Labha', value: 'ଲାଭ', regex: false },
{ key: 'Ladhiba', value: 'ଲଢ଼ିବା', regex: false },
{ key: 'Lagaiba', value: 'ଲଗାଇବା', regex: false },
{ key: 'Lagi', value: 'ଲାଗି', regex: false },
{ key: 'Laagila', value: 'ଲାଗିଲା', regex: false },
{ key: 'Lakshya', value: 'ଲକ୍ଷ୍ୟ', regex: false },
{ key: 'Lambaiba', value: 'ଲମ୍ବାଇବା', regex: false },
{ key: 'Lekhi', value: 'ଲେଖି', regex: false },
{ key: 'Libhaiba', value: 'ଲିଭାଇବା', regex: false },
{ key: 'License', value: 'ଲାଇସେନ୍ସ', regex: false },
{ key: 'Load', value: 'ଲୋଡ୍', regex: false },
{ key: 'Luchaiba', value: 'ଲୁଚାଇବା', regex: false },
{ key: 'Luchi', value: 'ଲୁଚି', regex: false },
{ key: 'Luchiba', value: 'ଲୁଚିବା', regex: false },
{ key: 'Luchijiba', value: 'ଲୁଚିଯିବା', regex: false },
{ key: 'Machine', value: 'ମେସିନ୍', regex: false },
{ key: 'Mail', value: 'ମେଲ୍', regex: false },
{ key: 'Majak', value: 'ମଜାକ', regex: false },
{ key: 'Mona', value: 'ମନା', regex: false },
{ key: 'Mane', value: 'ମାନେ', regex: false },
{ key: 'Maniba', value: 'ମାନିବା', regex: false },
{ key: 'Manonibesha', value: 'ମନୋନିବେଶ', regex: false },
{ key: 'Manonita', value: 'ମନୋନୀତ', regex: false },
{ key: 'ranjan', value: 'ରଞ୍ଜନ', regex: false },
{ key: 'Mano', value: 'ମନୋ', regex: false },
{ key: 'Mapiba', value: 'ମାପିବା', regex: false },
{ key: 'Maramati', value: 'ମରାମତି', regex: false },
{ key: 'March', value: 'ମାର୍ଚ୍ଚ', regex: false },
{ key: 'Mariba', value: 'ମାରିବା', regex: false },
{ key: 'Matamata', value: 'ମତାମତ', regex: false },
{ key: 'Mela', value: 'ମେଳ', regex: false },
{ key: 'Michha', value: 'ମିଛ', regex: false },
{ key: 'Mishaiba', value: 'ମିଶାଇବା', regex: false },
{ key: 'Mishiba', value: 'ମିଶିବା', regex: false },
{ key: 'Model', value: 'ମଡେଲ୍', regex: false },
{ key: 'Modiba', value: 'ମୋଡ଼ିବା', regex: false },
{ key: 'Mukhasta', value: 'ମୁଖସ୍ଥ', regex: false },
{ key: 'Mukta', value: 'ମୁକ୍ତ', regex: false },
{ key: 'Mulatabi', value: 'ମୁଲତବୀ', regex: false },
{ key: 'Mulya', value: 'ମୂଲ୍ୟ', regex: false },
{ key: 'Mulyankana', value: 'ମୂଲ୍ୟାଙ୍କନ', regex: false },
{ key: 'Mundo', value: 'ମୁଣ୍ଡ', regex: false },
{ key: 'Muthae', value: 'ମୁଠାଇ', regex: false },
{ key: 'Muthakari', value: 'ମୁଠାକରି', regex: false },
{ key: 'Nachiba', value: 'ନାଚିବା', regex: false },
{ key: 'Najar', value: 'ନଜର', regex: false },
{ key: 'Nakala', value: 'ନକଲ', regex: false },
{ key: 'Namuna', value: 'ନମୁନା', regex: false },
{ key: 'Nasta', value: 'ନଷ୍ଟ', regex: false },
{ key: 'Nehura', value: 'ନେହୁରା', regex: false },
{ key: 'Netrutwa', value: 'ନେତୃତ୍ୱ', regex: false },
{ key: 'Nikataku', value: 'ନିକଟକୁ', regex: false },
{ key: 'Nind', value: 'ନିନ୍ଦ', regex: false },
{ key: 'Nirasha', value: 'ନିରାଶ', regex: false },
{ key: 'Nirbachita', value: 'ନିର୍ବାଚିତ', regex: false },
{ key: 'Nirbhara', value: 'ନିର୍ଭର', regex: false },
{ key: 'Nirdesha', value: 'ନିର୍ଦ୍ଦେଶ', regex: false },
{ key: 'Nirikshana', value: 'ନିରୀକ୍ଷଣ', regex: false },
{ key: 'Nirmana', value: 'ନିର୍ମାଣ', regex: false },
{ key: 'Nirnaya', value: 'ନିର୍ଣ୍ଣୟ', regex: false },
{ key: 'nischita', value: 'ନିଶ୍ଚିତ', regex: false },
{ key: 'anischita', value: 'ଅନିଶ୍ଚିତ', regex: false },
{ key: 'nischaya', value: 'ନିଶ୍ଚୟ', regex: false },
{ key: 'anischaya', value: 'ଅନିଶ୍ଚୟ', regex: false },
{ key: 'anischaya', value: 'ଅନିଶ୍ଚୟ', regex: false },
{ key: 'jaanti', value: 'ଯାଆନ୍ତି', regex: false },
{ key: 'janti', value: 'ଯାନ୍ତି', regex: false },
{ key: 'Nishiddha', value: 'ନିଷିଦ୍ଧ', regex: false },
{ key: 'Nishkasana', value: 'ନିଷ୍କାସନ', regex: false },
{ key: 'Nishpatti', value: 'ନିଷ୍ପତ୍ତି', regex: false },
{ key: 'Nishwasa', value: 'ନିଶ୍ୱାସ', regex: false },
{ key: 'asile', value: 'ଆସିଲେ', regex: false },
{ key: 'jogi', value: 'ଜଗି', regex: false },
{ key: 'mnu', value: 'ମୁଁ', regex: false },
{ key: 'Niyamita', value: 'ନିୟମିତ', regex: false },
{ key: 'niyambhongo', value: 'ନିୟମଭଙ୍ଗ', regex: false },
{ key: 'Niyantrana', value: 'ନିୟନ୍ତ୍ରଣ', regex: false },
{ key: 'Niyojita', value: 'ନିୟୋଜିତ', regex: false },
{ key: 'Niyukti', value: 'ନିଯୁକ୍ତି', regex: false },
{ key: 'Nuaniba', value: 'ନୁଆଁଇବା', regex: false },
{ key: 'Nyasta', value: 'ନ୍ୟସ୍ତ', regex: false },
{ key: 'Nyayasiddha', value: 'ନ୍ୟାୟସିଦ୍ଧ', regex: false },
{ key: 'Pachari', value: 'ପଚାରି', regex: false },
{ key: 'Pachariba', value: 'ପଚାରିବା', regex: false },
{ key: 'Padayatra', value: 'ପଦଯାତ୍ରା', regex: false },
{ key: 'Padei', value: 'ପାଦେଇ', regex: false },
{ key: 'padib', value: 'ପଡ଼ିବ', regex: false },
{ key: 'dib', value: 'ଡ଼ିବ', regex: false },
{ key: 'Pahanchaiba', value: 'ପହଞ୍ଚାଇବା', regex: false },
{ key: 'Pahanchiba', value: 'ପହଞ୍ଚିବା', regex: false },
{ key: 'Pahara', value: 'ପହରା', regex: false },
{ key: 'Paiba', value: 'ପାଇବା', regex: false },
{ key: 'Pakaiba', value: 'ପକାଇବା', regex: false },
{ key: 'Pakhaku', value: 'ପାଖକୁ', regex: false },
{ key: 'Pakhare', value: 'ପାଖରେ', regex: false },
{ key: 'Palaiba', value: 'ପଳାଇବା', regex: false },
{ key: 'Palaka', value: 'ପଲକ', regex: false },
{ key: 'Palan', value: 'ପାଳନ', regex: false },
{ key: 'Paramarsha', value: 'ପରାମର୍ଶ', regex: false },
{ key: 'Parangama', value: 'ପାରଙ୍ଗମ', regex: false },
{ key: 'Parasta', value: 'ପରାସ୍ତ', regex: false },
{ key: 'Pare', value: 'ପାରେ', regex: false },
{ key: 'Pari', value: 'ପାରି', regex: false },
{ key: 'Poribartana', value: 'ପରିବର୍ତ୍ତନ', regex: false },
{ key: 'Parichalana', value: 'ପରିଚାଳନା', regex: false },
{ key: 'Parichalita', value: 'ପରିଚାଳିତ', regex: false },
{ key: 'Parichaya', value: 'ପରିଚୟ', regex: false },
{ key: 'Parikalpana', value: 'ପରିକଳ୍ପନା', regex: false },
{ key: 'porikhya', value: 'ପରୀକ୍ଷା', regex: false },
{ key: 'Parithanta', value: 'ପାରିଥାନ୍ତା', regex: false },
{ key: 'Paryabekshana', value: 'ପର୍ଯ୍ୟବେକ୍ଷଣ', regex: false },
{ key: 'Patha', value: 'ପଥ', regex: false },
{ key: 'Patti', value: 'ପାଟି', regex: false },
{ key: 'Peshiba', value: 'ପେଷିବା', regex: false },
{ key: 'Phasaib', value: 'ଫସାଇବ', regex: false },
{ key: 'Phashi', value: 'ଫାଶୀ', regex: false },
{ key: 'Phatib', value: 'ଫାଟିବ', regex: false },
{ key: 'Phingib', value: 'ଫିଙ୍ଗିବ', regex: false },
{ key: 'Phodib', value: 'ଫୋଡ଼ିବ', regex: false },
{ key: 'Phone', value: 'ଫୋନ୍', regex: false },
{ key: 'Phopadib', value: 'ଫୋପାଡ଼ିବ', regex: false },
{ key: 'Phunkib', value: 'ଫୁଙ୍କିବ', regex: false },
{ key: 'Phutaiba', value: 'ଫୁଟାଇବା', regex: false },
{ key: 'Phutiba', value: 'ଫୁଟିବା', regex: false },
{ key: 'Pib', value: 'ପିଇବ', regex: false },
{ key: 'Pichha', value: 'ପିଛା', regex: false },
{ key: 'Pindhaib', value: 'ପିନ୍ଧାଇବ', regex: false },
{ key: 'Pindhib', value: 'ପିନ୍ଧିବ', regex: false },
{ key: 'Pitib', value: 'ପିଟିବ', regex: false },
{ key: 'Padiba', value: 'ପଡ଼ିବ', regex: false },
{ key: 'Poshaka', value: 'ପୋଷାକ', regex: false },
{ key: 'Poshan', value: 'ପୋଷଣ', regex: false },
{ key: 'Poshhyaputra', value: 'ପୋଷ୍ୟପୁତ୍ର', regex: false },
{ key: 'Potiba', value: 'ପୋତିବା', regex: false },
{ key: 'Prabahita', value: 'ପ୍ରବାହିତ', regex: false },
{ key: 'Prabartana', value: 'ପ୍ରବର୍ତ୍ତନ', regex: false },
{ key: 'Prabesha', value: 'ପ୍ରବେଶ', regex: false },
{ key: 'Prabhabita', value: 'ପ୍ରଭାବିତ', regex: false },
{ key: 'Pradana', value: 'ପ୍ରଦାନ', regex: false },
{ key: 'Pradarshita', value: 'ପ୍ରଦର୍ଶିତ', regex: false },
{ key: 'Prakasha', value: 'ପ୍ରକାଶ', regex: false },
{ key: 'Prakata', value: 'ପ୍ରକଟ', regex: false },
{ key: 'Prapta', value: 'ପ୍ରାପ୍ତ', regex: false },
{ key: 'Prasansa', value: 'ପ୍ରଶଂସା', regex: false },
{ key: 'Prasarana', value: 'ପ୍ରସାରଣ', regex: false },
{ key: 'Prashikshana', value: 'ପ୍ରଶିକ୍ଷଣ', regex: false },
{ key: 'Prastaba', value: 'ପ୍ରସ୍ତାବ', regex: false },
{ key: 'Pratidhwani', value: 'ପ୍ରତିଧ୍ୱନି', regex: false },
{ key: 'Pratigya', value: 'ପ୍ରତିଜ୍ଞା', regex: false },
{ key: 'Pratirakshya', value: 'ପ୍ରତିରକ୍ଷା', regex: false },
{ key: 'Pratishruti', value: 'ପ୍ରତିଶ୍ରୁତି', regex: false },
{ key: 'Pratistha', value: 'ପ୍ରତିଷ୍ଠା', regex: false },
{ key: 'Pratiyogita', value: 'ପ୍ରତିଯୋଗିତା', regex: false },
{ key: 'Pratyakhyana', value: 'ପ୍ରତ୍ୟାଖ୍ୟାନ', regex: false },
{ key: 'Pratyaya', value: 'ପ୍ରତ୍ୟୟ', regex: false },
{ key: 'Prayoga', value: 'ପ୍ରୟୋଗ', regex: false },
{ key: 'Prerita', value: 'ପ୍ରେରିତ', regex: false },
{ key: 'Prustha poshakata', value: 'ପୃଷ୍ଠ ପୋଷକତା', regex: false },
{ key: 'Pruthaka', value: 'ପୃଥକ', regex: false },
{ key: 'Purana', value: 'ପୂରଣ', regex: false },
{ key: 'Purna', value: 'ପୂର୍ଣ୍ଣ', regex: false },
{ key: 'Purvanumana', value: 'ପୂର୍ବାନୁମାନ', regex: false },
{ key: 'Pushta', value: 'ପୁଷ୍ଟ', regex: false },
{ key: 'ajana', value: 'ଅଜଣା', regex: false },
{ key: 'achapa', value: 'ଅଛପା', regex: false },
{ key: 'jone', value: 'ଜଣେ', regex: false },
{ key: 'ote', value: 'ଅଟେ', regex: false },
{ key: 'chhadi', value: 'ଛାଡ଼ି', regex: false },
{ key: 'pila', value: 'ପିଲା', regex: false },
{ key: 'Pushti', value: 'ପୁଷ୍ଟି', regex: false },
{ key: 'Rachana', value: 'ରଚନା', regex: false },
{ key: 'Rahiba', value: 'ରହିବା', regex: false },
{ key: 'Raji', value: 'ରାଜି', regex: false },
{ key: 'Rakhiba', value: 'ରଖିବା', regex: false },
{ key: 'Rakshana bekshana', value: 'ରକ୍ଷଣା ବେକ୍ଷଣ', regex: false },
{ key: 'Rakshya', value: 'ରକ୍ଷା', regex: false },
{ key: 'Rakta', value: 'ରକ୍ତ', regex: false },
{ key: 'Randhib', value: 'ରାନ୍ଧିବ', regex: false },
{ key: 'Raptani', value: 'ରପ୍ତାନି', regex: false },
{ key: 'Record', value: 'ରେକର୍ଡ', regex: false },
{ key: 'Rojagar', value: 'ରୋଜଗାର', regex: false },
{ key: 'Rosei', value: 'ରୋଷେଇ', regex: false },
{ key: 'ruuna', value: 'ଋଣ', regex: false },
{ key: 'Rupa', value: 'ରୂପ', regex: false },
{ key: 'tuna', value: 'ଟୁନା', regex: false },
{ key: 'nonda', value: 'ନଣ୍ଡା', regex: false },
{ key: 'nanda', value: 'ନନ୍ଦ', regex: false },
{ key: 'jayananda', value: 'ଜୟାନନ୍ଦ', regex: false },
{ key: 'bondhu', value: 'ବନ୍ଧୁ', regex: false },
{ key: 'dakara', value: 'ଡ଼ାକରା', regex: false },
{ key: 'stariya', value: 'ସ୍ତରୀୟ', regex: false },
{ key: 'saharanchala', value: 'ସହରାଞ୍ଚଳ', regex: false },
{ key: 'bibhina', value: 'ବିଭିନ୍ନ', regex: false },
{ key: 'dakil', value: 'ଡ଼ାକିଲ', regex: false },
{ key: 'shunil', value: 'ଶୁଣିଲ', regex: false },
{ key: 'rupantara', value: 'ରୂପାନ୍ତର', regex: false },
{ key: 'Sadhan', value: 'ସାଧନ', regex: false },
{ key: 'Sahajya', value: 'ସାହାଯ୍ୟ', regex: false },
{ key: 'Sahamata', value: 'ସହମତ', regex: false },
{ key: 'Sahasa', value: 'ସାହସ', regex: false },
{ key: 'Sahayata', value: 'ସହାୟତା', regex: false },
{ key: 'Sahayoga', value: 'ସହଯୋଗ', regex: false },
{ key: 'Sahajoga', value: 'ସହଯୋଗ', regex: false },
{ key: 'samarpan', value: 'ସମର୍ପଣ', regex: false },
{ key: 'Sahya', value: 'ସହ୍ୟ', regex: false },
{ key: 'Sajadiba', value: 'ସଜାଡ଼ିବା', regex: false },
{ key: 'Sajaib', value: 'ସଜାଇବ', regex: false },
{ key: 'Sakshama', value: 'ସକ୍ଷମ', regex: false },
{ key: 'Samadhan', value: 'ସମାଧାନ', regex: false },
{ key: 'Samalochana', value: 'ସମାଲୋଚନା', regex: false },
{ key: 'Samana', value: 'ସମାନ', regex: false },
{ key: 'jibant', value: 'ଜୀବନ୍ତ', regex: false },

{ key: 'Samapta', value: 'ସମାପ୍ତ', regex: false },
{ key: 'Samarthana', value: 'ସମର୍ଥନ', regex: false },
{ key: 'Samatala', value: 'ସମତଳ', regex: false },
{ key: 'Samatula', value: 'ସମତୁଲ', regex: false },
{ key: 'Samayojita', value: 'ସମାୟୋଜିତ', regex: false },
{ key: 'Sambandhita', value: 'ସମ୍ବନ୍ଧିତ', regex: false },
{ key: 'Sambhaba', value: 'ସମ୍ଭବ', regex: false },
{ key: 'Sambhaliba', value: 'ସମ୍ଭାଳିବା', regex: false },
{ key: 'Sammana', value: 'ସମ୍ମାନ', regex: false },
{ key: 'Samna', value: 'ସାମ୍ନା', regex: false },
{ key: 'Sampadana', value: 'ସମ୍ପାଦନ', regex: false },
{ key: 'Sampark', value: 'ସମ୍ପର୍କ', regex: false },
{ key: 'Samparkita', value: 'ସମ୍ପର୍କିତ', regex: false },
{ key: 'Samprati', value: 'ସମ୍ପ୍ରତି', regex: false },
{ key: 'Samruddha', value: 'ସମୃଦ୍ଧ', regex: false },
{ key: 'Sandeha', value: 'ସନ୍ଦେହ', regex: false },
{ key: 'Sangraha', value: 'ସଂଗ୍ରହ', regex: false },
{ key: 'Sanjnya', value: 'ସଂଜ୍ଞା', regex: false },
{ key: 'Sanjoga', value: 'ସଂଯୋଗ', regex: false },
{ key: 'Sanjota', value: 'ସଂଯତ', regex: false },
{ key: 'Sankuchita', value: 'ସଂକୁଚିତ', regex: false },
{ key: 'Sanlagna', value: 'ସଂଲଗ୍ନ', regex: false },
{ key: 'Sanshodhana', value: 'ସଂଶୋଧନ', regex: false },
{ key: 'Santulana', value: 'ସନ୍ତୁଳନ', regex: false },
{ key: 'Sapha', value: 'ସଫା', regex: false },
{ key: 'Sarala', value: 'ସରଳ', regex: false },
{ key: 'Sarbanimna', value: 'ସର୍ବନିମ୍ନ', regex: false },
{ key: 'Sori', value: 'ସରି', regex: false },
{ key: 'Saru', value: 'ସରୁ', regex: false },
{ key: 'Seemita', value: 'ସୀମିତ', regex: false },
{ key: 'Shesha', value: 'ଶେଷ', regex: false },
{ key: 'Shibira', value: 'ଶିବିର', regex: false },
{ key: 'Shighra', value: 'ଶୀଘ୍ର', regex: false },
{ key: 'Shikhib', value: 'ଶିଖିବ', regex: false },
{ key: 'Shikshya', value: 'ଶିକ୍ଷା', regex: false },
{ key: 'Shoib', value: 'ଶୋଇବ', regex: false },
{ key: 'Shoshib', value: 'ଶୋଷିବ', regex: false },
{ key: 'Shukhaib', value: 'ଶୁଖାଇବ', regex: false },
{ key: 'Shukhib', value: 'ଶୁଖିବ', regex: false },
{ key: 'Shwasa', value: 'ଶ୍ୱାସ', regex: false },
{ key: 'Siddhanta', value: 'ସିଦ୍ଧାନ୍ତ', regex: false },
{ key: 'Snana', value: 'ସ୍ନାନ', regex: false },
{ key: 'Spashta', value: 'ସ୍ପଷ୍ଟ', regex: false },
{ key: 'Srushti', value: 'ସୃଷ୍ଟି', regex: false },
{ key: 'Sthapana', value: 'ସ୍ଥାପନ', regex: false },
{ key: 'Sthayi', value: 'ସ୍ଥାୟୀ', regex: false },
{ key: 'Sthira', value: 'ସ୍ଥିର', regex: false },
{ key: 'Suchaib', value: 'ସୂଚାଇବ', regex: false },
{ key: 'Suchana', value: 'ସୂଚନା', regex: false },
{ key: 'Suchita', value: 'ସୂଚିତ', regex: false },
{ key: 'Sunib', value: 'ଶୁଣିବ', regex: false },
{ key: 'Swagata', value: 'ସ୍ୱାଗତ', regex: false },
{ key: 'Swapna', value: 'ସ୍ୱପ୍ନ', regex: false },
{ key: 'Swikara', value: 'ସ୍ୱୀକାର', regex: false },
{ key: 'Tadanta', value: 'ତଦନ୍ତ', regex: false },
{ key: 'Tala', value: 'ତାଲା', regex: false },
{ key: 'Talima', value: 'ତାଲିମ', regex: false },
{ key: 'Tangib', value: 'ଟାଙ୍ଗିବ', regex: false },
{ key: 'Tanib', value: 'ଟାଣିବ', regex: false },
{ key: 'Taralaib', value: 'ତରଳାଇବ', regex: false },
{ key: 'Taralib', value: 'ତରଳିବ', regex: false },
{ key: 'Taratar', value: 'ତରତର', regex: false },
{ key: 'Tarka', value: 'ତର୍କ', regex: false },
{ key: 'Thai', value: 'ଥାଇ', regex: false },
{ key: 'Thok', value: 'ଠକ୍', regex: false },
{ key: 'Thakib', value: 'ଠକିବ', regex: false },
{ key: 'Thonda', value: 'ଥଣ୍ଡା', regex: false },
{ key: 'Thota', value: 'ଥଟ୍ଟା', regex: false },
{ key: 'Thik', value: 'ଠିକ୍', regex: false },
{ key: 'Tiari', value: 'ତିଆରି', regex: false },
{ key: 'Tiika', value: 'ଟୀକା', regex: false },
{ key: 'Tipi', value: 'ଟିପି', regex: false },
{ key: 'Tishthi', value: 'ତିଷ୍ଠି', regex: false },
{ key: 'Tulana', value: 'ତୁଳନା', regex: false },
{ key: 'Tyaga', value: 'ତ୍ୟାଗ', regex: false },
{ key: 'Uchhulib', value: 'ଉଛୁଳିବ', regex: false },
{ key: 'Uddeshya', value: 'ଉଦ୍ଦେଶ୍ୟ', regex: false },
{ key: 'Udbhabana', value: 'ଉଦ୍ଭାବନ', regex: false },
{ key: 'Udib', value: 'ଉଡ଼ିବ', regex: false },
//{ key: 'Ujjwala', value: 'ଉଜ୍ଜ୍ୱଳ', regex: false },
{ key: 'Ulekha', value: 'ଉଲ୍ଲେଖ', regex: false },
{ key: 'Unnata', value: 'ଉନ୍ନତ', regex: false },
{ key: 'Unnati', value: 'ଉନ୍ନତି', regex: false },
{ key: 'Unnita', value: 'ଉନ୍ନୀତ', regex: false },
{ key: 'Upabhoga', value: 'ଉପଭୋଗ', regex: false },
{ key: 'Uparaku', value: 'ଉପରକୁ', regex: false },
{ key: 'Upasthita', value: 'ଉପସ୍ଥିତ', regex: false },
{ key: 'Upekhya', value: 'ଉପେକ୍ଷା', regex: false },
{ key: 'Uthaib', value: 'ଉଠାଇବ', regex: false },
{ key: 'Uthib', value: 'ଉଠିବ', regex: false },
{ key: 'Utkhepana', value: 'ଉତକ୍ଷେପଣ', regex: false },
{ key: 'Utpanna', value: 'ଉତ୍ପନ୍ନ', regex: false },
{ key: 'Utsarga', value: 'ଉତ୍ସର୍ଗ', regex: false },
{ key: 'jolokhia', value: 'ଜଳଖିଆ', regex: false },
{ key: 'Uttara', value: 'ଉତ୍ତର', regex: false },
{ key: 'Uttejita', value: 'ଉତ୍ତେଜିତ', regex: false },
{ key: 'Uttolana', value: 'ଉତ୍ତୋଳନ', regex: false },
{ key: 'jancha', value: 'ଯାଞ୍ଚ', regex: false },
{ key: 'jatna', value: 'ଯତ୍ନ', regex: false },
{ key: 'jatra', value: 'ଯାତ୍ରା', regex: false },
{ key: 'jyoga', value: 'ଯୋଗ', regex: false },
{ key: 'jogya', value: 'ଯୋଗ୍ୟ', regex: false },
{ key: 'yojana', value: 'ଯୋଜନା', regex: false },
{ key: 'jyojana', value: 'ଯୋଜନା', regex: false },
{ key: 'panjikaran', value: 'ପଞ୍ଜିକରଣ', regex: false },
{ key: 'krusaka', value: 'କୃଷକ', regex: false },
{ key: 'karajauachhi', value: 'କରାଯାଉଅଛି', regex: false },
//{ key: 'jee', value: 'ଯେ', regex: false },
{ key: 'cholita', value: 'ଚଳିତ', regex: false },
{ key: 'chalito', value: 'ଚାଳିତ', regex: false },
{ key: 'bidyut', value: 'ବିଦ୍ୟୁତ', regex: false },
{ key: 'jono', value: 'ଜଣ', regex: false },
{ key: 'mono', value: 'ମନ', regex: false },
{ key: 'adhi', value: 'ଅଧି', regex: false },
{ key: 'bhagyo', value: 'ଭାଗ୍ୟ', regex: false },
{ key: 'bidhata', value: 'ବିଧାତା', regex: false },
{ key: 'joge', value: 'ଜଗେ', regex: false },
{ key: 'tano', value: 'ଟାଣ', regex: false },
{ key: 'shunu', value: 'ଶୁଣୁ', regex: false },
{ key: 'bulo', value: 'ବୁଲ', regex: false },
{ key: 'juktijukta', value: 'ଯୁକ୍ତିଯୁକ୍ତ', regex: false },
{ key: 'admission', value: 'ଆଡମିଶନ୍', regex: false },
{ key: 'epari', value: 'ଏପାରି', regex: false },
{ key: 'separi', value: 'ସେପାରି', regex: false },
{ key: 'epori', value: 'ଏପରି', regex: false },
{ key: 'jyogya', value: 'ଯୋଗ୍ୟ', regex: false },
{ key: 'joga', value: 'ଯୋଗ', regex: false },
{ key: 'sachetana', value: 'ସଚେତନ', regex: false },
{ key: 'adhyaya', value: 'ଅଧ୍ୟାୟ', regex: false },
{ key: 'keyboard', value: 'କିବୋର୍ଡ଼', regex: false },
{ key: 'bakta', value: 'ବକ୍ତା', regex: false },
{ key: 'ajira', value: 'ଆଜିର', regex: false },
{ key: 'swagat', value: 'ସ୍ୱାଗତ', regex: false },
{ key: 'online', value: 'ଅନଲାଇନ', regex: false },
{ key: 'kahai', value: 'କହଇ', regex: false },
{ key: 'akash', value: 'ଆକାଶ', regex: false },
{ key: 'khao', value: 'ଖାଅ', regex: false },
{ key: 'buto', value: 'ବୁଟ', regex: false },
{ key: 'tarakari', value: 'ତରକାରି', regex: false },
{ key: 'pahila', value: 'ପାହିଲା', regex: false },
{ key: 'andhar', value: 'ଅନ୍ଧାର', regex: false },
{ key: 'ebe', value: 'ଏବେ', regex: false },
{ key: 'gao', value: 'ଗାଅ', regex: false },
{ key: 'pulake', value: 'ପୁଲକେ', regex: false },
{ key: 'rabidi', value: 'ରାବିଡ଼ି', regex: false },
{ key: 'rabi', value: 'ରବି', regex: false },
{ key: 'kiran', value: 'କିରଣ', regex: false },
{ key: 'phuti', value: 'ଫୁଟି', regex: false },
{ key: 'dhire', value: 'ଧୀରେ', regex: false },
{ key: 'bahe', value: 'ବହେ', regex: false },
{ key: 'paban', value: 'ପବନ', regex: false },
{ key: 'nidra', value: 'ନିଦ୍ରା', regex: false },
{ key: 'dhoranibasi', value: 'ଧରଣୀବାସୀ', regex: false },
{ key: 'keun', value: 'କେଉଁ', regex: false },
{ key: 'podhil', value: 'ପଢ଼ିଲ', regex: false },
{ key: 'kichi', 'value': 'କିଛି', regex: false },
{ key: 'are', value: ' ଆରେ', regex: false },
{ key: 'sabu', value: 'ସବୁ', regex: false },
{ key: 'tankar', value: 'ତାଙ୍କର', regex: false },
{ key: 'icha', value: 'ଇଛା', regex: false },
{ key: 'ame', value: 'ଆମେ', regex: false },
{ key: 'janupati', value: 'ଜାନୁପାତି', regex: false },
{ key: 'aradhana', value: 'ଆରାଧନା', regex: false },
{ key: 'karib', value: 'କରିବ', regex: false },
{ key: 'ahara', value: 'ଆହାର', regex: false },
{ key: 'prang', value: 'ପ୍ରାଙ୍ଗ', regex: false },
{ key: 'prangon', value: 'ପ୍ରାଙ୍ଗଣ', regex: false },
{ key: 'pote', value: 'ପଟେ', regex: false },
{ key: 'musha', value: 'ମୂଷା', regex: false },
{ key: 'machhi', value: 'ମାଛି', regex: false },
{ key: 'koront', value: 'କରନ୍ତ', regex: false },
{ key: 'sabhy', value: 'ସଭ୍ୟ', regex: false },
{ key: 'abadhi', value: 'ଅବଧି', regex: false },
{ key: 'aushadha', value: 'ଔଷଧ', regex: false },
{ key: 'abanchaniya', value: 'ଅବାଞ୍ଛନୀୟ', regex: false },
{ key: 'abarnaniya', value: 'ଅବର୍ଣ୍ଣନୀୟ', regex: false },
{ key: 'abashyaka', value: 'ଆବଶ୍ୟକ', regex: false },
{ key: 'anabashyaka', value: 'ଅନାବଶ୍ୟକ', regex: false },
{ key: 'abasanna', value: 'ଅବସନ୍ନ', regex: false },
{ key: 'abastha', value: 'ଅବସ୍ଥା', regex: false },
{ key: 'abdul', value: 'ଅବଦୁଲ', regex: false },
{ key: 'abhagini', value: 'ଅଭାଗିନୀ', regex: false },
{ key: 'bhogini', value: 'ଭଗିନୀ', regex: false },
{ key: 'anwesana', value: 'ଅନ୍ବେଷଣ', regex: false },
{ key: 'apadastha', value: 'ଅପଦସ୍ଥ', regex: false },
{ key: 'aparajit', value: 'ଅପରାଜିତ', regex: false },
{ key: 'abhibhabak', value: 'ଅଭିଭାବକ', regex: false },
{ key: 'abadha', value: 'ଅବଢ଼ା', regex: false },
{ key: 'abhishap', value: 'ଅଭିଶାପ', regex: false },
{ key: 'abhisikta', value: 'ଅଭିଷିକ୍ତ', regex: false },
{ key: 'abhishikta', value: 'ଅଭିଷିକ୍ତ', regex: false },
{ key: 'adbhut', value: 'ଅଦ୍ଭୁତ', regex: false },
{ key: 'abhyasta', value: 'ଅଭ୍ୟସ୍ତ', regex: false },
{ key: 'amruta', value: 'ଅମୃତ', regex: false },
{ key: 'arakhita', value: 'ଅରକ୍ଷିତ', regex: false },
{ key: 'doiba', value: 'ଦୖବ', regex: false },
{ key: 'anno', value: 'ଅନ୍ନ', regex: false },
{ key: 'anha', value: 'ଅନ୍ନ', regex: false },
{ key: 'ast', value: 'ଅଷ୍ଟ', regex: false },
{ key: 'uttap', value: 'ଉତ୍ତାପ', regex: false },
{ key: 'utschab', value: 'ଉତ୍ସବ', regex: false },
{ key: 'unna', value: 'ଊଣା', regex: false },
{ key: 'utpat', value: 'ଉତ୍ପାତ', regex: false },
{ key: 'utscharg', value: 'ଉତ୍ସର୍ଗ', regex: false },
{ key: 'udgirin', value: 'ଉଦଗିରିଣ', regex: false },
{ key: 'matru', value: 'ମାତୃ', regex: false },
{ key: 'hruday', value: 'ହୃଦୟ', regex: false },
{ key: 'gadyansh', value: 'ଗଦ୍ୟାଂଶ', regex: false },
{ key: 'padyansh', value: 'ପଦ୍ୟାଂଶ', regex: false },
{ key: 'abhijoga', value: 'ଅଭିଯୋଗ', regex: false },
{ key: 'abhilas', value: 'ଅଭିଳାଷ', regex: false },
{ key: 'abhyas', value: 'ଅଭ୍ୟାସ', regex: false },
{ key: 'abyaya', value: 'ଅବ୍ୟୟ', regex: false },
{ key: 'achant', value: 'ଅଛନ୍ତ', regex: false },
{ key: 'achara', value: 'ଆଗ୍ଭର', regex: false },
{ key: 'achhi', value: 'ଅଛି', regex: false },
{ key: 'ach', value: 'ଅଚ', regex: false },
{ key: 'bhagirathi', value: 'ଭଗୀରଥୀ', regex: false },
{ key: 'bishn', value: 'ବିଷ୍ଣ', regex: false },
{ key: 'vishn', value: 'ବିଷ୍ଣ', regex: false },
{ key: 'tho', value: 'ଠ', regex: false },
{ key: 'to', value: 'ଟ', regex: false },
{ key: 'do', value: 'ଡ', regex: false },
{ key: 'dho', value: 'ଢ଼', regex: false },
{ key: 'no', value: 'ଣ', regex: false },
{ key: 'ddh', value: 'ଧ', regex: false },
{ key: 'ph', value: 'ଫ', regex: false },
{ key: 'jo', value: 'ଯ', regex: false },
{ key: 'deogarh', value: 'ଦେବଗଡ଼', regex: false },
{ key: 'bargarh', value: 'ବରଗଡ଼', regex: false },
{ key: 'balangir district', value: 'ବଲାଙ୍ଗିର', regex: false },
{ key: 'langir', value: 'ଲାଙ୍ଗିର', regex: false },
{ key: 'adesh', value: 'ଆଦେଶ', regex: false },
{ key: 'adhigrahan', value: 'ଅଧିଗ୍ରହଣ', regex: false },
{ key: 'adhika', value: 'ଅଧିକ', regex: false },
{ key: 'adhiniyam', value: 'ଅଧିନିୟମ', regex: false },
{ key: 'adhyabasaya', value: 'ଅଧ୍ୟବସାୟ', regex: false },
{ key: 'adhyakhya', value: 'ଅଧ୍ୟକ୍ଷ୍ୟ', regex: false },
{ key: 'adhyayan', value: 'ଅଧ୍ୟୟନ', regex: false },
{ key: 'agneyagiri', value: 'ଆଗ୍ନେୟଗିରି', regex: false },
{ key: 'agni', value: 'ଅଗ୍ନି', regex: false },
{ key: 'agrabarti', value: 'ଅଗ୍ରବର୍ତ୍ତୀ', regex: false },
{ key: 'agrabhumi', value: 'ଅଗ୍ରଭୂମି', regex: false },
{ key: 'agradarsi', value: 'ଅଗ୍ରଦର୍ଶୀ', regex: false },
{ key: 'agradipa', value: 'ଅଗ୍ରଦୀପ', regex: false },
{ key: 'agraduta', value: 'ଅଗ୍ରଦୂତ', regex: false },
{ key: 'agya', value: 'ଆଜ୍ଞା', regex: false },
{ key: 'sagya', value: 'ସଜ୍ଞା', regex: false },
{ key: 'pragya', value: 'ପ୍ରଜ୍ଞା', regex: false },
{ key: 'ahnika', value: 'ଆହ୍ନିକ', regex: false },
{ key: 'aikya', value: 'ଐକ୍ୟ', regex: false },
{ key: 'aingata', value: 'ଆଇନଗତ', regex: false },
{ key: 'aintha', value: 'ଅଇଁଠା', regex: false },
{ key: 'airabata', value: 'ଐରାବତ୍ତ', regex: false },
{ key: 'aitihya', value: 'ଐତିହ୍ୟ', regex: false },
{ key: 'ajenda', value: 'ଏଜେଣ୍ଡା', regex: false },
{ key: 'ajirna', value: 'ଅଜୀର୍ଣ୍ଣ', regex: false },
{ key: 'ajoiba', value: 'ଅଜୈବ', regex: false },
{ key: 'akarmanya', value: 'ଅକର୍ମଣ୍ୟ', regex: false },
{ key: 'akarsan', value: 'ଆକର୍ଷଣ', regex: false },
{ key: 'akasa', value: 'ଆକାଶ', regex: false },
{ key: 'akha', value: 'ଅଖା', regex: false },
{ key: 'akhanda', value: 'ଅଖଣ୍ଡ', regex: false },
{ key: 'akhandata', value: 'ଅଖଣ୍ଡତା', regex: false },
{ key: 'aklant', value: 'ଅକ୍ଲାନ୍ତ', regex: false },
{ key: 'akruti', value: 'ଆକୃତି', regex: false },
{ key: 'aktiara', value: 'ଅକ୍ତିଆର', regex: false },
{ key: 'alankruta', value: 'ଅଳଙ୍କୃତ', regex: false },
{ key: 'alasua', value: 'ଅଳସୁଆ', regex: false },
{ key: 'alasya', value: 'ଆଳସ୍ୟ', regex: false },
{ key: 'aloukika', value: 'ଅଲୌକିକ', regex: false },
{ key: 'alpa', value: 'ଅଳ୍ପ', regex: false },
{ key: 'amaku', value: 'ଆମକୁ', regex: false },
{ key: 'ambha', value: 'ଆମ୍ଭ', regex: false },
{ key: 'amen', value: 'ଆମେନ', regex: false },
{ key: 'amla', value: 'ଅମ୍ଳ', regex: false },
{ key: 'amlajan', value: 'ଅମ୍ଳଜାନ', regex: false },
{ key: 'anai', value: 'ଅନାଇ', regex: false },
{ key: 'anajib', value: 'ଅଣାଯିବ', regex: false },
{ key: 'anando', value: 'ଆନନ୍ଦ', regex: false },
{ key: 'ananta', value: 'ଅନନ୍ତ', regex: false },
{ key: 'anchal', value: 'ଅଞ୍ଚଳ', regex: false },
{ key: 'anda', value: 'ଅଣ୍ଡା', regex: false },
{ key: 'andakosa', value: 'ଅଣ୍ଡକୋଷ', regex: false },
{ key: 'andha', value: 'ଅନ୍ଧ', regex: false },
{ key: 'andhrapradesh', value: 'ଆନ୍ଧ୍ରପ୍ରଦେଶ', regex: false },
{ key: 'anek', value: 'ଅନେକ', regex: false },
{ key: 'angarakamla', value: 'ଅଙ୍ଗାରକାମ୍ଳ', regex: false },
{ key: 'anguli', value: 'ଆଙ୍ଗୁଳି', regex: false },
{ key: 'anirdhista', value: 'ଅନିର୍ଦ୍ଧିଷ୍ଟ', regex: false },
{ key: 'nirdhista', value: 'ନିର୍ଦ୍ଧିଷ୍ଟ', regex: false },
{ key: 'ankur', value: 'ଅଙ୍କୁର', regex: false },
{ key: 'ankurita', value: 'ଅଙ୍କୁରିତ', regex: false },
{ key: 'ankus', value: 'ଅଙ୍କୁଶ', regex: false },
{ key: 'anna', value: 'ଅନ୍ନ', regex: false },
{ key: 'anoupacharik', value: 'ଅନୌପଗ୍ଭରିକ', regex: false },
{ key: 'ansa', value: 'ଅଂଶ', regex: false },
{ key: 'ansagrahan', value: 'ଅଂଶଗ୍ରହଣ', regex: false },
{ key: 'ansidar', value: 'ଅଂଶୀଦାର', regex: false },
{ key: 'ansika', value: 'ଆଂଶିକ', regex: false },
{ key: 'ansupa', value: 'ଅଂଶୁପା', regex: false },
{ key: 'antakosa', value: 'ଅନ୍ତକୋଷ', regex: false },
{ key: 'antarbhukta', value: 'ଅନ୍ତର୍ଭୁକ୍ତ', regex: false },
{ key: 'antardesio', value: 'ଅନ୍ତର୍ଦେଶୀୟ', regex: false },
{ key: 'antardhan', value: 'ଅନ୍ତର୍ଦ୍ଧାନ', regex: false },
{ key: 'antarghat', value: 'ଅନ୍ତର୍ଘାତ', regex: false },
{ key: 'antarnibesa', value: 'ଅନ୍ତର୍ନିବେଶ', regex: false },
{ key: 'antat', value: 'ଅନ୍ତତଃ', regex: false },
{ key: 'anth', value: 'ଅନ୍ତଃ', regex: false },
{ key: 'antyesti', value: 'ଅନ୍ତ୍ୟେଷ୍ଟି', regex: false },
{ key: 'anubad', value: 'ଅନୁବାଦ', regex: false },
{ key: 'anubartan', value: 'ଅନୁବର୍ତ୍ତନ', regex: false },
{ key: 'anubarti', value: 'ଅନୁବର୍ତ୍ତୀ', regex: false },
{ key: 'anucheda', value: 'ଅନୁଚ୍ଛେଦ', regex: false },
{ key: 'anujai', value: 'ଅନୁଯାୟୀ', regex: false },
{ key: 'anukula', value: 'ଅନୁକୂଳ', regex: false },
{ key: 'anumati', value: 'ଅନୁମତି', regex: false },
{ key: 'anupacharita', value: 'ଅନୁପଗ୍ଭରିତା', regex: false },
{ key: 'anupasthan', value: 'ଅନୁପସ୍ଥାନ', regex: false },
{ key: 'anupat', value: 'ଅନୁପାତ', regex: false },
{ key: 'anurodha', value: 'ଅନୁରୋଧ', regex: false },
{ key: 'anusaran', value: 'ଅନୁସରଣ', regex: false },
{ key: 'anusilan', value: 'ଅନୁଶୀଳନ', regex: false },
{ key: 'anya', value: 'ଅନ୍ୟ', regex: false },
{ key: 'anyamane', value: 'ଅନ୍ୟମାନେ', regex: false },
{ key: 'anyamanka', value: 'ଅନ୍ୟମାନଙ୍କ', regex: false },
{ key: 'apachalak', value: 'ଅପଗ୍ଭଳକ', regex: false },
{ key: 'apachari', value: 'ଅପଗ୍ଭରୀ', regex: false },
{ key: 'apan', value: 'ଆପଣ', regex: false },
{ key: 'aparadh', value: 'ଅପରାଧ', regex: false },
{ key: 'khyamaniya', value: 'କ୍ଷମଣୀୟ', regex: false },
{ key: 'khoje', value: 'ଖୋଜେ', regex: false },
{ key: 'bipoti', value: 'ବିପତ୍ତି', regex: false },
{ key: 'apaharan', value: 'ଅପହରଣ', regex: false },
{ key: 'aparupa', value: 'ଅପରୂପ', regex: false },
{ key: 'apekhika', value: 'ଆପେକ୍ଷିକ', regex: false },
{ key: 'apostrofi', value: 'ଆପୋଷ୍ଟ୍ରୋଫି', regex: false },
{ key: 'april', value: 'ଏପ୍ରିଲ', regex: false },
{ key: 'apurba', value: 'ଅପୂର୍ବ', regex: false },
{ key: 'aranya', value: 'ଅରଣ୍ୟ', regex: false },
{ key: 'archana', value: 'ଅର୍ଚ୍ଚନା', regex: false },
{ key: 'archive', value: 'ଆର୍କାଇଭ୍', regex: false },
{ key: 'ardha', value: 'ଅର୍ଦ୍ଧ', regex: false },
{ key: 'ardhansa', value: 'ଅର୍ଦ୍ଧାଂଶ', regex: false },
{ key: 'ratro', value: 'ରାତ୍ର', regex: false },
{ key: 'ardha', value: 'ଅର୍ଦ୍ଧ', regex: false },
{ key: 'posana', value: 'ପୋଷଣ', regex: false },
{ key: 'tathya', value: 'ତଥ୍ୟ', regex: false },
{ key: 'anusare', value: 'ଅନୁସାରେ', regex: false },
{ key: 'arthniti', value: 'ଅର୍ଥନୀତି', regex: false },
{ key: 'arthnaitika', value: 'ଅର୍ଥନୈତିକ', regex: false },
{ key: 'sudh', value: 'ସୁଦ୍ଧ', regex: false },
{ key: 'praya', value: 'ପ୍ରାୟ', regex: false },
{ key: 'matric', value: 'ମେଟ୍ରିକ', regex: false },
{ key: 'sasya', value: 'ଶସ୍ୟ', regex: false },
{ key: 'mahajud', value: 'ମହଜୁଦ', regex: false },
{ key: 'maha', value: 'ମହା', regex: false },
{ key: 'stock', value: 'ଷ୍ଟକ', regex: false },
{ key: 'arts', value: 'ଆର୍ଟ୍ସ', regex: false },
{ key: 'asa', value: 'ଆସ', regex: false },
{ key: 'asaddho', value: 'ଆଷାଢ଼', regex: false },
{ key: 'asamanata', value: 'ଅସମାନତା', regex: false },
{ key: 'ase', value: 'ଆସେ', regex: false },
{ key: 'ashesa', value: 'ଅଶେଷ', regex: false },
{ key: 'asha', value: 'ଆଶା', regex: false },
{ key: 'ashram', value: 'ଆଶ୍ରମ', regex: false },
{ key: 'esia', value: 'ଏସିଆ', regex: false },
{ key: 'asima', value: 'ଅସୀମ', regex: false },
{ key: 'aslila', value: 'ଅଶ୍ଳୀଳ', regex: false },
{ key: 'astabhuja', value: 'ଅଷ୍ଟଭୂଜ', regex: false },
{ key: 'astropachar', value: 'ଅସ୍ତ୍ରୋପଗ୍ଭର', regex: false },
{ key: 'aswachata', value: 'ଅସ୍ୱଚ୍ଛତା', regex: false },
{ key: 'aswast', value: 'ଆଶ୍ୱସ୍ତ', regex: false },
{ key: 'aswasta', value: 'ଅସ୍ୱଷ୍ଟ', regex: false },
{ key: 'aswastha', value: 'ଅଶ୍ୱସ୍ଥ', regex: false },
{ key: 'swasthya', value: 'ସ୍ୱାସ୍ଥ୍ୟ', regex: false },
{ key: 'prada', value: 'ପ୍ରଦ', regex: false },
{ key: 'kahinki', value: 'କାହିଁକି', regex: false },
{ key: 'aswin', value: 'ଅଶ୍ୱିନ', regex: false },
{ key: 'aswini', value: 'ଅଶ୍ୱିନୀ', regex: false },
{ key: 'udbega', value: 'ଉଦବେଗ', regex: false },
{ key: 'birodha', value: 'ବିରୋଧ', regex: false },
{ key: 'sthali', value: 'ସ୍ଥଳି', regex: false },
{ key: 'ashraya', value: 'ଆଶ୍ରୟ', regex: false },
{ key: 'nirman', value: 'ନିର୍ମାଣ', regex: false },
{ key: 'ethijonit', value: 'ଏଥିଜନିତ', regex: false },
{ key: 'bhorot', value: 'ଭରତ', regex: false },
{ key: 'badal', value: 'ବାଦଲ', regex: false },
{ key: 'bodol', value: 'ବଦଳ', regex: false },
{ key: 'adol', value: 'ଅଦଳ', regex: false },
{ key: 'baasi', value: 'ବାସୀ', regex: false },
{ key: 'kotiabasi', value: 'କୋଟିଆବାସୀ', regex: false },
{ key: 'andhra', value: 'ଆନ୍ଧ୍ର', regex: false },
{ key: 'atalika', value: 'ଅଟ୍ଟାଳିକା', regex: false },
{ key: 'atisaya', value: 'ଅତିଶୟ', regex: false },
{ key: 'atithi', value: 'ଅତିଥି', regex: false },
{ key: 'atma', value: 'ଆତ୍ମା', regex: false },
{ key: 'atmo', value: 'ଆତ୍ମ', regex: false },
{ key: 'sikhya', value: 'ଶିକ୍ଷା', regex: false },
{ key: 'sanskara', value: 'ସଂସ୍କାର', regex: false },
{ key: 'loda', value: 'ଲୋଡ଼ା', regex: false },
{ key: 'shasaka', value: 'ଶାସକ', regex: false },
{ key: 'rahuchanti', value: 'ରହୁଛନ୍ତି', regex: false },
{ key: 'rahuchha', value: 'ରହୁଛ', regex: false },
{ key: 'barna', value: 'ବର୍ଣ୍ଣ', regex: false },
{ key: 'ketoti', value: 'କେତୋଟି', regex: false },
{ key: 'atoeb', value: 'ଅତଏବ', regex: false },
{ key: 'atyachara', value: 'ଅତ୍ୟାଗ୍ଭର', regex: false },
{ key: 'atyutama', value: 'ଅତ୍ୟୁତ୍ତମ', regex: false },
{ key: 'audhatya', value: 'ଔଦ୍ଧତ୍ୟ', regex: false },
{ key: 'audio', value: 'ଅଡିଓ', regex: false },
{ key: 'august', value: 'ଅଗଷ୍ଟ', regex: false },
{ key: 'aupacharit', value: 'ଔପଚାରିତ', regex: false },
{ key: 'aupanibesa', value: 'ଔପନିବେଶ', regex: false },
{ key: 'ausadha', value: 'ଔଷଧ', regex: false },
{ key: 'authore', value: 'ଆଉଥରେ', regex: false },
{ key: 'ayushman', value: 'ଆୟୁଷ୍ମାନ', regex: false },  
  { key: 'bodhoi', value: 'ବଢ଼ଇ', regex: false },
  { key: 'bagicha', value: 'ବଗିଚା ', regex: false },
  { key: 'bahu', value: 'ବହୁ', regex: false },
  { key: 'bahuchi', value: 'ବହୁଛି', regex: false },
  { key: 'bahuta', value: 'ବହୁତ', regex: false },
  { key: 'baidya', value: 'ବୈଦ୍ୟ', regex: false },
  { key: 'baigyanika', value: 'ବୈଜ୍ଞାନିକ', regex: false },
  { key: 'baisakha', value: 'ବୈଶାଖ', regex: false },
  { key: 'baishnaba', value: 'ବୈଷ୍ଣବ', regex: false },
  { key: 'baisya', value: 'ବୈଶ୍ୟ', regex: false },
  { key: 'bajaina', value: 'ବଜାଇଣ', regex: false },
  { key: 'bajra', value: 'ବଜ୍ର', regex: false },
  { key: 'bajuachi', value: 'ବାଜୁଅଛି', regex: false },
  { key: 'bajuchi', value: 'ବାଜୁଛି ', regex: false },
  { key: 'bakya', value: 'ବାକ୍ୟ', regex: false },
  //{ key: 'bakyansh', value: 'ବାକ୍ୟାଂଶ', regex: false },
  { key: 'bakya', value: 'ବାକ୍ୟ', regex: false },
  { key: 'boliar', value: 'ବଳିୟାର', regex: false },
  { key: 'bamphi', value: 'ବାମ୍ଫି', regex: false },
  { key: 'bampho', value: 'ବାମ୍ଫ', regex: false },
  { key: 'bancha', value: 'ବାଞ୍ଛା', regex: false },
  { key: 'banchi', value: 'ବଞ୍ଚି', regex: false },
  { key: 'banda', value: 'ବନ୍ଦ', regex: false },
  { key: 'bando', value: 'ବାଣ୍ଡ', regex: false },
  { key: 'bandhu', value: 'ବନ୍ଧୁ', regex: false },
  { key: 'bangalore', value: 'ବେଙ୍ଗାଲୁରୁ', regex: false },
  { key: 'banijyika', value: 'ବାଣିଜ୍ୟିକ ', regex: false },
  { key: 'banka', value: 'ବଙ୍କା', regex: false },
  { key: 'banso', value: 'ବଂଶ', regex: false },
  { key: 'bantan', value: 'ବଣ୍ଟନ ', regex: false },
  { key: 'bantibaku', value: 'ବାଣ୍ଟିବାକୁ', regex: false },
  { key: 'bapa', value: 'ବାପା', regex: false },
  { key: 'baragacha', value: 'ବରଗଛ', regex: false },
  { key: 'barambar', value: 'ବାରମ୍ବାର ', regex: false },
  { key: 'barga', value: 'ବର୍ଗ ', regex: false },
  { key: 'baristha', value: 'ବରିଷ୍ଠ ', regex: false },
  //{ key: 'bars', value: 'ବର୍ଷ ', regex: false },
  { key: 'barta', value: 'ବାର୍ତ୍ତା', regex: false },
  { key: 'bartaman', value: 'ବର୍ତ୍ତମାନ ', regex: false },
  { key: 'bosaib', value: 'ବସାଇବ', regex: false },
  { key: 'shiba', value: 'ଶିବ', regex: false },
  { key: 'antarjatiya', value: 'ଅନ୍ତର୍ଜାତୀୟ', regex: false },
  { key: 'jubo', value: 'ଯୁବ', regex: false },
  { key: 'aba', value: 'ଅବ', regex: false },
  { key: 'sara', value: 'ସର', regex: false },
  { key: 'pidhi', value: 'ପିଢ଼ି', regex: false },
  { key: 'hardika', value: 'ହାର୍ଦ୍ଦିକ', regex: false },
  { key: 'subhecha', value: 'ଶୁଭେଛା', regex: false },
  { key: 'janauch', value: 'ଜଣାଉଛ', regex: false },
  { key: 'janau', value: 'ଜଣାଉ', regex: false },
  { key: 'amo', value: 'ଆମ', regex: false },
  { key: 'pragati', value: 'ପ୍ରଗତି', regex: false },
  { key: 'naba', value: 'ନବ', regex: false },
  { key: 'srujana', value: 'ସୃଜନ', regex: false },
  { key: 'joutuka', value: 'ଯୖୋତୁକ', regex: false },
  { key: 'bascha', value: 'ବତ୍ସ', regex: false },
  { key: 'basiachh', value: 'ବସିଅଛ', regex: false },
  { key: 'baspa', value: 'ବାଷ୍ପ', regex: false },
  { key: 'bastra', value: 'ବସ୍ତ୍ର ', regex: false },
  { key: 'bastragara', value: 'ବସ୍ତ୍ରାଗାର', regex: false },
  { key: 'bastu', value: 'ବସ୍ତୁ', regex: false },
  { key: 'basuachh', value: 'ବାସୁଅଛ', regex: false },
  { key: 'batsch', value: 'ବତ୍ସ ', regex: false },
  { key: 'baunsa', value: 'ବାଉଁଶ', regex: false },
  { key: 'bayanika', value: 'ବୟନିକା', regex: false },
  { key: 'bayasa', value: 'ବୟସ ', regex: false },
  { key: 'bayaska', value: 'ବୟସ୍କ' , regex: false },
  { key: 'bayaskata', value: 'ବୟସ୍କତା ', regex: false },
  { key: 'bddruti', value: 'ଉଦ୍ଧୃତି ', regex: false },
  { key: 'bedi', value: 'ବେଡ଼ି', regex: false },
  { key: 'bedhi', value: 'ବେଢ଼ି ', regex: false },
  { key: 'beddi', value: 'ବେଦୀ', regex: false },
  { key: 'bello', value: 'ବେଲ', regex: false },
  { key: 'benga', value: 'ବେଙ୍ଗ', regex: false },
  { key: 'beni', value: 'ବେଣୀ', regex: false },
  { key: 'beredakia', value: 'ବେରେଡ଼ାଆ', regex: false },
  { key: 'besi', value: 'ବେଶି', regex: false },
  { key: 'beso', value: 'ବେଶ', regex: false },
//  { key: 'bhabantu', value: 'ଭାବନ୍ତୁ', regex: false },
  { key: 'bhabant', value: 'ଭାବନ୍ତ', regex: false },
  { key: 'bhabare', value: 'ଭାବରେ', regex: false },
  { key: 'bhabisyat', value: 'ଭବିଷ୍ୟତ', regex: false },
  { key: 'bhadraba', value: 'ଭାଦ୍ରବ', regex: false },
  { key: 'bhagaban', value: 'ଭଗବାନ', regex: false },
  { key: 'bhagare', value: 'ଭାଗରେ', regex: false },
  { key: 'bhairaba', value: 'ଭୈରବ', regex: false },
  { key: 'bhajan', value: 'ଭଜନ', regex: false },
  { key: 'bhala', value: 'ଭଲ', regex: false },
  { key: 'bhali', value: 'ଭଳି', regex: false },
  { key: 'bhalluk', value: 'ଭଲ୍ଲକ', regex: false },
  { key: 'bhandababa', value: 'ଭଣ୍ଡବାବା', regex: false },
  { key: 'bhanr', value: 'ଭଅଁର', regex: false },
  { key: 'bharat', value: 'ଭାରତ', regex: false },
  { key: 'bharatbani', value: 'ଭାରତବାଣୀ', regex: false },
  { key: 'bharatiya', value: 'ଭାରତୀୟ', regex: false },
  { key: 'bhardi', value: 'ଭର୍ଡି', regex: false },
  { key: 'bhasa', value: 'ଭାଷା', regex: false },
  { key: 'bhason', value: 'ଭାଷଣ' , regex: false },
  { key: 'bhasare', value: 'ଭାଷାରେ', regex: false },
  { key: 'bhata', value: 'ଭାତ', regex: false },
  { key: 'bhaunri', value: 'ଭଉଁରୀ', regex: false },
  { key: 'bhaya', value: 'ଭୟ', regex: false },
  { key: 'bhayankara', value: 'ଭୟଙ୍କର', regex: false },
  { key: 'bhitibhumi', value: 'ଭିତ୍ତିଭୂମି' , regex: false },
  { key: 'bhitre', value: 'ଭିତରେ', regex: false },
  { key: 'bhobantu', value: 'ଭବନ୍ତୁ', regex: false },
  { key: 'bhogini', value: 'ଭଗିନୀ', regex: false },
  { key: 'bhojon', value: 'ଭୋଜନ', regex: false },
  { key: 'bhorat', value: 'ଭରତ', regex: false },
  { key: 'bhot', value: 'ଭୋଟ', regex: false },
  { key: 'bhouni', value: 'ଭଉଣୀ', regex: false },
  { key: 'bhoutika', value: 'ଭୌତିକ', regex: false },
  { key: 'bhrutya', value: 'ଭୃତ୍ୟ', regex: false },
  { key: 'bhula', value: 'ଭୁଲ', regex: false },
  { key: 'bhumi', value: 'ଭୂମି', regex: false },
  { key: 'bhusan', value: 'ଭୂଷଣ', regex: false },
  { key: 'bibarani', value: 'ବିବରଣୀ', regex: false },
  { key: 'bibhaga', value: 'ବିଭାଗ', regex: false },
  { key: 'bibhokti', value: 'ବିଭକ୍ତି', regex: false },
  { key: 'bidesh', value: 'ବିଦେଶ', regex: false },
  { key: 'bidya', value: 'ବିଦ୍ୟା', regex: false },
  { key: 'bidyalaya', value: 'ବିଦ୍ୟାଳୟ', regex: false },
  { key: 'bighna', value: 'ବିଘ୍ନ', regex: false },
  { key: 'bighnaraj', value: 'ବିଘ୍ନରାଜ', regex: false },
  { key: 'bigyan', value: 'ବିଜ୍ଞାନ', regex: false },
  { key: 'bigyani', value: 'ବିଜ୍ଞାନୀ', regex: false },
  { key: 'bihari', value: 'ବିହାରୀ', regex: false },
  { key: 'bihwal', value: 'ବିହ୍ଵଳ', regex: false },
  { key: 'bijo', value: 'ବୀଜ', regex: false },
  { key: 'bikas', value: 'ବିକାଶ', regex: false },
  { key: 'bikasita', value: 'ବିକଶିତ', regex: false },
  { key: 'bikreta', value: 'ବିକ୍ରେତା', regex: false },
  { key: 'biliyan', value: 'ବିଲିୟନ ', regex: false },
  { key: 'bina', value: 'ବିନା', regex: false },
  { key: 'binapani', value: 'ବୀଣାପାଣି', regex: false },
  { key: 'bindu', value: 'ବିନ୍ଦୁ', regex: false },
  { key: 'binjharpur', value: 'ବିଞ୍ଛାରପୁର', regex: false },
  { key: 'binna', value: 'ବୀଣା', regex: false },
  { key: 'bipad', value: 'ବିପଦ', regex: false },
  { key: 'bipade', value: 'ବିପଦେ', regex: false },
  { key: 'biparita', value: 'ବିପରୀତ', regex: false },
  { key: 'bippali', value: 'ବିପ୍ପଳୀ', regex: false },
  { key: 'biram', value: 'ବିରାମ', regex: false },
  { key: 'biro', value: 'ବୀର', regex: false },
  { key: 'bisakhapatan', value: 'ବିଶାଖାପାଟଣା', regex: false },
  { key: 'bisama', value: 'ବିଷମ', regex: false },
  { key: 'bisaya', value: 'ବିଷୟ', regex: false },
  { key: 'bisayabastu', value: 'ବିଷୟବସ୍ତୁ', regex: false },
  { key: 'bisayare', value: 'ବିଷୟରେ', regex: false },
  { key: 'bisesagya', value: 'ବିଶେଷଜ୍ଞ', regex: false },
  { key: 'bisesagyan', value: 'ବିଶେଷଜ୍ଞ', regex: false },
  { key: 'bisesakari', value: 'ବିଶେଷକରି', regex: false },
  { key: 'bisesana', value: 'ବିଶେଷଣ', regex: false },
  { key: 'bisesho', value: 'ବିଶେଷ', regex: false },
  { key: 'bisesya', value: 'ବିଶେଷ୍ୟ', regex: false },
  { key: 'bishram', value: 'ବିଶ୍ରାମ', regex: false },
  { key: 'bismaya', value: 'ବିସ୍ମୟ', regex: false },
  { key: 'suchak', value: 'ସୂଚକ', regex: false },
  { key: 'ani', value: 'ଆଣି', regex: false },
  { key: 'narendra', value: 'ନରେନ୍ଦ୍ର', regex: false },  
  { key: 'biswa', value: 'ବିଶ୍ୱ', regex: false },
  { key: 'bidyalaya', value: 'ବିଦ୍ୟାଳୟ', regex: false },
  { key: 'vidyalaya', value: 'ବିଦ୍ୟାଳୟ', regex: false },
  { key: 'biswas', value: 'ବିଶ୍ୱାସ', regex: false },
  { key: 'sthata', value: 'ସ୍ଥତା', regex: false },
  { key: 'bitai', value: 'ବିତାଇ', regex: false },
  { key: 'parant', value: 'ପାରନ୍ତ', regex: false },
  { key: 'bansidhar', value: 'ବଂଶୀଧର', regex: false },
  { key: 'bahi', value: 'ବହି', regex: false },
  { key: 'bohi', value: 'ବୋହି', regex: false },  
  { key: 'boisayika', value: 'ବୈଷୟିକ', regex: false },
  { key: 'box', value: 'ବକ୍ସ', regex: false },
  { key: 'bonchao', value: 'ବଞ୍ଚାଅ', regex: false },
  { key: 'bosi', value: 'ବସି', regex: false },
  { key: 'brohm', value: 'ବ୍ରହ୍ମ', regex: false },
  { key: 'brahmgyana', value: 'ବ୍ରହ୍ମଜ୍ଞାନ', regex: false },
  { key: 'brahmon', value: 'ବ୍ରାହ୍ମଣ', regex: false },
  { key: 'bramhand', value: 'ବ୍ରହ୍ମାଣ୍ଡ', regex: false },
  { key: 'brudhi', value: 'ବୃଦ୍ଧି ', regex: false },
  { key: 'brukhy', value: 'ବୃକ୍ଷ', regex: false },
  { key: 'brukhya', value: 'ବୃକ୍ଷ', regex: false },
  { key: 'brukhyadale', value: 'ବୃକ୍ଷଡ଼ାଳେ', regex: false },
  { key: 'brusa', value: 'ବୃଷ', regex: false },
  { key: 'brusti', value: 'ବୃଷ୍ଟି', regex: false },
  { key: 'khyurn', value: 'କ୍ଷୁର୍ଣ୍ଣ', regex: false },
  { key: 'brusabhanu', value: 'ବୃଷଭାନୁ', regex: false },
  { key: 'brutha', value: 'ବୃଥା', regex: false },
  { key: 'brutigata', value: 'ବୃତ୍ତିଗତ ', regex: false },
  { key: 'buddhi', value: 'ବୁଦ୍ଧି', regex: false },
  { key: 'budhi', value: 'ବୁଢ଼ୀ', regex: false },
  { key: 'budhiani', value: 'ବୁଢ଼ିଆଣୀ', regex: false },
  { key: 'budi', value: 'ବୁଡ଼ି', regex: false },
  { key: 'buli', value: 'ବୁଲି ', regex: false },
  { key: 'byabahar', value: 'ବ୍ୟବହାର' , regex: false },
  { key: 'kari', value: 'କାରୀ ', regex: false },
  { key: 'byabasaya', value: 'ବ୍ୟବସାୟ', regex: false },
  { key: 'byabastha', value: 'ବ୍ୟବସ୍ଥା ', regex: false },
  { key: 'byaghra', value: 'ବ୍ୟାଘ୍ର', regex: false },
  { key: 'byakarana', value: 'ବ୍ୟାକରଣ', regex: false },
  { key: 'byakhya', value: 'ବ୍ୟାଖ୍ୟା', regex: false },
  { key: 'byakti', value: 'ବ୍ୟକ୍ତି', regex: false },
  { key: 'byaktigata', value: 'ବ୍ୟକ୍ତିଗତ', regex: false },
  { key: 'byaktimane', value: 'ବ୍ୟକ୍ତିମାନେ', regex: false },
  { key: 'byatha', value: 'ବ୍ୟଥା', regex: false },
  { key: 'sabadhana', value: 'ସାବଧାନ', regex: false },
  { key: 'swadhina', value: 'ସ୍ୱାଧିନ', regex: false },
  { key: 'encounter', value: 'ଏନକାଉଣ୍ଟର', regex: false },
  { key: 'specialist', value: 'ସ୍ପେସାଲିଷ୍ଟ', regex: false },
  { key: 'Supreme', value: 'ସୁପ୍ରିମ', regex: false },
  { key: 'Court', value: 'କୋର୍ଟ', regex: false },
  { key: 'london', value: 'ଲଣ୍ଡନ', regex: false },
  { key: 'lonthon', value: 'ଲଣ୍ଠନ', regex: false },
  { key: 'porida', value: 'ପରିଡ଼ା', regex: false },
  { key: 'sameta', value: 'ସମେତ', regex: false },
  { key: 'swarthya', value: 'ସ୍ୱାର୍ଥ୍ୟ', regex: false },
  { key: 'first', value: 'ପ୍ରଥମ', regex: false },
  { key: 'second', value: 'ଦ୍ୱିତୀୟ', regex: false },
  { key: 'trutiya', value: 'ତୃତୀୟ', regex: false },
  { key: 'third', value: 'ତୃତୀୟ', regex: false },
  { key: 'fourth', value: 'ଚତୁର୍ଥ', regex: false },
  { key: 'fifth', value: 'ପଞ୍ଚମ', regex: false },
  { key: 'hrutpindo', value: 'ହୃତପିଣ୍ଡ', regex: false },
  { key: 'anyuna', value: 'ଅନ୍ୟୁନ', regex: false },  
  { key: 'kutanitigya', value: 'କୂଟନୀତିଜ୍ଞ', regex: false },
  { key: 'kuta', value: 'କୂଟ', regex: false },
  { key: 'prashna', value: 'ପ୍ରଶ୍ନ', regex: false },
  { key: 'kutib', value: 'କୁଟିବ', regex: false },
  { key: 'kutil', value: 'କୁଟିଳ', regex: false },
  { key: 'kutir', value: 'କୁଟୀର', regex: false },
  { key: 'kutumba', value: 'କୁଟୁମ୍ବ', regex: false },
  { key: 'kwachit', value: 'କ୍ୱଚିତ', regex: false },
  { key: 'kyapita', value: 'କ୍ୟାପିତ', regex: false },
  { key: 'labdha', value: 'ଲବ୍ଧ', regex: false },
  { key: 'lagna', value: 'ଲଗ୍ନ', regex: false },
  { key: 'lajja', value: 'ଲଜ୍ଜା', regex: false },
  { key: 'lakhya', value: 'ଲକ୍ଷ୍ୟ', regex: false },
  { key: 'lakhyan', value: 'ଲକ୍ଷଣ', regex: false },
  { key: 'lakshman', value: 'ଲକ୍ଷ୍ମଣ', regex: false },
  { key: 'lakshmi', value: 'ଲକ୍ଷ୍ମୀ', regex: false },
  { key: 'lamungia', value: 'ଲାମୁଙ୍ଗିଆ', regex: false },
  { key: 'langhai', value: 'ଲଙ୍ଘଇ', regex: false },
  { key: 'langhan', value: 'ଲଙ୍ଘନ', regex: false },
  { key: 'langhi', value: 'ଲଙ୍ଘି', regex: false },
  { key: 'language', value: 'ଲାଙ୍ଗୁଏଜ୍', regex: false },
  { key: 'lata', value: 'ଲତା', regex: false },
  { key: 'lekha', value: 'ଲେଖା', regex: false },
  { key: 'lekhak', value: 'ଲେଖକ', regex: false },
  { key: 'leso', value: 'ଲେଶ', regex: false },
  { key: 'linga', value: 'ଲିଙ୍ଗ', regex: false },
  { key: 'lippa', value: 'ଲିପ୍ପା', regex: false },
  { key: 'pathyapustak', value: 'ପାଠ୍ୟପୁସ୍ତକ', regex: false },
  
  { key: 'pathyo', value: 'ପାଠ୍ୟ', regex: false },
  { key: 'pathy', value: 'ପାଠି', regex: false },
  { key: 'tri', value: 'ତ୍ରି', regex: false },
  
  { key: 'pathyokrama', value: 'ପାଠ୍ୟକ୍ରମ', regex: false },
  { key: 'patni', value: 'ପତ୍ନୀ', regex: false },
    { key: 'pattn', value: 'ପତ୍ତନ', regex: false },
  { key: 'input', value: 'ଇନପୁଟ', regex: false },
  { key: 'pauchi', value: 'ପାଉଛି', regex: false },
  { key: 'paunsa', value: 'ପାଉଁଶ', regex: false },
  { key: 'pcharajauthib', value: 'ପଚରାଯାଉଥିବ', regex: false },
  { key: 'pchha', value: 'ପାଚ୍ଛା', regex: false },
  { key: 'pecha', value: 'ପେଚା', regex: false },
  { key: 'pela', value: 'ପେଳ', regex: false },
  { key: 'peti', value: 'ପେଟି', regex: false },
  { key: 'phaguna', value: 'ଫଗୁଣ', regex: false },
  { key: 'phalguna', value: 'ଫାଲ୍ଗୁନ', regex: false },
  { key: 'pholak', value: 'ଫଳକ', regex: false },
  { key: 'photographer', value: 'ଫଟୋଗ୍ରାଫର', regex: false },
  { key: 'phoujadari', value: 'ଫୌଜଦାରୀ', regex: false },
  { key: 'phula', value: 'ଫୁଲ', regex: false },
  { key: 'phutiachi', value: 'ଫୁଟିଅଛି', regex: false },
  { key: 'phutichi', value: 'ଫୁଟିଛି', regex: false },
  { key: 'pichha', value: 'ପିଛା', regex: false },
  { key: 'pida', value: 'ପୀଡ଼ା', regex: false },
  { key: 'pilamane', value: 'ପିଲାମାନେ', regex: false },
  { key: 'pin', value: 'ପିନ୍', regex: false },
  { key: 'pindhe', value: 'ପିନ୍ଧେ', regex: false },
  { key: 'pindhibo', value: 'ପିନ୍ଧିବ', regex: false },
  { key: 'enatene', value: 'ଏଣେତେଣେ', regex: false },
  { key: 'engineer', value: 'ଇଞ୍ଜିନିୟରିଂ', regex: false },
  { key: 'engraji', value: 'ଇଂରାଜୀ', regex: false },
  { key: 'eniki', value: 'ଏଣିକି', regex: false },
  { key: 'enutenu', value: 'ଏଣୁତେଣୁ', regex: false },
  { key: 'epakh', value: 'ଏପାଖ', regex: false },
  { key: 'eparjyant', value: 'ଏପର୍ଯ୍ୟନ୍ତ', regex: false },
  { key: 'erundi', value: 'ଏରୁଣ୍ଡି', regex: false },
  { key: 'etadbhinn', value: 'ଏତଦଭିନ୍ନ', regex: false },
  { key: 'etadwara', value: 'ଏତଦ୍ୱାରା', regex: false },
  { key: 'etala', value: 'ଏତଲା', regex: false },
  { key: 'ethare', value: 'ଏଠାରେ', regex: false },
  { key: 'etharu', value: 'ଏଠାରୁ', regex: false },
  { key: 'ethiki', value: 'ଏଠିକି', regex: false },
  { key: 'ethire', value: 'ଏଥିରେ', regex: false },
  { key: 'ethiru', value: 'ଏଥିରୁ', regex: false },
  { key: 'etthare', value: 'ଏଠାରେ', regex: false },
  { key: 'february', value: 'ଫେବୃଆରୀ', regex: false },
  { key: 'flopi', value: 'ଫ୍ଲପି', regex: false },
  { key: 'format', value: 'ଫର୍ମାଟ', regex: false },
  { key: 'friday', value: 'ଶୁକ୍ରବାର', regex: false },
  { key: 'futbal', value: 'ଫୁଟବଲ୍', regex: false },
  { key: 'gabakhya', value: 'ଗବାକ୍ଷ', regex: false },
  { key: 'gabesana', value: 'ଗବେଷଣା', regex: false },
  { key: 'gabhir', value: 'ଗଭୀର', regex: false },
  { key: 'gacha', value: 'ଗଛ', regex: false },
  { key: 'gadania', value: 'ଗଡ଼ାଣିଆ', regex: false },
  { key: 'gadanti', value: 'ଗଡ଼ନ୍ତି', regex: false },
  { key: 'rabilu', value: 'ରାବିଲୁ', regex: false },
  { key: 'rabu', value: 'ରାବୁ', regex: false },
  { key: 'rachana', value: 'ରଚନା', regex: false },
  { key: 'rahasya', value: 'ରହସ୍ୟ', regex: false },
  { key: 'raikia', value: 'ରାଇକିଆ', regex: false },
  { key: 'rajani', value: 'ରଜନୀ', regex: false },
  { key: 'rakha', value: 'ରଖ', regex: false },
  { key: 'rakhantu', value: 'ରଖନ୍ତୁ', regex: false },
  { key: 'rakhib', value: 'ରଖିବ', regex: false },
  { key: 'rakhichi', value: 'ରଖିଛି', regex: false },
  { key: 'rakta', value: 'ରକ୍ତ', regex: false },
  { key: 'rambha', value: 'ରମ୍ଭା', regex: false },
  { key: 'ranga', value: 'ରଙ୍ଗ', regex: false },
  { key: 'rasi', value: 'ରାଶି', regex: false },
  { key: 'rastradrohi', value: 'ରାଷ୍ଟ୍ରଦ୍ରୋହୀ', regex: false },
  { key: 'ratire', value: 'ରାତିରେ', regex: false },
  { key: 'ratna', value: 'ରତ୍ନ', regex: false },
  { key: 'ratraakle', value: 'ରାତ୍ରିକାଳେ', regex: false },
  { key: 'rebati', value: 'ରେବତୀ', regex: false },
  { key: 'registrar', value: 'ରେଜିଷ୍ଟ୍ରାର', regex: false },
  { key: 'rekard', value: 'ରେକର୍ଡ', regex: false },
  { key: 'rekha', value: 'ରେଖା', regex: false },
  { key: 'renu', value: 'ରେଣୁ', regex: false },
  { key: 'report', value: 'ରିପୋର୍ଟ', regex: false },
  { key: 'riksa', value: 'ରିକ୍ସା', regex: false },
  { key: 'riti', value: 'ରୀତି', regex: false },
  { key: 'road', value: 'ରୋଡ୍', regex: false },
  { key: 'roga', value: 'ରୋଗ', regex: false },
  { key: 'rokha', value: 'ରଖ', regex: false },
  { key: 'lochha', value: 'ଲଚ୍ଛା', regex: false },
  { key: 'logao', value: 'ଲଗାଅ', regex: false },
  { key: 'loka', value: 'ଲୋକ', regex: false },
  { key: 'lokanka', value: 'ଲୋକଙ୍କ', regex: false },
  { key: 'loke', value: 'ଲୋକେ', regex: false },
  { key: 'lokmane', value: 'ଲୋକମାନେ', regex: false },
  { key: 'luchakali', value: 'ଲୁଚକାଳି', regex: false },
  { key: 'luha', value: 'ଲୁହା', regex: false },
  { key: 'luni', value: 'ଲୁଣୀ', regex: false },
  { key: 'lunthan', value: 'ଲୁଣ୍ଠନ', regex: false },
  { key: 'macha', value: 'ମାଛ', regex: false },
  { key: 'machala', value: 'କାମଚଳା', regex: false },
  { key: 'mada', value: 'ମାଡ଼ା', regex: false },
  { key: 'madhukare', value: 'ମଧୁକରେ', regex: false },
  { key: 'madhyahn', value: 'ମଧ୍ୟାହ୍ନ', regex: false },
  { key: 'madhyam', value: 'ମାଧ୍ୟମ', regex: false },
  { key: 'mado', value: 'ମାଡ଼', regex: false },
  { key: 'madya', value: 'ମଧ୍ୟ', regex: false },
  { key: 'magana', value: 'ମାଗଣା', regex: false },
  { key: 'magha', value: 'ମାଘ', regex: false },
  { key: 'mahasaya', value: 'ମହାଶୟ', regex: false },
  { key: 'mahatwa', value: 'ମହତ୍ତ୍ୱ', regex: false },
  { key: 'mahavidyalaya', value: 'ମହାବିଦ୍ୟାଳୟ', regex: false },
  { key: 'mahila', value: 'ମହିଳା', regex: false },
  { key: 'mahima', value: 'ମହିମା', regex: false },
  { key: 'mahis', value: 'ମହିଷ', regex: false },
  { key: 'jillapala', value: 'ଜିଲ୍ଲାପାଳ', regex: false },
  { key: 'mhodaya', value: 'ମହୋଦୟ', regex: false },
  { key: 'mail', value: 'ମେଲ୍', regex: false },
  { key: 'santona', value: 'ସାନ୍ତ୍ୱନା', regex: false },
  { key: 'santosh', value: 'ସନ୍ତୋଷ', regex: false },
  { key: 'santwana', value: 'ସାନ୍ତ୍ୱନା', regex: false },
  { key: 'sapakhya', value: 'ସପକ୍ଷ', regex: false },
  { key: 'saptaha', value: 'ସପ୍ତାହ', regex: false },
  { key: 'saptahika', value: 'ସାପ୍ତାହିକ', regex: false },
  { key: 'saptam', value: 'ସପ୍ତମ', regex: false },
  { key: 'saptama', value: 'ସପ୍ତମା', regex: false },
  { key: 'saptami', value: 'ସପ୍ତମୀ', regex: false },
  { key: 'sarakar', value: 'ସରକାର', regex: false },
  { key: 'sarapanch', value: 'ସରପଞ୍ଚ', regex: false },
  { key: 'sarba', value: 'ସର୍ବ', regex: false },
  { key: 'sarbada', value: 'ସର୍ବଦା', regex: false },
  { key: 'sarbajanin', value: 'ସାର୍ବଜନୀନ', regex: false },
  { key: 'sarbanama', value: 'ସର୍ବନାମ', regex: false },
  { key: 'sarbashaktiman', value: 'ସର୍ବଶକ୍ତିମାନ', regex: false },
  { key: 'sarbe', value: 'ସର୍ବେ', regex: false },
  { key: 'sarbnama', value: 'ସର୍ବନାମ', regex: false },
  { key: 'sarbotam', value: 'ସର୍ବୋତ୍ତମ', regex: false },
  { key: 'sarile', value: 'ସାରିଲେ', regex: false },
  { key: 'sarobare', value: 'ସରୋବରେ', regex: false },
  { key: 'sartabali', value: 'ସର୍ତ୍ତାବଳୀ', regex: false },
  { key: 'sastha', value: 'ଷଷ୍ଠ', regex: false },
  { key: 'sastra', value: 'ଶାସ୍ତ୍ର', regex: false },
  { key: 'saturday', value: 'ଶନିବାର', regex: false },
  { key: 'satyabani', value: 'ସତ୍ୟବାଣୀ', regex: false },
  { key: 'sbukichhi', value: 'ସବୁକିଛିକୁ', regex: false },
  { key: 'school', value: 'ସ୍କୁଲ', regex: false },
  { key: 'science', value: 'ସାଇନ୍ସ', regex: false },
  { key: 'secretary', value: 'ସେକ୍ରେଟାରୀ', regex: false },
  { key: 'seema', value: 'ସୀମା', regex: false },
  { key: 'sehi', value: 'ସେହି', regex: false },
  { key: 'manonka', value: 'ମାନଙ୍କ', regex: false },
  { key: 'tank', value: 'ତାଙ୍କ', regex: false },
  { key: 'tanku', value: 'ତାଙ୍କୁ', regex: false },
  { key: 'dakile', value: 'ଡାକିଲେ', regex: false },
  { key: 'bolli', value: 'ବୋଲି', regex: false },
  { key: 'ahimsa', value: 'ଅହିଁସା', regex: false },
  { key: 'balaka', value: 'ବାଳକ', regex: false },
  { key: 'balika', value: 'ବାଳିକା', regex: false },
  { key: 'arthat', value: 'ଅର୍ଥାତ୍', regex: false },
  { key: 'trano', value: 'ତ୍ରାଣ', regex: false },
  { key: 'pori', value: 'ପରି', regex: false },
  { key: 'kupori', value: ' କୁପରି', regex: false },  
  { key: 'semicolon', value: 'ସେମିକୋଲନ୍', regex: false },
  { key: 'aila', value: 'ଆଇଲା', regex: false },
  { key: 'usha', value: 'ଉଷା', regex: false },
  { key: 'bikat', value: 'ବିକାଟ', regex: false },
  { key: 'sepakha', value: 'ସେପାଖ', regex: false },
  { key: 'sepori', value: 'ସେପରି', regex: false },
  { key: 'jepori', value: 'ଯେପରି', regex: false },
  { key: 'sephali', value: 'ଶେଫାଳୀ', regex: false },
  { key: 'september', value: 'ସେପ୍ଟେମ୍ବର', regex: false },
  { key: 'sesh', value: 'ଶେଷ', regex: false },
  { key: 'sethare', value: 'ସେଠାରେ', regex: false },
  { key: 'setu', value: 'ସେତୁ', regex: false },
  { key: 'shakti', value: 'ଶକ୍ତି', regex: false },
  { key: 'shalana', value: 'ସ୍ଖଳନ', regex: false },
  { key: 'shanti', value: 'ଶାନ୍ତି', regex: false },
  { key: 'shashra', value: 'ସହସ୍ର', regex: false },
  { key: 'shlesa', value: 'ଶ୍ଲେଷ', regex: false },
  { key: 'shraban', value: 'ଶ୍ରାବଣ', regex: false },
  { key: 'shri', value: 'ଶ୍ରୀ', regex: false },
  { key: 'shrijukta', value: 'ଶ୍ରୀଯୁକ୍ତ', regex: false },
  { key: 'shrimati', value: 'ଶ୍ରୀମତୀ', regex: false },
  { key: 'siddhi', value: 'ସିଦ୍ଧି', regex: false },
  { key: 'sidhasalakha', value: 'ସିଧାସଳଖ', regex: false },
  { key: 'sulo', value: 'ଶୂଳ', regex: false },
  { key: 'suna', value: 'ସୁନା', regex: false },
  { key: 'sunday', value: 'ରବିବାର', regex: false },
  { key: 'sukrabara', value: 'ଶୁକ୍ରବାର', regex: false },
  { key: 'bara', value: 'ବାର', regex: false },
  { key: 'somabara', value: 'ସୋମବାର', regex: false },
  { key: 'mangalbara', value: 'ମଙ୍ଗଳବାର', regex: false },
  { key: 'gurubara', value: 'ଗୁରୁବାର', regex: false },
  { key: 'sanibara', value: 'ଶନିବାର', regex: false },
  { key: 'rabibara', value: 'ରବିବାର', regex: false },
  { key: 'church', value: 'ଚର୍ଚ୍ଚ', regex: false },
  { key: 'sundha', value: 'ଶୁଣ୍ଢ', regex: false },
  { key: 'dia', value: 'ଦିଆ', regex: false },
  { key: 'sunithibe', value: 'ଶୁଣିଥିବେ', regex: false },
  { key: 'suno', value: 'ଶୁଣ', regex: false },
  { key: 'suparish', value: 'ସୁପାରିଶ', regex: false },
  { key: 'susamachara', value: 'ସୁସମାଗ୍ଭର', regex: false },
  { key: 'sushitala', value: 'ସୁଶୀତଳ', regex: false },
  { key: 'suska', value: 'ଶୁଷ୍କ', regex: false },
  { key: 'suskata', value: 'ଶୁଷ୍କତା', regex: false },
  { key: 'sustha', value: 'ସୁସ୍ଥ', regex: false },
  { key: 'suta', value: 'ସୂତା', regex: false },
  { key: 'swabhab', value: 'ସ୍ୱଭାବ', regex: false },
  { key: 'swacha', value: 'ସ୍ଵଛ', regex: false },
  { key: 'swami', value: 'ସ୍ୱାମୀ', regex: false },
  { key: 'swapna', value: 'ସ୍ୱପ୍ନା', regex: false },
  { key: 'sworo', value: 'ସ୍ୱର', regex: false },
  { key: 'swaraj', value: 'ସ୍ୱରାଜ', regex: false },
  { key: 'thire', value: 'ଥିରେ', regex: false },
  { key: 'jhati', value: 'ଝାଟି', regex: false },
    { key: 'dina', value: 'ଦିନ', regex: false },
  { key: 'puraskara', value: 'ପୁରଷ୍କାର', regex: false },
  { key: 'tiraskara', value: 'ତିରଷ୍କାର', regex: false },
  { key: 'champa', value: 'ଚମ୍ପା', regex: false },
  { key: 'jie', value: 'ଯିଏ', regex: false },
  { key: 'pani', value: 'ପାଣି', regex: false },
  { key: 'jigyansu', value: 'ଜିଜ୍ଞାସୁ', regex: false },
  { key: 'jihwa', value: 'ଜିହ୍ୱା', regex: false },
  { key: 'niyojita', value: 'ନିୟୋଜିତ', regex: false },
  { key: 'jodie', value: 'ଯୋଡ଼ିଏ', regex: false },
  { key: 'jodio', value: 'ଯଦିଓ', regex: false },
  { key: 'jogajoga', value: 'ଯୋଗଯୋଗ', regex: false },
  { key: 'jogauchhi', value: 'ଯୋଗାଉଛି', regex: false },
  { key: 'jogai', value: 'ଯୋଗାଇ', regex: false },
  { key: 'jogya', value: 'ଯଜ୍ଞ', regex: false },
  { key: 'jojana', value: 'ଯୋଜନା', regex: false },
  { key: 'jona', value: 'ଜଣ', regex: false },
  { key: 'joubana', value: 'ଯୌବନ', regex: false },
  { key: 'jparjanta', value: 'ଯେପର୍ଯ୍ୟନ୍ତ', regex: false },
  { key: 'judha', value: 'ଯୁଦ୍ଧ', regex: false },
  { key: 'jugare', value: 'ଯୁଗରେ', regex: false },
  { key: 'juge', value: 'ଯୁଗେ', regex: false },
  { key: 'juiphula', value: 'ଯୂଈଫୁଲ', regex: false },
  { key: 'jukta', value: 'ଯୁକ୍ତ', regex: false },
  { key: 'july', value: 'ଜୁଲାଇ', regex: false },
  { key: 'june', value: 'ଜୁନ୍', regex: false },
  { key: 'tejo', value: 'ତେଜ', regex: false },
  { key: 'thae', value: 'ଥାଏ', regex: false },
  { key: 'thant', value: 'ଥାନ୍ତ', regex: false },
    { key: 'thare', value: 'ଠାରେ', regex: false },
  { key: 'thib', value: 'ଥିବ', regex: false },
    { key: 'chitobinodana', value: 'ଚିତ୍ତବିନୋଦନ', regex: false },
  { key: 'thoi', value: 'ଥୋଇ', regex: false },
  { key: 'thonta', value: 'ଥଣ୍ଟ', regex: false },
  { key: 'thore', value: 'ଥରେ', regex: false },
  { key: 'thursday', value: 'ଗୁରୁବାର', regex: false },
  //{ key: 'ti', value: 'ଟି', regex: false },
  { key: 'tiangia', value: 'ଟିଆଙ୍ଗିଆ', regex: false },
  { key: 'tikhma', value: 'ତୀକ୍ଷ୍ମ', regex: false },
  { key: 'tikie', value: 'ଟିକିଏ', regex: false },
  { key: 'tippani', value: 'ଟିପ୍ପଣୀ', regex: false },
  { key: 'tiraskar', value: 'ତିରସ୍କାର', regex: false },
  { key: 'tire', value: 'ତୀରେ', regex: false },
  { key: 'tiro', value: 'ତୀର', regex: false },
  { key: 'tonka', value: 'ଟଙ୍କା', regex: false },
  { key: 'tote', value: 'ତୋତେ', regex: false },
  { key: 'truna', value: 'ତୃଣ', regex: false },
  { key: 'trusa', value: 'ତୃଷା', regex: false },
  { key: 'truti', value: 'ତ୍ରୁଟି', regex: false },
  { key: 'trutiya', value: 'ତୃତୀୟ', regex: false },
  { key: 'tharu', value: 'ଠାରୁ', regex: false },
  { key: 'tatpar', value: 'ତତ୍ପର', regex: false },
    { key: 'jutho', value: 'ଯୂଥ', regex: false },
  { key: 'jwala', value: 'ଜ୍ୱାଲା', regex: false },
  { key: 'jwara', value: 'ଜ୍ୱର', regex: false },
  { key: 'jyestho', value: 'ଜୈଷ୍ଠ', regex: false },
  { key: 'kaale', value: 'କାଳେ', regex: false },
  { key: 'kabach', value: 'କବଚ', regex: false },
  { key: 'kabar', value: 'କବର', regex: false },
  { key: 'kabat', value: 'କବାଟ', regex: false },
  { key: 'coverage', value: 'କଭରେଜ୍', regex: false },
  { key: 'kabita', value: 'କବିତା', regex: false },
  { key: 'patho', value: 'ପାଠ', regex: false },
  { key: 'podh', value: 'ପଢ଼', regex: false },
  { key: 'kacha', value: 'କଚ୍ଚା', regex: false },
  { key: 'kach', value: 'କାଚ', regex: false },
  //{ key: 'kachadi', value: 'କଗ୍ଭଡ଼ି', regex: false },
  //{ key: 'kachadiba', value: 'କଗ୍ଭଡ଼ିବା', regex: false },
  { key: 'kadachar', value: 'କଦାଗ୍ଭର', regex: false },
  { key: 'kadachit', value: 'କଦାଚିତ', regex: false },
  { key: 'kadambini', value: 'କାଦମ୍ବିନୀ', regex: false },
  { key: 'kadarjya', value: 'କଦର୍ଯ୍ୟ', regex: false },
  { key: 'kadh', value: 'କାଢ଼', regex: false },
  { key: 'kadhineba', value: 'କାଢ଼ିନେବା', regex: false },
  { key: 'kodh', value: 'କଢ଼', regex: false },
  { key: 'kagaj', value: 'କାଗଜ', regex: false },
  { key: 'kahaku', value: 'କାହାକୁ', regex: false },
  { key: 'kahali', value: 'କାହାଳୀ', regex: false },
  { key: 'kahant', value: 'କହନ୍ତ', regex: false },
  { key: 'koha', value: 'କୋହ', regex: false },
  { key: 'mondo', value: 'ମନ୍ଦ', regex: false },  
  { key: 'kahar', value: 'କାହାର', regex: false },
  { key: 'kahib', value: 'କହିବ', regex: false },
  { key: 'kahun', value: 'କହୁନ', regex: false },
  { key: 'maha', value: 'ମହା', regex: false },
  { key: 'nadi', value: 'ନଦୀ', regex: false },
  { key: 'atita', value: 'ଅତୀତ', regex: false },
  { key: 'moto', value: 'ମତ', regex: false },
  { key: 'mantabya', value: 'ମନ୍ତବ୍ୟ', regex: false },
  { key: 'nabina', value: 'ନବୀନ', regex: false },
  { key: 'chatisgada', value: 'ଛତିଶଗଡ଼', regex: false },
  { key: 'aposa', value: 'ଆପୋସ', regex: false },
  { key: 'aino', value: 'ଆଇନ', regex: false },
  { key: 'tribunal', value: 'ଟ୍ରାଇବୁନାଲ', regex: false },
  { key: 'dhari', value: 'ଧାରି', regex: false },
  { key: 'baithaka', value: 'ବୈଠକ', regex: false },
  { key: 'ahuri', value: 'ଆହୁରି', regex: false },
  { key: 'anekabara', value: 'ଅନେକବାର', regex: false },
  { key: 'ashonka', value: ' ଆଶଙ୍କ ', regex: false },
  { key: 'rahichhi', value: 'ରହିଛି', regex: false },
  { key: 'hathat', value: 'ହଠାତ', regex: false },
  { key: 'bharatiya', value: 'ଭାରତୀୟ', regex: false },
  { key: 'bhara', value: 'ଭାର', regex: false },
  { key: 'tiya', value: 'ତୀୟ', regex: false },
  { key: 'chahni', value: 'ଚାହିଁ', regex: false },
  { key: 'chahnu', value: 'ଚାହୁଁ', regex: false },
  { key: 'hon', value: 'ହଁ', regex: false },  
  { key: 'tuesday', value: 'ମଙ୍ଗଳବାର', regex: false },
  { key: 'tumamananka', value: 'ତୁମମାନଙ୍କ', regex: false },
  { key: 'tumanku', value: 'ତୁମଙ୍କୁ', regex: false },
  { key: 'tumar', value: 'ତୁମର', regex: false },
  { key: 'tumari', value: 'ତୁମରି', regex: false },
  { key: 'tumbha', value: 'ତୁମ୍ଭ', regex: false },
  { key: 'tumbhamanank', value: 'ତୁମ୍ଭମାନଙ୍କ', regex: false },
  { key: 'tume', value: 'ତୁମେ', regex: false },
  { key: 'twacha', value: 'ତ୍ୱଚା', regex: false },
  { key: 'twaja', value: 'ତ୍ୱଜା', regex: false },
  { key: 'type', value: 'ଟାଇପ', regex: false },
  { key: 'ubhaya', value: 'ଉଭୟ', regex: false },
  { key: 'uccha', value: 'ଉଚ୍ଚା', regex: false },
  { key: 'ucharana', value: 'ଉଚ୍ଚାରଣ', regex: false },
  { key: 'ucho', value: 'ଉଚ୍ଚ', regex: false },
  { key: 'uchokara', value: 'ଉଚ୍ଚକର', regex: false },
  { key: 'udaharana', value: 'ଉଦାହରଣ', regex: false },
  { key: 'udana', value: 'ଉଡ଼ାଣ', regex: false },
  { key: 'udbhaba', value: 'ଉଦ୍ଭବ', regex: false },
  { key: 'uddan', value: 'ଉଡ୍ଡନ', regex: false },
  { key: 'uddes', value: 'ଉଦ୍ଦେଶ', regex: false },
  { key: 'uddesya', value: 'ଉଦ୍ଦେଶ୍ୟ', regex: false },
  { key: 'uddhab', value: 'ଉଦ୍ଧବ', regex: false },
  { key: 'uddhesya', value: 'ଉଦ୍ଦେଶ୍ୟ', regex: false },
  { key: 'uddiyaman', value: 'ଉଡ୍ଡୀୟମାନ', regex: false },
  { key: 'udi', value: 'ଉଡ଼ି', regex: false },
  { key: 'pahanchila', value: 'ପହଞ୍ଚିଲା', regex: false },
  { key: 'ghara', value: 'ଘର', regex: false },
  { key: 'udjogi', value: 'ଉଦଯୋଗୀ', regex: false },
  { key: 'udyag', value: 'ଉଦ୍ୟୋଗ', regex: false },
  { key: 'ujwal', value: 'ଉଜ୍ଜ୍ୱଳ', regex: false },
  { key: 'ujwala', value: 'ଉଜ୍ଜ୍ୱଳ', regex: false },
  { key: 'ulanghana', value: 'ଉଲ୍ଲଂଘନ', regex: false },
  { key: 'ulla', value: 'ଉଲ୍ଲା', regex: false },
  { key: 'ullas', value: 'ଉଲ୍ଲାସ', regex: false },
  { key: 'ullekha', value: 'ଉଲ୍ଲେଖ', regex: false },
  { key: 'unnayana', value: 'ଉନ୍ନୟନ', regex: false },
  { key: 'unadhika', value: 'ଉଣାଧିକ', regex: false },
  { key: 'unmad', value: 'ଉନ୍ମାଦ', regex: false },
  { key: 'unnati', value: 'ଉନ୍ନତ', regex: false },
  { key: 'upadana', value: 'ଉପାଦାନ', regex: false },
  { key: 'upadesh', value: 'ଉପଦେଶ', regex: false },
  { key: 'upajogi', value: 'ଉପଯୋଗୀ', regex: false },
  { key: 'upajukta', value: 'ଉପଯୁକ୍ତ', regex: false },
  { key: 'upakaran', value: 'ଉପକରଣ', regex: false },
  { key: 'upanirdesaka', value: 'ଉପନିର୍ଦ୍ଦେଶକ', regex: false },
  { key: 'upare', value: 'ଉପରେ', regex: false },  
  { key: 'dolajatra', value: 'ଦୋଳଯାତ୍ରା', regex: false },
  { key: 'dosho', value: ' ଦୋଷ', regex: false },
  { key: 'download', value: 'ଡାଉନଲୋଡ୍ ', regex: false },
  { key: 'drudha', value: ' ଦୃଢ଼', regex: false },
  { key: 'drustikona', value: 'ଦୃଷ୍ଟିକୋଣ', regex: false },
  { key: 'druta', value: 'ଦ୍ରୁତ ', regex: false },
  { key: 'drusti', value: 'ଦୃଷ୍ଟି', regex: false },
  { key: 'duba', value: 'ଦୂବ', regex: false },
  { key: 'ghasa', value: 'ଘାସ', regex: false },
  { key: 'dudha', value: 'ଦୁଧ', regex: false },  
  { key: 'dugdha', value: 'ଦୁଗ୍ଧ', regex: false },
    { key: 'pana', value: 'ପାନ', regex: false },
  { key: 'duhen', value: 'ଦୁହେଁ', regex: false },
  { key: 'dukhi', value: 'ଦୁଃଖୀ', regex: false },
  { key: 'dukhit', value: 'ଦୁଃଖୀତ', regex: false },
  { key: 'dusahas', value: 'ଦୁଃସାହସ', regex: false },
  { key: 'dukh', value: 'ଦୁଃଖ', regex: false },   
  { key: 'labh', value: 'ଲାଭ', regex: false },
  { key: 'dayak', value: 'ଦାୟକ', regex: false },  
  { key: 'lagna', value: 'ଲଗ୍ନ', regex: false },
  { key: 'lajja', value: 'ଲଜ୍ଜା', regex: false },
  { key: 'lojya', value: 'ଲଜ୍ଜା', regex: false },
  { key: 'gidrimala', value: 'ଗିଡ୍ରିମାଲା', regex: false },
  { key: 'nidhiapalli', value: 'ନିଧିଆପଲ୍ଲୀ', regex: false },
  { key: 'kendujhar', value: 'କେନ୍ଦୁଝର', regex: false },
  { key: 'kendrapara', value: 'କେନ୍ଦ୍ରାପଡ଼ା', regex: false },
  { key: 'khordha', value: 'ଖୋର୍ଦ୍ଧା', regex: false },
  { key: 'dhenkanal', value: 'ଢ଼େଙ୍କାନାଳ', regex: false },
  { key: 'anugul', value: 'ଅନୁଗୋଳ', regex: false },
  { key: 'lakhy', value: 'ଲକ୍ଷ୍ୟ', regex: false },
  { key: 'lakhyan', value: 'ଲକ୍ଷଣ', regex: false },
  { key: 'lakshman', value: 'ଲକ୍ଷ୍ମଣ', regex: false },
  { key: 'lakshmi', value: 'ଲକ୍ଷ୍ମୀ', regex: false },
  { key: 'lamungia', value: 'ଲାମୁଙ୍ଗିଆ', regex: false },
  { key: 'longol', value: 'ଲଙ୍ଗଳ', regex: false },
  { key: 'shrunkhal', value: 'ଶୃଙ୍ଖଳ', regex: false },
  { key: 'aishwarik', value: 'ଐଶ୍ବରିକ', regex: false },
  { key: 'kalindhi', value: 'କାଳିନ୍ଧୀ', regex: false },
  { key: 'kimpa', value: 'କିମ୍ପା', regex: false },
  { key: 'langhai', value: 'ଲଙ୍ଘଇ', regex: false },
  { key: 'langhan', value: 'ଲଙ୍ଘନ', regex: false },
  { key: 'langhi', value: 'ଲଙ୍ଘି', regex: false },
  { key: 'language', value: 'ଲାଙ୍ଗୁଏଜ୍', regex: false },
  { key: 'lata', value: 'ଲତା', regex: false },
  { key: 'lekh', value: 'ଲେଖ', regex: false },
  { key: 'lekhoka', value: 'ଲେଖକ', regex: false },
  { key: 'leso', value: 'ଲେଶ', regex: false },
  { key: 'linga', value: 'ଲିଙ୍ଗ', regex: false },
  { key: 'lippa', value: 'ଲିପ୍ପା', regex: false },
  { key: 'pathyapustak', value: 'ପାଠ୍ୟପୁସ୍ତକ', regex: false },
  { key: 'pathyo', value: 'ପାଠ୍ୟ', regex: false },
  { key: 'pathyokrama', value: 'ପାଠ୍ୟକ୍ରମ', regex: false },
  { key: 'patni', value: 'ପତ୍ନୀ', regex: false },
  { key: 'pattn', value: 'ପତ୍ତନ', regex: false },
  { key: 'input', value: 'ଇନପୁଟ', regex: false },
  { key: 'pauchi', value: 'ପାଉଛି', regex: false },
  { key: 'paunsa', value: 'ପାଉଁଶ', regex: false },
  { key: 'jauthib', value: 'ଯାଉଥିବ', regex: false },
  { key: 'pchha', value: 'ପାଚ୍ଛା', regex: false },
  { key: 'pecha', value: 'ପେଚା', regex: false },
  { key: 'pela', value: 'ପେଳ', regex: false },
  { key: 'peti', value: 'ପେଟି', regex: false },
  { key: 'phaguna', value: 'ଫଗୁଣ', regex: false },
  { key: 'phalguna', value: 'ଫାଲ୍ଗୁନ', regex: false },
  { key: 'pholak', value: 'ଫଳକ', regex: false },
  { key: 'photographer', value: 'ଫଟୋଗ୍ରାଫର', regex: false },
  { key: 'phoujadari', value: 'ଫୌଜଦାରୀ', regex: false },
  { key: 'phula', value: 'ଫୁଲ', regex: false },
  { key: 'phut', value: 'ଫୁଟ', regex: false },  
  { key: 'phutichi', value: 'ଫୁଟିଛି', regex: false },
  { key: 'pichha', value: 'ପିଛା', regex: false },
  { key: 'pida', value: 'ପୀଡ଼ା', regex: false },
  { key: 'pilamane', value: 'ପିଲାମାନେ', regex: false },
  { key: 'pin', value: 'ପିନ୍', regex: false },
  { key: 'pindhe', value: 'ପିନ୍ଧେ', regex: false },
  { key: 'pindhib', value: 'ପିନ୍ଧିବ', regex: false },
  { key: 'enatene', value: 'ଏଣେତେଣେ', regex: false },
  { key: 'engineer', value: 'ଇଞ୍ଜିନିୟରିଂ', regex: false },
  { key: 'engraji', value: 'ଇଂରାଜୀ', regex: false },
  { key: 'eniki', value: 'ଏଣିକି', regex: false },
  { key: 'enutenu', value: 'ଏଣୁତେଣୁ', regex: false },
  { key: 'epakh', value: 'ଏପାଖ', regex: false },
  { key: 'eparjyant', value: 'ଏପର୍ଯ୍ୟନ୍ତ', regex: false },
  { key: 'erundi', value: 'ଏରୁଣ୍ଡି', regex: false },
  { key: 'etadbhinn', value: 'ଏତଦଭିନ୍ନ', regex: false },
  { key: 'etadwara', value: 'ଏତଦ୍ୱାରା', regex: false },
  { key: 'etala', value: 'ଏତଲା', regex: false },
  { key: 'ethare', value: 'ଏଠାରେ', regex: false },
  { key: 'etharu', value: 'ଏଠାରୁ', regex: false },
  { key: 'ethiki', value: 'ଏଠିକି', regex: false },
  { key: 'ethire', value: 'ଏଥିରେ', regex: false },
  { key: 'ethiru', value: 'ଏଥିରୁ', regex: false },
  { key: 'etthare', value: 'ଏଠାରେ', regex: false },
  { key: 'february', value: 'ଫେବୃଆରୀ', regex: false },
  { key: 'flopi', value: 'ଫ୍ଲପି', regex: false },
  { key: 'format', value: 'ଫର୍ମାଟ', regex: false },
  { key: 'friday', value: 'ଶୁକ୍ରବାର', regex: false },
  { key: 'futbal', value: 'ଫୁଟବଲ୍', regex: false },
  { key: 'gabakhya', value: 'ଗବାକ୍ଷ', regex: false },
  { key: 'gabesana', value: 'ଗବେଷଣା', regex: false },
  { key: 'gabhir', value: 'ଗଭୀର', regex: false },
  { key: 'gacha', value: 'ଗଛ', regex: false },
  { key: 'gadania', value: 'ଗଡ଼ାଣିଆ', regex: false },
  { key: 'gadanti', value: 'ଗଡ଼ନ୍ତି', regex: false },
  { key: 'rabilu', value: 'ରାବିଲୁ', regex: false },
  { key: 'rabu', value: 'ରାବୁ', regex: false },
  { key: 'rachana', value: 'ରଚନା', regex: false },
  { key: 'rahasya', value: 'ରହସ୍ୟ', regex: false },
  { key: 'raikia', value: 'ରାଇକିଆ', regex: false },
  { key: 'rajani', value: 'ରଜନୀ', regex: false },
  { key: 'rakha', value: 'ରଖ', regex: false },
  { key: 'rakhantu', value: 'ରଖନ୍ତୁ', regex: false },
  { key: 'rakhiba', value: 'ରଖିବା', regex: false },
  { key: 'rakhichi', value: 'ରଖିଛି', regex: false },
  { key: 'rakta', value: 'ରକ୍ତ', regex: false },
  { key: 'rambha', value: 'ରମ୍ଭା', regex: false },
  { key: 'ranga', value: 'ରଙ୍ଗ', regex: false },
  { key: 'rasi', value: 'ରାଶି', regex: false },
  { key: 'rastradrohi', value: 'ରାଷ୍ଟ୍ରଦ୍ରୋହୀ', regex: false },
  { key: 'ratire', value: 'ରାତିରେ', regex: false },
  { key: 'ratna', value: 'ରତ୍ନ', regex: false },
  { key: 'ratra', value: 'ରାତ୍ରି', regex: false },
  { key: 'niti', value: 'ନିତି', regex: false },
  { key: 'niropekhya', value: 'ନିରପେକ୍ଷ', regex: false },
  { key: 'nirbhik', value: 'ନିର୍ଭୀକ', regex: false },
  { key: 'udbudho', value: 'ଉଦବୁଦ୍ଧ', regex: false },
  { key: 'punkhanupunkh', value: 'ପୁଙ୍ଖାନୁପୁଙ୍ଖ', regex: false },
  { key: 'sambidhan', value: 'ସମ୍ବିଧାନ', regex: false },
  { key: 'sambit', value: 'ସମ୍ବିତ', regex: false },
  { key: 'rebati', value: 'ରେବତୀ', regex: false },
  { key: 'registrar', value: 'ରେଜିଷ୍ଟ୍ରାର', regex: false },
  { key: 'rekha', value: 'ରେଖା', regex: false },
  { key: 'renu', value: 'ରେଣୁ', regex: false },
  { key: 'report', value: 'ରିପୋର୍ଟ', regex: false },
  { key: 'riksa', value: 'ରିକ୍ସା', regex: false },
  { key: 'riti', value: 'ରୀତି', regex: false },
  { key: 'road', value: 'ରୋଡ୍', regex: false },
  { key: 'roga', value: 'ରୋଗ', regex: false },
  { key: 'rokha', value: 'ରଖ', regex: false },
  { key: 'lochha', value: 'ଲଚ୍ଛା', regex: false },
  { key: 'logao', value: 'ଲଗାଅ', regex: false },
  { key: 'loka', value: 'ଲୋକ', regex: false },
  { key: 'lokanka', value: 'ଲୋକଙ୍କ', regex: false },
  { key: 'loke', value: 'ଲୋକେ', regex: false },
  { key: 'lokmane', value: 'ଲୋକମାନେ', regex: false },
  { key: 'luchakali', value: 'ଲୁଚକାଳି', regex: false },
  { key: 'luha', value: 'ଲୁହା', regex: false },
  { key: 'luni', value: 'ଲୁଣୀ', regex: false },
  { key: 'lunthan', value: 'ଲୁଣ୍ଠନ', regex: false },
  { key: 'macha', value: 'ମାଛ', regex: false },
  { key: 'machala', value: 'କାମଚଳା', regex: false },
  { key: 'mada', value: 'ମାଡ଼ା', regex: false },
  { key: 'madhyam', value: 'ମାଧ୍ୟମ', regex: false },
  { key: 'mado', value: 'ମାଡ଼', regex: false },
  { key: 'magana', value: 'ମାଗଣା', regex: false },
  { key: 'magha', value: 'ମାଘ', regex: false },
  { key: 'mahasaya', value: 'ମହାଶୟ', regex: false },
  { key: 'mahatwa', value: 'ମହତ୍ତ୍ୱ', regex: false },
  { key: 'mahavidyalaya', value: 'ମହାବିଦ୍ୟାଳୟ', regex: false },
  { key: 'mahila', value: 'ମହିଳା', regex: false },
  { key: 'mahima', value: 'ମହିମା', regex: false },
  { key: 'mahis', value: 'ମହିଷ', regex: false },
  { key: 'jillapala', value: 'ଜିଲ୍ଲାପାଳ', regex: false },
  { key: 'mhodaya', value: 'ମହୋଦୟ', regex: false },
  { key: 'mail', value: 'ମେଲ୍', regex: false },
  { key: 'santona', value: 'ସାନ୍ତ୍ୱନା', regex: false },
  { key: 'santosh', value: 'ସନ୍ତୋଷ', regex: false },
  { key: 'santwana', value: 'ସାନ୍ତ୍ୱନା', regex: false },
  { key: 'sapakhya', value: 'ସପକ୍ଷ', regex: false },
  { key: 'saptaha', value: 'ସପ୍ତାହ', regex: false },
  { key: 'saptahika', value: 'ସାପ୍ତାହିକ', regex: false },
  { key: 'saptama', value: 'ସପ୍ତମ', regex: false },
  { key: 'saptami', value: 'ସପ୍ତମୀ', regex: false },
  { key: 'sarakar', value: 'ସରକାର', regex: false },
  { key: 'saransh', value: 'ସାରାଂଶ', regex: false },
  { key: 'sarapanch', value: 'ସରପଞ୍ଚ', regex: false },
  { key: 'sarba', value: 'ସର୍ବ', regex: false },
  { key: 'sarbada', value: 'ସର୍ବଦା', regex: false },
  { key: 'sarbajanin', value: 'ସାର୍ବଜନୀନ', regex: false },
  { key: 'sarbanama', value: 'ସର୍ବନାମ', regex: false },
  { key: 'shaktiman', value: 'ଶକ୍ତିମାନ', regex: false },
  { key: 'sarbe', value: 'ସର୍ବେ', regex: false },
  { key: 'sarbnama', value: 'ସର୍ବନାମ', regex: false },
  { key: 'sarbotam', value: 'ସର୍ବୋତ୍ତମ', regex: false },
  { key: 'sarile', value: 'ସାରିଲେ', regex: false },
  { key: 'sarobare', value: 'ସରୋବରେ', regex: false },
  { key: 'sartabali', value: 'ସର୍ତ୍ତାବଳୀ', regex: false },
  { key: 'sastho', value: 'ଷଷ୍ଠ', regex: false },
  { key: 'sastra', value: 'ଶାସ୍ତ୍ର', regex: false },
  { key: 'saturday', value: 'ଶନିବାର', regex: false },
  { key: 'satyabani', value: 'ସତ୍ୟବାଣୀ', regex: false },
  { key: 'sbukichhi', value: 'ସବୁକିଛିକୁ', regex: false },
  { key: 'school', value: 'ସ୍କୁଲ', regex: false },
  { key: 'science', value: 'ସାଇନ୍ସ', regex: false },
  { key: 'secretary', value: 'ସେକ୍ରେଟାରୀ', regex: false },
  { key: 'seema', value: 'ସୀମା', regex: false },
  { key: 'sehi', value: 'ସେହି', regex: false },
  { key: 'semananka', value: 'ସେମାନଙ୍କ', regex: false },
  { key: 'semicolon', value: 'ସେମିକୋଲନ୍', regex: false },
  { key: 'sepakha', value: 'ସେପାଖ', regex: false },
  //{ key: 'separi', value: 'ସେପରି', regex: false },
  { key: 'sephali', value: 'ଶେଫାଳୀ', regex: false },
  { key: 'sesh', value: 'ଶେଷ', regex: false },
  { key: 'sethare', value: 'ସେଠାରେ', regex: false },
  { key: 'setu', value: 'ସେତୁ', regex: false },
  { key: 'shakti', value: 'ଶକ୍ତି', regex: false },
  { key: 'skhalana', value: 'ସ୍ଖଳନ', regex: false },
  { key: 'shanti', value: 'ଶାନ୍ତି', regex: false },
  { key: 'sahashra', value: 'ସହସ୍ର', regex: false },
  { key: 'slesho', value: 'ଶ୍ଲେଷ', regex: false },
  { key: 'shraban', value: 'ଶ୍ରାବଣ', regex: false },
  { key: 'shri', value: 'ଶ୍ରୀ', regex: false },
  { key: 'shrijukta', value: 'ଶ୍ରୀଯୁକ୍ତ', regex: false },
  { key: 'shrimati', value: 'ଶ୍ରୀମତୀ', regex: false },
  { key: 'siddhi', value: 'ସିଦ୍ଧି', regex: false },
  { key: 'sidha', value: 'ସିଧା', regex: false },
  { key: 'salakha', value: 'ସଳଖ', regex: false },
  { key: 'sulo', value: 'ଶୂଳ', regex: false },
  { key: 'suna', value: 'ସୁନା', regex: false },
  { key: 'sunday', value: 'ରବିବାର', regex: false },
  { key: 'sukrabara', value: 'ଶୁକ୍ରବାର', regex: false },
  { key: 'bara', value: 'ବାର', regex: false },
  { key: 'somabara', value: 'ସୋମବାର', regex: false },
  { key: 'mangalbara', value: 'ମଙ୍ଗଳବାର', regex: false },
  { key: 'gurubara', value: 'ଗୁରୁବାର', regex: false },
  { key: 'sanibara', value: 'ଶନିବାର', regex: false },
  { key: 'rabibara', value: 'ରବିବାର', regex: false },
  { key: 'church', value: 'ଚର୍ଚ୍ଚ', regex: false },
  { key: 'sundha', value: 'ଶୁଣ୍ଢ', regex: false },
  { key: 'dia', value: 'ଦିଆ', regex: false },
  { key: 'sunithibe', value: 'ଶୁଣିଥିବେ', regex: false },
  { key: 'suno', value: 'ଶୁଣ', regex: false },
  { key: 'suparish', value: 'ସୁପାରିଶ', regex: false },
  { key: 'susamachara', value: 'ସୁସମାଗ୍ଭର', regex: false },
  { key: 'sushitala', value: 'ସୁଶୀତଳ', regex: false },
  { key: 'suska', value: 'ଶୁଷ୍କ', regex: false },
  { key: 'suskata', value: 'ଶୁଷ୍କତା', regex: false },
  { key: 'sustha', value: 'ସୁସ୍ଥ', regex: false },
  { key: 'suta', value: 'ସୂତା', regex: false },
  { key: 'swabhab', value: 'ସ୍ୱଭାବ', regex: false },
  { key: 'swacha', value: 'ସ୍ଵଛ', regex: false },
  { key: 'swami', value: 'ସ୍ୱାମୀ', regex: false },
  { key: 'swapna', value: 'ସ୍ୱପ୍ନା', regex: false },
  { key: 'swar', value: 'ସ୍ୱର', regex: false },
  { key: 'swaraj', value: 'ସ୍ୱରାଜ', regex: false },
  { key: 'thare', value: 'ଠାରେ', regex: false },
  { key: 'thire', value: 'ଥିରେ', regex: false },
  { key: 'jhati', value: 'ଝାଟି', regex: false },
  { key: 'jiba', value: 'ଯିବ', regex: false },
  { key: 'mallick', value: 'ମଲ୍ଲିକ', regex: false },
  { key: 'koranti', value: 'କରାନ୍ତି', regex: false },
  { key: 'koranti', value: 'କରାନ୍ତି', regex: false },
  { key: 'pustak', value: 'ପୁସ୍ତକ', regex: false },
  { key: 'bhondar', value: 'ଭଣ୍ଡାର', regex: false },
  { key: 'jiibon', value: 'ଜୀବନ', regex: false },
  { key: 'dina', value: 'ଦିନ', regex: false },
  { key: 'jibanare', value: 'ଜୀବନରେ', regex: false },
  { key: 'jie', value: 'ଯିଏ', regex: false },
  { key: 'pani', value: 'ପାଣି', regex: false },
  { key: 'jigyansu', value: 'ଜିଜ୍ଞାସୁ', regex: false },
  { key: 'jihwa', value: 'ଜିହ୍ୱା', regex: false },
  //{ key: 'jisu', value: 'ଯୀଶୁ', regex: false },
  { key: 'niyojita', value: 'ନିୟୋଜିତ', regex: false },
  { key: 'jodie', value: 'ଯୋଡ଼ିଏ', regex: false },
  { key: 'jodio', value: 'ଯଦିଓ', regex: false },
  { key: 'jogajoga', value: 'ଯୋଗଯୋଗ', regex: false },
  { key: 'jogauchhi', value: 'ଯୋଗାଉଛି', regex: false },
  { key: 'jogii', value: 'ଯୋଗାଇ', regex: false },
  { key: 'jogya', value: 'ଯଜ୍ଞ', regex: false },
  { key: 'jojana', value: 'ଯୋଜନା', regex: false },
  { key: 'jona', value: 'ଜଣ', regex: false },
  { key: 'joubana', value: 'ଯୌବନ', regex: false },
  { key: 'jparjanta', value: 'ଯେପର୍ଯ୍ୟନ୍ତ', regex: false },
  { key: 'judha', value: 'ଯୁଦ୍ଧ', regex: false },
  { key: 'jugare', value: 'ଯୁଗରେ', regex: false },
  { key: 'juge', value: 'ଯୁଗେ', regex: false },
  { key: 'juiphula', value: 'ଯୂଈଫୁଲ', regex: false },
  { key: 'jukta', value: 'ଯୁକ୍ତ', regex: false },
  { key: 'july', value: 'ଜୁଲାଇ', regex: false },
  { key: 'june', value: 'ଜୁନ୍', regex: false },
  { key: 'tejo', value: 'ତେଜ', regex: false },
  { key: 'thae', value: 'ଥାଏ', regex: false },
  { key: 'thanta', value: 'ଥାନ୍ତା', regex: false },
  { key: 'thante', value: 'ଥାନ୍ତେ', regex: false },
  { key: 'thanti', value: 'ଥାନ୍ତି', regex: false },
  { key: 'thantu', value: 'ଥାନ୍ତୁ', regex: false },
  { key: 'thare', value: 'ଠାରେ', regex: false },
  { key: 'thib', value: 'ଥିବ', regex: false },
  { key: 'thiba', value: 'ଥିବା', regex: false },
  { key: 'thitobinodana', value: 'ଚିତ୍ତବିନୋଦନ', regex: false },
  { key: 'thoi', value: 'ଥୋଇ', regex: false },
  { key: 'thonta', value: 'ଥଣ୍ଟ', regex: false },
  { key: 'thore', value: 'ଥରେ', regex: false },
  { key: 'thursday', value: 'ଗୁରୁବାର', regex: false },
  //{ key: 'ti', value: 'ଟି', regex: false },
  { key: 'tiangia', value: 'ଟିଆଙ୍ଗିଆ', regex: false },
  { key: 'tikhma', value: 'ତୀକ୍ଷ୍ମ', regex: false },
  { key: 'tikie', value: 'ଟିକିଏ', regex: false },
  { key: 'tippani', value: 'ଟିପ୍ପଣୀ', regex: false },
  { key: 'tiraskar', value: 'ତିରସ୍କାର', regex: false },
  { key: 'tire', value: 'ତୀରେ', regex: false },
  { key: 'tiro', value: 'ତୀର', regex: false },
  { key: 'tonka', value: 'ଟଙ୍କ', regex: false },
  { key: 'tote', value: 'ତୋତେ', regex: false },
  { key: 'truna', value: 'ତୃଣ', regex: false },
  { key: 'trusa', value: 'ତୃଷା', regex: false },
  { key: 'truti', value: 'ତ୍ରୁଟି', regex: false },
  { key: 'trutiya', value: 'ତୃତୀୟ', regex: false },
  { key: 'ttharu', value: 'ଠାରୁ', regex: false },
  { key: 'ttpar', value: 'ତତ୍ପର', regex: false },
  { key: 'tudarasa', value: 'ଗୁଡ଼ରସ', regex: false },
  { key: 'jutho', value: 'ଯୂଥ', regex: false },
  //{ key: 'jwala', value: 'ଜ୍ୱାଳା', regex: false },
  { key: 'jwara', value: 'ଜ୍ୱର', regex: false },
  { key: 'jyestho', value: 'ଜୈଷ୍ଠ', regex: false },  
  { key: 'kabach', value: 'କବଚ', regex: false },
  { key: 'kabar', value: 'କବର', regex: false },
  { key: 'kabat', value: 'କବାଟ', regex: false },
  { key: 'kabharej', value: 'କଭରେଜ୍', regex: false },
  { key: 'kabita', value: 'କବିତା', regex: false },
  { key: 'kabitapatho', value: 'କବିତାପାଠ', regex: false },
  { key: 'kaccha', value: 'କଚ୍ଚା', regex: false },
  { key: 'kach', value: 'କାଚ', regex: false },  
  { key: 'kochadi', value: 'କଗ୍ଭଡ଼ି', regex: false },
  //{ key: 'kachadiba', value: 'କଗ୍ଭଡ଼ିବା', regex: false },
  { key: 'kadachar', value: 'କଦାଗ୍ଭର', regex: false },
  { key: 'kadachit', value: 'କଦାଚିତ', regex: false },
  { key: 'kadambini', value: 'କାଦମ୍ବିନୀ', regex: false },
  { key: 'kadarjya', value: 'କଦର୍ଯ୍ୟ', regex: false },
  { key: 'kadhi', value: 'କାଢ଼ି', regex: false },
  { key: 'kadhineba', value: 'କାଢ଼ିନେବା', regex: false },
  { key: 'kadho', value: 'କଢ଼', regex: false },
  { key: 'kagaj', value: 'କାଗଜ', regex: false },
  { key: 'kahaku', value: 'କାହାକୁ', regex: false },
  { key: 'kahali', value: 'କାହାଳୀ', regex: false },
  { key: 'kahib', value: 'କହିବ', regex: false },
  { key: 'kahuni', value: 'କହୁଣି', regex: false },  
  { key: 'tuesday', value: 'ମଙ୍ଗଳବାର', regex: false },
  { key: 'tumamananka', value: 'ତୁମମାନଙ୍କ', regex: false },
  { key: 'tumanku', value: 'ତୁମଙ୍କୁ', regex: false },
  { key: 'tumar', value: 'ତୁମର', regex: false },
  { key: 'tumari', value: 'ତୁମରି', regex: false },
  { key: 'tumbha', value: 'ତୁମ୍ଭ', regex: false },
  { key: 'tume', value: 'ତୁମେ', regex: false },
  { key: 'twacha', value: 'ତ୍ୱଚା', regex: false },
  { key: 'twaja', value: 'ତ୍ୱଜା', regex: false },
  { key: 'type', value: 'ଟାଇପ', regex: false },
  { key: 'ubhaya', value: 'ଉଭୟ', regex: false },
  { key: 'uccha', value: 'ଉଚ୍ଚା', regex: false },
  { key: 'ucharana', value: 'ଉଚ୍ଚାରଣ', regex: false },
  { key: 'ucho', value: 'ଉଚ୍ଚ', regex: false },
  { key: 'uchokara', value: 'ଉଚ୍ଚକର', regex: false },
  { key: 'alasa', value: 'ଅଳସ', regex: false },
  { key: 'laguchhi', value: 'ଲାଗୁଛି', regex: false },
  { key: 'laguchi', value: 'ଲାଗୁଚି', regex: false },
  { key: 'phakir', value: 'ଫକୀର', regex: false },
  { key: 'udaharana', value: 'ଉଦାହରଣ', regex: false },
  { key: 'udana', value: 'ଉଡ଼ାଣ', regex: false },
  { key: 'udbhaba', value: 'ଉଦ୍ଭବ', regex: false },
  { key: 'uddan', value: 'ଉଡ୍ଡନ', regex: false },
  { key: 'uddes', value: 'ଉଦ୍ଦେଶ', regex: false },
  { key: 'uddesya', value: 'ଉଦ୍ଦେଶ୍ୟ', regex: false },
  { key: 'uddhab', value: 'ଉଦ୍ଧବ', regex: false },
  { key: 'uddhesya', value: 'ଉଦ୍ଦେଶ୍ୟ', regex: false },
  { key: 'uddiyaman', value: 'ଉଡ୍ଡୀୟମାନ', regex: false },
  { key: 'udi', value: 'ଉଡ଼ି', regex: false },
  { key: 'pahanchila', value: 'ପହଞ୍ଚିଲା', regex: false },
  { key: 'ghara', value: 'ଘର', regex: false },
  { key: 'udjogi', value: 'ଉଦଯୋଗୀ', regex: false },
  { key: 'udyag', value: 'ଉଦ୍ୟୋଗ', regex: false },
  { key: 'ujwal', value: 'ଉଜ୍ଜ୍ୱଳ', regex: false },
  { key: 'ujwala', value: 'ଉଜ୍ଜ୍ୱଳ', regex: false },
  { key: 'ulanghana', value: 'ଉଲ୍ଲଂଘନ', regex: false },
  { key: 'ulla', value: 'ଉଲ୍ଲା', regex: false },
  { key: 'ullas', value: 'ଉଲ୍ଲାସ', regex: false },
  { key: 'ullekha', value: 'ଉଲ୍ଲେଖ', regex: false },
  { key: 'unnayana', value: 'ଉନ୍ନୟନ', regex: false },
  { key: 'unadhka', value: 'ଉଣାଧିକ', regex: false },
  { key: 'unmad', value: 'ଉନ୍ମାଦ', regex: false },
  { key: 'unnati', value: 'ଉନ୍ନତ', regex: false },
  { key: 'upadana', value: 'ଉପାଦାନ', regex: false },
  { key: 'upadesh', value: 'ଉପଦେଶ', regex: false },
  { key: 'upajogi', value: 'ଉପଯୋଗୀ', regex: false },
  { key: 'upajukta', value: 'ଉପଯୁକ୍ତ', regex: false },
  { key: 'upakaran', value: 'ଉପକରଣ', regex: false },
  { key: 'upanirdesaka', value: 'ଉପନିର୍ଦ୍ଦେଶକ', regex: false },
  { key: 'upare', value: 'ଉପରେ', regex: false },  
  { key: 'uplabdha', value: 'ଉପଲବ୍ଧ', regex: false },
  { key: 'urddh', value: 'ଉର୍ଦ୍ଧ୍ୱ', regex: false },
  { key: 'urdhbhaga', value: 'ଉର୍ଦ୍ଧ୍ୱଭାଗ', regex: false },
  { key: 'urdhpata', value: 'ଉର୍ଦ୍ଧ୍ୱପାତ', regex: false },
  { key: 'urdhtama', value: 'ଉର୍ଦ୍ଧ୍ୱତ୍ତମ', regex: false },
  { key: 'urdhwa', value: 'ଉର୍ଦ୍ଧ୍ୱ', regex: false },
  { key: 'usmn', value: 'ଉଷ୍ମ', regex: false },  
  { key: 'uttar', value: 'ଉତ୍ତର', regex: false },
  { key: 'utaradayi', value: 'ଉତ୍ତରଦାୟିତ୍ୱର', regex: false },
  { key: 'utejana', value: 'ଉତ୍ତେଜକ', regex: false },
  { key: 'uthan', value: 'ଉଠାଣ', regex: false },
  { key: 'uthila', value: 'ଉଠିଲା', regex: false },
  { key: 'utho', value: 'ଉଠ', regex: false },
  { key: 'utkal', value: 'ଉତ୍କଳ', regex: false },
  { key: 'utkarsh', value: 'ଉତ୍କର୍ଷ', regex: false },
  { key: 'utolana', value: 'ଉତ୍ତୋଳନ', regex: false },
  { key: 'utpad', value: 'ଉତ୍ପାଦ', regex: false },
  { key: 'utpal', value: 'ଉତ୍ପଳ', regex: false },
  { key: 'utpan', value: 'ଉତ୍ପନ', regex: false },
  { key: 'utpati', value: 'ଉତ୍ପତି', regex: false },
  { key: 'utpatu', value: 'ଉତ୍ପାତୁ', regex: false },
  { key: 'uttam', value: 'ଉତ୍ତମ', regex: false },
  { key: 'utthan', value: 'ଉତ୍ଥାନ', regex: false },
  { key: 'velure', value: 'ବେଲୁରୁ', regex: false },
  { key: 'video', value: 'ଭିଡିଓ', regex: false },
  { key: 'wednesday', value: 'ବୁଧବାର', regex: false },
  { key: 'west', value: 'ପଶ୍ଚିମ', regex: false },
  { key: 'budhabara', value: 'ବୁଧବାର', regex: false },
  { key: 'dukhi', value: 'ଦୁଃଖୀ', regex: false },
  { key: 'dukhita', value: 'ଦୁଃଖିତ', regex: false },
  { key: 'dukho', value: 'ଦୁଃଖ', regex: false },
  { key: 'dunia', value: 'ଦୁନିଆ', regex: false },
  { key: 'durabhasa', value: 'ଦୂରଭାଷ', regex: false },
  { key: 'durbal', value: 'ଦୁର୍ବଳ ', regex: false },
  { key: 'durlabha', value: 'ଦୁର୍ଲ୍ଲଭ', regex: false },
  { key: 'duro', value: 'ଦୂର', regex: false },
  { key: 'dusahas', value: 'ଦୁଃସାହସ', regex: false },
  { key: 'duta', value: 'ଦୂତ', regex: false },
  { key: 'dwaha', value: 'ଦ୍ୱାହ', regex: false },
  { key: 'dwahi', value: 'ଦ୍ୱାହି', regex: false },
  { key: 'dwanda', value: 'ଦ୍ୱନ୍ଦ', regex: false },
  { key: 'dwara', value: 'ଦ୍ୱାରା', regex: false },
  { key: 'dwitiya', value: 'ଦ୍ୱିତୀୟ ', regex: false },
  //{ key: 'east', value: 'ପୂର୍ବ ', regex: false },  
  { key: 'ebng', value: 'ଏଵଂ', regex: false },
  { key: 'ebom', value: 'ଏଵଂ', regex: false },
  { key: 'sishu', value: 'ଶିଶୁ', regex: false },
  { key: 'jane', value: 'ଜଣେ', regex: false },
  { key: 'jack', value: 'ଜାକ', regex: false },
  { key: 'jill', value: 'ଜିଲ', regex: false },
  { key: 'chhota', value: 'ଛୋଟ', regex: false },
  { key: 'tale', value: 'ତଳେ', regex: false },
  { key: 'shirshare', value: 'ଶୀର୍ଷରେ', regex: false },
  { key: 'gotie', value: 'ଗୋଟିଏ', regex: false },
  { key: 'goti', value: 'ଗୋଟି', regex: false },  
  { key: 'gotei', value: 'ଗୋଟେଇ', regex: false },
  { key: 'basithile', value: 'ବସିଥିଲେ', regex: false },
  { key: 'thile', value: 'ଥିଲେ', regex: false },
  { key: 'thilu', value: 'ଥିଲୁ', regex: false },
  { key: 'jai', value: 'ଯାଇ', regex: false },
  { key: 'durbipaka', value: 'ଦୁର୍ବିପାକ', regex: false },
  { key: 'amal', value: 'ଅମଳ', regex: false },
  { key: 'hele', value: 'ହେଲେ', regex: false },
  { key: 'purana', value: 'ପୁରଣ', regex: false },
  { key: 'nirdharita', value: 'ନିର୍ଦ୍ଦାରିତ', regex: false },
  { key: 'form', value: 'ଫର୍ମ', regex: false },
  { key: 'phorm', value: 'ଫର୍ମ', regex: false },
  { key: 'pharm', value: 'ଫାର୍ମ', regex: false },
  { key: 'farm', value: 'ଫାର୍ମ', regex: false },
  { key: 'jomi', value: 'ଜମି', regex: false },
  { key: 'malika', value: 'ମାଲିକ', regex: false },
  { key: 'sahamati', value: 'ସହମତି', regex: false },
  { key: 'ruuni', value: 'ଋଣୀ', regex: false },
  { key: 'pusti', value: 'ପୁଷ୍ଟି', regex: false },
  { key: 'chori', value: 'ଚୋରି', regex: false },
  { key: 'edhare', value: 'ଏଠାରେ ', regex: false },
  { key: 'ediba', value: 'ଏଡ଼ିବା', regex: false },
  { key: 'edideba', value: 'ଏଡ଼ିଦେବା', regex: false },
  { key: 'ehaku', value: 'ଏହାକୁ ', regex: false },
  { key: 'ehapare', value: 'ଏହାପରେ', regex: false },
  { key: 'ehapurbaru', value: 'ଏହାପୂର୍ଵରୁ ', regex: false },
  { key: 'ehara', value: 'ଏହାର ', regex: false },
  { key: 'panda', value: 'ପଣ୍ଡା', regex: false },
  { key: 'sampadaka', value: 'ସମ୍ପାଦକ', regex: false },
  { key: 'sampadika', value: 'ସମ୍ପାଦିକା', regex: false },
  { key: 'sampadana', value: 'ସମ୍ପାଦନ', regex: false },
  { key: 'ehikhyani', value: 'ଏହିକ୍ଷଣି', regex: false },
  { key: 'ekabachan', value: 'ଏକଵଚନ', regex: false },
  { key: 'eka', value: 'ଏକା', regex: false },
  { key: 'mukhi', value: 'ମୁଖୀ', regex: false },
  { key: 'bhi', value: 'ଭି', regex: false },
  { key: 'ekachatia', value: 'ଏକଚାଟିଆ', regex: false },
  { key: 'ekada', value: 'ଏକଦା', regex: false },
  { key: 'ekadam', value: 'ଏକଦମ', regex: false },
  { key: 'ekadhika', value: 'ଏକାଧିକ', regex: false },
  { key: 'prabhu', value: 'ପ୍ରଭୁ', regex: false },
  { key: 'ekagrata', value: 'ଏକାଗ୍ରତା', regex: false },
  { key: 'ekajidia', value: 'ଏକଜିଦିଆ', regex: false },
  { key: 'shreni', value: 'ଶ୍ରେଣୀ', regex: false },
  { key: 'ambhe', value: 'ଆମ୍ଭେ', regex: false },
  { key: 'nibasi', value: 'ନିବାସୀ', regex: false },
  { key: 'janna', value: 'ଜଣା', regex: false },
  { key: 'block', value: 'ବ୍ଲକ', regex: false },
  { key: 'karibara', value: 'କରିବାର', regex: false },
  { key: 'jauchhi', value: 'ଯାଉଛି', regex: false },
  { key: 'asiba', value: 'ଆସିବ', regex: false },
  { key: 'abhipraya', value: 'ଅଭିପ୍ରାୟ', regex: false },  
  { key: 'ekajuta', value: 'ଏକଜୁଟ', regex: false },
  { key: 'ekakalina', value: 'ଏକକାଳୀନ', regex: false },
  { key: 'ekaki', value: 'ଏକାକୀ', regex: false },
  { key: 'antargata', value: 'ଅନ୍ତର୍ଗତ', regex: false },
  { key: 'jibo', value: 'ଯିବ', regex: false },
  { key: 'sikhyaka', value: 'ଶିକ୍ଷକ', regex: false },
  { key: 'ekakitwa', value: 'ଏକାକୀତ୍ୱ', regex: false },
  { key: 'ekala', value: 'ଏକଲା', regex: false },
  { key: 'ekalapa', value: 'ଏକାଳାପ', regex: false },
  { key: 'ekomarga', value: 'ଏକମାର୍ଗ', regex: false },
  { key: 'ekomatra', value: 'ଏକମାତ୍ର', regex: false },
  { key: 'ekanistha', value: 'ଏକନିଷ୍ଠା', regex: false },
  { key: 'ekanta', value: 'ଏକାନ୍ତ', regex: false },
  { key: 'ekantabasi', value: 'ଏକାନ୍ତବାସୀ', regex: false },
  { key: 'ekantar', value: 'ଏକାନ୍ତର', regex: false },
  { key: 'ekantare', value: 'ଏକାନ୍ତରେ', regex: false },
  { key: 'ekantata', value: 'ଏକାନ୍ତତା ', regex: false },
  { key: 'ekopakhia', value: 'ଏକପାଖିଆ', regex: false },
  { key: 'ekapakhiya', value: 'ଏକପକ୍ଷୀୟ', regex: false },
  { key: 'ekarupa', value: 'ଏକରୂପ', regex: false },
  { key: 'ekasangare', value: 'ଏକାସାଙ୍ଗରେ', regex: false },
  { key: 'ekasila', value: 'ଏକଶିଳା', regex: false },
  { key: 'ekasongare', value: 'ଏକସଙ୍ଗରେ', regex: false },
  { key: 'ekata', value: 'ଏକତା', regex: false },
  { key: 'ekatana', value: 'ଏକତାନ', regex: false },
  { key: 'ekatarapha', value: 'ଏକତରଫା', regex: false },
  { key: 'ekatharake', value: 'ଏକାଥରକେ', regex: false },
  { key: 'ekathi', value: 'ଏକାଠି', regex: false },
  { key: 'ekatmaka', value: 'ଏକାତ୍ମକ', regex: false },
  { key: 'ekatra', value: 'ଏକତ୍ର', regex: false },
  { key: 'ekatrikaran', value: 'ଏକତ୍ରୀକରଣ', regex: false },
  { key: 'ekatrikruta', value: 'ଏକତ୍ରୀକୃତ', regex: false },
  { key: 'ekibhuta', value: 'ଏକୀଭୂତ', regex: false },
  { key: 'ekikaran', value: 'ଏକୀକରଣ', regex: false },
  { key: 'ekikruta', value: 'ଏକୀକୃତ', regex: false },
  { key: 'ekutia', value: 'ଏକୁଟିଆ', regex: false },
  { key: 'enetene', value: 'ଏଣେତେଣେ ', regex: false },
  { key: 'engineer', value: 'ଇଞ୍ଜିନିୟରିଂ', regex: false },
  { key: 'engraji', value: 'ଇଂରାଜୀ', regex: false },
  { key: 'eniki', value: 'ଏଣିକି ', regex: false },
  { key: 'enutenu', value: 'ଏଣୁତେଣୁ', regex: false },
  { key: 'epakh', value: 'ଏପାଖ ', regex: false },
  { key: 'eparjyant', value: 'ଏପର୍ଯ୍ୟନ୍ତ ', regex: false },
  { key: 'erundi', value: 'ଏରୁଣ୍ଡି', regex: false },
  { key: 'etadbhinn', value: 'ଏତଦଭିନ୍ନ', regex: false },
  { key: 'etadwara', value: 'ଏତଦ୍ୱାରା', regex: false },
  { key: 'etala', value: 'ଏତଲା', regex: false },
  { key: 'ethare', value: 'ଏଠାରେ', regex: false },
  { key: 'etharu', value: 'ଏଠାରୁ ', regex: false },
  { key: 'ethiki', value: 'ଏଠିକି', regex: false },
  { key: 'ethire', value: 'ଏଥିରେ ', regex: false },
  { key: 'ethiru', value: 'ଏଥିରୁ', regex: false },
  { key: 'etthare', value: 'ଏଠାରେ ', regex: false },
  { key: 'february', value: 'ଫେବୃଆରୀ', regex: false },
  { key: 'flopi', value: 'ଫ୍ଲପି', regex: false },
  { key: 'format', value: 'ଫର୍ମାଟ', regex: false },
  { key: 'friday', value: 'ଶୁକ୍ରବାର', regex: false },
  { key: 'futbal', value: 'ଫୁଟବଲ୍', regex: false },
  { key: 'gabakhya', value: 'ଗବାକ୍ଷ', regex: false },
  { key: 'gabesana', value: 'ଗବେଷଣା', regex: false },
  { key: 'gabhir', value: 'ଗଭୀର', regex: false },
  { key: 'gacha', value: 'ଗଛ', regex: false },
  { key: 'gadania', value: 'ଗଡ଼ାଣିଆ', regex: false },
  { key: 'gadanti', value: 'ଗଡ଼ନ୍ତି', regex: false },
  { key: 'gadeiba', value: 'ଗଡେ଼ଇବା', regex: false },
  { key: 'gadhona', value: 'ଗଢ଼ଣ', regex: false },
  { key: 'gadi', value: 'ଗାଡ଼ି', regex: false },
  { key: 'gadibhada', value: 'ଗାଡ଼ିଭଡ଼ା', regex: false },
  { key: 'gadyadharmi', value: 'ଗଦ୍ୟଧର୍ମୀ', regex: false },
  { key: 'gadyatmaka', value: 'ଗଦ୍ୟାତ୍ମକ', regex: false },
  { key: 'gahali', value: 'ଗହଳି', regex: false },
  { key: 'gahana', value: 'ଗହଣା', regex: false },
  { key: 'gahwar', value: 'ଗହ୍ୱର', regex: false },
  { key: 'gola', value: 'ଗଳା', regex: false },
  { key: 'gala', value: 'ଗଲା', regex: false },
  { key: 'goli', value: 'ଗଳି', regex: false },
  { key: 'galicha', value: 'ଗାଲିଗ୍ଭ', regex: false },
  { key: 'galigulaj', value: 'ଗାଳିଗୁଲଜ', regex: false },
  { key: 'gali', value: 'ଗଲି', regex: false },
  { key: 'srusti', value: 'ସୃଷ୍ଟି', regex: false },
  { key: 'gruhit', value: 'ଗୃହୀତ', regex: false },
  { key: 'bichhino', value: 'ବିଛିନ୍ନ', regex: false },
  { key: 'jolatanka', value: 'ଜଳାତଙ୍କ', regex: false },
  { key: 'galu', value: 'ଗଲୁ', regex: false },
  { key: 'galpa', value: 'ଗଳ୍ପ', regex: false },
  { key: 'gaman', value: 'ଗମନ', regex: false },
  { key: 'gambhira', value: 'ଗମ୍ଭୀର', regex: false },
  { key: 'gambhirjya', value: 'ଗାମ୍ଭୀର୍ଯ୍ୟ', regex: false },
  { key: 'gana', value: 'ଗଣ', regex: false },
  { key: 'ganabikhyobh', value: 'ଗଣବିକ୍ଷୋଭ', regex: false },
  { key: 'ganahatya', value: 'ଗଣହତ୍ୟା', regex: false },
  { key: 'ganamadhyam', value: 'ଗଣମାଧ୍ୟମ', regex: false },
  { key: 'ganan', value: 'ଗଣନ', regex: false },
  { key: 'gananajantra', value: 'ଗଣନାଯନ୍ତ୍ର', regex: false },
  { key: 'ganarajya', value: 'ଗଣରାଜ୍ୟ', regex: false },
  { key: 'ganatantra', value: 'ଗଣତନ୍ତ୍ର', regex: false },
  { key: 'gandhajukta', value: 'ଗନ୍ଧଯୁକ୍ତ', regex: false },
  { key: 'gondh', value: 'ଗନ୍ଧ', regex: false },
  { key: 'gandi', value: 'ଗାଣ୍ଡି', regex: false },
  { key: 'ganesh', value: 'ଗଣେଶ', regex: false },
  { key: 'gonit', value: 'ଗଣିତ', regex: false },
  { key: 'ganjei', value: 'ଗଞ୍ଜେଇ', regex: false },
  { key: 'gantabya', value: 'ଗନ୍ତବ୍ୟ', regex: false },
  { key: 'sthan', value: 'ସ୍ଥାନ', regex: false },
  { key: 'gonthi', value: 'ଗଣ୍ଠି', regex: false },
  { key: 'ganthia', value: 'ଗାଣ୍ଠିଆ', regex: false },
  { key: 'gonthibat', value: 'ଗଣ୍ଠିବାତ', regex: false },
  { key: 'ganthili', value: 'ଗଣ୍ଠିଲି', regex: false },
  { key: 'garakha', value: 'ଗରାଖ', regex: false },
  { key: 'garba', value: 'ଗର୍ବ', regex: false },
  { key: 'garbhabastha', value: 'ଗର୍ଭାବସ୍ଥା', regex: false },
  { key: 'garbhabati', value: 'ଗର୍ଭବତୀ', regex: false },
  { key: 'tirodhana', value: 'ତିରଧାନ', regex: false },
  { key: 'garbhadharana', value: 'ଗର୍ଭଧାରଣ', regex: false },
  { key: 'garbhagruba', value: 'ଗର୍ଭଗୃହ', regex: false },
  { key: 'garbhapata', value: 'ଗର୍ଭପାତ', regex: false },
  { key: 'garbita', value: 'ଗର୍ବିତ', regex: false },
  { key: 'gareiba', value: 'ଗାରେଇବା', regex: false },
  { key: 'garib', value: 'ଗରିବ', regex: false },
  { key: 'garima', value: 'ଗାରିମା', regex: false },
  { key: 'gatakali', value: 'ଗତକାଲି', regex: false },
  { key: 'gathon', value: 'ଗଠନ', regex: false },
  { key: 'gatire', value: 'ଗତିରେ ', regex: false },
  { key: 'gaunli', value: 'ଗାଉଁଲି', regex: false },
  { key: 'gayak', value: 'ଗାୟକ', regex: false },
  { key: 'geda', value: 'ଗେଡ଼ା', regex: false },
  { key: 'gelha', value: 'ଗେହ୍ଲା', regex: false },
  { key: 'genda', value: 'ଗେଣ୍ଡା', regex: false },
  { key: 'gerua', value: 'ଗେରୁଆ', regex: false },
  { key: 'ghadaghadi', value: 'ଘଡ଼ଘଡ଼ି', regex: false },
  { key: 'ghadi', value: 'ଘଡ଼ି', regex: false },
  { key: 'ghagara', value: 'ଘାଗରା', regex: false },
  { key: 'ghanakruti', value: 'ଘନାକୃତି', regex: false },
  { key: 'ghancha', value: 'ଘଞ୍ଚ', regex: false },
  { key: 'ghanibhut', value: 'ଘନୀଭୂତ', regex: false },
  { key: 'ghanistho', value: 'ଘନିଷ୍ଠ', regex: false },
  { key: 'ghanta', value: 'ଘଣ୍ଟା', regex: false },
  { key: 'ghanti', value: 'ଘଣ୍ଟି', regex: false },
  { key: 'ghantib', value: 'ଘାଣ୍ଟିବ', regex: false },
  { key: 'ghantodhwani', value: 'ଘଣ୍ଟଧ୍ୱନି', regex: false },
  { key: 'gharabadi', value: 'ଘରବାଡ଼ି', regex: false },
  { key: 'gharabandi', value: 'ଘରବନ୍ଦୀ', regex: false },
  { key: 'gharani', value: 'ଘରଣୀ', regex: false },
  { key: 'ghare', value: 'ଘରେ', regex: false },
  { key: 'gharoi', value: 'ଘରୋଇ', regex: false },
  { key: 'ghasabida', value: 'ଘାସବିଡ଼ା', regex: false },
  { key: 'ghasakatali', value: 'ଘାସକଟାଳି', regex: false },
  { key: 'ghasara', value: 'ଘଷରା', regex: false },
  { key: 'ghasi', value: 'ଘାସି', regex: false },
  { key: 'ghasiba', value: 'ଘଷିବା', regex: false },
  { key: 'ghatak', value: 'ଘାତକ', regex: false },
  { key: 'ghatanashala', value: 'ଘଟଣାସ୍ଥଳ', regex: false },
  { key: 'ghatanastholi', value: 'ଘଟଣାସ୍ଥଳୀ', regex: false },
  { key: 'ghate', value: 'ଘଟେ', regex: false },
  { key: 'ghati', value: 'ଘାଟି', regex: false },
  { key: 'ghenib', value: 'ଘେନିବ', regex: false },
  { key: 'gheno', value: 'ଘେନ', regex: false },
  { key: 'gherau', value: 'ଘେରାଉ', regex: false },
  { key: 'ghhasapadi', value: 'ଘାସପଡିଅ', regex: false },
  { key: 'ghnta', value: 'ଘଣ୍ଟା', regex: false },
  { key: 'ghoda', value: 'ଘୋଡ଼ା', regex: false },
  { key: 'ghodaiba', value: 'ଘୋଡ଼ାଇବ', regex: false },
  { key: 'ghodasala', value: 'ଘୋଡ଼ାଶାଳ', regex: false },
  { key: 'ghont', value: 'ଘଣ୍ଟ', regex: false },
  { key: 'ghor', value: 'ଘୋର', regex: false },
  { key: 'ghosak', value: 'ଘୋଷକ ', regex: false },
  { key: 'ghosana', value: 'ଘୋଷଣା', regex: false },
  { key: 'ghosanakari', value: 'ଘୋଷଣାକାରୀ', regex: false },
  { key: 'ghru', value: 'ଘୃ', regex: false },
  { key: 'ghruna', value: 'ଘୃଣା', regex: false },
  { key: 'ghrunajanak', value: 'ଘୃଣାଜନକ', regex: false },
  { key: 'ghrunya', value: 'ଘୃଣ୍ୟ', regex: false },
  { key: 'ghruta', value: 'ଘୃତ', regex: false },
  { key: 'ghumaiba', value: 'ଘୁମାଇବ', regex: false },
  { key: 'ghunchiba', value: 'ଘୁଞ୍ଚିବ', regex: false },
  { key: 'ghunga', value: 'ଘୁଙ୍ଗା', regex: false },
  { key: 'ghungudi', value: 'ଘୁଙ୍ଗୁଡ଼ି', regex: false },
  { key: 'ghuraiba', value: 'ଘୁରାଇବ', regex: false },
  { key: 'ghurib', value: 'ଘୁରିବ', regex: false },
  { key: 'ghurnan', value: 'ଘୁର୍ଣ୍ଣନ', regex: false },
  { key: 'ghurnibatya', value: 'ଘୁର୍ଣ୍ଣିବାତ୍ୟା', regex: false },
  { key: 'ghusuriba', value: 'ଘୁଷୁରିବ', regex: false },
  { key: 'gina', value: 'ଗିନା', regex: false },
  { key: 'giripatha', value: 'ଗିରିପଥ', regex: false },
  { key: 'girisankat', value: 'ଗିରିଶଙ୍କଟ', regex: false },
  { key: 'girsnath', value: 'ଗିରିଶନାଥ ', regex: false },
  { key: 'girja', value: 'ଗୀର୍ଜା', regex: false },
  { key: 'gita', value: 'ଗୀତା', regex: false },
  { key: 'gitanjali', value: 'ଗୀତାଞ୍ଜଳୀ', regex: false },
  { key: 'gitinatya', value: 'ଗୀତିନାଟ୍ୟ', regex: false },
  { key: 'gito', value: 'ଗୀତ', regex: false },
  { key: 'glani', value: 'ଗ୍ଲାନି', regex: false },
  { key: 'glass', value: 'ଗ୍ଲାସ', regex: false },
  { key: 'gobija', value: 'ଗୋବୀଜ', regex: false },
  { key: 'gochar', value: 'ଗୋଚର', regex: false },
  { key: 'gochha', value: 'ଗୋଚ୍ଛା', regex: false },
  { key: 'goda', value: 'ଗୋଡ଼', regex: false },
  { key: 'godam', value: 'ଗୋଦାମ', regex: false },
  { key: 'godar', value: 'ଗୋଦର', regex: false },
  { key: 'goddiba', value: 'ଗୋଡ଼ାଇବା ', regex: false },
  { key: 'godhuli', value: 'ଗୋଧୂଳି ', regex: false },
  { key: 'godi', value: 'ଗୋଡ଼ି', regex: false },
  { key: 'goinda', value: 'ଗୋଇନ୍ଦା', regex: false },
  { key: 'goithi', value: 'ଗୋଇଠି ', regex: false },
  { key: 'gola', value: 'ଗୋଳା', regex: false },
  { key: 'golak', value: 'ଗୋଲକ', regex: false },
  { key: 'golam', value: 'ଗୋଲାମ', regex: false },
  { key: 'golamala', value: 'ଗୋଲମାଳ', regex: false },
  { key: 'golamalia', value: 'ଗୋଳମାଳିଆ', regex: false },
  { key: 'golei', value: 'ଗୋଲେଇ', regex: false },
  { key: 'golia', value: 'ଗୋଳିଆ', regex: false },
  { key: 'gondi', value: 'ଗଣ୍ଡି', regex: false },
  { key: 'gopalan', value: 'ଗୋପାଳନ', regex: false },
  { key: 'gopan', value: 'ଗୋପନ', regex: false },
  { key: 'gopanata', value: 'ଗୋପନତା', regex: false },
  { key: 'gopaniya', value: 'ଗୋପନୀୟ', regex: false },
  { key: 'gora', value: 'ଗୋରା', regex: false },
  { key: 'goruchari', value: 'ଗୋରୁଗ୍ଭରୀ', regex: false },
  { key: 'gosala', value: 'ଗୋଶାଳା', regex: false },
  { key: 'gosthi', value: 'ଗୋଷ୍ଠୀ', regex: false },
  { key: 'gosthigata', value: 'ଗୋଷ୍ଠୀଗତ', regex: false },
  { key: 'gosthipriya', value: 'ଗୋଷ୍ଠୀପ୍ରିୟ', regex: false },
  { key: 'gasto', value: 'ଗସ୍ତ', regex: false },
  { key: 'gosto', value: 'ଗଷ୍ଟ', regex: false },  
  { key: 'gotaiba', value: 'ଗୋଟାଇବା', regex: false },
  { key: 'gothakhandia', value: 'ଗୋଠଖଣ୍ଡିଆ ', regex: false },  
  { key: 'gotibidhi', value: 'ଗତିବିଧି', regex: false },
  { key: 'gotisila', value: 'ଗତିଶୀଳ', regex: false },
  { key: 'gouda', value: 'ଗୌଡ଼', regex: false },
  { key: 'gouna', value: 'ଗୌଣ', regex: false },
  { key: 'goura', value: 'ଗୌର', regex: false },
  { key: 'gourab', value: 'ଗୌରବ', regex: false },
  { key: 'gourabamay', value: 'ଗୌରବମୟ', regex: false },
  { key: 'gourabanwita', value: 'ଗୌରବାନ୍ୱିତ', regex: false },
  { key: 'graha', value: 'ଗ୍ରହ', regex: false },
  { key: 'grahana', value: 'ଗ୍ରହଣ', regex: false },
  { key: 'grahaniya', value: 'ଗ୍ରହଣୀୟ ', regex: false },
  { key: 'grahita', value: 'ଗ୍ରହୀତା', regex: false },
  { key: 'grama', value: 'ଗ୍ରାମ', regex: false },
  { key: 'gramobasi', value: 'ଗ୍ରାମବାସୀ', regex: false },
  { key: 'pratikatmaka', value: 'ପ୍ରତୀକାତ୍ମକ', regex: false },
  { key: 'bula', value: 'ବୁଲା', regex: false },
  { key: 'karajibani', value: 'କରାଯିବନି', regex: false },
  { key: 'pasu', value: 'ପଶୁ', regex: false },
  { key: 'premi', value: 'ପ୍ରେମୀ', regex: false },
  { key: 'gramasebak', value: 'ଗ୍ରାମସେବକ', regex: false },
  { key: 'gramya', value: 'ଗ୍ରାମ୍ୟ', regex: false },
  { key: 'grandhakita', value: 'ଗ୍ରନ୍ଥକୀଟ', regex: false },
  { key: 'granghagar', value: 'ଗ୍ରନ୍ଥାଗାର', regex: false },
  { key: 'gruha', value: 'ଗୃହ', regex: false },
  { key: 'gruhadaha', value: 'ଗୃହଦାହ', regex: false },
  { key: 'gruhajudha', value: 'ଗୃହଯୁଦ୍ଧ', regex: false },
  { key: 'gruhakatra', value: 'ଗୃହକର୍ତ୍ତା', regex: false },
  { key: 'gruhapalit', value: 'ଗୃହପାଳିତ', regex: false },
  { key: 'gruharakhi', value: 'ଗୃହରକ୍ଷୀ', regex: false },
  { key: 'gruhastha', value: 'ଗୃହସ୍ଥ', regex: false },
  { key: 'gruhita', value: 'ଗୃହୀତ', regex: false },
  { key: 'guchakhyar', value: 'ଗୁଚ୍ଛକ୍ଷର', regex: false },
  { key: 'guchha', value: 'ଗୁଚ୍ଛ', regex: false },
  { key: 'guda', value: 'ଗୁଡ଼', regex: false },
  { key: 'gudaiba', value: 'ଗୁଡ଼ାଇବ', regex: false },
  { key: 'gudho', value: 'ଗୂଢ଼', regex: false },
  { key: 'gudika', value: 'ଗୁଡ଼ିକ ', regex: false },
  { key: 'gugul', value: 'ଗୁଗୁଲ', regex: false },
  { key: 'gujab', value: 'ଗୁଜବ', regex: false },
  { key: 'gujagan', value: 'ଗୁଣଗାନ', regex: false },
  { key: 'gula', value: 'ଗୁଳା', regex: false },
  { key: 'guli', value: 'ଗୁଳି', regex: false },
  { key: 'gulma', value: 'ଗୁଳ୍ମ', regex: false },
  { key: 'gulmalata', value: 'ଗୁଳ୍ମଲତା', regex: false },
  { key: 'gumasta', value: 'ଗୁମାସ୍ତା', regex: false },
  { key: 'gumpha', value: 'ଗୁମ୍ଫା', regex: false },
  { key: 'gunabanta', value: 'ଗୁଣବନ୍ତ', regex: false },
  { key: 'gunabata', value: 'ଗୁଣାବତ୍ତା', regex: false },
  { key: 'gunak', value: 'ଗୁଣକ', regex: false },
  { key: 'gunaniyak', value: 'ଗୁଣନୀୟକ', regex: false },
  { key: 'gunaphala', value: 'ଗୁଣଫଳ', regex: false },
  { key: 'gunasampan', value: 'ଗୁଣସମ୍ପନ୍ନ', regex: false },
  { key: 'gunatmaka', value: 'ଗୁଣାତ୍ମକ', regex: false },
  { key: 'gunda', value: 'ଗୁଣ୍ଡା', regex: false },
  { key: 'gundagiri', value: 'ଗୁଣ୍ଡାଗିରି', regex: false },
  { key: 'gundami', value: 'ଗୁଣ୍ଡାମି', regex: false },
  { key: 'gunibidya', value: 'ଗୁଣିବିଦ୍ୟା', regex: false },
  { key: 'gunitak', value: 'ଗୁଣିତକ', regex: false },
  { key: 'gunjan', value: 'ଗୁଞ୍ଜନ', regex: false },
  { key: 'gunjaraj', value: 'ଗୁଞ୍ଜରଣ', regex: false },
  { key: 'gunjibadi', value: 'ଗୁଞ୍ଜିବାଡ଼ି', regex: false },
  { key: 'gunthiba', value: 'ଗୁନ୍ଥିବା', regex: false },
  { key: 'gupta', value: 'ଗୁପ୍ତ ', regex: false },
  { key: 'guptachara', value: 'ଗୁପ୍ତଚର', regex: false },
  { key: 'gupto', value: 'ଗୁପ୍ତ ', regex: false },
  { key: 'guruchatra', value: 'ଗୁରୁଛାତ୍ର ', regex: false },
  { key: 'gurujana', value: 'ଗୁରୁଜନ', regex: false },
  { key: 'gurundib', value: 'ଗୁରୁଣ୍ଡିବ', regex: false },
  { key: 'gurutar', value: 'ଗୁରୁତର', regex: false },
  { key: 'gurutwa', value: 'ଗୁରୁତ୍ୱ', regex: false },
  { key: 'gutika', value: 'ଗୁଟିକା', regex: false },
  { key: 'gyana', value: 'ଜ୍ଞାନ ', regex: false },
  { key: 'gyani', value: 'ଜ୍ଞାନୀ', regex: false },
  { key: 'harash', value: 'ହରଷ', regex: false },
  { key: 'hori', value: 'ହରି ', regex: false },
  { key: 'harina', value: 'ହରିଣ', regex: false },
  { key: 'harmoni', value: 'ହାର୍ମୋନି', regex: false },
  { key: 'hasal', value: 'ହାସଲ', regex: false },
  { key: 'hastakhyar', value: 'ହସ୍ତାକ୍ଷର', regex: false },
  { key: 'hati', value: 'ହାତୀ', regex: false },
  { key: 'heuchhi', value: 'ହେଉଛି', regex: false },
  { key: 'heuchi', value: 'ହେଉଚି', regex: false },
  { key: 'hino', value: 'ହୀନ', regex: false },
  { key: 'hinsa', value: 'ହିଂସା', regex: false },
  { key: 'hoiachi', value: 'ହୋଇଅଛି', regex: false },
  { key: 'hoichi', value: 'ହୋଇଛି', regex: false },
  { key: 'hosto', value: 'ହସ୍ତ ', regex: false },
  { key: 'hrasa', value: 'ହ୍ରାସ ', regex: false },
  { key: 'huni', value: 'ଖୁନୀ', regex: false },
  { key: 'hydrabad', value: 'ହାଇଦ୍ରାବାଦ', regex: false },
  { key: 'ichha', value: 'ଇଚ୍ଛା', regex: false },
  { key: 'ijjat', value: 'ଇଜ୍ଜତ', regex: false },
  { key: 'india', value: 'ଇଣ୍ଡିଆ ', regex: false },
  { key: 'indrio', value: 'ଇନ୍ଦ୍ରିୟ', regex: false },
  { key: 'ingraji', value: 'ଇଂରାଜୀ ', regex: false },
  { key: 'internet', value: 'ଇଣ୍ଟରନେଟ୍ ', regex: false },
  { key: 'iswar', value: 'ଈଶ୍ୱର', regex: false },
  { key: 'ityadi', value: 'ଇତ୍ୟାଦି ', regex: false },
  { key: 'jabaharlal', value: 'ଜବାହରଲାଲ ', regex: false },
  { key: 'jadio', value: 'ଯଦିଓ ', regex: false },
  { key: 'jadit', value: 'ଜଡିତ', regex: false },
  { key: 'jaghnya', value: 'ଜଘନ୍ୟ', regex: false },
  { key: 'jaguali', value: 'ଜଗୁଆଳି', regex: false },
  { key: 'jaha', value: 'ଯାହା', regex: false },
  { key: 'taha', value: 'ତାହା', regex: false },  
  { key: 'jakhama', value: 'ଜଖମ', regex: false },
  { key: 'jakhma', value: 'ଯକ୍ଷ୍ମା', regex: false },
  { key: 'jala', value: 'ଜଳ', regex: false },
  { key: 'jalo', value: 'ଜାଲ', regex: false },
  { key: 'jami', value: 'ଜାମି', regex: false },
  { key: 'jamini', value: 'ଯାମିନୀ', regex: false },
  { key: 'jana', value: 'ଜନ', regex: false },
  { key: 'janadisto', value: 'ଜନାଦିଷ୍ଟ', regex: false },
  { key: 'janagahal', value: 'ଜନଗହଳ', regex: false },
  { key: 'janaganana', value: 'ଜନଗଣନା', regex: false },
  { key: 'janajati', value: 'ଜନଜାତି', regex: false },
  { key: 'janakalyan', value: 'ଜନକଲ୍ୟାଣ', regex: false },
  { key: 'janakirna', value: 'ଜନାକୀର୍ଣ୍ଣ', regex: false },
  { key: 'janamat', value: 'ଜନମତ', regex: false },
  { key: 'namaskar', value: 'ନମସ୍କାର', regex: false },
  { key: 'jananakhyama', value: 'ଜନନକ୍ଷମ', regex: false },
  { key: 'janani', value: 'ଜନନୀ', regex: false },
  { key: 'janarab', value: 'ଜନରବ', regex: false },
  { key: 'janasadharan', value: 'ଜନସାଧାରଣ', regex: false },
  { key: 'janasadharana', value: 'ଜନସାଧାରଣ', regex: false },
  { key: 'janasankhya', value: 'ଜନସଂଖ୍ୟା', regex: false },
  { key: 'janasankhyagata', value: 'ଜନସଂଖ୍ୟାଗତ ', regex: false },
  { key: 'janashakti', value: 'ଜନଶକ୍ତି', regex: false },
  { key: 'jana', value: 'ଜନ', regex: false },
  { key: 'jana', value: 'ଜନ', regex: false },
  { key: 'swartho', value: 'ସ୍ୱାର୍ଥ', regex: false },
  { key: 'tatwa', value: 'ତତ୍ତ୍ୱ', regex: false },
  { key: 'janch', value: 'ଯାଞ୍ଚ', regex: false },
  { key: 'jane', value: 'ଜାଣେ', regex: false },
  { key: 'jangha', value: 'ଜଙ୍ଘ ', regex: false },
  { key: 'janghia', value: 'ଜଂଘିଆ ', regex: false },
  { key: 'janha', value: 'ଜହ୍ନ', regex: false },
  { key: 'janhamamu', value: 'ଜହ୍ନମାମୁଁ', regex: false },
  { key: 'janjal', value: 'ଜଞ୍ଜାଳ', regex: false },
  { key: 'janji', value: 'ପାଞ୍ଜି', regex: false },
  { key: 'janla', value: 'ଯାଆଁଳା', regex: false },
  { key: 'janma', value: 'ଜନ୍ମ ', regex: false },
  { key: 'janmabhumi', value: 'ଜନ୍ମଭୂମି', regex: false },
  { key: 'janmagata', value: 'ଜନ୍ମଗତ', regex: false },
  { key: 'janmajati', value: 'ଜନ୍ମଜାତ', regex: false },
  { key: 'jano', value: 'ଜାଣ', regex: false },
  { key: 'january', value: 'ଜାନୁଆରୀ', regex: false },
  { key: 'jatibadi', value: 'ଜାତିବାଦୀ', regex: false },
  { key: 'jatil', value: 'ଜଟିଳ', regex: false },
  { key: 'jatilikruta', value: 'ଜଟିଳିକୃତ', regex: false },
  { key: 'jatisanth', value: 'ଜାତିସଂଘ', regex: false },
  { key: 'jatiya', value: 'ଜାତୀୟ', regex: false },
  { key: 'jatna', value: 'ଯତ୍ନ', regex: false },
  { key: 'jaucha', value: 'ଯାଉଛ', regex: false },
  { key: 'jeun', value: 'ଯେଉଁ', regex: false },
  { key: 'jekounasi', value: 'ଯେକୌଣସି ', regex: false },
  { key: 'jepari', value: 'ଯେପରି ', regex: false },
  { key: 'jerundi', value: 'ଜେରୁଣ୍ଡ', regex: false },     
  { key: 'thire', value: 'ଥିରେ ', regex: false },
  { key: 'jhati', value: 'ଝାଟି', regex: false },
  { key: 'jiba', value: 'ଯିବ', regex: false },  
  { key: 'dina', value: 'ଦିନ', regex: false },
  { key: 'kathi', value: 'କାଠି', regex: false },
  { key: 'jibanare', value: 'ଜୀବନରେ', regex: false },
  { key: 'jie', value: 'ଯିଏ', regex: false },
  { key: 'pani', value: 'ପାଣି', regex: false },
  { key: 'jigyansu', value: 'ଜିଜ୍ଞାସୁ ', regex: false },
  { key: 'jihwa', value: 'ଜିହ୍ୱା', regex: false },
  { key: 'jisu', value: 'ଯୀଶୁ', regex: false },
  { key: 'niyojita', value: 'ନିୟୋଜିତ ', regex: false },
  { key: 'jodie', value: 'ଯୋଡ଼ିଏ', regex: false },
  { key: 'jodio', value: 'ଯଦିଓ ', regex: false },
  { key: 'jogajoga', value: 'ଯୋଗଯୋଗ ', regex: false },
  { key: 'jogauchhi', value: 'ଯୋଗାଉଛି', regex: false },
  { key: 'jogai', value: 'ଯୋଗାଇ ', regex: false },
  { key: 'jogya', value: 'ଯଜ୍ଞ', regex: false },
  { key: 'jojana', value: 'ଯୋଜନା', regex: false },
  { key: 'jona', value: 'ଜଣ', regex: false },
  { key: 'joubana', value: 'ଯୌବନ', regex: false },
  { key: 'jparjanta', value: 'ଯେପର୍ଯ୍ୟନ୍ତ', regex: false },
  { key: 'judha', value: 'ଯୁଦ୍ଧ', regex: false },
  { key: 'jugare', value: 'ଯୁଗରେ ', regex: false },
  { key: 'juge', value: 'ଯୁଗେ', regex: false },
  { key: 'juiphula', value: 'ଯୂଈଫୁଲ ', regex: false },
  { key: 'jukta', value: 'ଯୁକ୍ତ', regex: false },
  { key: 'july', value: 'ଜୁଲାଇ', regex: false },
  { key: 'june', value: 'ଜୁନ୍', regex: false },
  { key: 'jutho', value: 'ଯୂଥ', regex: false },
  //{ key: 'jwala', value: 'ଜ୍ଵାଲା', regex: false },
  { key: 'jwara', value: 'ଜ୍ୱର', regex: false },
  { key: 'jyestho', value: 'ଜୈଷ୍ଠ ', regex: false },
  { key: 'kaale', value: 'କାଳେ', regex: false },
  { key: 'kabach', value: 'କବଚ', regex: false },
  { key: 'kabar', value: 'କବର', regex: false },
  { key: 'kabat', value: 'କବାଟ', regex: false },
  { key: 'kabharej', value: 'କଭରେଜ୍ ', regex: false },
  { key: 'kabita', value: 'କବିତା', regex: false },
  { key: 'kabitapatho', value: 'କବିତାପାଠ', regex: false },
  { key: 'kaccha', value: 'କଚ୍ଚା', regex: false },
  { key: 'kach', value: 'କାଚ ', regex: false },
  { key: 'kadachar', value: 'କଦାଗ୍ଭର', regex: false },
  { key: 'kadachit', value: 'କଦାଚିତ', regex: false },
  { key: 'kadambini', value: 'କାଦମ୍ବିନୀ', regex: false },
  { key: 'kadarjya', value: 'କଦର୍ଯ୍ୟ', regex: false },
  { key: 'kadhi', value: 'କାଢ଼ି', regex: false },
  { key: 'kadhineba', value: 'କାଢ଼ିନେବା', regex: false },
  { key: 'kadho', value: 'କଢ଼', regex: false },
  { key: 'kagaj', value: 'କାଗଜ', regex: false },
  { key: 'kahaku', value: 'କାହାକୁ', regex: false },
  { key: 'kahali', value: 'କାହାଳୀ', regex: false },  
  { key: 'kahuni', value: 'କହୁଣି ', regex: false },
  { key: 'kahuthibara', value: 'କହୁଥିବାର', regex: false },
  { key: 'kaikeyi', value: 'କୈକେୟୀ', regex: false },
  { key: 'kailasa', value: 'କୈଳାସ', regex: false },
  { key: 'kailasagiri', value: 'କୈଳାସଗିରି', regex: false },
  { key: 'kaincha', value: 'କାଇଁଚ', regex: false },
  { key: 'kainchi', value: 'କଇଁଚି ', regex: false },
  { key: 'kaincho', value: 'କଇଁଛ', regex: false },
  { key: 'kaindrik', value: 'କୈନ୍ଦ୍ରିକ', regex: false },
  { key: 'kaindrikaran', value: 'କୈନ୍ଦ୍ରିକରଣ', regex: false },
  { key: 'kaishor', value: 'କୈଶୋର', regex: false },
  { key: 'kajal', value: 'କାଜଲ', regex: false },
  { key: 'kajalapati', value: 'କଜଳପାତି', regex: false },
  { key: 'kajwal', value: 'କଜ୍ଜଳ', regex: false },
  { key: 'kakhya', value: 'କକ୍ଷ ', regex: false },
  { key: 'kala', value: 'କଲ', regex: false },
  { key: 'kalah', value: 'କଳହ ', regex: false },
  { key: 'kalahpriya', value: 'କଳହପ୍ରିୟ', regex: false },
  { key: 'kalakakhy', value: 'କଳାକକ୍ଷ', regex: false },
  { key: 'kalakar', value: 'କଳାକାର ', regex: false },
  { key: 'kalalangal', value: 'କଳଲଙ୍ଗଳ', regex: false },
  { key: 'kalam', value: 'କାଲାମ', regex: false },
  { key: 'kalank', value: 'କଳଙ୍କ', regex: false },
  { key: 'kalanki', value: 'କଳଙ୍କି ', regex: false },
  { key: 'kalankita', value: 'କଳଙ୍କିତ', regex: false },
  { key: 'kalapadhar', value: 'କଳାପଥର', regex: false },
  { key: 'kalapata', value: 'କଳାପଟା', regex: false },
  { key: 'kalare', value: 'କାଳରେ', regex: false },
  { key: 'kalaru', value: 'କାଳରୁ', regex: false },
  { key: 'kale', value: 'କଲେ', regex: false },
  { key: 'kalli', value: 'କାଲି', regex: false },
  { key: 'kalichuna', value: 'କଲିଚୂନ', regex: false },
  { key: 'kalihuda', value: 'କଳିହୁଡ଼ା', regex: false },
  { key: 'kalipsa', value: 'କାଲିପ୍ଶା', regex: false },
  { key: 'kalo', value: 'କାଳ', regex: false },
  { key: 'kalpana', value: 'କଳ୍ପନା', regex: false },
  { key: 'kalpanik', value: 'କାଳ୍ପନିକ', regex: false },
  { key: 'kalushita', value: 'କଳୁଷିତ', regex: false },
  { key: 'kalyana', value: 'କଲ୍ୟାଣ', regex: false },
  { key: 'kamo', value: 'କାମ', regex: false },
  { key: 'kamai', value: 'କମାଇ', regex: false },
  { key: 'kamaiba', value: 'କମାଇବା', regex: false },
  { key: 'kamaibo', value: 'କମାଇବ', regex: false },
  { key: 'kamaicha', value: 'କମାଇଚା', regex: false },
  { key: 'kamaiche', value: 'କମାଇଚେ', regex: false },
  { key: 'kamaichho', value: 'କମାଇଛ', regex: false },
  { key: 'kamaicho', value: 'କମାଇଚ', regex: false },
  { key: 'kamaideba', value: 'କମାଇଦେବା', regex: false },
  { key: 'kamaikari', value: 'କମାଇକରି ', regex: false },
  { key: 'kamailo', value: 'କମାଇଲ', regex: false },
  { key: 'kamaithanto', value: 'କମାଇଥାନ୍ତ', regex: false },
  { key: 'kamajibo', value: 'କମାଯିବ ', regex: false },
  { key: 'kaman', value: 'କମାଣ', regex: false },
  { key: 'kamanto', value: 'କମାନ୍ତ', regex: false },
  { key: 'kamarpati', value: 'କମରପଟି', regex: false },
  { key: 'kambal', value: 'କମ୍ବଳ', regex: false },
  { key: 'kambu', value: 'କମ୍ବୁ', regex: false },
  { key: 'kamei', value: 'କମେଇ', regex: false },
  { key: 'kameibo', value: 'କମେଇବ ', regex: false },
  { key: 'kameicha', value: 'କମେଇଚ', regex: false },
  { key: 'kameichha', value: 'କମେଇଚ୍ଛା', regex: false },
  { key: 'kameichho', value: 'କମେଇଛ ', regex: false },
  { key: 'kameichi', value: 'କମେଇଚି', regex: false },
  { key: 'kameichu', value: 'କମେଇଚୁ', regex: false },
  { key: 'kameilo', value: 'କମେଇଲ', regex: false },
  { key: 'kameilu', value: 'କମେଇଲୁ', regex: false },
  { key: 'kameithanto', value: 'କମେଇଥାନ୍ତ', regex: false },
  { key: 'kamejibo', value: 'କମେଇଯିବ ', regex: false },
  { key: 'kamidiajibo', value: 'କମାଇଦିଆଯିବ', regex: false },
  { key: 'kamijibo', value: 'କମିଯିବ ', regex: false },
  { key: 'kamikatho', value: 'କାମୀକାଠ', regex: false },
  { key: 'kamini', value: 'କାମିନୀ', regex: false },
  { key: 'kamiti', value: 'କମିଟି', regex: false },
  { key: 'kamp', value: 'କମ୍ପ', regex: false },
  { key: 'kampan', value: 'କମ୍ପନ ', regex: false },
  { key: 'kampi', value: 'କାମ୍ପି', regex: false },
  { key: 'computer', value: 'କମ୍ପ୍ୟୁଟର', regex: false },
  { key: 'course', value: 'କୋର୍ସ', regex: false },
  { key: 'baddi', value: 'ବାଡ଼ି', regex: false },
  { key: 'maddi', value: 'ବାଡ଼ି', regex: false },
  { key: 'bonhi', value: 'ବହ୍ନି', regex: false },
  { key: 'hutashan', value: 'ହୁତାଶନ', regex: false },
  { key: 'baishwanara', value: 'ବୈଶ୍ବାନର', regex: false },
  { key: 'piyush', value: 'ପିୟୂଷ', regex: false },
  { key: 'amiya', value: 'ଅମିୟ', regex: false },
  { key: 'gahan', value: 'ଗହନ', regex: false },
  { key: 'deitya', value: 'ଦୖେତ୍ୟ', regex: false },
  { key: 'kamya', value: 'କାମ୍ୟ', regex: false },
  { key: 'kona', value: 'କଣା', regex: false },
  { key: 'kanbhan', value: 'କାଁଭାଁ', regex: false },
  { key: 'kancha', value: 'କଞ୍ଚା ', regex: false },
  { key: 'kanchan', value: 'କାଞ୍ଚନ', regex: false },
  { key: 'kanda', value: 'କାଣ୍ଡ', regex: false },
  { key: 'kandagyana', value: 'କାଣ୍ଡଜ୍ଞାନ', regex: false },
  { key: 'kandakota', value: 'କନ୍ଦାକଟା', regex: false },
  { key: 'kandan', value: 'କାନ୍ଦଣ', regex: false },
  { key: 'kandha', value: 'କନ୍ଧ', regex: false },
  { key: 'mal', value: 'ମାଳ', regex: false },
  { key: 'kandhei', value: 'କଣ୍ଢେଇ', regex: false },
  { key: 'kaandha', value: 'କାନ୍ଧ', regex: false },
  { key: 'kando', value: 'କାଣ୍ଡ', regex: false },
  { key: 'kangal', value: 'କାଙ୍ଗାଳ', regex: false },
  { key: 'kanhar', value: 'କହଁର', regex: false },
  { key: 'kanhiki', value: 'କାହିଁକି', regex: false },
  { key: 'kanika', value: 'କଣିକା', regex: false },
  { key: 'kanistha', value: 'କନିଷ୍ଠ', regex: false },
  { key: 'kanistho', value: 'କନିଷ୍ଠ', regex: false },
  { key: 'kanjamendi', value: 'କନ୍ଯାମେଣ୍ଡି', regex: false },
  { key: 'kanjiahuda', value: 'କାଞ୍ଜିଆହୁଦା', regex: false },
  { key: 'kanjush', value: 'କଞ୍ଜୁଷ', regex: false },
  { key: 'kankada', value: 'କଙ୍କଡ଼ା', regex: false },
  { key: 'kankal', value: 'କଙ୍କାଳ ', regex: false },
  { key: 'kanla', value: 'କଅଁଳା', regex: false },
  { key: 'kansa', value: 'କଂସା', regex: false },
  { key: 'kansari', value: 'କଂସାରି', regex: false },
  { key: 'kansasura', value: 'କଂସାସୁର', regex: false },
  { key: 'kansei', value: 'କଂସେଇ', regex: false },
  { key: 'kanso', value: 'କଂସ', regex: false },
  { key: 'kanta', value: 'କଣ୍ଟା', regex: false },
  { key: 'kontakita', value: 'କଣ୍ଟକିତ', regex: false },
  { key: 'kantha', value: 'କାନ୍ଥ', regex: false },
  { key: 'kantho', value: 'କଣ୍ଠ', regex: false },
  { key: 'kanti', value: 'କାଣ୍ଟି', regex: false },
  { key: 'kanya', value: 'କନ୍ୟା', regex: false },
  { key: 'kapat', value: 'କପଟ ', regex: false },
  { key: 'kapatachara', value: 'କପଟାଗ୍ଭରା', regex: false },
  { key: 'kaphin', value: 'କଫନ', regex: false },
  { key: 'koro', value: 'କର', regex: false },
  { key: 'karabasa', value: 'କାରାବାସ', regex: false },
  { key: 'karadata', value: 'କରଦାତା', regex: false },
  { key: 'karadharjya', value: 'କରଧାର୍ଯ୍ୟ ', regex: false },
  { key: 'karaib', value: 'କରାଇବ ', regex: false },
  { key: 'karaj', value: 'କରଜ', regex: false },
  { key: 'kora', value: 'କରା', regex: false },
  { key: 'jaichhi', value: 'ଯାଇଛି', regex: false },
  { key: 'jaichi', value: 'ଯାଇଚି', regex: false },
  { key: 'jaithiba', value: 'ଯାଇଥିବ', regex: false },
  { key: 'jauchhi', value: 'ଯାଉଛି', regex: false },
  { key: 'jauchi', value: 'ଯାଉଚି', regex: false },
  { key: 'mantri', value: 'ମନ୍ତ୍ରୀ', regex: false },
  { key: 'uparu', value: 'ଉପରୁ', regex: false },
  { key: 'karjyanusthana', value: 'କାର୍ଯ୍ୟାନୁଷ୍ଠାନ', regex: false },
  { key: 'pachhare', value: 'ପଛରେ', regex: false },
  { key: 'pachare', value: 'ପଚାରେ', regex: false },
  { key: 'sadasya', value: 'ସଦସ୍ୟ', regex: false },
  { key: 'pain', value: 'ପାଇଁ', regex: false },
  { key: 'karokhana', value: 'କାରଖାନା', regex: false },
  { key: 'karan', value: 'କାରଣ', regex: false },
  { key: 'darsao', value: 'ଦର୍ଶାଅ', regex: false },
  { key: 'nirdharak', value: 'ନିର୍ଦ୍ଧାରକ', regex: false },  
  { key: 'koroniya', value: 'କରଣୀୟ', regex: false },
  { key: 'korontu', value: 'କରନ୍ତୁ', regex: false },
  { key: 'kararakhi', value: 'କାରାରକ୍ଷୀ', regex: false },
  { key: 'kararudhha', value: 'କାରାରୁଦ୍ଧ', regex: false },
  { key: 'karasadi', value: 'କାରସାଦି', regex: false },
  { key: 'kare', value: 'କରେ', regex: false },
  { key: 'kori', value: 'କରି ', regex: false },
  { key: 'karichanti', value: 'କରିଛନ୍ତି', regex: false },
  { key: 'karichhi', value: 'କରିଛି', regex: false },
  { key: 'karigar', value: 'କାରିଗର', regex: false },
  { key: 'kari', value: 'କରି', regex: false },
  { key: 'karithae', value: 'କରିଥାଏ ', regex: false },
  { key: 'karjya', value: 'କାର୍ଯ୍ୟ', regex: false },
  { key: 'karjyabhara', value: 'କାର୍ଯ୍ୟଭାର', regex: false },
  { key: 'karjyabibarani', value: 'କାର୍ଯ୍ୟବିବରଣୀ', regex: false },
  { key: 'karjyabidhi', value: 'କାର୍ଯ୍ୟବିଧି', regex: false },
  { key: 'karjyadakhya', value: 'କାର୍ଯ୍ୟଦକ୍ଷ', regex: false },
  { key: 'karjyadesha', value: 'କାର୍ଯ୍ୟାଦେଶ', regex: false },
  { key: 'karjyaduta', value: 'କାର୍ଯ୍ୟଦୂତ', regex: false },
  { key: 'karjyagyan', value: 'କାର୍ଯ୍ୟଜ୍ଞାନ', regex: false },
  { key: 'karjyajyogi', value: 'କାର୍ଯ୍ୟପଯୋଗୀ', regex: false },
  { key: 'karjyakala', value: 'କାର୍ଯ୍ୟକାଳ', regex: false },
  { key: 'karjyakalap', value: 'କାର୍ଯ୍ୟକଳାପ ', regex: false },
  { key: 'karjyakari', value: 'କାର୍ଯ୍ୟକାରୀ', regex: false },
  { key: 'karjyakarini', value: 'କାର୍ଯ୍ୟକାରିଣୀ', regex: false },
  { key: 'karjyakarita', value: 'କାର୍ଯ୍ୟକାରିତା', regex: false },
  { key: 'karjyakarta', value: 'କାର୍ଯ୍ୟକର୍ତ୍ତା', regex: false },
  { key: 'karjyakhetra', value: 'କାର୍ଯ୍ୟକ୍ଷେତ୍ର', regex: false },
  { key: 'karjyakrama', value: 'କାର୍ଯ୍ୟକ୍ରମ', regex: false },
  { key: 'karjyakusal', value: 'କାର୍ଯ୍ୟକୁଶଳ', regex: false },
  { key: 'karjyalaya', value: 'କାର୍ଯ୍ୟାଳୟ', regex: false },
  { key: 'karjyamukta', value: 'କାର୍ଯ୍ୟମୁକ୍ତ', regex: false },
  { key: 'karjyanirbaha', value: 'କାର୍ଯ୍ୟନିର୍ବାହ', regex: false },
  { key: 'karjyanirbahaka', value: 'କାର୍ଯ୍ୟନିର୍ବାହକ', regex: false },
  { key: 'karjyanirbahi', value: 'କାର୍ଯ୍ୟନିର୍ବାହୀ', regex: false },
  { key: 'karjyanusthan', value: 'କାର୍ଯ୍ୟାନୁଷ୍ଠାନ ', regex: false },
  { key: 'karjyanwaya', value: 'କାର୍ଯ୍ୟାନ୍ୱୟ', regex: false },
  { key: 'karjyanwita', value: 'କାର୍ଯ୍ୟାନ୍ବିତ', regex: false },
  { key: 'karjyapadhati', value: 'କାର୍ଯ୍ୟପଦ୍ଧତି', regex: false },
  { key: 'karjyapustika', value: 'କାର୍ଯ୍ୟପୁସ୍ତିକା ', regex: false },
  { key: 'karjyaramba', value: 'କାର୍ଯ୍ୟାରମ୍ଭ ', regex: false },
  { key: 'karjyarata', value: 'କାର୍ଯ୍ୟରତ', regex: false },
  { key: 'karjyasadhan', value: 'କାର୍ଯ୍ୟସାଧନ', regex: false },
  { key: 'karjyasamaya', value: 'କାର୍ଯ୍ୟସମୟ ', regex: false },
  { key: 'karjyashala', value: 'କାର୍ଯ୍ୟଶାଳା', regex: false },
  { key: 'karjyatara', value: 'କାର୍ଯ୍ୟତ୍ତର', regex: false },
  { key: 'karjyatho', value: 'କାର୍ଯ୍ୟତଃ', regex: false },
  { key: 'karmabira', value: 'କର୍ମବୀର', regex: false },
  { key: 'karmachari', value: 'କର୍ମଗ୍ଭରୀ ', regex: false },
  { key: 'karmachyut', value: 'କର୍ମଚ୍ୟୁତ', regex: false },
  { key: 'karmanibrut', value: 'କର୍ମନିବୃତ୍ତ', regex: false },
  { key: 'karmashala', value: 'କର୍ମଶାଳା', regex: false },
  { key: 'karmatha', value: 'କର୍ମଠ', regex: false },
  { key: 'karmidala', value: 'କର୍ମୀଦଳ', regex: false },
  { key: 'karna', value: 'କର୍ଣ୍ଣ', regex: false },
  { key: 'karne', value: 'କର୍ଣ୍ଣେ ', regex: false },
  { key: 'karpas', value: 'କାର୍ପାସ', regex: false },
  { key: 'karshan', value: 'କର୍ଷଣ', regex: false },
  { key: 'korta', value: 'କର୍ତ୍ତା', regex: false },
  { key: 'kortri', value: 'କର୍ତ୍ତ୍ରୀ', regex: false },
  { key: 'mahiyasi', value: 'ମହୀୟସୀ', regex: false },  
  { key: 'kartabya', value: 'କର୍ତ୍ତବ୍ୟ', regex: false },
  { key: 'bakhara', value: 'ବଖରା', regex: false },
  { key: 'sabat', value: 'ସାବତ', regex: false },
  { key: 'ado', value: 'ଆଡ଼', regex: false },
  { key: 'chahun', value: 'ଚାହୁଁ', regex: false },
  { key: 'chanti', value: 'ଛନ୍ତି', regex: false },
  { key: 'rasta', value: 'ରାସ୍ତା', regex: false },
  { key: 'shita', value: 'ଶୀତ', regex: false },
  { key: 'kartika', value: 'କାର୍ତ୍ତିକ', regex: false },
  { key: 'kartupakhya', value: 'କର୍ତ୍ତୃପକ୍ଷ', regex: false },
  { key: 'karuna', value: 'କରୁଣା', regex: false },
  { key: 'kastasadhya', value: 'କଷ୍ଟସାଧ୍ୟ', regex: false },
  { key: 'kastho', value: 'କାଷ୍ଠ', regex: false },
  { key: 'kasthochitra', value: 'କାଷ୍ଠଚିତ୍ର', regex: false },
  { key: 'kata', value: 'କଟା', regex: false },
  { key: 'katani', value: 'କଟଣି', regex: false },
  { key: 'katchandi', value: 'କାଟଛାଣ୍ଟ', regex: false },
  { key: 'katha', value: 'କଥା', regex: false },
  { key: 'kathabarta', value: 'କଥାବାର୍ତ୍ତା', regex: false },
  { key: 'kathachitra', value: 'କଥାଚିତ୍ର', regex: false },
  { key: 'kathagada', value: 'କାଠଗଡ଼', regex: false },
  { key: 'kathakama', value: 'କାଠକାମ', regex: false },
  { key: 'kathaniya', value: 'କଥନୀୟ', regex: false },
  { key: 'kathino', value: 'କଠିନ', regex: false },
  { key: 'katho', value: 'କାଠ', regex: false },
  { key: 'kathok', value: 'କଥକ', regex: false },
  { key: 'kathon', value: 'କଥନ', regex: false },
  { key: 'kathoniya', value: 'କଥନୀୟ', regex: false },
  { key: 'kathopkathan', value: 'କଥୋପକଥନ', regex: false },
  { key: 'kathsanitya', value: 'କଥାସାହିତ୍ୟ ', regex: false },
  { key: 'kathuria', value: 'କାଠୁରିଆ', regex: false },
  { key: 'katiba', value: 'କାଟିବା', regex: false },
  { key: 'katipakeiba', value: 'କାଟିପକାଇବା', regex: false },
  { key: 'katkhya', value: 'କଟାକ୍ଷ ', regex: false },
  { key: 'kato', value: 'କାଟ', regex: false },
  { key: 'katukti', value: 'କଟୁକ୍ତି ', regex: false },
  { key: 'kau', value: 'କାଉ', regex: false },
  { key: 'kaudi', value: 'କଉଡ଼ି', regex: false },
  { key: 'kaul', value: 'କାଉଲ', regex: false },
  { key: 'kaya', value: 'କାୟା', regex: false },
  { key: 'kebal', value: 'କେବଳ ', regex: false },
  { key: 'kebala', value: 'କେବଳ', regex: false },
  { key: 'kebalmatra', value: 'କେବଳମାତ୍ର', regex: false },
  { key: 'kebe', value: 'କେବେ', regex: false },
  { key: 'kebebi', value: 'କେବେବି', regex: false },
  { key: 'kede', value: 'କେଡ଼େ', regex: false },
  { key: 'keela', value: 'କୀଳା', regex: false },
  { key: 'kenchiba', value: 'କେଞ୍ଚିବା', regex: false },
  { key: 'kenchua', value: 'କେଞ୍ଚୁଆ', regex: false },
  { key: 'kendra', value: 'କେନ୍ଦ୍ର', regex: false },
  { key: 'kendriya', value: 'କେନ୍ଦ୍ରୀୟ', regex: false },
  { key: 'keral', value: 'କେରଳ', regex: false },
  { key: 'keshari', value: 'କେଶର', regex: false },
  { key: 'keso', value: 'କେଶ', regex: false },
  { key: 'kete', value: 'କେତେ', regex: false },
  { key: 'ketaka', value: 'କେତେକ', regex: false },
  { key: 'ketaki', value: 'କେତକୀ', regex: false },
  { key: 'ketideba', value: 'କାଟିଦେବା', regex: false },
  { key: 'keunti', value: 'କେଉଁଟି', regex: false },
  { key: 'khaanda', value: 'ଖଣ୍ଡା ', regex: false },
  { key: 'khachit', value: 'ଖଚିତ ', regex: false },
  { key: 'khdan', value: 'ଖାଦାନ', regex: false },
  { key: 'khadga', value: 'ଖଡ୍ଗ ', regex: false },
  { key: 'khadgadhari', value: 'ଖଡ୍ଗଧାରୀ', regex: false },
  { key: 'khadi', value: 'ଖାଡ଼ି', regex: false },
  { key: 'khadya', value: 'ଖାଦ୍ୟ', regex: false },
  { key: 'khadyadrobya', value: 'ଖାଦ୍ୟଦ୍ରବ୍ୟ', regex: false },
  { key: 'khadyapadarth', value: 'ଖାଦ୍ୟପଦାର୍ଥ', regex: false },
  { key: 'khadyasasya', value: 'ଖାଦ୍ୟଶସ୍ୟ', regex: false },
  { key: 'khai', value: 'ଖାଇ', regex: false },
  { key: 'khaiba', value: 'ଖାଇବା', regex: false },
  { key: 'khaibaku', value: 'ଖାଇବାକୁ', regex: false },
  { key: 'kasta', value: 'କଷ୍ଟ', regex: false },
  //{ key: 'khaisari', value: 'ଖାଇସାରି ', regex: false },
  { key: 'khajana', value: 'ଖଜଣା', regex: false },
//  { key: 'khajuri', value: 'ଖଜୁରି', regex: false },
  { key: 'khalas', value: 'ଖଲାସ', regex: false },
  { key: 'khali', value: 'ଖାଲି', regex: false },
  { key: 'khalo', value: 'ଖାଲ', regex: false },
  { key: 'khamkhiali', value: 'ଖାମଖିଆଲୀ', regex: false },
  { key: 'khan', value: 'ଖାନ୍', regex: false },
  //{ key: 'khanan', value: 'ଖନନ', regex: false },
  { key: 'khanda', value: 'ଖଣ୍ଡ', regex: false },
  { key: 'khandagiri', value: 'ଖଣ୍ଡଗିରି', regex: false },
  { key: 'khandan', value: 'ଖଣ୍ଡନ', regex: false },
  { key: 'khandayat', value: 'ଖଣ୍ଡାୟତ', regex: false },
  { key: 'khandia', value: 'ଖଣ୍ଡିଆ', regex: false },
  //{ key: 'khandita', value: 'ଖଣ୍ଡିତ', regex: false },
  { key: 'khani', value: 'ଖଣି', regex: false },
  { key: 'khanjib', value: 'ଖଞ୍ଜିବ', regex: false },
  { key: 'khantalas', value: 'ଖାନତଲାସ ', regex: false },
  { key: 'khanti', value: 'ଖାଣ୍ଟି', regex: false },
  { key: 'khapachada', value: 'ଖାପଛଡ଼ା', regex: false },
  { key: 'khappa', value: 'ଖପ୍ପା', regex: false },
  { key: 'khara', value: 'ଖାରା', regex: false },
  { key: 'kharaj', value: 'ଖାରଜ ', regex: false },
  { key: 'kharap', value: 'ଖରାପ', regex: false },
  { key: 'kharia', value: 'ଖାରିଆ', regex: false },
  { key: 'khariti', value: 'ଖାତିରି', regex: false },
  { key: 'khasada', value: 'ଖସଡ଼ା', regex: false },
  { key: 'khasiba', value: 'ଖସିବା', regex: false },
  { key: 'khata', value: 'ଖାତା', regex: false },
  { key: 'khyati', value: 'ଖ୍ୟାତି', regex: false },
  { key: 'khatikhia', value: 'ଖଟିଖିଆ', regex: false },
  { key: 'khatua', value: 'ଖଟୁଆ', regex: false },
  { key: 'khauti', value: 'ଖାଉଟି', regex: false },
  { key: 'khela', value: 'ଖେଳ', regex: false },
  { key: 'khelali', value: 'ଖେଳାଳି', regex: false },
  { key: 'mananku', value: 'ମାନଙ୍କୁ', regex: false },
  { key: 'khelana', value: 'ଖେଳନା', regex: false },
  { key: 'khelapriya', value: 'ଖେଳପ୍ରିୟ', regex: false },
  { key: 'kheliba', value: 'ଖେଳିବା', regex: false },
  { key: 'kheli', value: 'ଖେଳି', regex: false },
  { key: 'khepan', value: 'କ୍ଷେପଣ', regex: false },
  { key: 'khepanastra', value: 'କ୍ଷେପଣାସ୍ତ୍ର', regex: false },
  { key: 'khepani', value: 'କ୍ଷେପଣୀ', regex: false },
  { key: 'khetraphala', value: 'କ୍ଷେତ୍ରଫଳ', regex: false },
  { key: 'khod', value: 'ଖୋଦ ', regex: false },
  { key: 'khodada', value: 'ଖଦଡ', regex: false },
  { key: 'khodan', value: 'ଖୋଦନ', regex: false },
  { key: 'khodeiba', value: 'ଖୋଦେଇବ', regex: false },
  { key: 'khodeila', value: 'ଖୋଦେଇଲ', regex: false },
  { key: 'khodita', value: 'ଖୋଦିତ', regex: false },
  { key: 'khojiba', value: 'ଖୋଜିବ', regex: false },
  { key: 'khojila', value: 'ଖୋଜିଲ', regex: false },
  { key: 'khola', value: 'ଖୋଳ', regex: false },
  { key: 'kholanayak', value: 'ଖଳନାୟକ', regex: false },
  { key: 'kholap', value: 'ଖୋଳପ', regex: false },
  { key: 'kholi', value: 'ଖୋଳି', regex: false },
  { key: 'kholiba', value: 'ଖୋଳିବା', regex: false },
  { key: 'khora', value: 'ଖରା', regex: false },
  { key: 'khorch', value: 'ଖର୍ଚ୍ଚ', regex: false },
  { key: 'khosamat', value: 'ଖୋସାମତ', regex: false },
  { key: 'khota', value: 'ଖଟା', regex: false },
  { key: 'khoto', value: 'ଖଟ', regex: false },
  { key: 'khotoka', value: 'ଖଟକା', regex: false },
  { key: 'khotoni', value: 'ଖଟଣି', regex: false },
  { key: 'khristabdha', value: 'ଖ୍ରୀଷ୍ଟାବ୍ଦ', regex: false },
  { key: 'khristian', value: 'ଖ୍ରୀଷ୍ଟିୟାନ', regex: false },
  { key: 'khristopurba', value: 'ଖ୍ରୀଷ୍ଟ ପୂର୍ବ', regex: false },
  { key: 'khuaiba', value: 'ଖୁଆଇବ', regex: false },
  { key: 'khuaila', value: 'ଖୁଆଇଲ', regex: false },
  { key: 'khuchura', value: 'ଖୁଚୁରା', regex: false },
  { key: 'khumpi', value: 'ଖୁମ୍ପିବ', regex: false },
  { key: 'khuni', value: 'ଖୁଣୀ', regex: false },
  { key: 'khyama', value: 'କ୍ଷମା', regex: false },
  { key: 'khyanata', value: 'କ୍ଷଣତା', regex: false },
  { key: 'khyariya', value: 'କ୍ଷାରୀୟ', regex: false },
  { key: 'khyati', value: 'କ୍ଷତି', regex: false },
  { key: 'khydhart', value: 'କ୍ଷୁଧାର୍ତ୍ତ', regex: false },
  { key: 'khyetra', value: 'କ୍ଷେତ୍ର', regex: false },
  { key: 'khyetradhika', value: 'କ୍ଷେତ୍ରାଧିକାର', regex: false },
  { key: 'khyina', value: 'କ୍ଷୀଣ', regex: false },
  { key: 'khyipra', value: 'କ୍ଷିପ୍ର', regex: false },
  { key: 'khyiprata', value: 'କ୍ଷିପ୍ରତା', regex: false },
  { key: 'khyobha', value: 'କ୍ଷୋଭ', regex: false },
  { key: 'khyohat', value: 'କ୍ଷତ', regex: false },
  { key: 'khyoma', value: 'କ୍ଷମା', regex: false },
  { key: 'khyomaniya', value: 'କ୍ଷମଣୀୟ', regex: false },
  { key: 'khyomasila', value: 'କ୍ଷମାଶୀଳ', regex: false },
  { key: 'khyonasthayi', value: 'କ୍ଷଣସ୍ଥାୟୀ', regex: false },
  { key: 'khyonika', value: 'କ୍ଷଣିକ', regex: false },
  { key: 'khyoran', value: 'କ୍ଷରଣ', regex: false },
  { key: 'khyotigrasta', value: 'କ୍ଷତିଗ୍ରସ୍ତ', regex: false },
  { key: 'khyotipurak', value: 'କ୍ଷତିପୂରକ', regex: false },
  { key: 'khyotipuran', value: 'କ୍ଷତିପୂରଣ', regex: false },
  { key: 'khyoyakari', value: 'କ୍ଷୟକାରୀ', regex: false },
  { key: 'khyudha', value: 'କ୍ଷୁଧା', regex: false },
  { key: 'khyudra', value: 'କ୍ଷୁଦ୍ର', regex: false },
  { key: 'kian', value: 'କିଆଁ', regex: false },
  { key: 'kiari', value: 'କିଆରୀ', regex: false },
  { key: 'kichhi', value: 'କିଛି', regex: false },
  { key: 'nahi', value: 'ନାହିଁ', regex: false },
  { key: 'janiba', value: 'ଜାଣିବ', regex: false },  
  { key: 'kimba', value: 'କିମ୍ବା', regex: false },
  { key: 'kimbadanti', value: 'କିମ୍ବଦନ୍ତୀ', regex: false },
  { key: 'kinchit', value: 'କିଞ୍ଚିତ୍', regex: false },
  { key: 'kinib', value: 'କିଣିବ', regex: false },
  { key: 'kintu', value: 'କିନ୍ତୁ', regex: false },
  { key: 'kipari', value: 'କିପରି', regex: false },
  { key: 'kirani', value: 'କିରାଣୀ', regex: false },
  { key: 'kirati', value: 'କୀରତି', regex: false },
  { key: 'kirti', value: 'କୀର୍ତ୍ତି', regex: false },
  { key: 'kisam', value: 'କିସମ', regex: false },
  { key: 'kishor', value: 'କିଶୋର', regex: false },
  { key: 'kisti', value: 'କିସ୍ତି', regex: false },
  { key: 'kito', value: 'କୀଟ', regex: false },
  { key: 'kitobigyan', value: 'କୀଟବିଜ୍ଞାନ', regex: false },
  { key: 'kitonasak', value: 'କୀଟନାଶକ', regex: false },
  { key: 'kk', value: 'କ୍କ', regex: false },
  { key: 'klanta', value: 'କ୍ଲାନ୍ତ ', regex: false },
  { key: 'klanti', value: 'କ୍ଲାନ୍ତି', regex: false },
  { key: 'klantijanak', value: 'କ୍ଳାନ୍ତିଜନକ', regex: false },
  { key: 'klantikar', value: 'କ୍ଳାନ୍ତିକର', regex: false },
  { key: 'kleba', value: 'କ୍ଳୀବ', regex: false },
  { key: 'klesa', value: 'କ୍ଳେଶ', regex: false },
  { key: 'kodhi', value: 'କଢ଼ି', regex: false },
  { key: 'kodie', value: 'କୋଡ଼ିଏ', regex: false },
  { key: 'kohal', value: 'କୋହଳ', regex: false },
  { key: 'koili', value: 'କୋଇଲି', regex: false },
  { key: 'koin', value: 'କଇଁ', regex: false },
  { key: 'kojal', value: 'କଜଳ', regex: false },
  { key: 'kojjl', value: 'କଜ୍ଜଳ ', regex: false },
  { key: 'kokua', value: 'କୋକୁଆ', regex: false },
  { key: 'kola', value: 'କଳା', regex: false },
  { key: 'kolahala', value: 'କୋଳାହଳ', regex: false },
  { key: 'kolam', value: 'କଲମ', regex: false },
  { key: 'kolan', value: 'କୋଲନ୍‌', regex: false },
  { key: 'kolare', value: 'କୋଳରେ', regex: false },
  { key: 'kole', value: 'କୋଳେ', regex: false },
  { key: 'kolebar', value: 'କଳେବର', regex: false },
  { key: 'kolija', value: 'କଲିଜା', regex: false },
  { key: 'kol', value: 'କୋଳ', regex: false },
  { key: 'komal', value: 'କୋମଳ', regex: false },
  { key: 'komalamati', value: 'କୋମଳମତୀ', regex: false },
  { key: 'komiti', value: 'କମିଟି ', regex: false },
  { key: 'kon', value: 'କୋଣ', regex: false },
  { key: 'koo', value: 'କୂ ', regex: false },
  { key: 'kopal', value: 'କପାଳ', regex: false },
  { key: 'kopikal', value: 'କପିକଳ ', regex: false },
  { key: 'kopo', value: 'କୋପ', regex: false },
  { key: 'korada', value: 'କୋରଡ଼ା', regex: false },
  { key: 'kosa', value: 'କୋଷ', regex: false },
  { key: 'koshadhyakhya', value: 'କୋଷାଧ୍ୟକ୍ଷ', regex: false },
  { key: 'koshagara', value: 'କୋଷାଗାର', regex: false },
  { key: 'kosthee', value: 'କୋଷ୍ଠୀ', regex: false },
  { key: 'kotagarh', value: 'କୋଠଗଡ଼', regex: false },
  { key: 'kotho', value: 'କୋଠ', regex: false },
  { key: 'kothor', value: 'କଠୋର', regex: false },
  { key: 'kothori', value: 'କୋଠରୀ', regex: false },
  { key: 'kounasi', value: 'କୌଣସି', regex: false },
  { key: 'koupina', value: 'କୌପୀନ', regex: false },
  { key: 'kousala', value: 'କୌଶଳ', regex: false },
  { key: 'koushalya', value: 'କୌଶଲ୍ୟା', regex: false },
  { key: 'koutuhala', value: 'କୌତୁହଳ', regex: false },
  { key: 'koutuhali', value: 'କୌତୁହଳୀ', regex: false },
  { key: 'koutuka', value: 'କୌତୁକ', regex: false },
  { key: 'joutuka', value: 'ଯୋୖତୁକ', regex: false },
  { key: 'utapta', value: 'ଉତ୍ତପ୍ତ', regex: false },
  { key: 'kabindra', value: 'କବିନ୍ଦ୍ର', regex: false },
  { key: 'chalachitra', value: 'ଚଳଚିତ୍ର', regex: false },
  { key: 'digambar', value: 'ଦିଗମ୍ବର', regex: false },
  { key: 'mitoni', value: 'ନିତଣୀ', regex: false },
  { key: 'jubati', value: 'ଯୁବତୀ', regex: false },
  { key: 'jubaka', value: 'ଯୁବକ', regex: false },
  { key: 'sikhyoyatri', value: 'ଶିକ୍ଷୟତ୍ରୀ', regex: false },
  { key: 'sikhyok', value: 'ଶିକ୍ଷକ', regex: false },
  { key: 'drudhota', value: 'ଦୃଢ଼ତା', regex: false },
  { key: 'pourusa', value: 'ପୖୋରୁଷ', regex: false },
  { key: 'soundarjya', value: 'ସୖୋନ୍ଦର୍ଯ୍ୟ', regex: false },
  { key: 'baisistya', value: 'ବୖେଶିଷ୍ତ୍ୟ', regex: false },
  { key: 'purbanha', value: 'ପୂର୍ବାହ୍ନ', regex: false },
  { key: 'aparanha', value: 'ଅପରାହ୍ନ', regex: false },
  { key: 'madhyanha', value: 'ମଧ୍ୟାହ୍ନ', regex: false },
  { key: 'sworna', value: 'ସ୍ୱର୍ଣ୍ଣ', regex: false },
  { key: 'sorbangino', value: 'ସର୍ବାଙ୍ଗୀନ', regex: false },
  { key: 'atmiya', value: 'ଆତ୍ମୀ୍ୟ', regex: false },
  { key: 'ekotra', value: 'ଏକତ୍ର', regex: false },
  { key: 'akankhya', value: 'ଆକାଂକ୍ଷା', regex: false },
  { key: 'spruha', value: 'ସ୍ପୃହା', regex: false },
  { key: 'paramatma', value: 'ପରମାତ୍ମା', regex: false },
  { key: 'koutukia', value: 'କୌତୁକିୟା', regex: false },
  { key: 'kramash', value: 'କ୍ରମଶଃ', regex: false },
  { key: 'kramagata', value: 'କ୍ରମାଗତ', regex: false },
  { key: 'kramanka', value: 'କ୍ରମାଙ୍କ', regex: false },
  { key: 'kramanusare', value: 'କ୍ରମାନୁସାରେ', regex: false },
  { key: 'kramik', value: 'କ୍ରମିକ', regex: false },
  { key: 'kramoj', value: 'କ୍ରମଜ', regex: false },
  { key: 'kramonnti', value: 'କ୍ରମୋନ୍ନତି', regex: false },
  { key: 'krantibadi', value: 'କ୍ରାନ୍ତିବାଦୀ', regex: false },
  { key: 'krantikari', value: 'କ୍ରାନ୍ତିକାରୀ', regex: false },
  { key: 'kreta', value: 'କ୍ରେତା', regex: false },
  { key: 'krida', value: 'କ୍ରୀଡ଼ା', regex: false },
  { key: 'kridangan', value: 'କ୍ରୀଡାଙ୍ଗନ', regex: false },
  { key: 'kridanouka', value: 'କ୍ରିଡାନୌକ', regex: false },
  { key: 'kridonaka', value: 'କ୍ରୀଡ଼ନକ', regex: false },
  { key: 'krishilata', value: 'କ୍ରିୟାଶୀଳତା', regex: false },
  { key: 'krisikhetra', value: 'କୃଷିକ୍ଷେତ୍ର', regex: false },
  { key: 'kritangia', value: 'କ୍ରିଟାଙ୍ଗିଆ', regex: false },
  { key: 'kriya', value: 'କ୍ରିୟା', regex: false },
  { key: 'kriyabidhi', value: 'କ୍ରିୟାବିଧି', regex: false },
  { key: 'kriyakalap', value: 'କ୍ରିୟାକଳାପ', regex: false },
  { key: 'kriyakarma', value: 'କ୍ରିୟାକର୍ମ', regex: false },
  { key: 'kriyashila', value: 'କ୍ରିୟାଶୀଳ', regex: false },
  { key: 'krodha', value: 'କ୍ରୋଧ', regex: false },
  { key: 'krodhandha', value: 'କ୍ରୋଧାନ୍ଧ', regex: false },
  { key: 'krodhanwita', value: 'କ୍ରୋଧାନ୍ୱିତ', regex: false },
  { key: 'kromanusare', value: 'କ୍ରମାନୁସାରେ', regex: false },
  { key: 'kru', value: 'କୃ', regex: false },
  { key: 'krupa', value: 'କୃପା', regex: false },
  { key: 'krupan', value: 'କୃପଣ', regex: false },
  { key: 'krupita', value: 'କୄପିତ', regex: false },
  { key: 'krura', value: 'କୃର', regex: false },
  { key: 'kruso', value: 'କୃଶ', regex: false },
  { key: 'Krushna', value: 'କୃଷ୍ଣ', regex: false },
  { key: 'krusikari', value: 'କୃଷିକାରୀ', regex: false },
  { key: 'kruskkarma', value: 'କୃଷିକର୍ମ', regex: false },
  { key: 'krustihina', value: 'ଦୃଷ୍ଟିହୀନ', regex: false },
  { key: 'krutaghna', value: 'କୃତଘ୍ନ', regex: false },
  { key: 'ghna', value: 'ଘ୍ନ', regex: false },  
  { key: 'krutaghna', value: 'କୃତଘ୍ନ', regex: false },
  { key: 'krutagya', value: 'କୃତଜ୍ଞ ', regex: false },
  { key: 'krutakarjya', value: 'କୃତକାର୍ଯ୍ୟ', regex: false },
  { key: 'kruti', value: 'କୃତି', regex: false },
  { key: 'krutrim', value: 'କୃତ୍ରିମ', regex: false },
  //{ key: 'ks', value: 'କ୍ସ', regex: false },
  { key: 'kua', value: 'କୂଅ', regex: false },
  { key: 'kuanri', value: 'କୁଆଁର', regex: false },
  { key: 'kubhasi', value: 'କୁଭାଷା', regex: false },
  { key: 'kubyabastha', value: 'କୁବ୍ୟବସ୍ଥା', regex: false },
  { key: 'kuchakra', value: 'କୁଚକ୍ର', regex: false },
  { key: 'kudheiba', value: 'କୁଢ଼େଇବ', regex: false },
  { key: 'kuhapocha', value: 'କୁହାପୋଛା', regex: false },
  { key: 'kuheli', value: 'କୁହେଳି', regex: false },
  { key: 'kuhudi', value: 'କୁହୁଡ଼ି', regex: false },
  { key: 'kujantra', value: 'କୁଦାଯନ୍ତ୍ର', regex: false },
  { key: 'kukarma', value: 'କୁକର୍ମ', regex: false },
  { key: 'kukhya', value: 'ମୁଖ୍ୟ', regex: false },
  { key: 'kukhyat', value: 'କୁଖ୍ୟାତ', regex: false },
  { key: 'kula', value: 'କୂଳ', regex: false },
  { key: 'ngara', value: 'ଙ୍ଗାର', regex: false },
  { key: 'brudha', value: 'ବୃଦ୍ଧ', regex: false },
  { key: 'kuladhipati', value: 'କୁଳାଧିପତି', regex: false },
  { key: 'kulangar', value: 'କୁଳାଙ୍ଗାର', regex: false },
  { key: 'kulapati', value: 'କୁଳପତି', regex: false },
  { key: 'kumar', value: 'କୁମାର', regex: false },
  { key: 'kumari', value: 'କୁମାରୀ', regex: false },
  { key: 'kumbha', value: 'କୁମ୍ଭ', regex: false },
  { key: 'kumbhara', value: 'କୁମ୍ଭାର', regex: false },
  { key: 'kumbhilak', value: 'କୁମ୍ଭୀଳକ', regex: false },
  { key: 'kumbhir', value: 'କୁମ୍ଭୀର', regex: false },
  { key: 'kumbhira', value: 'କୁମ୍ଭୀର', regex: false },
  { key: 'kunch', value: 'କୁଞ୍ଚ', regex: false },
  { key: 'kunchan', value: 'କୁଞ୍ଚନ', regex: false },
  { key: 'kunda', value: 'କୁଣ୍ଡ', regex: false },
  { key: 'kundheb', value: 'କୁଣ୍ଢେଇବ', regex: false },
  { key: 'kundhita', value: 'କୁଣ୍ଠିତ', regex: false },
  { key: 'kunti', value: 'ଖୁଣ୍ଟି', regex: false },
  { key: 'kupa', value: 'କୂପ', regex: false },
  { key: 'kuparibahi', value: 'କୁପରିବାହୀ', regex: false },  
  { key: 'kupo', value: 'କୂପ', regex: false },
  { key: 'kuprorochak', value: 'କୁପ୍ରରୋଚକ', regex: false },
  { key: 'kuprorochana', value: 'କୁପ୍ରରୋଚନା', regex: false },
  { key: 'kupusti', value: 'କୁପୁଷ୍ଟି ', regex: false },
  { key: 'prusti', value: 'ପୃଷ୍ଟି', regex: false },
  { key: 'kusanskara', value: 'କୁସଂସ୍କାର', regex: false },
  { key: 'kuscharkhata', value: 'କୁତ୍ସାରଘାତ', regex: false },
  { key: 'kuschit', value: 'କୁତ୍ସତ', regex: false },
    { key: 'kushasak', value: 'କୁଶାସକ', regex: false },
  { key: 'kushasan', value: 'କୁଶାସନ', regex: false },
  { key: 'kustho', value: 'କୁଷ୍ଠ', regex: false },
  { key: 'kusti', value: 'କୁସ୍ତି', regex: false },
  { key: 'kustibad', value: 'କୁସ୍ତିବାଦ', regex: false },
  { key: 'chakra', value: 'ଚକ୍ର', regex: false },
  { key: 'chakrabalaya', value: 'ଚକ୍ରବଳୟ ', regex: false },
  { key: 'barti', value: 'ବର୍ତ୍ତୀ', regex: false },
  { key: 'chakrabrudhi', value: 'ଚକ୍ରବୃଦ୍ଧି', regex: false },
  { key: 'moni', value: 'ମଣି', regex: false },
  { key: 'chakranta', value: 'ଚକ୍ରାନ୍ତ', regex: false },
  { key: 'chakriya', value: 'ଚକ୍ରୀୟ', regex: false },
  { key: 'chalo', value: 'ଗ୍ଭଲ', regex: false },
  { key: 'chalabaji', value: 'ଗ୍ଭଲବାଜି', regex: false },
  { key: 'chalabat', value: 'ଚଲାବାଟ', regex: false },
  { key: 'cholochitra', value: 'ଚଳଚ୍ଚିତ୍ର', regex: false },
  { key: 'chalaib', value: 'ଚଳାଇବ', regex: false },
  { key: 'chalak', value: 'ଗ୍ଭଳକ', regex: false },
  { key: 'chalaki', value: 'ଗ୍ଭଲାକି', regex: false },
  { key: 'chalakire', value: 'ଗ୍ଭଲାକିରେ', regex: false },
  { key: 'chalana', value: 'ଗ୍ଭଳନା', regex: false },
  { key: 'chalani', value: 'ଚଳଣି', regex: false },
  { key: 'chalaprachala', value: 'ଚଳପ୍ରଚଳ', regex: false },
  { key: 'chalbaji', value: 'ଗ୍ଭଲବାଜି', regex: false },
  { key: 'chalia', value: 'ଗ୍ଭଳିଆ', regex: false },
  { key: 'chalichalan', value: 'ଗ୍ଭଲିଚଳନ', regex: false },
  { key: 'cholita', value: 'ଚଳିତ', regex: false },
  { key: 'chona', value: 'ଚଣା', regex: false },
  { key: 'chhona', value: 'ଛଣା', regex: false },
  { key: 'chaluni', value: 'ଗ୍ଭଲୁଣି', regex: false },
  { key: 'chalano', value: 'ଗ୍ଭଲାଣ', regex: false },
  { key: 'luhuringia', value: 'ଲୁହୁରିଙ୍ଗିଆ', regex: false },
  { key: 'chamach', value: 'ଗ୍ଭମଚ', regex: false },
  { key: 'petapanga', value: 'ପେଟାପାଙ୍ଗ', regex: false },
  { key: 'chamada', value: 'ଚମଡ଼ା', regex: false },
  { key: 'chamakib', value: 'ଚମକିବ', regex: false },
  { key: 'chamari', value: 'ଚମରୀ', regex: false },
  { key: 'chomatkar', value: 'ଚମତ୍କାର', regex: false },
  { key: 'chandadata', value: 'ଗ୍ଭନ୍ଦାଦାତା', regex: false },
  { key: 'chonchol', value: 'ଚଞ୍ଚଳ', regex: false },
  { key: 'chanchalya', value: 'ଗ୍ଭଞ୍ଚଲ୍ୟ', regex: false },
  { key: 'chonchano', value: 'ଛଞ୍ଚାଣ', regex: false },
  { key: 'chanchiba', value: 'ଚାଞ୍ଛବା', regex: false },
  { key: 'chonchu', value: 'ଚଞ୍ଚୁ', regex: false },
  { key: 'chanda', value: 'ଚାନ୍ଦା', regex: false },
  { key: 'chondon', value: 'ଚନ୍ଦନ', regex: false },
  { key: 'chandini', value: 'ଗ୍ଭନ୍ଦିନୀ', regex: false },
  { key: 'chandra', value: 'ଚନ୍ଦ୍ର', regex: false },
  { key: 'chandua', value: 'ଗ୍ଭନ୍ଦୁଆ', regex: false },
  { key: 'chanhiba', value: 'ଗ୍ଭହିଁବା', regex: false },
  { key: 'chapa', value: 'ଗ୍ଭପ', regex: false },
  { key: 'chapal', value: 'ଚପଲ', regex: false },
  { key: 'chapalmati', value: 'ଚପଳମତି', regex: false },
  { key: 'chapib', value: 'ଗ୍ଭପିବ', regex: false },
  { key: 'chapuda', value: 'ଗ୍ଭପୁଡ଼ା', regex: false },
  { key: 'chara', value: 'ଗ୍ଭରା', regex: false },
  { key: 'chara', value: 'ଗ୍ଭର', regex: false },
  { key: 'gachha', value: 'ଗଛ', regex: false },
  { key: 'chorakha', value: 'ଚରଖା', regex: false },
  { key: 'chorali', value: 'ଚରାଳି', regex: false },
  { key: 'choram', value: 'ଚରମ', regex: false },
  { key: 'chorampanthi', value: 'ଚରମପନ୍ଥୀ', regex: false },
  { key: 'choran', value: 'ଚରଣ', regex: false },
  { key: 'charbi', value: 'ଚର୍ବି', regex: false },
  { key: 'charcha', value: 'ଚର୍ଚ୍ଚା ', regex: false },
  { key: 'charigodia', value: 'ଗ୍ଭରିଗୋଡିଆ', regex: false },
  { key: 'charikhanda', value: 'ଗ୍ଭରିଖଣ୍ଡ', regex: false },
  { key: 'charikonia', value: 'ଗ୍ଭରିକୋଣିଆ', regex: false },
  { key: 'charitra', value: 'ଚରିତ୍ର', regex: false },
  { key: 'charma', value: 'ଚର୍ମ ', regex: false },
  { key: 'charoti', value: 'ଚାରୋଟି ', regex: false },
  { key: 'chasa', value: 'ଗ୍ଭଷ', regex: false },
  { key: 'chasajogya', value: 'ଗ୍ଭଷଯୋଗ୍ୟ', regex: false },
  { key: 'chasakama', value: 'ଗ୍ଭଷକାମ', regex: false },
  { key: 'chasama', value: 'ଚଷମା', regex: false },
  { key: 'chasapojygi', value: 'ଗ୍ଭଷଯୋଗ୍ୟ', regex: false },
  { key: 'chasi', value: 'ଗ୍ଭଷୀ', regex: false },
  { key: 'chosib', value: 'ଚଷିବ', regex: false },
  { key: 'chasikula', value: 'ଗ୍ଭଷୀକୁଳ', regex: false },
  { key: 'chatakarsak', value: 'ଚିତାକର୍ଷକ', regex: false },
  { key: 'chatan', value: 'ଚଟାଣ', regex: false },
  { key: 'chati', value: 'ଚାଟି', regex: false },
  { key: 'chhatra', value: 'ଛାତ୍ର', regex: false },
  { key: 'chhatri', value: 'ଛାତ୍ରୀ', regex: false },
  { key: 'niya', value: 'ନୀୟ', regex: false },
  { key: 'kalumaha', value: 'କାଲୁମାହା', regex: false },
  { key: 'chotura', value: 'ଚତୁର', regex: false },
  { key: 'sahi', value: 'ସାହି', regex: false },
  { key: 'sambandhe', value: 'ସମ୍ବନ୍ଧେ', regex: false },
  { key: 'chaturata', value: 'ଚତୁରତା', regex: false },
  { key: 'chaturbhuja', value: 'ଚତୁର୍ଭୁଜ', regex: false },
  { key: 'chaturjya', value: 'ଗ୍ଭତୂର୍ଯ୍ୟ', regex: false },
  { key: 'chaturokti', value: 'ଚତୁରୋକ୍ତ', regex: false },
  { key: 'chaturtha', value: 'ଚତୁର୍ଥ ', regex: false },
  { key: 'chatuskona', value: 'ଚତୁଷକୋଣୀ', regex: false },
  { key: 'chatuspada', value: 'ଚତୁଷ୍ପଦ', regex: false },
  { key: 'chaubacha', value: 'ଚଉବଗ୍ଭ', regex: false },
  { key: 'chaula', value: 'ଗ୍ଭଉଳ', regex: false },
  { key: 'choutho', value: 'ଚଉଠ', regex: false },
  { key: 'cho', value: 'ଚ', regex: false },
  //{ key: 'chodiapolli', value: 'ଚଡ଼ିଆପଲ୍ଲୀ', regex: false },
  { key: 'choutib', value: 'ଚଉତିବ', regex: false },
  { key: 'chayan', value: 'ଚୟନ', regex: false },
  { key: 'chedeib', value: 'ଚିଡ଼େଇବ', regex: false },
  { key: 'chehera', value: 'ଚେହେରା ', regex: false },
  { key: 'cheli', value: 'ଛେଳି', regex: false },
  { key: 'chogala', value: 'ଚଗଲା', regex: false },  
  { key: 'chepta', value: 'ଚେପଟା', regex: false },
  { key: 'cheremula', value: 'ଚେରମୂଳ', regex: false },
  { key: 'chesta', value: 'ଚେଷ୍ଟା', regex: false },
  { key: 'chho', value: 'ଛ', regex: false },
  { key: 'chhoda', value: 'ଛଡ଼ା', regex: false },
  { key: 'chhadopatra', value: 'ଛାଡ଼ପତ୍ର', regex: false },
  { key: 'chhadideb', value: 'ଛାଡ଼ିଦେବ', regex: false },
  { key: 'chhodma', value: 'ଛଦ୍ମ', regex: false },
  { key: 'chhodmabesa', value: 'ଛଦ୍ମବେଶ', regex: false },
  { key: 'chhodmanama', value: 'ଛଦ୍ମନାମ', regex: false },
  { key: 'chhodmasastra', value: 'ଛଦ୍ମଶାସ୍ତ୍ର', regex: false },
  { key: 'chhai', value: 'ଛାଇ', regex: false },
  { key: 'chhaib', value: 'ଛାଇବ', regex: false },
  { key: 'chhoka', value: 'ଛକ', regex: false },
  { key: 'chhokiab', value: 'ଛକିବ', regex: false },
  { key: 'chhono', value: 'ଛଣ', regex: false },
  { key: 'chhancho', value: 'ଛାଞ୍ଚ', regex: false },
  { key: 'chhaniba', value: 'ଛାଣିବ', regex: false },
  { key: 'chhapo', value: 'ଛାପ', regex: false },
  { key: 'chhato', value: 'ଛାତ', regex: false },
  { key: 'chhatapat', value: 'ଛଟପଟ', regex: false },
  { key: 'chhatei', value: 'ଛଟେଇ', regex: false },
  { key: 'chhato', value: 'ଛାଟ', regex: false },
  { key: 'chhatrabhanga', value: 'ଛତ୍ରଭଙ୍ଗ', regex: false },
  { key: 'chhotu', value: 'ଛତୁ', regex: false },
  { key: 'chhauni', value: 'ଛାଉଣୀ', regex: false },
  { key: 'chhoparo', value: 'ଛପର', regex: false },
  { key: 'chhi', value: 'ଛି', regex: false },
  { key: 'chhida', value: 'ଛିଡା ', regex: false },
  { key: 'chhinna', value: 'ଛିନ୍ନ ', regex: false },
  { key: 'chhotia', value: 'ଛୋଟିଆ', regex: false },
  { key: 'chhuan', value: 'ଛୁଆଁ ', regex: false },
  { key: 'chhuinb', value: 'ଛୁଇଁବ', regex: false },
  { key: 'chian', value: 'ଚିଆଁ', regex: false },
  { key: 'chidiakhana', value: 'ଚିଡିଆଖାନା', regex: false },
  { key: 'chikan', value: 'ଚିକଣ', regex: false },
  { key: 'chikisch', value: 'ଚିକିତ୍ସ', regex: false },
  { key: 'chikischalaya', value: 'ଚିକିତ୍ସାଳୟ', regex: false },
  { key: 'chikischka', value: 'ଚିକିତ୍ସକ', regex: false },
  { key: 'chikitsha', value: 'ଚିକିତ୍ସକ', regex: false },
  { key: 'chikkan', value: 'ଚିକ୍କଣ', regex: false },
  { key: 'chimuna', value: 'ଚିମୁନା', regex: false },
  { key: 'chinamati', value: 'ଚିନାମାଟି', regex: false },
  { key: 'odia', value: 'ଓଡ଼ିଆ', regex: false },
  { key: 'bhari', value: 'ଭାରି', regex: false },
  { key: 'bodhia', value: 'ବଢ଼ିଆ', regex: false },
  { key: 'chhinda', value: 'ଛିଣ୍ଡା', regex: false },
  { key: 'kahi', value: 'କହି', regex: false },
  { key: 'kahil', value: 'କହିଲ', regex: false },
  { key: 'mono', value: 'ମନ', regex: false },
  { key: 'youtube', value: 'ୟୁଟୁବ୍', regex: false },
  { key: 'guideline', value: 'ଗାଇଡ୍ ଲାଇନ୍', regex: false },
  { key: 'chinha', value: 'ଚିହ୍ନ ', regex: false },
  { key: 'chinhat', value: 'ଚିହ୍ନଟ', regex: false },
  { key: 'chinta', value: 'ଚିନ୍ତା ', regex: false },
  { key: 'chintahina', value: 'ଚିନ୍ତାହୀନ', regex: false },
  { key: 'chintaka', value: 'ଚିନ୍ତକ', regex: false },
  { key: 'chintaklista', value: 'ଚିନ୍ତାକ୍ଲିଷ୍ଟ', regex: false },
  { key: 'chintita', value: 'ଚିନ୍ତିତ', regex: false },
  { key: 'chipib', value: 'ଚିପିବ', regex: false },
  { key: 'chipudiba', value: 'ଚିପୁଡିବା', regex: false },
  { key: 'chipuni', value: 'ଚିପୁଣି', regex: false },
  { key: 'chiradina', value: 'ଚିରଦିନ', regex: false },
  { key: 'chitasudhi', value: 'ଚିତ୍ତଶୁଦ୍ଧି', regex: false },
  { key: 'chitkar', value: 'ଚିତ୍କାର', regex: false },
  { key: 'chitra', value: 'ଚିତ୍ର', regex: false },
  { key: 'chitralaya', value: 'ଚିତ୍ରାଳୟ', regex: false },
  { key: 'chitrankana', value: 'ଚିତ୍ରାଙ୍କନ', regex: false },
  { key: 'astomo', value: 'ଅଷ୍ଟମ', regex: false },
  { key: 'kada', value: 'କଡ଼ା', regex: false },
  { key: 'prem', value: 'ପ୍ରେମ', regex: false },
  { key: 'jugal', value: 'ଯୁଗଳ', regex: false },
  { key: 'dhorai', value: 'ଧରାଇ', regex: false },
  { key: 'bulai', value: 'ବୁଲାଇ', regex: false },
  { key: 'asanta', value: 'ଆସନ୍ତା', regex: false },  
{ key: 'harash', value: 'ହରଷ', regex: false },
{ key: 'hori', value: 'ହରି', regex: false },
{ key: 'harina', value: 'ହରିଣ', regex: false },
{ key: 'harmoni', value: 'ହାର୍ମୋନି', regex: false },
{ key: 'hasal', value: 'ହାସଲ', regex: false },
{ key: 'hastakhyar', value: 'ହସ୍ତାକ୍ଷର', regex: false },
{ key: 'hati', value: 'ହାତୀ', regex: false },
{ key: 'heuchi', value: 'ହେଉଛି', regex: false },
{ key: 'hino', value: 'ହୀନ', regex: false },
{ key: 'hinsa', value: 'ହିଂସା', regex: false },
{ key: 'hoiachi', value: 'ହୋଇଅଛି', regex: false },
{ key: 'hoichi', value: 'ହୋଇଛି', regex: false },
{ key: 'hosto', value: 'ହସ୍ତ', regex: false },
{ key: 'hrasa', value: 'ହ୍ରାସ', regex: false },
{ key: 'huni', value: 'ଖୁନୀ', regex: false },
{ key: 'hydrabad', value: 'ହାଇଦ୍ରାବାଦ', regex: false },
{ key: 'ichha', value: 'ଇଚ୍ଛା', regex: false },
{ key: 'ijjat', value: 'ଇଜ୍ଜତ', regex: false },
{ key: 'india', value: 'ଇଣ୍ଡିଆ', regex: false },
{ key: 'indrio', value: 'ଇନ୍ଦ୍ରିୟ', regex: false },
{ key: 'ingraji', value: 'ଇଂରାଜୀ', regex: false },
{ key: 'internet', value: 'ଇଣ୍ଟରନେଟ୍', regex: false },
{ key: 'iswar', value: 'ଈଶ୍ୱର', regex: false },
{ key: 'ityadi', value: 'ଇତ୍ୟାଦି', regex: false },
{ key: 'jabaharlal', value: 'ଜବାହାରଲାଲ', regex: false },
{ key: 'jadio', value: 'ଯଦିଓ', regex: false },
{ key: 'jadit', value: 'ଜଡିତ', regex: false },
{ key: 'jaghnya', value: 'ଜଘନ୍ୟ', regex: false },
{ key: 'jaguali', value: 'ଜଗୁଆଳି', regex: false },
{ key: 'jaha', value: 'ଯାହା', regex: false },
{ key: 'jahara', value: 'ଯାହାର', regex: false },
{ key: 'jakhama', value: 'ଜଖମ', regex: false },
{ key: 'jakhma', value: 'ଯକ୍ଷ୍ମା', regex: false },
{ key: 'jala', value: 'ଜଳ', regex: false },
{ key: 'jalo', value: 'ଜାଲ', regex: false },
{ key: 'jami', value: 'ଜାମି', regex: false },
{ key: 'jan', value: 'ଜନ', regex: false },
{ key: 'janadisto', value: 'ଜନାଦିଷ୍ଟ', regex: false },
{ key: 'janagahal', value: 'ଜନଗହଳ', regex: false },
{ key: 'janaganana', value: 'ଜନଗଣନା', regex: false },
{ key: 'janajati', value: 'ଜନଜାତି', regex: false },
{ key: 'janakalyan', value: 'ଜନକଲ୍ୟାଣ', regex: false },
{ key: 'janakirna', value: 'ଜନାକୀର୍ଣ୍ଣ', regex: false },
{ key: 'janamat', value: 'ଜନମତ', regex: false },
{ key: 'jananakhyama', value: 'ଜନନକ୍ଷମ', regex: false },
{ key: 'janani', value: 'ଜନନୀ', regex: false },
{ key: 'janarab', value: 'ଜନରବ', regex: false },
{ key: 'janasadharan', value: 'ଜନସାଧାରଣ', regex: false },
{ key: 'janasankhya', value: 'ଜନସଂଖ୍ୟା', regex: false },
{ key: 'janasankhyagata', value: 'ଜନସଂଖ୍ୟାଗତ', regex: false },
{ key: 'janashakti', value: 'ଜନଶକ୍ତି', regex: false },
{ key: 'janasuna', value: 'ଜଣାଶୁଣା', regex: false },
{ key: 'janaswarth', value: 'ଜନସ୍ୱାର୍ଥ', regex: false },
{ key: 'janatatwa', value: 'ତତ୍ତ୍ୱ', regex: false },
{ key: 'janch', value: 'ଯାଞ୍ଚ', regex: false },
{ key: 'jane', value: 'ଜାଣେ', regex: false },
{ key: 'jangha', value: 'ଜଙ୍ଘ', regex: false },
{ key: 'janghia', value: 'ଜଂଘିଆ', regex: false },
{ key: 'janha', value: 'ଜହ୍ନ', regex: false },
{ key: 'janhamamu', value: 'ଜହ୍ନମାମୁଁ', regex: false },
{ key: 'janjal', value: 'ଜଞ୍ଜାଳ', regex: false },
{ key: 'janji', value: 'ପାଞ୍ଜି', regex: false },
{ key: 'janla', value: 'ଯାଆଁଳା', regex: false },
{ key: 'janma', value: 'ଜନ୍ମ', regex: false },
{ key: 'janmabhumi', value: 'ଜନ୍ମଭୂମି', regex: false },
{ key: 'janmagata', value: 'ଜନ୍ମଗତ', regex: false },
{ key: 'janmajati', value: 'ଜନ୍ମଜାତ', regex: false },
{ key: 'jano', value: 'ଜାଣ', regex: false },
{ key: 'january', value: 'ଜାନୁଆରୀ', regex: false },
{ key: 'jatibadi', value: 'ଜାତିବାଦୀ', regex: false },
{ key: 'jatil', value: 'ଜଟିଳ', regex: false },
{ key: 'jatilikruta', value: 'ଜଟିଳିକୃତ', regex: false },
{ key: 'jatisanth', value: 'ଜାତିସଂଘ', regex: false },
{ key: 'jatiya', value: 'ଜାତୀୟ', regex: false },
{ key: 'jatna', value: 'ଯତ୍ନ', regex: false },
{ key: 'jaucha', value: 'ଯାଉଛ', regex: false },
{ key: 'jete', value: 'ଯେତେ', regex: false },
{ key: 'sete', value: 'ସେତେ', regex: false },
{ key: 'pekhi', value: 'ପେକ୍ଷୀ', regex: false },
{ key: 'paramukha', value: 'ପରମୁଖା', regex: false },
{ key: 'jekounasi', value: 'ଯେକୌଣସି', regex: false },
{ key: 'jena', value: 'ଜେନା', regex: false },
{ key: 'jerundi', value: 'ଜେରୁଣ୍ଡ', regex: false },
{ key: 'thire', value: 'ଥିରେ', regex: false },
{ key: 'jhati', value: 'ଝାଟି', regex: false },
{ key: 'mati', value: 'ମାଟି', regex: false },
{ key: 'jiba', value: 'ଯିବ', regex: false },
{ key: 'dina', value: 'ଦିନ', regex: false },
{ key: 'jibanare', value: 'ଜୀବନରେ', regex: false },
{ key: 'jie', value: 'ଯିଏ', regex: false },
{ key: 'jeunthi', value: 'ଯେଉଁଠି', regex: false },
{ key: 'uchhi', value: 'ଉଛି', regex: false },
{ key: 'jigyansu', value: 'ଜିଜ୍ଞାସୁ', regex: false },
{ key: 'jihwa', value: 'ଜିହ୍ୱା', regex: false },
{ key: 'niyojita', value: 'ନିୟୋଜିତ', regex: false },
{ key: 'jodie', value: 'ଯୋଡ଼ିଏ', regex: false },
{ key: 'jodio', value: 'ଯଦିଓ', regex: false },
{ key: 'jogajoga', value: 'ଯୋଗଯୋଗ', regex: false },
{ key: 'jogauchhi', value: 'ଯୋଗାଉଛି', regex: false },
{ key: 'jogai', value: 'ଯୋଗାଇ', regex: false },
//{ key: 'jogyan', value: 'ଯଜ୍ଞ', regex: false },
{ key: 'jojana', value: 'ଯୋଜନା', regex: false },
{ key: 'jona', value: 'ଜଣ', regex: false },
{ key: 'joubana', value: 'ଯୌବନ', regex: false },
{ key: 'jeparjanta', value: 'ଯେପର୍ଯ୍ୟନ୍ତ', regex: false },
{ key: 'judha', value: 'ଯୁଦ୍ଧ', regex: false },
{ key: 'jugare', value: 'ଯୁଗରେ', regex: false },
{ key: 'juge', value: 'ଯୁଗେ', regex: false },
{ key: 'juiphula', value: 'ଯୂଈଫୁଲ', regex: false },
{ key: 'jukta', value: 'ଯୁକ୍ତ', regex: false },
{ key: 'july', value: 'ଜୁଲାଇ', regex: false },
{ key: 'june', value: 'ଜୁନ୍', regex: false },
{ key: 'jutho', value: 'ଯୂଥ', regex: false },
//{ key: 'jwala', value: 'ଜ୍ଵାଲା', regex: false },
{ key: 'jwara', value: 'ଜ୍ୱର', regex: false },
{ key: 'jyestho', value: 'ଜୈଷ୍ଠ', regex: false },
{ key: 'kaale', value: 'କାଳେ', regex: false },
{ key: 'kabach', value: 'କବଚ', regex: false },
{ key: 'kabar', value: 'କବର', regex: false },
{ key: 'kabat', value: 'କବାଟ', regex: false },
{ key: 'kabharej', value: 'କଭରେଜ୍', regex: false },
{ key: 'kabita', value: 'କବିତା', regex: false },
{ key: 'kabitapatho', value: 'କବିତାପାଠ', regex: false },
{ key: 'kaccha', value: 'କଚ୍ଚା', regex: false },
{ key: 'kach', value: 'କାଚ', regex: false },
{ key: 'kamaichho', value: 'କମାଇଛ', regex: false },
{ key: 'kamaicho', value: 'କମାଇଚ', regex: false },
{ key: 'kamaideba', value: 'କମାଇଦେବା', regex: false },
{ key: 'kamaikari', value: 'କମାଇକରି', regex: false },
{ key: 'kamailo', value: 'କମାଇଲ', regex: false },
{ key: 'kaman', value: 'କମାଣ', regex: false },
{ key: 'kamarpati', value: 'କମରପଟି', regex: false },
{ key: 'kambal', value: 'କମ୍ବଳ', regex: false },
{ key: 'kambu', value: 'କମ୍ବୁ', regex: false },
{ key: 'kamei', value: 'କମେଇ', regex: false },
{ key: 'kameibo', value: 'କମେଇବ', regex: false },
{ key: 'kameicha', value: 'କମେଇଚ', regex: false },
{ key: 'kameichho', value: 'କମେଇଛ', regex: false },
{ key: 'kameilo', value: 'କମେଇଲ', regex: false },
{ key: 'chitrita', value: 'ଚିତ୍ରିତ', regex: false },
{ key: 'chittipotu', value: 'ଚିଟ୍ଟିପୋଟୁ', regex: false },
{ key: 'chori', value: 'ଚୋରି', regex: false },
{ key: 'chotia', value: 'ଚଟିଆ', regex: false },
{ key: 'chouki', value: 'ଚୌକି', regex: false },
{ key: 'choukidar', value: 'ଚୌକିଦାର', regex: false },
{ key: 'chounri', value: 'ଚଉଁରୀ', regex: false },
{ key: 'choutara', value: 'ଚଉତରା', regex: false },
{ key: 'chua', value: 'ଛୁଆ', regex: false },
{ key: 'chuan', value: 'ଚୁଆଁ', regex: false },
{ key: 'chuda', value: 'ଚୁଡ଼', regex: false },
{ key: 'chudanta', value: 'ଚୂଡାନ୍ତ', regex: false },
{ key: 'chugula', value: 'ଚଗୁଲା', regex: false },
{ key: 'chukti', value: 'ଚୁକ୍ତି', regex: false },
{ key: 'chuktibhitika', value: 'ଚୁକ୍ତିଭିତ୍ତିକ', regex: false },
{ key: 'chuktinama', value: 'ଚୁକ୍ତିନାମା', regex: false },
{ key: 'chul', value: 'ଚୂଳ', regex: false },
{ key: 'chula', value: 'ଚୁଲା', regex: false },
{ key: 'chumbak', value: 'ଚୁମ୍ବକ', regex: false },
{ key: 'chumbakiya', value: 'ଚୁମ୍ବକୀୟ', regex: false },
{ key: 'chunti', value: 'ଚୁଣ୍ଟି', regex: false },
{ key: 'churmar', value: 'ଚୁରମାର', regex: false },
{ key: 'churna', value: 'ଚୁର୍ଣ୍ଣ', regex: false },
{ key: 'churnana', value: 'ଚୁର୍ଣ୍ଣନ', regex: false },
{ key: 'cliba', value: 'କ୍ଳୀବ', regex: false },
{ key: 'collage', value: 'କଲେଜ', regex: false },
{ key: 'commerce', value: 'କମର୍ସ', regex: false },
{ key: 'copy', value: 'କପି', regex: false },
{ key: 'copyright', value: 'କପିରାଇଟ୍', regex: false },
{ key: 'dakhina', value: 'ଦକ୍ଷିଣା', regex: false },
{ key: 'dakhin', value: 'ଦକ୍ଷିଣ', regex: false },
{ key: 'dakyata', value: 'ଦକ୍ଷତା', regex: false },
{ key: 'dansan', value: 'ଦଂଶନ', regex: false },
{ key: 'danta', value: 'ଦାନ୍ତ', regex: false },
{ key: 'dara', value: 'ଡର', regex: false },
{ key: 'daridra', value: 'ଦରିଦ୍ର', regex: false },
{ key: 'daridya', value: 'ଦାରିଦ୍ୟ', regex: false },
{ key: 'darpan', value: 'ଦର୍ପଣ', regex: false },
{ key: 'dasakar', value: 'ଦଶକର', regex: false },
{ key: 'dayakari', value: 'ଦୟାକରି', regex: false },
{ key: 'dayi', value: 'ଦାୟୀ', regex: false },
{ key: 'dayitwa', value: 'ଦାୟିତ୍ୱ', regex: false },
{ key: 'deba', value: 'ଦେବା', regex: false },
{ key: 'debe', value: 'ଦେବେ', regex: false },
{ key: 'december', value: 'ଡ଼ିସେମ୍ବର', regex: false },
{ key: 'dei', value: 'ଦେଇ', regex: false },
{ key: 'deinpadila', value: 'ଡେଇଁପଡ଼ିଲା', regex: false },
{ key: 'dekha', value: 'ଦେଖା', regex: false },
{ key: 'dekhanti', value: 'ଦେଖାନ୍ତି', regex: false },
{ key: 'dekhantu', value: 'ଦେଖାନ୍ତୁ', regex: false },
{ key: 'dekhibo', value: 'ଦେଖିବ', regex: false },
{ key: 'dekhilo', value: 'ଦେଖିଲ', regex: false },
{ key: 'dekhonti', value: 'ଦେଖନ୍ତି', regex: false },
{ key: 'dena', value: 'ଡେଣା', regex: false },
{ key: 'deputy', value: 'ଡେପୁଟି', regex: false },
{ key: 'desha', value: 'ଦେଶ', regex: false },
{ key: 'design', value: 'ଡିଜାଇନ୍', regex: false },
{ key: 'deso', value: 'ଦେଶ', regex: false },
{ key: 'dhalagai', value: 'ଧଳାଗାଈ', regex: false },
{ key: 'dhara', value: 'ଧାରା', regex: false },
{ key: 'dhariachi', value: 'ଧରିଅଛି', regex: false },
{ key: 'dharma', value: 'ଧର୍ମ', regex: false },
{ key: 'mandal', value: 'ମଣ୍ଡଳ', regex: false },
{ key: 'dhwani', value: 'ଧ୍ୱନି', regex: false },
{ key: 'dhwansa', value: 'ଧ୍ଵଂସ', regex: false },
{ key: 'dhyana', value: 'ଧ୍ୟାନ', regex: false },
{ key: 'diajaithiba', value: 'ଦିଆଯାଇଥିବା', regex: false },
{ key: 'diajiba', value: 'ଦିଆଯିବ', regex: false },
{ key: 'dianti', value: 'ଦିଅନ୍ତି', regex: false },
{ key: 'dige', value: 'ଦିଗେ', regex: false },
{ key: 'digital', value: 'ଡ଼ିଜିଟାଲ', regex: false },
{ key: 'diontu', value: 'ଦିଅନ୍ତୁ', regex: false },
{ key: 'dipali', value: 'ଦୀପାଳି', regex: false },
{ key: 'dirgha', value: 'ଦୀର୍ଘ', regex: false },
{ key: 'dirghayu', value: 'ଦୀର୍ଘାୟୁ', regex: false },
{ key: 'dise', value: 'ଦିଶେ', regex: false },
{ key: 'doctor', value: 'ଡକ୍ଟର', regex: false },
{ key: 'narayan', value: 'ନାରାୟଣ', regex: false },
{ key: 'patana', value: 'ପାଟଣା', regex: false },
{ key: 'satwe', value: 'ସତ୍ତ୍ୱେ', regex: false },
{ key: 'ekagrata', value: 'ଏକାଗ୍ରତା', regex: false },
{ key: 'ekakar', value: 'ଏକକାର', regex: false },
{ key: 'ekakarya', value: 'ଏକକାର୍ଯ୍ୟ', regex: false },
{ key: 'ekakhand', value: 'ଏକଖଣ୍ଡ', regex: false },
{ key: 'ekakshetra', value: 'ଏକକ୍ଷେତ୍ର', regex: false },
{ key: 'ekakshina', value: 'ଏକାକ୍ଷିଣ', regex: false },
{ key: 'ekal', value: 'ଏକଲ', regex: false },
{ key: 'ekale', value: 'ଏକାଲେ', regex: false },
{ key: 'ekalu', value: 'ଏକାଲୁ', regex: false },
{ key: 'ekalya', value: 'ଏକାଲ୍ୟ', regex: false },
{ key: 'ekalyata', value: 'ଏକାଲ୍ୟତା', regex: false },
{ key: 'ekanya', value: 'ଏକାନ୍ୟ', regex: false },
{ key: 'ekanyata', value: 'ଏକାନ୍ୟତା', regex: false },
{ key: 'ekapade', value: 'ଏକପଦେ', regex: false },
{ key: 'ekapatna', value: 'ଏକପତ୍ନା', regex: false },
{ key: 'ekaputra', value: 'ଏକପୁତ୍ର', regex: false },
{ key: 'ekarthaka', value: 'ଏକାର୍ଥକ', regex: false },
{ key: 'ekarjya', value: 'ଏକାର୍ଯ୍ୟ', regex: false },
{ key: 'ekasya', value: 'ଏକାସ୍ୟ', regex: false },
{ key: 'ekasyma', value: 'ଏକାସ୍ୟମା', regex: false },
{ key: 'ekata', value: 'ଏକତା', regex: false },
{ key: 'ekatar', value: 'ଏକତର', regex: false },
{ key: 'ekatha', value: 'ଏକଥା', regex: false },
{ key: 'ekatibi', value: 'ଏକତିବି', regex: false },
{ key: 'ekatma', value: 'ଏକାତ୍ମା', regex: false },
{ key: 'ekatmakata', value: 'ଏକାତ୍ମକତା', regex: false },
{ key: 'ekatmaka', value: 'ଏକାତ୍ମକ', regex: false },
{ key: 'ekatwa', value: 'ଏକତ୍ୱ', regex: false },
{ key: 'ekatwata', value: 'ଏକତ୍ୱତା', regex: false },
{ key: 'ekbidiya', value: 'ଏକବିଦ୍ୟା', regex: false },
{ key: 'kuchakranti', value: ' କୁଚକ୍ରାନ୍ତି ', regex: false },
{ key: 'kudhibo', value: ' କୁଢ଼ିବ ', regex: false },
{ key: 'kudhicha', value: ' କୁଢ଼ିଛ ', regex: false },
{ key: 'kudhila', value: ' କୁଢ଼ିଲା ', regex: false },
{ key: 'kuhuk', value: ' କୁହୁକ ', regex: false },
{ key: 'kuhusa', value: ' କୁହୁସା ', regex: false },
{ key: 'kujagaran', value: ' କୁଜାଗରଣ ', regex: false },
{ key: 'kujana', value: ' କୁଜନ ', regex: false },
{ key: 'kumarikala', value: ' କୁମାରୀ', regex: false },
{ key: 'kumbha', value: ' କୁମ୍ଭ', regex: false },
{ key: 'kumbhamela', value: 'କୁମ୍ଭମେଳା', regex: false },
{ key: 'kumbhi', value: 'କୁମ୍ଭୀ', regex: false },
{ key: 'kumudini', value: 'କୁମୁଦିନୀ', regex: false },
{ key: 'kumuda', value: 'କୁମୁଦା ', regex: false },
{ key: 'kunja', value: 'କୁଞ୍ଜ', regex: false },
{ key: 'banabasi', value: 'ବନବାସୀ', regex: false },
{ key: 'bihari', value: 'ବିହାରୀ', regex: false },
{ key: 'mohan', value: 'ମୋହନ', regex: false },
{ key: 'mohana', value: 'ମୋହନା ', regex: false },
{ key: 'netr', value: 'ନେତ୍ର', regex: false },
{ key: 'lochan', value: 'ଲୋଚନ', regex: false },
{ key: 'manseth', value: 'ମାନସେଠ', regex: false },
{ key: 'chakhyu', value: 'ଚକ୍ଷୁ', regex: false },
{ key: 'akshya', value: 'ଅକ୍ଷୟ', regex: false },
{ key: 'ajaya', value: 'ଅଜୟ', regex: false },
{ key: 'surapati', value: 'ସୁରପତି', regex: false },
{ key: 'sachipati', value: 'ଶଚୀପତି', regex: false },
{ key: 'purandar', value: 'ପୁରନ୍ଦର', regex: false },
{ key: 'sahasrakhy', value: 'ସହସ୍ରାକ୍ଷ', regex: false },
{ key: 'bati', value: 'ବତୀ', regex: false },
{ key: 'kunjita', value: ' କୁଞ୍ଜିତ', regex: false },
{ key: 'kunjitha', value: ' କୁଞ୍ଜିଥ', regex: false },
{ key: 'Baliguda', value: 'ବାଲିଗୁଡା', regex: false },
{ key: 'Chakapada', value: 'ଚକାପାଦ', regex: false },
{ key: 'Daringbadi', value: 'ଦାରିଙ୍ଗବାଡ଼ି', regex: false },
{ key: 'Udayagiri', value: 'ଉଦୟଗିରି', regex: false },
{ key: 'Nuagan', value: 'ନୂଆଗାଁ', regex: false },
{ key: 'Kotagarh', value: 'କୋଟଗଡ଼', regex: false },
{ key: 'Phiringia', value: 'ଫିରିଙ୍ଗିଆ', regex: false },
{ key: 'Phulbani', value: 'ଫୁଲବାଣୀ', regex: false },
{ key: 'Raikia', value: 'ରାଇକିଆ', regex: false },
{ key: 'Tikabali', value: 'ଟିକାବାଲି', regex: false },
{ key: 'Tumudibandh', value: 'ତୁମୁଡ଼ିବନ୍ଧ', regex: false },
{ key: 'Kutikia', value: 'କୁଟିକିଆ', regex: false },
{ key: 'Khamankhol', value: 'ଖମନଖୋଲ୍', regex: false },
{ key: 'Dadakangia', value: 'ଡଡ଼କାଙ୍ଗିଆ', regex: false },
{ key: 'Parampanga', value: 'ପରମପାଙ୍ଗା', regex: false },
{ key: 'Bataguda', value: 'ବାଟାଗୁଡ଼ା', regex: false },
{ key: 'Barakhama', value: 'ବାରଖମା', regex: false },
{ key: 'Midiakia', value: 'ମିଡ଼ିଆକିଆ', regex: false },
{ key: 'Rutungia', value: 'ରୁତୁଙ୍ଗିଆ', regex: false },
{ key: 'Rebingia', value: 'ରେବିଙ୍ଗିଆ', regex: false },
{ key: 'Salaguda', value: 'ସଲାଗୁଡା', regex: false },
{ key: 'Sindrigaon', value: 'ସିନ୍ଦ୍ରିଗାଁ', regex: false },
{ key: 'Sudra', value: 'ସୁଡ୍ରା', regex: false },
{ key: 'Landagaon', value: 'ଲଣ୍ଡାଗାଁ', regex: false },
{ key: 'Arabaka', value: 'ଆରାବାକା', regex: false },
{ key: 'Kakharujhol', value: 'କଖାରୁଝୋଳ', regex: false },
{ key: 'Kusumendi', value: 'କୁସୁମେଣ୍ଡି', regex: false },
{ key: 'Chahali', value: 'ଚାହାଳି', regex: false },
{ key: 'Pasara', value: 'ପସରା', regex: false },
{ key: 'Bapalmendi-B', value: 'ବାପଲମେଣ୍ଡି-ବି', regex: false },
{ key: 'Bapalmendi-L', value: 'ବାପଲମେଣ୍ଡି-ଏଲ', regex: false },
{ key: 'Bastingia', value: 'ବସ୍ତିଙ୍ଗିଆ', regex: false },
{ key: 'Beheragaon', value: 'ବେହେରାଗାଁ', regex: false },
{ key: 'Brahmanpad', value: 'ବ୍ରାହ୍ମଣପାଦ', regex: false },
{ key: 'Sankarakhol', value: 'ଶଙ୍କରାଖୋଲ୍', regex: false },
{ key: 'Daringbadi', value: 'ଦାରିଙ୍ଗବାଡ଼ି', regex: false },
{ key: 'Kattingia', value: 'କାଟିଙ୍ଗିଆ', regex: false },
{ key: 'Kirikuti', value: 'କିରିକୁଟି', regex: false },
{ key: 'Kumbharigaon', value: 'କୁମ୍ଭାରିଗାଁ', regex: false },
{ key: 'Gadapur', value: 'ଗଦାପୁର୍', regex: false },
{ key: 'Greenbadi', value: 'ଗ୍ରୀନବାଡ଼ି', regex: false },
{ key: 'Gumikia', value: 'ଗୁମିକିଆ', regex: false },
{ key: 'Jhinjiriguda', value: 'ଝିଞ୍ଜିରିଗୁଡା', regex: false },
{ key: 'Tajungia', value: 'ତାଜୁଙ୍ଗିଆ', regex: false },
{ key: 'Tilori', value: 'ତିଲୋରି', regex: false },
{ key: 'Danekbadi', value: 'ଦାନେକବାଡ଼ି', regex: false },
{ key: 'Dasingbadi', value: 'ଦାସିଙ୍ଗବାଡ଼ି', regex: false },
{ key: 'Partamaha', value: 'ପର୍ତମାହା', regex: false },
{ key: 'Pliheri', value: 'ପ୍ଲିହେରୀ', regex: false },
{ key: 'Badabanga', value: 'ବାଡ଼ାବାଙ୍ଗା', regex: false },
{ key: 'Brahmunigaon', value: 'ବ୍ରାହ୍ମଣୀଗାଁ', regex: false },
{ key: 'Budaguda', value: 'ବୁଡାଗୁଡ଼ା', regex: false },
{ key: 'Bharmarbadi', value: 'ଭରମରବାଡ଼ି', regex: false },
{ key: 'Sraniketa', value: 'ଶ୍ରାନିକେତା', regex: false },
{ key: 'Saramuli', value: 'ସାରାମୁଳି', regex: false },
{ key: 'Siangbali', value: 'ସିଆଙ୍ଗବାଲି', regex: false },
{ key: 'Sirkabarga', value: 'ସିର୍କାବର୍ଗ', regex: false },
{ key: 'Simanbadi', value: 'ସିମନବାଡ଼ି', regex: false },
{ key: 'Sonepur', value: 'ସୋନପୁର', regex: false },
{ key: 'Kotingia', value: 'କତିଙ୍ଗିଆ ', regex: false },
{ key: 'Kalingia', value: 'କଳିଙ୍ଗିଆ', regex: false },
{ key: 'Gresingia', value: 'ଗ୍ରେସିଙ୍ଗିଆ', regex: false },
{ key: 'Talarimaha', value: 'ତଲାରିମାହା', regex: false },
{ key: 'Mallickpadi', value: 'ମାଲ୍ଲିକାପଡ଼ି', regex: false },
{ key: 'Ratingia', value: 'ରଟିଙ୍ଗିଆ', regex: false },
{ key: 'Raikala', value: 'ରାଇକଲା', regex: false },
{ key: 'Lingagada', value: 'ଲିଙ୍ଗାଗଡ଼', regex: false },
{ key: 'Adimaha', value: 'ଅଡ଼ିମାହା', regex: false },
{ key: 'Kanjamendi', value: 'କଞ୍ଜାମେଣ୍ଡି', regex: false },
{ key: 'Kudutuli', value: 'କୁଡୁତୁଲି', regex: false },
{ key: 'Gandrigaon', value: 'ଗାନ୍ଦ୍ରିଗାଁ', regex: false },
{ key: 'Gunjibadi', value: 'ଗୁଞ୍ଜିବାଡ଼ି', regex: false },
{ key: 'Chanchedi', value: 'ଚାଞ୍ଚେଡ଼ି', regex: false },
{ key: 'Jiridikia', value: 'ଜିରିଡିକିଆ', regex: false },
{ key: 'Bandaguda', value: 'ବାନ୍ଦାଗୁଡ଼ା', regex: false },
{ key: 'Balligada', value: 'ବାଲିଗାଡ଼ା', regex: false },
{ key: 'Mahasingh', value: 'ମାହାସିଂ', regex: false },
{ key: 'Sainpada', value: 'ସାଇନପଡ଼ା', regex: false },
{ key: 'Sarangada', value: 'ସାରାଙ୍ଗଡ଼', regex: false },
{ key: 'Letingia', value: 'ଲେତିଙ୍ଗିଆ', regex: false },
{ key: 'Arapaju', value: 'ଆରାପାଜୁ', regex: false },
{ key: 'Adasipada', value: 'ଆଡାସିପଡ଼ା', regex: false },
{ key: 'Gudari', value: 'ଗୁଡାରୀ', regex: false },
{ key: 'Titrapanga', value: 'ଟିଟ୍ରାପାଙ୍ଗା', regex: false },
{ key: 'Dalapada', value: 'ଦଳପଡ଼ା', regex: false },
{ key: 'Dutipada', value: 'ଦୁତିପଡ଼ା', regex: false },
{ key: 'Dutimendi', value: 'ଦୁତିମେଣ୍ଡି', regex: false },
{ key: 'Pirikudi', value: 'ପିରିକୁଡ଼ି', regex: false },
{ key: 'Balaskumpa', value: 'ବଲସକୁମ୍ପା', regex: false },
{ key: 'Bilabadi', value: 'ବିଲାବାଡ଼ି', regex: false },
{ key: 'Nuagaon', value: 'ନୂଆଗାଁ', regex: false },
{ key: 'gam', value: 'ଗାଁ', regex: false },
{ key: 'Sudreju', value: 'ସୁଦ୍ରେଜୁ', regex: false },
{key: 'Kotagarh', value: 'କୋଟଗଡ଼', regex: false },
{ key: 'Ora', value: 'ଓରା', regex: false },
{ key: 'Gugurumaha', value: 'ଗୁଗୁରୁମାହା', regex: false },
{ key: 'Judabali', value: 'ଜୁଡ଼ାବାଲି', regex: false },
{ key: 'Durgapanga', value: 'ଦୁର୍ଗାପାଙ୍ଗା', regex: false },
{ key: 'Dharakot', value: 'ଧରାକୋଟ', regex: false },
{ key: 'Pakari', value: 'ପକାରୀ', regex: false },
{ key: 'Parigada', value: 'ପାରିଗଡ଼', regex: false },
{ key: 'Madaguda', value: 'ମାଡାଗୁଡ଼ା', regex: false },
{ key: 'Marlang', value: 'ମାରଲାଙ୍ଗ', regex: false },
{ key: 'Jubaguda', value: 'ଜୁବାଗୁଡ଼ା', regex: false },
{ key: 'Ranipanga', value: 'ରାଣୀପାଙ୍ଗା', regex: false },
{ key: 'Sriranmpur', value: 'ଶ୍ରୀରାମପୁର', regex: false },
{ key: 'Sartul', value: 'ସାର୍ତୁଲ୍', regex: false },
{ key: 'Subarnagiri', value: 'ସୁବର୍ଣ୍ଣଗିରି', regex: false },
{ key: 'Phiringia', value: 'ଫିରିଙ୍ଗିଆ', regex: false },
{ key: 'Kasinipadar', value: 'କାସିନିପଦର', regex: false },
{ key: 'Krandibali', value: 'କ୍ରାଣ୍ଡିବାଲି', regex: false },
{ key: 'Kelapada', value: 'କେଲାପଡ଼ା', regex: false },
{ key: 'Koirimandu', value: 'କୋଇରିମାଣ୍ଡୁ', regex: false },
{ key: 'Gochhapada', value: 'ଗୋଛାପଡ଼ା', regex: false },
{ key: 'Jajespanga', value: 'ଜାଜେସପାଙ୍ଗା', regex: false },
{ key: 'Dimiriguda', value: 'ଡିମିରିଗୁଡ଼ା', regex: false },
{ key: 'Dindragaon', value: 'ଡିଣ୍ଡ୍ରାଗାଁ', regex: false },
{ key: 'Taladandikia', value: 'ତଳଦଣ୍ଡିକିଆ', regex: false },
{ key: 'Nuapadar', value: 'ନୂଆପଦର', regex: false },
{ key: 'Pabingia', value: 'ପବିଙ୍ଗିଆ', regex: false },
{ key: 'Polabrudi', value: 'ପୋଲାବୃଡି', regex: false },
{ key: 'Pahiraju', value: 'ପାହିରାଜୁ', regex: false },
{ key: 'Pangauparasahi', value: 'ପାଙ୍ଗାଉପରସାହି', regex: false },
{ key: 'Bandhagada', value: 'ବନ୍ଧଗଡ଼', regex: false },
{ key: 'Blandapada', value: 'ବ୍ଲାନ୍ଦାପଡ଼ା', regex: false },
{ key: 'Bhrungijodi', value: 'ଭୃଙ୍ଗିଜୋଡି', regex: false },
{ key: 'Ratanga', value: 'ରତଙ୍ଗ', regex: false },
{ key: 'Samarbandha', value: 'ସମରବନ୍ଧ', regex: false },
{ key: 'Sadingia', value: 'ସାଡ଼ିଙ୍ଗିଆ', regex: false },
{ key: 'Luising', value: 'ଲୁଇସିଙ୍ଗ', regex: false },
{key: 'Phulbani', value: 'ଫୁଲବାଣୀ', regex: false },
{ key: 'Alami', value: 'ଆଲାମି', regex: false },
{ key: 'Katringia', value: 'କତ୍ରିଙ୍ଗିଆ', regex: false },
{ key: 'Keradi', value: 'କେରଡ଼ି', regex: false },
{ key: 'Ganjuguda', value: 'ଗଞ୍ଜୁଗୁଡ଼ା', regex: false },
{ key: 'Gumagarh', value: 'ଗୁମାଗଡ଼', regex: false },
{ key: 'Jamajhari', value: 'ଯାମଝରୀ', regex: false },
{ key: 'Tudipaju', value: 'ତୁଡ଼ିପାଜୁ', regex: false },
{ key: 'Dadaki', value: 'ଦଡ଼କି', regex: false },
{ key: 'Duduki', value: 'ଦୁଡୁକି', regex: false },
{ key: 'Bisipada', value: 'ବିସିପଡ଼ା', regex: false },
{ key: 'Minia', value: 'ମିଣିଆ', regex: false },
{ key: 'Raikia', value: 'ରାଇକିଆ', regex: false },
{ key: 'Indragada', value: 'ଇନ୍ଦ୍ରଗଡ଼', regex: false },
{ key: 'Karada', value: 'କରାଡ଼ା', regex: false },
{ key: 'Gumamaha', value: 'ଗୁମାମାହା', regex: false },
{ key: 'Dadingia', value: 'ଡଡ଼ିଙ୍ଗିଆ', regex: false },
{ key: 'Petapanga', value: 'ପେଟାପାଙ୍ଗା', regex: false },
{ key: 'Badabaraba', value: 'ବଡବାରବା', regex: false },
{ key: 'Beredakia', value: 'ବେରେଡ଼ାକିଆ', regex: false },
{ key: 'Mandakia', value: 'ମଣ୍ଡାକିଆ', regex: false },
{ key: 'Manikeswara', value: 'ମାଣିକେଶ୍ୱର', regex: false },
{ key: 'Ranaba', value: 'ରଣବା', regex: false },
{ key: 'Sugadabadi', value: 'ସୁଗଡ଼ବାଡ଼ି', regex: false },
{key: 'Tikabali', value: 'ଟିକାବାଲି', regex: false },
{ key: 'Kainjhar', value: 'କଇଁଝର', regex: false },
{ key: 'Katimaha', value: 'କଟିମାହା', regex: false },
{ key: 'Gadaguda', value: 'ଗଦଗୁଡ଼ା', regex: false },
{ key: 'Gardingia', value: 'ଗାର୍ଡ଼ିଙ୍ଗିଆ', regex: false },
{ key: 'Gutingia', value: 'ଗୁଟିଙ୍ଗିଆ', regex: false },
{ key: 'Padangi', value: 'ପାଡାଙ୍ଗି', regex: false },
{ key: 'Paburia', value: 'ପାବୁରିଆ', regex: false },
{ key: 'Pikaradi', value: 'ପିକରଡ଼ି', regex: false },
{ key: 'Badimunda', value: 'ବଡ଼ିମୁଣ୍ଡା', regex: false },
{ key: 'Burbinaju', value: 'ବୁର୍ବିନାଜୁ', regex: false },
{ key: 'Beheragaon', value: 'ବେହେରାଗାଁ', regex: false },
{ key: 'Tumudibandh', value: 'ତୁମୁଡ଼ିବନ୍ଧ', regex: false },
{ key: 'Karukudupa', value: 'କରୁକୁଡୁପା', regex: false },
{ key: 'Kurtamgada', value: 'କୁର୍ତମଗଡ଼', regex: false },
{ key: 'Jhiripani', value: 'ଝିରିପାଣି', regex: false },
{ key: 'Bilamala', value: 'ବିଲାମାଲା', regex: false },
{ key: 'Belaghar', value: 'ବେଲଘର', regex: false },
{ key: 'Bhandrangi', value: 'ଭନ୍ଦ୍ରାଙ୍ଗି', regex: false },
{ key: 'Mundigada', value: 'ମୁଣ୍ଡିଗଡ଼', regex: false },
{ key: 'Sirla', value: 'ସିର୍ଲା', regex: false },
{ key: 'Lankagada', value: 'ଲଙ୍କାଗଡ଼', regex: false },
{ key: 'Anlapata', value: 'ଆଁଲାପଟା', regex: false },
{ key: 'Baanda', value: 'ବାନ୍ଦା', regex: false },
{ key: 'Badabarba', value: 'ବଡବାରବା', regex: false },
{ key: 'Badagada', value: 'ପଦାଗଡ଼', regex: false },
{ key: 'Badaindragada', value: 'ବଡଇନ୍ଦ୍ରଗଡ଼', regex: false },
{ key: 'Badajiri', value: 'ବାଡ଼ାଜିରି', regex: false },
{ key: 'Badamaha', value: 'ବଡାମାହା', regex: false },
{ key: 'Bageiju', value: 'ବାଗେଇଜୁ', regex: false },
{ key: 'Bakingia', value: 'ବାକିଙ୍ଗିଆ', regex: false },
{ key: 'Balingia', value: 'ବାଲିଙ୍ଗିଆ', regex: false },
{ key: 'Barada', value: 'ବରାଡା', regex: false },
{ key: 'Baradali', value: 'ବରଡାଲି', regex: false },
{ key: 'Barepanga', value: 'ବରେପାଙ୍ଗା', regex: false },
{ key: 'Bariguda', value: 'ବାରିଗୁଡା', regex: false },
{ key: 'Bedaguba', value: 'ବେଡାଗୁବା', regex: false },
{ key: 'Beredakia', value: 'ବେରେଡ଼ାକିଆ', regex: false },
{ key: 'Bhitarabadi', value: 'ଭିତରବାଡି', regex: false },
{ key: 'Bierpanga', value: 'ବିଅରପାଙ୍ଗା', regex: false },
{ key: 'Bisitota', value: 'ବିସିତୋଟା', regex: false },
{ key: 'Borimunda', value: 'ବୋରିମୁଣ୍ଡା', regex: false },
{ key: 'Budamaha', value: 'ବୁଡାମାହା', regex: false },
{ key: 'Budringia', value: 'ବୁଦ୍ରିଙ୍ଗିଆ', regex: false },
{ key: 'Burapanga', value: 'ବୁରାପାଙ୍ଗା', regex: false },
{ key: 'Chakapad', value: 'ଚକାପାଦ', regex: false },
{ key: 'Dadagamaha', value: 'ଡଡ୍ଗାମାହା', regex: false },
{ key: 'Dadingia', value: 'ଡଡ଼ିଙ୍ଗିଆ', regex: false },
{ key: 'Dakapanga', value: 'ଡକାପାଙ୍ଗା', regex: false },
{ key: 'Dalbali', value: 'ଡାଲବାଲି', regex: false },
{ key: 'Damaguda', value: 'ଡ଼ମାଗୁଡ଼ା', regex: false },
{ key: 'Dandapanga', value: 'ଦଣ୍ଡାପାଙ୍ଗା', regex: false },
{ key: 'Danderi', value: 'ଦାଣ୍ଡେରୀ', regex: false },
{ key: 'Darju', value: 'ଦାର୍ଜୁ', regex: false },
{ key: 'Dhepaguda', value: 'ଢ଼େପାଗୁଡ଼ା', regex: false },
{ key: 'Dibari', value: 'ଡ଼ିବାରି', regex: false },
{ key: 'Dimiripali', value: 'ଡିମିରିପାଲି', regex: false },
{ key: 'Gadringia', value: 'ଗାଦ୍ରିଙ୍ଗିଆ', regex: false },
{ key: 'gomandi', value: 'ଗମାଣ୍ଡି', regex: false },
{ key: 'Gamerikia', value: 'ଗାମେରିକିଆ', regex: false },
{ key: 'Gandhari', value: 'ଗାନ୍ଧାରୀ', regex: false },
{ key: 'Ganjuguda', value: 'ଗଞ୍ଜୁଗୁଡା', regex: false },
{ key: 'khariguda', value: 'ଖାରିଗୁଡ଼ା', regex: false },
{ key: 'Ghati', value: 'ଘାଟି', regex: false },
{ key: 'Gochha', value: 'ଗୋଛା', regex: false },
{ key: 'Gudrighasi', value: 'ଗୁଡ଼୍ରିଘାସି', regex: false },
{ key: 'Gujapanga', value: 'ଗୁଜାପାଙ୍ଗା', regex: false },
{ key: 'Gumamaha', value: 'ଗୁମାମାହା', regex: false },
{ key: 'Gundhani', value: 'ଗୁନ୍ଧାଣୀ', regex: false },
{ key: 'Iriputa', value: 'ଇରିପୁଟା', regex: false },
{ key: 'Kadingia', value: 'କାଡ଼ିଙ୍ଗିଆ', regex: false },
{ key: 'Kajuri', value: 'କାଜୁରି', regex: false },
{ key: 'Kakarabadi', value: 'କାକରାବାଡ଼ି', regex: false },
{ key: 'Kaliamba', value: 'କାଲିଆମ୍ବା', regex: false },
{ key: 'Kaligadu', value: 'କାଲିଗାଡୁ', regex: false },
{ key: 'Kambaguda', value: 'କାମ୍ବାଗୁଡ଼ା', regex: false },
{ key: 'Kambarikia', value: 'କାମ୍ବାରିକିଆ', regex: false },
{ key: 'Konadi', value: 'କାନାଡ଼ି', regex: false },
{ key: 'Kanasaru', value: 'କନସରୁ', regex: false },
{ key: 'Kandabada', value: 'କାଣ୍ଡାବାଡ଼ା', regex: false },
{ key: 'Kantibana', value: 'କାନ୍ତିବନ', regex: false },
{ key: 'Kapuguta', value: 'କପୁଗୁଟା', regex: false },
{ key: 'Katedikia', value: 'କତେଡ଼ିକିଆ', regex: false },
{ key: 'Kendukhari', value: 'କେନ୍ଦୁଖାରି', regex: false },
{ key: 'Khajurikhaman', value: 'ଖଜୁରିଖମନ', regex: false },
{ key: 'Kilakia', value: 'କିଲାକିଆ', regex: false },
{ key: 'Kilapanga', value: 'କିଲାପାଙ୍ଗା', regex: false },
{ key: 'Kumbharakhadi', value: 'କୁମ୍ଭାରଖାଡ଼ି', regex: false },
{ key: 'Kuruguda', value: 'କୁରୁଗୁଡ଼ା', regex: false },
{ key: 'Lamungia', value: 'ଲାମୁଙ୍ଗିଆ', regex: false },
{ key: 'Landabali', value: 'ଲାଣ୍ଡାବାଲି', regex: false },
{ key: 'Latedi', value: 'ଲତେଡ଼ି', regex: false },
{ key: 'Lendrikia', value: 'ଲେଣ୍ଡ୍ରିକିଆ', regex: false },
{ key: 'Luhuringia', value: 'ଲୁହୁରିଙ୍ଗିଆ', regex: false },
{ key: 'Mahaguda', value: 'ମାହାଗୁଡ଼ା', regex: false },
{ key: 'Malaguda', value: 'ମାଲାଗୁଡ଼ା', regex: false },
{ key: 'Mandasaru', value: 'ମାଣ୍ଡାସରୁ', regex: false },
{ key: 'Manikeswar', value: 'ମାଣିକେଶ୍ୱର', regex: false },
{ key: 'Mankadaganda', value: 'ମାଙ୍କଡାଗାଣ୍ଡା', regex: false },
{ key: 'Mulukumaha', value: 'ମୁଲୁକୁମାହା', regex: false },
{ key: 'Mundanaju', value: 'ମୁଣ୍ଡାନାଜୁ', regex: false },
{ key: 'Mungelibadi', value: 'ମୁଙ୍ଗେଲିବାଡ଼ି', regex: false },
{ key: 'Murudikupuda', value: 'ମୁରୁଡିକୁପୁଡ଼ା', regex: false },
{ key: 'Murudipanga', value: 'ମୁରୁଡ଼ିପାଙ୍ଗା', regex: false },
{ key: 'Musumaha', value: 'ମୁସୁମାହା', regex: false },
{ key: 'Nahudimaha', value: 'ନାହୁଡ଼ିମାହା', regex: false },
{ key: 'Naipeta', value: 'ନାଇପେଟା', regex: false },
{ key: 'Nitibadi', value: 'ନିତିବାଡ଼ି', regex: false },
{ key: 'Nuagan', value: 'ନୂଆଗାଁ', regex: false },
{ key: 'Paderikia', value: 'ପାଦେରିକିଆ', regex: false },
{ key: 'Padrimaha', value: 'ପାଦ୍ରିମାହା', regex: false },
{ key: 'Pajigalu', value: 'ପାଜିଗାଲୁ', regex: false },
{ key: 'Pangamaha', value: 'ପାଙ୍ଗାମାହା', regex: false },
{ key: 'Papasi', value: 'ପପସି', regex: false },
{ key: 'Patalipanga', value: 'ପାଟଳିପାଙ୍ଗା', regex: false },
{ key: 'Penamala', value: 'ପେନାମାଲା', regex: false },
{ key: 'Petamaha', value: 'ପେଟାମାହା', regex: false },
{ key: 'Piseramaha', value: 'ପିସେରମାହା', regex: false },
{ key: 'Pitairpi', value: 'ପିତାଇର୍ପି', regex: false },
{ key: 'Podhamari', value: 'ପୋଢ଼ମାରି', regex: false },
{ key: 'Prangamaha', value: 'ପ୍ରାଙ୍ଗାମାହା', regex: false },
{ key: 'Radabali', value: 'ରାଡ଼ାବାଲି', regex: false },
{ key: 'Ratingia', value: 'ରଟିଙ୍ଗିଆ', regex: false },
{ key: 'Sahajakhole', value: 'ସାହାଜ ଖୋଲ', regex: false },
{ key: 'Sanabarba', value: 'ସାନବାରବା', regex: false },
{ key: 'Sandhakupa', value: 'ସନ୍ଧକୁପା', regex: false },
{ key: 'Sarbapanga', value: 'ସର୍ବପାଙ୍ଗା', regex: false },
{ key: 'Sidingipata', value: 'ସିଡିଙ୍ଗିପାଟା', regex: false },
{ key: 'Sihuripanga', value: 'ସିହୁରିପାଙ୍ଗା', regex: false },
{ key: 'Sikabadi', value: 'ସିକବାଡ଼ି', regex: false },
{ key: 'Sikriguda', value: 'ସିକ୍ରିଗୁଡ଼ା', regex: false },
{ key: 'Sikripadar', value: 'ସିକ୍ରିପଦର', regex: false },
{ key: 'Singarimaha', value: 'ସିଙ୍ଗାରିମାହା', regex: false },
{ key: 'Sipaeju', value: 'ସିପାଏଜୁ', regex: false },
{ key: 'Sisapanga', value: 'ଶିସପାଙ୍ଗା', regex: false },
{ key: 'Sugudabadi', value: 'ସୁଗୁଡ଼ବାଡ଼ି', regex: false },
{ key: 'Tagakia', value: 'ତଗାକିଆ', regex: false },
{ key: 'Talaindragada', value: 'ତଳଇନ୍ଦ୍ରଗଡ଼', regex: false },
{ key: 'Talapali', value: 'ତଲାପାଲି', regex: false },
{ key: 'Taraput', value: 'ତାରାପୁଟ', regex: false },
{ key: 'Tatamaha', value: 'ଟଟମାହା', regex: false },
{ key: 'Tentulia', value: 'ତେନ୍ତୁଳିଆ', regex: false },
{ key: 'Tiangia', value: 'ଟିଆଙ୍ଗିଆ', regex: false },
{ key: 'Turupanka', value: 'ତୁରୁପଙ୍କା', regex: false },
{ key: 'Bakamaha', value: 'ବାକାମାହା', regex: false },
{ key: 'Balamargan', value: 'ବଲାମାର୍ଗନ', regex: false },
{ key: 'Balipadar', value: 'ବାଲିପଦର', regex: false },
{ key: 'Bandudi', value: 'ବାଣ୍ଡୁଡି', regex: false },
{ key: 'Belaguma', value: 'ବେଲାଗୁମା', regex: false },
{ key: 'Bikanga', value: 'ବିକାଙ୍ଗା', regex: false },
{ key: 'Binjerkuti', value: 'ବିଞ୍ଜେରକୁଟି', regex: false },
{ key: 'Bipedi', value: 'ବିପେଡି', regex: false },
{ key: 'Budrumaha', value: 'ବୁଡ୍ରୁମାହା', regex: false },
{ key: 'Dadikilu', value: 'ଦାଡିକିଲୁ', regex: false },
{ key: 'Dakargan', value: 'ଡକରଗାଁ', regex: false },
{ key: 'Damerikia', value: 'ଡାମେରିକିଆ', regex: false },
{ key: 'Dandabali', value: 'ଦଣ୍ଡବାଲି', regex: false },
{ key: 'Daugan', value: 'ଦାଉଗାଁ', regex: false },
{ key: 'Dedimaha', value: 'ଡେଡ଼ିମାହା', regex: false },
{ key: 'Dudukakhol', value: 'ଦୁଡୁକାଖୋଲ', regex: false },
{ key: 'Duradadi', value: 'ଦୁରାଦଡ଼ି', regex: false },
{ key: 'Gajipadar', value: 'ଗାଜିପଦର', regex: false },
{ key: 'Ganipada', value: 'ଗାନିପଡ଼ା', regex: false },
{ key: 'Gardikia', value: 'ଗାର୍ଡିକିଆ', regex: false },
{ key: 'Gochhapada', value: 'ଗୋଛାପଡ଼ା', regex: false },
{ key: 'Gosanaju', value: 'ଗସାନାଜୁ', regex: false },
{ key: 'Gunjigam', value: 'ଗୁଞ୍ଜିଗାଁ', regex: false },
{ key: 'Jagerisuga', value: 'ଜାଗେରିସୁଗା', regex: false },
{ key: 'Jamapadar', value: 'ଜମାପଦର', regex: false },
{ key: 'Jangangia', value: 'ଜଗାଙ୍ଗିଆ', regex: false },
{ key: 'Jurukupuda', value: 'ଜୁରୁକୁପୁଡ଼ା', regex: false },
{ key: 'Kamangi', value: 'କାମାଙ୍ଗି', regex: false },
{ key: 'Kandibandha', value: 'କାଣ୍ଡିବନ୍ଧ', regex: false },
{ key: 'Kanisaru', value: 'କାନିସରୁ', regex: false },
{ key: 'Kasakupuda', value: 'କସାକୁପୁଡ଼ା', regex: false },
{ key: 'Katali', value: 'କଟଲି', regex: false },
{ key: 'Khaliapadar', value: 'ଖାଲିଆପଦର', regex: false },
{ key: 'Kilupada', value: 'କିଲୁପଡ଼ା', regex: false },
{ key: 'Kiraketa', value: 'କିରାକେତା', regex: false },
{ key: 'Kudupakia', value: 'କୁଡୁପାକିଆ', regex: false },
{ key: 'Lanjurmaha', value: 'ଲାଞ୍ଜୁରମାହା', regex: false },
{ key: 'Madiduba', value: 'ମାଦିଡୁବା', regex: false },
{ key: 'Mundargan', value: 'ମୁଣ୍ଡାରଗାଁ', regex: false },
{ key: 'Nandamaha', value: 'ନନ୍ଦମାହା', regex: false },
{ key: 'Nuarajaghara', value: 'ନୂଆରାଜଘର', regex: false },
{ key: 'Paderipada', value: 'ପାଦେରପଡ଼ା', regex: false },
{ key: 'Paibarasahi', value: 'ପାଇବରସାହି', regex: false },
{ key: 'Premakia', value: 'ପ୍ରେମାକିଆ', regex: false },
{ key: 'Pripeketa', value: 'ପ୍ରିପେକେତା', regex: false },
{ key: 'Rajaghara', value: 'ରାଜଘରା', regex: false },
{ key: 'Sabali', value: 'ସବାଳି', regex: false },
{ key: 'Sainipada', value: 'ସାଇନପଡ଼ା', regex: false },
{ key: 'Saraketa', value: 'ସାରାକେତା', regex: false },
{ key: 'Sikebari', value: 'ସିକେବାଡ଼ି', regex: false },
{ key: 'Sikesaru', value: 'ସିକେସରୁ', regex: false }, 
{ key: 'sirtiguda', value: 'ସିର୍ତ୍ତିଗୁଡ଼ା', regex: false },
{ key: 'Solaguda', value: 'ସୋଲାଗୁଡା', regex: false },
{ key: 'Taramakia', value: 'ତାରାମାକିଆ', regex: false },
{ key: 'Tetargan', value: 'ତେତରଗାଁ', regex: false },
{ key: 'Tilakpanga', value: 'ତିଲକପାଙ୍ଗା', regex: false },
{ key: 'achintapur', value: 'ଅଚିନ୍ତାପୁର', regex: false },
{ key: 'adabana', value: 'ଅଡବନ', regex: false },
{ key: 'alamramu', value: 'ଅଲାମ୍ରାମ', regex: false },
{ key: 'anlapata', value: 'ଅଁଲାପଟା', regex: false },
{ key: 'baanda', value: 'ବାନ୍ଦା', regex: false },
{ key: 'badabarba', value: 'ବଡବାର୍ବା', regex: false },
{ key: 'pakistan', value: 'ପାକିସ୍ତାନ', regex: false },
{ key: 'podmo', value: 'ପଦ୍ମ', regex: false },
{ key: 'bhratru', value: 'ଭ୍ରାତୃ', regex: false },
{ key: 'mantrimandl', value: 'ମନ୍ତ୍ରୀମଣ୍ଡଳ', regex: false },
{ key: 'indragada', value: 'ଇନ୍ଦ୍ରଗଡ଼', regex: false },
{ key: 'badajiri', value: 'ବାଡ଼ାଜିରି', regex: false },
{ key: 'nedi', value: 'ନେଡ଼ି', regex: false },
{ key: 'kohuni', value: 'କହୁଣୀ', regex: false },
{ key: 'bageiju', value: 'ବାଗେଏଜୁ', regex: false },
{ key: 'bakingia', value: 'ବାକିଙ୍ଗିଆ', regex: false },
{ key: 'balingia', value: 'ବାଲିଙ୍ଗିଆ', regex: false },
{ key: 'barada', value: 'ବରଡ଼ା', regex: false },
{ key: 'baradali', value: 'ବରଡ଼ାଳି', regex: false },
{ key: 'barepanga', value: 'ବରେପାଙ୍ଗା', regex: false },
{ key: 'bariguda', value: 'ବରିଗୁଡ଼ା', regex: false },
{ key: 'bedaguba', value: 'ବେଡାଗୁବା', regex: false },
{ key: 'bhitarabadi', value: 'ଭିତରବାଡ଼ି', regex: false },
{ key: 'bisitota', value: 'ବିସିତୋଟା', regex: false },
{ key: 'borigochha', value: 'ବୋରିଗୋଛା', regex: false },
{ key: 'borimunda', value: 'ବୋରିମୁଣ୍ଡା', regex: false },
{ key: 'budamaha', value: 'ବୁଡ଼ାମାହା', regex: false },
{ key: 'budringia', value: 'ବୁଦ୍ରିଙ୍ଗିଆ', regex: false },
{ key: 'burapanga', value: 'ବୁରାପାଙ୍ଗା', regex: false },
{ key: 'chakapad', value: 'ଚକାପାଦ', regex: false },
{ key: 'dadagamaha', value: 'ଡଡ଼ଗାମାହା', regex: false },
{ key: 'dakapanga', value: 'ଡାକପାଙ୍ଗା', regex: false },
{ key: 'damaguda', value: 'ଡମାଗୁଡ଼ା', regex: false },
{ key: 'dandapanga', value: 'ଦଣ୍ଡପାଙ୍ଗା', regex: false },
{ key: 'danderi', value: 'ଦାଣ୍ଡେରୀ', regex: false },
{ key: 'danturikhaman', value: 'ଦାନ୍ତୁରିଖମନ୍', regex: false },
{ key: 'darju', value: 'ଦର୍ଜୁ', regex: false },
{ key: 'dhepaguda', value: 'ଢ଼େପାଗୁଡ଼ା', regex: false },
{ key: 'dhngesu', value: 'ଢଙ୍ଗେସୁ', regex: false },
{ key: 'dibari', value: 'ଡ଼ିବାରି', regex: false },
{ key: 'dimiripali', value: 'ଡିମିରିପାଲି', regex: false },
{ key: 'gadringia', value: 'ଗଦ୍ରିଙ୍ଗିଆ', regex: false },
{ key: 'gamerikia', value: 'ଗାମେରିକିଆ', regex: false },
{ key: 'gandharibhuin', value: 'ଗନ୍ଧାରିଭୁଇଁ', regex: false },
{ key: 'ganiamentu', value: 'ଗାନିଆମେଣ୍ଟୁ', regex: false },
{ key: 'ganjuguda', value: 'ଗଞ୍ଜୁଗୁଡ଼ା', regex: false },
{ key: 'ghatikhariguda', value: 'ଘାଟିଖାରିଗୁଡ଼ା', regex: false },
{ key: 'gochhabadi', value: 'ଗୋଛାବାଡ଼ି', regex: false },
{ key: 'gudrighasi', value: 'ଗୁଡ୍ରିଘାସି', regex: false },
{ key: 'gujapanga', value: 'ଗୁଜାପାଙ୍ଗା', regex: false },
{ key: 'gumamaha', value: 'ଗୁମାମାହା', regex: false },
{ key: 'hatimunda', value: 'ହାତିମୁଣ୍ଡା', regex: false },
{ key: 'hatipathar', value: 'ହାତିପଥର', regex: false },
{ key: 'iriputa', value: 'ଇରିପୁଟା', regex: false },
{ key: 'kadingia', value: 'କାଡ଼ଙ୍ଗିଆ', regex: false },
{ key: 'kajuri', value: 'କାଜୁରି', regex: false },
{ key: 'kakarabadi', value: 'କାକାରବାଡ଼ି', regex: false },
{ key: 'kaliamba', value: 'କାଲିଆମ୍ବା', regex: false },
{ key: 'kaligadu', value: 'କାଲିଗାଡୁ', regex: false },
{ key: 'kambaguda', value: 'କାମ୍ବାଗୁଡ଼ା', regex: false },
{ key: 'kambarikia', value: 'କାମ୍ବାରିକିଆ', regex: false },
{ key: 'kanadi', value: 'କନାଡ଼ି', regex: false },
{ key: 'kanasaru', value: 'କାନସରୁ', regex: false },
{ key: 'kandabada', value: 'କାଣ୍ଡାବାଡ଼ା', regex: false },
{ key: 'kantibana', value: 'କନ୍ତିବନ', regex: false },
{ key: 'kapuguta', value: 'କପୁଗୁଟା', regex: false },
{ key: 'katedikia', value: 'କଟେଡ଼ିକିଆ', regex: false },
{ key: 'kendukhari', value: 'କେନ୍ଦୁଖାରି', regex: false },
{ key: 'khajurikhaman', value: 'ଖଜୁରିଖମନ୍', regex: false },
{ key: 'kilakia', value: 'କିଲାକିଆ', regex: false },
{ key: 'kilapanga', value: 'କିଲାପାଙ୍ଗା', regex: false },
{ key: 'kumbharakhadi', value: 'କୁମ୍ଭାରଖାଡ଼ି', regex: false },
{ key: 'kuruguda', value: 'କୁରୁଗୁଡ଼ା', regex: false },
{ key: 'lamungia', value: 'ଲାମୁଙ୍ଗିଆ', regex: false },
{ key: 'landabali', value: 'ଲାଣ୍ଡାବାଲି', regex: false },
{ key: 'latedi', value: 'ଲତେଡ଼ି', regex: false },
{ key: 'lendrikia', value: 'ଲେଣ୍ଡ୍ରିକିଆ', regex: false },
{ key: 'luhuringia', value: 'ଲୁହୁରିଙ୍ଗିଆ', regex: false },
{ key: 'mahaguda', value: 'ମାହାଗୁଡ଼ା', regex: false },
{ key: 'malaguda', value: 'ମାଲାଗୁଡ଼ା', regex: false },
{ key: 'mandasaru', value: 'ମଣ୍ଡାସରୁ', regex: false },
{ key: 'manikeswar', value: 'ମାଣିକେଶ୍ୱର', regex: false },
{ key: 'mankadaganda', value: 'ମାଙ୍କଡ଼ଗାଣ୍ଡା', regex: false },
{ key: 'mediadami', value: 'ମେଡିଆଦାମି', regex: false },
{ key: 'mulukumaha', value: 'ମୁଲୁକୁମାହା', regex: false },
{ key: 'mundanaju', value: 'ମୁଣ୍ଡାନାଜୁ', regex: false },
{ key: 'mungelibadi', value: 'ମୁଙ୍ଗେଲିବାଡ଼ି', regex: false },
{ key: 'murudikupuda', value: 'ମୁରୁଡ଼ିକୁପୁଡ଼ା', regex: false },
{ key: 'murudipanga', value: 'ମୁରୁଡ଼ିପାଙ୍ଗା', regex: false },
{ key: 'musumaha', value: 'ମୁସୁମହା', regex: false },
{ key: 'nahudimaha', value: 'ନାହୁଡିମାହା', regex: false },
{ key: 'naipeta', value: 'ନାଇପେଟା', regex: false },
{ key: 'naringipali', value: 'ନରିଙ୍ଗିପଲ୍ଲି', regex: false },
//{ key: 'nitibadi', value: 'ନିଟିବାଡ଼ି', regex: false },
{ key: 'nitidina', value: 'ନିତିଦିନ', regex: false },
{ key: 'paderikia', value: 'ପାଦେରିକିଆ', regex: false },
{ key: 'padrimaha', value: 'ପାଦ୍ରିମାହା', regex: false },
{ key: 'pajigalu', value: 'ପାଜିଗାଲୁ', regex: false },
{ key: 'pangamaha', value: 'ପାଙ୍ଗାମାହା', regex: false },
{ key: 'papasi', value: 'ପପସି', regex: false },
{ key: 'patalipanga', value: 'ପାଟଳିପାଙ୍ଗା', regex: false },
{ key: 'penamala', value: 'ପେନାମାଲା', regex: false },
{ key: 'petamaha', value: 'ପେଟମାହା', regex: false },
{ key: 'pipalabadi', value: 'ପିପଲାବାଡ଼ି', regex: false },
{ key: 'piseramaha', value: 'ପିସେରମହା', regex: false },
{ key: 'pitairpi', value: 'ପିତାଇର୍ପି', regex: false },
{ key: 'podhamari', value: 'ପୋଢମାରି', regex: false },
{ key: 'prangamaha', value: 'ପ୍ରାଙ୍ଗାମାହା', regex: false },
{ key: 'radabali', value: 'ରାଡ଼ାବାଲି', regex: false },
{ key: 'ratingia', value: 'ରଟିଙ୍ଗିଆ', regex: false },
{ key: 'sahajakhole', value: 'ସହଜଖୋଲ୍', regex: false },
{ key: 'sanabarba', value: 'ସାନବାର୍ବା', regex: false },
{ key: 'sandhakupa', value: 'ସନ୍ଧକୁପା', regex: false },
{ key: 'sandhigada', value: 'ସନ୍ଧିଗଡ଼', regex: false },
{ key: 'sarbapanga', value: 'ସର୍ବପାଙ୍ଗା', regex: false },
{ key: 'sidingipata', value: 'ସିଡିଙ୍ଗିପାଟା', regex: false },
{ key: 'sihuripanga', value: 'ସିହୁରିପାଙ୍ଗା', regex: false },
{ key: 'sikabadi', value: 'ସିକବାଡ଼ି', regex: false },
{ key: 'sikriguda', value: 'ସିକ୍ରିଗୁଡା', regex: false },
{ key: 'sikripadar', value: 'ସିକ୍ରିପଦର୍', regex: false },
{ key: 'singarimaha', value: 'ସିଙ୍ଗାରିମାହା', regex: false },
{ key: 'sipaeju', value: 'ସିପାଏଜୁ', regex: false },
{ key: 'sisapanga', value: 'ସିସପାଙ୍ଗା', regex: false },
{ key: 'sugudabadi', value: 'ସୁଗୁଡ଼ବାଡ଼ି', regex: false },
{ key: 'tagakia', value: 'ତଗାକିଆ', regex: false },
{ key: 'talaindragada', value: 'ଟଳଇନ୍ଦ୍ରଗଡ଼', regex: false },
{ key: 'talapali', value: 'ତଲାପାଲି', regex: false },
{ key: 'taraput', value: 'ତାରାପୁଟ', regex: false },
{ key: 'tatamaha', value: 'ଟଟମାହା', regex: false },
{ key: 'tentulia', value: 'ତେଣ୍ଟୁଳିଆ', regex: false },
{ key: 'tiangia', value: 'ଟିଆଙ୍ଗିଆ', regex: false },
{ key: 'turupanka', value: 'ତୁରୁପଙ୍କା', regex: false },
{ key: 'asika', value: 'ଆସିକା', regex: false },
{ key: 'berhampur', value: 'ବ୍ରହ୍ମପୁର', regex: false },
{ key: 'chatrapur', value: 'ଛତ୍ରପୁର', regex: false },
{ key: 'gopalpur', value: 'ଗୋପାଳପୁର', regex: false },
{ key: 'huma', value: 'ହୁମା', regex: false },
{ key: 'khalikote', value: 'ଖଲିକୋଟ', regex: false },
{ key: 'kodala', value: 'କୋଦଳା', regex: false },
{ key: 'polasara', value: 'ପୋଲସରା', regex: false },
{ key: 'purushottampur', value: 'ପୁରୁଷୋତ୍ତମପୁର', regex: false },
{ key: 'rambha', value: 'ରମ୍ଭା', regex: false },
{ key: 'sorada', value: 'ସୋରଡ଼ା', regex: false },
{ key: 'tarabha', value: 'ତାରଭା', regex: false },
{ key: 'patrapur', value: 'ପାତ୍ରପୁର୍', regex: false },
{ key: 'patra', value: 'ପାତ୍ର', regex: false },
{ key: 'digapahandi', value: 'ଦିଗପହଣ୍ଡି', regex: false },
{ key: 'dharakote', value: 'ଧରାକୋଟ', regex: false },
{ key: 'kabisuryanagar', value: 'କବିସୂର୍ଯ୍ୟନଗର', regex: false },
{ key: 'buguda', value: 'ବୁଗୁଡ଼ା', regex: false },
{ key: 'belaguntha', value: 'ବେଲଗୁଣ୍ଠା', regex: false },
{ key: 'sanakhemundi', value: 'ସାନଖେମୁଣ୍ଡି', regex: false },
{ key: 'sheragada', value: 'ଶେରଗଡ଼', regex: false },
{ key: 'surada', value: 'ସୋରଡ଼ା', regex: false },
{ key: 'jharsuguda', value: 'ଝାରସୁଗୁଡ଼ା', regex: false },
{ key: 'narendrapur', value: 'ନରେନ୍ଦ୍ରପୁର', regex: false },
{ key: 'pandia', value: 'ପାଣ୍ଡିଆ', regex: false },
{ key: 'golanthara', value: 'ଗୋଳନ୍ତରା', regex: false },
{ key: 'kukudakhandi', value: 'କୁକୁଡ଼ାଖଣ୍ଡି', regex: false },
{ key: 'tarsingi', value: 'ତାରସିଂ', regex: false },
{ key: 'nandapur', value: 'ନନ୍ଦପୁର', regex: false },
{ key: 'agastinuagaon', value: 'ଅଗସ୍ତିନୁଆଗାଁ', regex: false },
{ key: 'alada', value: 'ଆଳଦା', regex: false },
{ key: 'amba', value: 'ଅମ୍ବା', regex: false },
{ key: 'ambapua', value: 'ଅମ୍ବପୁଆ', regex: false },
{ key: 'anda', value: 'ଆଣ୍ଡା', regex: false },
{ key: 'andhari', value: 'ଅନ୍ଧାରୀ', regex: false },
{ key: 'arjyapalli', value: 'ଅର୍ଜ୍ଯପଲ୍ଲୀ', regex: false },
{ key: 'asika', value: 'ଆସିକା', regex: false },
{ key: 'badagada', value: 'ବଡ଼ଗଡ଼', regex: false },
{ key: 'badakhol', value: 'ବଡ଼ଖୋଲ', regex: false },
{ key: 'badapalli', value: 'ବଡପଲ୍ଲୀ', regex: false },
{ key: 'bagada', value: 'ବଗଡ଼ା', regex: false },
{ key: 'bahadajhola', value: 'ବହଦଝୋଳ', regex: false },
{ key: 'balipadar', value: 'ବଳିପଦର', regex: false },
{ key: 'banapur', value: 'ବାଣପୁର', regex: false },
{ key: 'banchua', value: 'ବାଞ୍ଚୁଆ', regex: false },
{ key: 'barua', value: 'ବାରୁଆ', regex: false },
{ key: 'belaguntha', value: 'ବେଲଗୁଣ୍ଠ', regex: false },
{ key: 'bhairipur', value: 'ଭାଇରିପୁର', regex: false },
{ key: 'bhanjanagar', value: 'ଭଞ୍ଜନଗର', regex: false },
{ key: 'bhetanai', value: 'ଭେଟାଣୀ', regex: false },
{ key: 'binayakpur', value: 'ବିନାୟକପୁର', regex: false },
{ key: 'brahmanigaon', value: 'ବ୍ରାହ୍ମଣୀଗାଁ', regex: false },
{ key: 'buguda', value: 'ବୁଗୁଡ଼ା', regex: false },
{ key: 'burujhari', value: 'ବୁରୁଝରୀ', regex: false },
{ key: 'chamakhandi', value: 'ଚମଖଣ୍ଡି', regex: false },
{ key: 'chandapur', value: 'ଚାନ୍ଦପୁର', regex: false },
{ key: 'chatrapur', value: 'ଛତ୍ରପୁର', regex: false },
{ key: 'chikiti', value: 'ଚିକିଟି', regex: false },
{ key: 'dakhinapur', value: 'ଦକ୍ଷିଣପୁର', regex: false },
{ key: 'dandisahi', value: 'ଦଣ୍ଡିସାହି', regex: false },
{ key: 'daringbadi', value: 'ଦାରିଙ୍ଗବାଡି', regex: false },
{ key: 'dharakote', value: 'ଧରାକୋଟ', regex: false },
{ key: 'digapahandi', value: 'ଦିଗପହଣ୍ଡି', regex: false },
{ key: 'dihasahi', value: 'ଡିହସାହି', regex: false },
{ key: 'gajapatinagaram', value: 'ଗଜପତିନଗରମ', regex: false },
{ key: 'gandahati', value: 'ଗାନ୍ଧାହାଟୀ', regex: false },
{ key: 'gandhinagar', value: 'ଗାନ୍ଧୀନଗର', regex: false },
{ key: 'golanthara', value: 'ଗୋଳନ୍ତରା', regex: false },
{ key: 'goudagotha', value: 'ଗୌଡ଼ଗୋଠ', regex: false },
{ key: 'gurujanga', value: 'ଗୁରୁଜଙ୍ଗ', regex: false },
{ key: 'hijili', value: 'ହିଜିଲି', regex: false },
{ key: 'huma', value: 'ହୁମା', regex: false },
{ key: 'jaganathapur', value: 'ଜଗନ୍ନାଥପୁର', regex: false },
{ key: 'jagannathprasad', value: 'ଜଗନ୍ନାଥପ୍ରସାଦ', regex: false },
{ key: 'jaleswar', value: 'ଜଳେଶ୍ଵର', regex: false },
{ key: 'jiranga', value: 'ଜିରଙ୍ଗ', regex: false },
{ key: 'kabisuryanagar', value: 'କବିସୂର୍ଯ୍ୟନଗର', regex: false },
{ key: 'kaling', value: 'କଳିଙ୍ଗ', regex: false },
{ key: 'khalikote', value: 'ଖଲିକୋଟ', regex: false },
{ key: 'kodala', value: 'କୋଦଳା', regex: false },
{ key: 'kukudakhandi', value: 'କୁକୁଡଖଣ୍ଡି', regex: false },
{ key: 'kullada', value: 'କୁଲ୍ଲଡା', regex: false },
{ key: 'lathi', value: 'ଲାଠି', regex: false },
{ key: 'makundapur', value: 'ମକୁନ୍ଦପୁର', regex: false },
{ key: 'malada', value: 'ମାଳଦା', regex: false },
{ key: 'mardarajpur', value: 'ମର୍ଦ୍ଦରାଜପୁର', regex: false },
{ key: 'mohuda', value: 'ମୋହୁଡା', regex: false },
{ key: 'narendrapur', value: 'ନରେନ୍ଦ୍ରପୁର', regex: false },
{ key: 'nayagarh', value: 'ନୟାଗଡ଼', regex: false },
{ key: 'nuagaon', value: 'ନୂଆଗାଁ', regex: false },
{ key: 'pandia', value: 'ପାଣ୍ଡିଆ', regex: false },
{ key: 'patrapur', value: 'ପାତ୍ରପୁର', regex: false },
{ key: 'polasara', value: 'ପୋଲସରା', regex: false },
{ key: 'purushottampur', value: 'ପୁରୁଷୋତ୍ତମପୁର', regex: false },
{ key: 'rambha', value: 'ରମ୍ଭା', regex: false },
{ key: 'ranapur', value: 'ରଣପୁର', regex: false },
{ key: 'sanahemundi', value: 'ସାନଖେମୁଣ୍ଡି', regex: false },
{ key: 'sheragada', value: 'ଶେରଗଡ଼', regex: false },
{ key: 'sorada', value: 'ସୋରଡ଼ା', regex: false },
{ key: 'tarbha', value: 'ତାରଭା', regex: false },
{ key: 'tarsingi', value: 'ତାରସିଂ', regex: false },
{ key: 'chhatrapur', value: 'ଛତ୍ରପୁର', regex: false },
{ key: 'alada', value: 'ଆଳଦା', regex: false },
{ key: 'amba', value: 'ଅମ୍ବା', regex: false },
{ key: 'andara', value: 'ଆଣ୍ଡାର', regex: false },
{ key: 'bahadajhola', value: 'ବହଦଝୋଳ', regex: false },
{ key: 'balipadar', value: 'ବଳିପଦର', regex: false },
{ key: 'barua', value: 'ବାରୁଆ', regex: false },
{ key: 'bhetanai', value: 'ଭେଟାଣୀ', regex: false },
{ key: 'binayakpur', value: 'ବିନାୟକପୁର', regex: false },
{ key: 'brahmanigaon', value: 'ବ୍ରାହ୍ମଣୀଗାଁ', regex: false },
{ key: 'burujhari', value: 'ବୁରୁଝରୀ', regex: false },
{ key: 'chamakhandi', value: 'ଚମଖଣ୍ଡି', regex: false },
{ key: 'chandapur', value: 'ଚାନ୍ଦପୁର', regex: false },
{ key: 'dakhinapur', value: 'ଦକ୍ଷିଣପୁର', regex: false },
{ key: 'dandisahi', value: 'ଦଣ୍ଡିସାହି', regex: false },
{ key: 'dihasahi', value: 'ଡିହସାହି', regex: false },
{ key: 'gandhinagar', value: 'ଗାନ୍ଧୀନଗର', regex: false },
{ key: 'bhadrak', value: 'ଭଦ୍ରକ', regex: false },
{ key: 'bhandaripokhari', value: 'ଭାଣ୍ଡାରିପୋଖରୀ', regex: false },
//  { key: 'bant', value: 'ବାନ୍ତ', regex: false },
{ key: 'basudevpur', value: 'ବାସୁଦେବପୁର', regex: false },
{ key: 'bhatapada', value: 'ଭଟପଡା', regex: false },
{ key: 'bhusandapur', value: 'ଭୁସଣ୍ଡପୁର', regex: false },
//  { key: 'bonth', value: 'ବୋନ୍ଥ', regex: false },
{ key: 'chandabali', value: 'ଚାନ୍ଦବାଲି', regex: false },
{ key: 'chandipur', value: 'ଚାନ୍ଦିପୁର', regex: false },
{ key: 'dhamara', value: 'ଧାମରା', regex: false },
{ key: 'dhusuri', value: 'ଧୁସୁରି', regex: false },
{ key: 'govindpur', value: 'ଗୋବିନ୍ଦପୁର', regex: false },
{ key: 'jajanga', value: 'ଜଜଙ୍ଗ', regex: false },
{ key: 'kamalanga', value: 'କମଳାଙ୍ଗ', regex: false },
{ key: 'kanpur', value: 'କାନପୁର', regex: false },
{ key: 'kothar', value: 'କୋଠାର', regex: false },
{ key: 'mathani', value: 'ମାଠାଣି', regex: false },
{ key: 'naikanidihi', value: 'ନଇକାନିଦିହି', regex: false },
{ key: 'tihidi', value: 'ତିହିଡି', regex: false },
{ key: 'jajwalya', value: 'ଜାଜ୍ଜ୍ୱଲ୍ୟ', regex: false }, 
{ key: 'abadhi', value: 'ଅବଧି', regex: false },
{ key: 'alanda', value: 'ଆଳନ୍ଦା', regex: false },
{ key: 'nalanda', value: 'ନାଳନ୍ଦା', regex: false },
{ key: 'aradapalli', value: 'ଆରଡ଼ପଲ୍ଲୀ', regex: false },
{ key: 'aradia', value: 'ଆରଡ଼ିଆ', regex: false },
{ key: 'asurabandha', value: 'ଅସୁରବନ୍ଧ', regex: false },
{ key: 'badabandha', value: 'ବଡ଼ବନ୍ଧ', regex: false },
{ key: 'badabhuin', value: 'ବଡ଼ଭୁଇଁ', regex: false },
{ key: 'gochha', value: 'ଗୋଛା', regex: false },
{ key: 'khandayat', value: 'ଖଣ୍ଡାୟତ', regex: false },
{ key: 'badamundapada', value: 'ବଡମୁଣ୍ଡାପଡା', regex: false },
{ key: 'badapokhari', value: 'ବଡ଼ପୋଖରୀ', regex: false },
{ key: 'badaranga', value: 'ବଡ଼ରଙ୍ଗ', regex: false },
{ key: 'badatribeni', value: 'ବଡ଼ତ୍ରିବେଣୀ', regex: false },
{ key: 'baghamari', value: 'ବଘମାରୀ', regex: false },
{ key: 'bahadajhola', value: 'ବହଡ଼ଝୋଳ', regex: false },
{ key: 'baunsapalli', value: 'ବଉଁସପଲ୍ଲୀ', regex: false },
{ key: 'belapada', value: 'ବେଲାପଡ଼ା', regex: false },
{ key: 'bhalukumpa', value: 'ଭାଲୁକୁମ୍ପା', regex: false },
{ key: 'bhandaripokhari', value: 'ଭାଣ୍ଡାରୀପୋଖରୀ', regex: false },
{ key: 'bharatapur', value: 'ଭରତପୁର', regex: false },
{ key: 'bhimpur', value: 'ଭିମପୁର', regex: false },
{ key: 'bhitargarh', value: 'ଭିତରଗଡ଼', regex: false },
{ key: 'bhod', value: 'ଭୋଦ', regex: false },
{ key: 'bhuinpalli', value: 'ଭୁଇଁପଲ୍ଲୀ', regex: false },
{ key: 'bhusandapur', value: 'ଭୁସଣ୍ଡପୁର', regex: false },
{ key: 'binjharapur', value: 'ବିଞ୍ଝରପୁର', regex: false },
{ key: 'brahmanasahi', value: 'ବ୍ରାହ୍ମଣସାହି', regex: false },
{ key: 'chadeibandha', value: 'ଚଢ଼େଇବନ୍ଧ', regex: false },
{ key: 'chakapada', value: 'ଚକାପାଦ', regex: false },
{ key: 'champapadar', value: 'ଚମ୍ପାପଦର', regex: false },
{ key: 'chandapur', value: 'ଚନ୍ଦ୍ରପୁର', regex: false },
{ key: 'chandiposh', value: 'ଚଣ୍ଡୀପୋଷ', regex: false },
{ key: 'chandipur', value: 'ଚାନ୍ଦିପୁର', regex: false },
{ key: 'chandrasekharpur', value: 'ଚନ୍ଦ୍ରଶେଖରପୁର', regex: false },
{ key: 'chanduali', value: 'ଚାନ୍ଦୁଆଳି', regex: false },
{ key: 'chheliapada', value: 'ଛେଲିଆପଡା', regex: false },
{ key: 'dandadeuli', value: 'ଡାନ୍ଦାଡେଉଳି', regex: false },
{ key: 'darpanarayanapur', value: 'ଦର୍ପଣାରୟଣପୁର', regex: false },
{ key: 'deogaon', value: 'ଦେଓଗାଁ', regex: false },
{ key: 'pochh', value: 'ପଛ', regex: false },  
{ key: 'pachoti', value: 'ପାଛୋଟି', regex: false }, 
//  { key: 'pochhi', value: ' ପୋଛି', regex: false }, 
{ key: 'poch', value: 'ପୋଛ', regex: false }, 
{ key: 'pachi', value: 'ପାଚି', regex: false }, 
{ key: 'chadib', value: 'ଛାଡ଼ିବ', regex: false },
{ key: 'jongala', value: 'ଜଙ୍ଗଲ', regex: false },    
{ key: 'jodi', value: 'ଯଦି', regex: false },    
{ key: 'adalot', value: 'ଅଦାଲତ', regex: false },    
{ key: 'deulapada', value: 'ଦେଉଳପଡା', regex: false },
{ key: 'deulijhari', value: 'ଦେଉଳିଝରି', regex: false },
{ key: 'dhaneswarpur', value: 'ଧନେଶ୍ଵରପୁର', regex: false },
{ key: 'dharampur', value: 'ଧରମପୁର', regex: false },
{ key: 'dihasahi', value: 'ଡିହସାହି', regex: false },
{ key: 'dhubasahi', value: 'ଧୁବାସାହି', regex: false },
{ key: 'gadadharprasad', value: 'ଗଦାଧରପ୍ରସାଦ', regex: false },
{ key: 'gadadharpur', value: 'ଗଦାଧରପୁର', regex: false },
{ key: 'ghantapada', value: 'ଘଣ୍ଟାପଡା', regex: false },
{ key: 'gobindapur', value: 'ଗୋବିନ୍ଦପୁର', regex: false },
{ key: 'gopinathpur', value: 'ଗୋପୀନାଥପୁର', regex: false },
{ key: 'goudapokhari', value: 'ଗୌଡ଼ପୋଖରୀ', regex: false },
{ key: 'goudasahi', value: 'ଗୌଡ଼ସାହି', regex: false },
{ key: 'goudasasan', value: 'ଗୌଡ଼ଶାସନ', regex: false },
{ key: 'gudupalli', value: 'ଗୁଡୁପଲ୍ଲୀ', regex: false },
{ key: 'gurudia', value: 'ଗୁରୁଡ଼ିଆ', regex: false },
{ key: 'haladibandha', value: 'ହଳଦିବନ୍ଧ', regex: false },
{ key: 'haladia', value: 'ହଳଡିଆ', regex: false },
{ key: 'haria', value: 'ହରିଆ', regex: false },
{ key: 'haripur', value: 'ହରିପୁର', regex: false },
{ key: 'hatibari', value: 'ହାଟିବାରି', regex: false },
{ key: 'jagannathapur', value: 'ଜଗନ୍ନାଥପୁର', regex: false },
{ key: 'jagannathprasad', value: 'ଜଗନ୍ନାଥପ୍ରସାଦ', regex: false },
{ key: 'jaguleipada', value: 'ଜାଗୁଲେଇପଡା', regex: false },
{ key: 'jaleswar', value: 'ଜଳେଶ୍ଵର', regex: false },
{ key: 'jankia', value: 'ଜଙ୍କିଆ', regex: false },
{ key: 'jhadrajhari', value: 'ଝାଡ୍ରଝରି', regex: false },
{ key: 'jhankadapada', value: 'ଝାଙ୍କଡପଡା', regex: false },
{ key: 'jharapada', value: 'ଝାରପଡ଼ା', regex: false },
{ key: 'bhuin', value: 'ଭୁଇଁ', regex: false },
{ key: 'jhadabandha', value: 'ଝାଡ଼ବନ୍ଧ', regex: false },
//{ key: 'jogiapada', value: 'ଯୋଗିଆପଡା', regex: false },
//{ key: 'jogisahi', value: 'ଯୋଗୀସାହି', regex: false },
{ key: 'kadalibadi', value: 'କାଦଲିବାଡ଼ି', regex: false },
{ key: 'kadamkhandi', value: 'କଦମଖଣ୍ଡି', regex: false },
{ key: 'kadampur', value: 'କଦମପୁର', regex: false },
{ key: 'kainchua', value: 'କାଇଚୁଆଁ', regex: false },
  //{ key: 'kalasahi', value: 'କଳାସାହି', regex: false },
  //{ key: 'kalasapada', value: 'କଳସାପଡ଼ା', regex: false },
  //{ key: 'kalasapalli', value: 'କଳସାପଲ୍ଲୀ', regex: false },
  //{ key: 'kalasapanga', value: 'କାଳସାପାଙ୍ଗା', regex: false },
{ key: 'adal', value: 'ଆଡଲ୍', regex: false },
{ key: 'agarpada', value: 'ଅଗରପଡ଼ା', regex: false },
{ key: 'alipur', value: 'ଆଳିପୁର', regex: false },
{ key: 'amalabadi', value: 'ଅମଳାବାଦୀ', regex: false },
//{ key: 'andharua', value: 'ଅନ୍ଧାରୁଆ', regex: false },
{ key: 'samagra', value: 'ସମଗ୍ର', regex: false },
{ key: 'bidesi', value: 'ବିଦେଶୀ', regex: false },
{ key: 'arajakata', value: 'ଅରାଜକତା', regex: false },
{ key: 'mohongga', value: 'ମହଙ୍ଗା', regex: false },
{ key: 'poornno', value: 'ପୂର୍ଣ୍ଣ', regex: false },
{ key: 'khali', value: 'ଖାଲି', regex: false },
{ key: 'thik', value: 'ଠିକ୍', regex: false },
{ key: 'bhul', value: 'ଭୁଲ୍', regex: false },
{ key: 'michha', value: 'ମିଛ', regex: false },
{ key: 'koshtokoro', value: 'କଷ୍ଟକର', regex: false },
{ key: 'ujjowlo', value: 'ଉଜ୍ଜ୍ୱଳ', regex: false },
{ key: 'andhokaro', value: 'ଅନ୍ଧକାର', regex: false },
{ key: 'kolaholopurnno', value: 'କୋଳାହଳପୂର୍ଣ୍ଣ', regex: false },
{ key: 'shanto', value: 'ଶାନ୍ତ', regex: false },
{ key: 'aalsua', value: 'ଆଳସୁଆ', regex: false },
{ key: 'sokriyo', value: 'ସକ୍ରିୟ', regex: false },
{ key: 'sustho', value: 'ସୁସ୍ଥ', regex: false },
{ key: 'osustho', value: 'ଅସୁସ୍ଥ', regex: false },
{ key: 'khola', value: 'ଖୋଲା', regex: false },
{ key: 'bondo', value: 'ବନ୍ଦ', regex: false },
{ key: 'tikshno', value: 'ତୀକ୍ଷ୍ଣ', regex: false },
{ key: 'kunthito', value: 'କୁଣ୍ଠିତ', regex: false },
{ key: 'mosruno', value: 'ମସୃଣ', regex: false },
{ key: 'khorokhora', value: 'ଖରଖରା', regex: false },
{ key: 'sidha', value: 'ସିଧା', regex: false },
{ key: 'bokro', value: 'ବକ୍ର', regex: false },
{ key: 'uchcho', value: 'ଉଚ୍ଚ', regex: false },
{ key: 'nimno', value: 'ନିମ୍ନ', regex: false },
{ key: 'gobhiro', value: 'ଗଭୀର', regex: false },
{ key: 'alpogobhiro', value: 'ଅଳ୍ପଗଭୀର', regex: false },
{ key: 'oneko', value: 'ଅନେକ', regex: false },
{ key: 'kom', value: 'କମ୍', regex: false },
{ key: 'somano', value: 'ସମାନ', regex: false },
{ key: 'bhinno', value: 'ଭିନ୍ନ', regex: false },
{ key: 'prothomo', value: 'ପ୍ରଥମ', regex: false },
{ key: 'shesho', value: 'ଶେଷ', regex: false },
{ key: 'poroborti', value: 'ପରବର୍ତ୍ତୀ', regex: false },
{ key: 'purboborti', value: 'ପୂର୍ବବର୍ତ୍ତୀ', regex: false },
{ key: 'shighro', value: 'ଶୀଘ୍ର', regex: false },
{ key: 'bilombo', value: 'ବିଳମ୍ବ', regex: false },
{ key: 'sarbojonino', value: 'ସାର୍ବଜନୀନ', regex: false },
{ key: 'byaktigoto', value: 'ବ୍ୟକ୍ତିଗତ', regex: false },
{ key: 'gurutwopurnno', value: 'ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ', regex: false },
{ key: 'agurutwopurnno', value: 'ଅଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ', regex: false },
{ key: 'sombhobo', value: 'ସମ୍ଭବ', regex: false },
{ key: 'osombhobo', value: 'ଅସମ୍ଭବ', regex: false },
{ key: 'prokruto', value: 'ପ୍ରକୃତ', regex: false },
{ key: 'nokoli', value: 'ନକଲି', regex: false },
{ key: 'jibito', value: 'ଜୀବିତ', regex: false },
{ key: 'mrito', value: 'ମୃତ', regex: false },
{ key: 'prokrutiko', value: 'ପ୍ରାକୃତିକ', regex: false },
{ key: 'kritrimo', value: 'କୃତ୍ରିମ', regex: false },
{ key: 'adhunik', value: 'ଆଧୁନିକ', regex: false },
{ key: 'prachin', value: 'ପ୍ରାଚୀନ', regex: false },
{ key: 'nirapodo', value: 'ନିରାପଦ', regex: false },
{ key: 'bipodjonoko', value: 'ବିପଦଜନକ', regex: false },
{ key: 'bhagyoban', value: 'ଭାଗ୍ୟବାନ', regex: false },
{ key: 'durbhagyo', value: 'ଦୁର୍ଭାଗ୍ୟ', regex: false },
{ key: 'nomro', value: 'ନମ୍ର', regex: false },
{ key: 'osobhyo', value: 'ଅସଭ୍ୟ', regex: false },
{ key: 'dhairyoshilo', value: 'ଧୈର୍ଯ୍ୟଶୀଳ', regex: false },
{ key: 'odhairjo', value: 'ଅଧୈର୍ଯ୍ୟ', regex: false },
{ key: 'udaro', value: 'ଉଦାର', regex: false },
{ key: 'nali', value: 'ନାଲି', regex: false },
{ key: 'nilo', value: 'ନୀଳ', regex: false },
{ key: 'sobujo', value: 'ସବୁଜ', regex: false },
{ key: 'holodi', value: 'ହଳଦୀ', regex: false },
{ key: 'komola', value: 'କମଳା', regex: false },
{ key: 'baigoni', value: 'ବାଇଗଣୀ', regex: false },
{ key: 'golapi', value: 'ଗୋଲାପୀ', regex: false },
{ key: 'matia', value: 'ମାଟିଆ', regex: false },
{ key: 'kalo', value: 'କଳା', regex: false },
{ key: 'dhala', value: 'ଧଳା', regex: false },
{ key: 'dhusoro', value: 'ଧୂସର', regex: false },
{ key: 'suneli', value: 'ସୁନେଲୀ', regex: false },
{ key: 'rupeli', value: 'ରୂପେଲୀ', regex: false },
{ key: 'phika nilo', value: 'ଫିକା ନୀଳ', regex: false },
{ key: 'gadho sobujo', value: 'ଗାଢ଼ ସବୁଜ', regex: false },
{ key: 'akashi', value: 'ଆକାଶୀ', regex: false },
{ key: 'tomburo', value: 'ତମ୍ବୁର', regex: false },
{ key: 'phiroja', value: 'ଫିରୋଜା', regex: false },
{ key: 'majenta', value: 'ମ୍ୟାଜେଣ୍ଟା', regex: false },
{ key: 'otinali', value: 'ଅତିନାଲି', regex: false },
{ key: 'bej', value: 'ବେଜ୍', regex: false },
{ key: 'pich', value: 'ପିଚ୍', regex: false },
{ key: 'lavendar', value: 'ଲାଭେଣ୍ଡର', regex: false },
{ key: 'nilogiri', value: 'ନୀଳଗିରି', regex: false },
{ key: 'til', value: 'ଟିଲ୍', regex: false },
{ key: 'olia', value: 'ଅଳିଆ', regex: false },
{ key: 'sorshopi', value: 'ସର୍ଷପୀ', regex: false },
{ key: 'angaria', value: 'ଅଙ୍ଗାରିଆ', regex: false },
{ key: 'hatidanti', value: 'ହାତୀଦାନ୍ତୀ', regex: false },
{ key: 'manikyo', value: 'ମାଣିକ୍ୟ', regex: false },
{ key: 'pochora', value: 'ପଚରା', regex: false },
{ key: 'nilomani', value: 'ନୀଳମଣି', regex: false },
{ key: 'omboro', value: 'ଅମ୍ବର', regex: false },
{ key: 'khushi', value: 'ଖୁସି', regex: false },
{ key: 'dukhito', value: 'ଦୁଃଖିତ', regex: false },
{ key: 'dukh', value: 'ଦୁଃଖ', regex: false },
{ key: 'prabidhana', value: 'ପ୍ରାବିଧାନ', regex: false },
{ key: 'bhougalika', value: 'ଭୖୋଗଳିକ', regex: false },
{ key: 'jabotiya', value: 'ଯାବତୀୟ', regex: false },
{ key: 'sarbojonin', value: 'ସାର୍ବଜନୀନ', regex: false },
{ key: 'akarmanya', value: 'ଅକର୍ମଣ୍ୟ', regex: false },
{ key: 'angikar', value: 'ଅଙ୍ଗୀକାର', regex: false },
{ key: 'anjali', value: 'ଅଞ୍ଜଳି', regex: false },
{ key: 'dharjya', value: 'ଧାର୍ଯ୍ୟ', regex: false },
{ key: 'dhourjya', value: 'ଧୖୋର୍ଯ୍ୟ', regex: false },
{ key: 'adhapatan', value: 'ଅଧଃପତନ', regex: false },
{ key: 'anath', value: 'ଅନାଥ', regex: false },
{ key: 'anastha', value: 'ଅନାସ୍ଥା', regex: false },
{ key: 'prastab', value: 'ପ୍ରସ୍ତାବ', regex: false },
{ key: 'ragia', value: 'ରାଗିଆ', regex: false },
{ key: 'utsahito', value: 'ଉତ୍ସାହିତ', regex: false },
{ key: 'birakto', value: 'ବିରକ୍ତ', regex: false },
{ key: 'chintito', value: 'ଚିନ୍ତିତ', regex: false },
{ key: 'bhoyobhito', value: 'ଭୟଭୀତ', regex: false },
{ key: 'aschoryochokito', value: 'ଆଶ୍ଚର୍ଯ୍ୟଚକିତ', regex: false },
{ key: 'dwondwoto', value: 'ଦ୍ୱନ୍ଦ୍ୱତ', regex: false },
{ key: 'gorbito', value: 'ଗର୍ବିତ', regex: false },
{ key: 'irshalu', value: 'ଈର୍ଷାଳୁ', regex: false },
{ key: 'ekaki', value: 'ଏକାକୀ', regex: false },
{ key: 'premito', value: 'ପ୍ରେମିତ', regex: false },
{ key: 'ghrunito', value: 'ଘୃଣିତ', regex: false },
{ key: 'ashabadi', value: 'ଆଶାବାଦୀ', regex: false },
{ key: 'nirasha', value: 'ନିରାଶ', regex: false },
{ key: 'doshi', value: 'ଦୋଷୀ', regex: false },
{ key: 'lojjoshilo', value: 'ଲଜ୍ଜାଶୀଳ', regex: false },
{ key: 'atmobishwasi', value: 'ଆତ୍ମବିଶ୍ୱାସୀ', regex: false },
{ key: 'snayubishrinkhala', value: 'ସ୍ନାୟୁବିଶୃଙ୍ଖଳ', regex: false },
{ key: 'kritoggo', value: 'କୃତଜ୍ଞ', regex: false },
{ key: 'ghruna', value: 'ଘୃଣା', regex: false },
{ key: 'hotasho', value: 'ହତାଶ', regex: false },
{ key: 'sontushto', value: 'ସନ୍ତୁଷ୍ଟ', regex: false },
{ key: 'lojjito', value: 'ଲଜ୍ଜିତ', regex: false },
{ key: 'kutuholi', value: 'କୁତୂହଳୀ', regex: false },
{ key: 'aram', value: 'ଆରାମ', regex: false },
{ key: 'otibharakranto', value: 'ଅତିଭାରାକ୍ରାନ୍ତ', regex: false },
{ key: 'shanto', value: 'ଶାନ୍ତ', regex: false },
{ key: 'chapogrostho', value: 'ଚାପଗ୍ରସ୍ତ', regex: false },
{ key: 'anondito', value: 'ଆନନ୍ଦିତ', regex: false },
{ key: 'dukhodo', value: 'ଦୁଃଖଦ', regex: false },
{ key: 'nirashabadi', value: 'ନିରାଶାବାଦୀ', regex: false },
{ key: 'utsahi', value: 'ଉତ୍ସାହୀ', regex: false },
{ key: 'udasino', value: 'ଉଦାସୀନ', regex: false },
{ key: 'hrudoyobidarok', value: 'ହୃଦୟବିଦାରକ', regex: false },
{ key: 'mlano', value: 'ମ୍ଳାନ', regex: false },
{ key: 'anondomoyo', value: 'ଆନନ୍ଦମୟ', regex: false },
{ key: 'bhoyonkoro', value: 'ଭୟଙ୍କର', regex: false },
{ key: 'sontushto', value: 'ସନ୍ତୁଷ୍ଟ', regex: false },
{ key: 'nirasha', value: 'ନିରାଶ', regex: false },
{ key: 'chintito', value: 'ଚିନ୍ତିତ', regex: false },
{ key: 'shaktishali', value: 'ଶକ୍ତିଶାଳୀ', regex: false },
{ key: 'klanto', value: 'କ୍ଳାନ୍ତ', regex: false },
{ key: 'sotej', value: 'ସତେଜ', regex: false },
{ key: 'premore', value: 'ପ୍ରେମରେ', regex: false },
{ key: 'mohito', value: 'ମୋହିତ', regex: false },
{ key: 'utkoto', value: 'ଉତ୍କଟ', regex: false },
{ key: 'aradhona', value: 'ଆରାଧନା', regex: false },
{ key: 'onurokto', value: 'ଅନୁରକ୍ତ', regex: false },
{ key: 'trushna', value: 'ତୃଷ୍ଣା', regex: false },
{ key: 'sneho', value: 'ସ୍ନେହ', regex: false },
{ key: 'mugdho', value: 'ମୁଗ୍ଧ', regex: false },
{ key: 'hrudoyongomo', value: 'ହୃଦୟଙ୍ଗମ', regex: false },
{ key: 'romantik', value: 'ରୋମାଣ୍ଟିକ୍', regex: false },
{ key: 'mlanota', value: 'ମ୍ଳାନତା', regex: false },
{ key: 'smrutimoyo', value: 'ସ୍ମୃତିମୟ', regex: false },
{ key: 'mishranubhuti', value: 'ମିଶ୍ରାନୁଭୂତି', regex: false },
{ key: 'onutapopurnno', value: 'ଅନୁତାପପୂର୍ଣ୍ଣ', regex: false },
{ key: 'nirmolo', value: 'ନିର୍ମଳ', regex: false },
{ key: 'sombedonoshilo', value: 'ସଂବେଦନଶୀଳ', regex: false },
{ key: 'ontorongo', value: 'ଅନ୍ତରଙ୍ଗ', regex: false },
{ key: 'prema', value: 'ପ୍ରେମ', regex: false },
{ key: 'basanda', value: 'ବାସନ୍ଦ', regex: false },
{ key: 'atmiko', value: 'ଆତ୍ମିକ', regex: false },
{ key: 'pidito', value: 'ପୀଡ଼ିତ', regex: false },
{ key: 'tyagi', value: 'ତ୍ୟାଗୀ', regex: false },
{ key: 'shrodhalu', value: 'ଶ୍ରଦ୍ଧାଳୁ', regex: false },
{ key: 'sthiro', value: 'ସ୍ଥିର', regex: false },
{ key: 'bismito', value: 'ବିସ୍ମିତ', regex: false },
{ key: 'irshaporaoyon', value: 'ଈର୍ଷାପରାୟଣ', regex: false },
{ key: 'ghatokota', value: 'ଘାତକତା', regex: false },
{ key: 'shikar', value: 'ଶିକାର', regex: false },
{ key: 'biswasa', value: 'ବିଶ୍ୱାସ', regex: false },
{ key: 'tyakta', value: 'ତ୍ୟକ୍ତ', regex: false },
{ key: 'akrusta', value: 'ଆକୃଷ୍ଟ', regex: false },
{ key: 'mugdha', value: 'ମୁଗ୍ଧ', regex: false },
{ key: 'nirasa', value: 'ନିରାଶ', regex: false },
{ key: 'grasta', value: 'ଗ୍ରସ୍ତ', regex: false },
{ key: 'tmaka', value: 'ତ୍ମକ', regex: false },
{ key: 'bichedana', value: 'ବିଚ୍ଛେଦନ', regex: false },
{ key: 'hinata', value: 'ହୀନତା', regex: false },
{ key: 'father', value: 'ଫାଦେର୍', regex: false },
{ key: 'kahu', value: 'କହୁ', regex: false },
{ key: 'kandi', value: 'କାନ୍ଦି', regex: false },
{ key: 'pokaila', value: 'ପକାଇଲା', regex: false },
{ key: 'pokaile', value: 'ପକାଇଲେ', regex: false },
{ key: 'akho', value: ' ଆଖ', regex: false },
{ key: 'pakho', value: 'ପାଖ', regex: false },
{ key: 'nuhn', value: 'ନୁହଁ', regex: false },
{ key: 'dukha', value: 'ଦୁଃଖ', regex: false },
{ key: 'shudhhi', value: 'ଶୁଦ୍ଧି', regex: false },
{ key: 'alokodorshon', value: 'ଆଲୋକଦର୍ଶନ', regex: false },
{ key: 'korunoroso', value: 'କରୁଣରସ', regex: false },
{ key: 'bayaska', value: 'ବୟସ୍କ', regex: false },
{ key: 'upanyasa', value: 'ଉପନ୍ୟାସ', regex: false },
{ key: 'parjyanta', value: 'ପର୍ଯ୍ୟନ୍ତ', regex: false },
{ key: 'asonka', value: 'ଆଶଙ୍କା', regex: false },
{ key: 'gata', value: 'ଗତ', regex: false },
{ key: 'astitwa', value: 'ଅସ୍ତିତ୍ୱ', regex: false },
{ key: 'hinotabad', value: 'ହୀନତାବାଦ', regex: false },
{ key: 'ortho', value: 'ଅର୍ଥ', regex: false },
{ key: 'porjon sotta', value: 'ପରଜନ ସତ୍ତା', regex: false },
{ key: 'shunyotar bhoy', value: 'ଶୂନ୍ୟତାର ଭୟ', regex: false },
{ key: 'nastibad', value: 'ନାସ୍ତିବାଦ', regex: false },
{ key: 'nibaron', value: 'ନିବାରଣ', regex: false },
{ key: 'prokshepon', value: 'ପ୍ରକ୍ଷେପଣ', regex: false },
{ key: 'sthanantor', value: 'ସ୍ଥାନାନ୍ତର', regex: false },
{ key: 'oswikar', value: 'ଅସ୍ୱୀକାର', regex: false },
{ key: 'snayudurbalota', value: 'ସ୍ନାୟୁଦୁର୍ବଳତା', regex: false },
{ key: 'bhokti', value: 'ଭକ୍ତି', regex: false },
{ key: 'dibyo prem', value: 'ଦିବ୍ୟ ପ୍ରେମ', regex: false },
{ key: 'bishwas', value: 'ବିଶ୍ୱାସ', regex: false },
{ key: 'atmosomorpon', value: 'ଆତ୍ମସମର୍ପଣ', regex: false },
{ key: 'shrodha', value: 'ଶ୍ରଦ୍ଧା', regex: false },
{ key: 'gyanoday', value: 'ଜ୍ଞାନୋଦୟ', regex: false },
{ key: 'anondo', value: 'ଆନନ୍ଦ', regex: false },
{ key: 'krupa', value: 'କୃପା', regex: false },
{ key: 'pabitra', value: 'ପବିତ୍ର', regex: false },
{ key: 'otindriyota', value: 'ଅତୀନ୍ଦ୍ରିୟତା', regex: false },
{ key: 'papobodh', value: 'ପାପବୋଧ', regex: false },
{ key: 'poschotap', value: 'ପଶ୍ଚାତାପ', regex: false },
{ key: 'mukti', value: 'ମୁକ୍ତି', regex: false },
{ key: 'kshoma', value: 'କ୍ଷମା', regex: false },
{ key: 'bhabosomadhi', value: 'ଭାବସମାଧି', regex: false },
{ key: 'odwaitobodh', value: 'ଅଦ୍ୱୈତବୋଧ', regex: false },
{ key: 'ishworiyo sannidhya', value: 'ଈଶ୍ୱରୀୟ ସାନ୍ନିଧ୍ୟ', regex: false },
{ key: 'dibyo bishad', value: 'ଦିବ୍ୟ ବିଷାଦ', regex: false },
{ key: 'trushna', value: 'ତୃଷ୍ଣା', regex: false },
{ key: 'tyag', value: 'ତ୍ୟାଗ', regex: false },
{ key: 'dharmikota', value: 'ଧାର୍ମିକତା', regex: false },
{ key: 'deshprem', value: 'ଦେଶପ୍ରେମ', regex: false },
{ key: 'jatiatabad', value: 'ଜାତୀୟତାବାଦ', regex: false },
{ key: 'krantikari', value: 'କ୍ରାନ୍ତିକାରୀ ଉତ୍ସାହ', regex: false },
{ key: 'utsaho', value: 'ଉତ୍ସାହ', regex: false },
{ key: 'nishtha', value: 'ନିଷ୍ଠା', regex: false },
{ key: 'sahamata', value: 'ଅସହମତ', regex: false },
{ key: 'pradhikar', value: 'ପ୍ରାଧିକାର', regex: false },
{ key: 'durniti', value: 'ଦୁର୍ନୀତି', regex: false },
{ key: 'paradarshita', value: 'ପାରଦର୍ଶିତା', regex: false },
{ key: 'tantra', value: 'ତନ୍ତ୍ର', regex: false },
{ key: 'nirjaton', value: 'ନିର୍ଯାତନ', regex: false },
{ key: 'protirodh', value: 'ପ୍ରତିରୋଧ', regex: false },
{ key: 'protikara', value: 'ପ୍ରତିକାର', regex: false },
{ key: 'mukti', value: 'ମୁକ୍ତି', regex: false },
{ key: 'uponibeshobad', value: 'ଉପନିବେଶବାଦ', regex: false },
{ key: 'shoson', value: 'ଶୋଷଣ', regex: false },
{ key: 'gonotontro', value: 'ଗଣତନ୍ତ୍ର', regex: false },
{ key: 'samyobad', value: 'ସାମ୍ୟବାଦ', regex: false },
{ key: 'dhontontro', value: 'ଧନତନ୍ତ୍ର', regex: false },
{ key: 'dhormoniropekshota', value: 'ଧର୍ମନିରପେକ୍ଷତା', regex: false },
{ key: 'obishwas', value: 'ଅବିଶ୍ୱାସ', regex: false },
{ key: 'ekota', value: 'ଏକତା', regex: false },
{ key: 'andolon', value: 'ଆନ୍ଦୋଳନ', regex: false },
{ key: 'nirashabad', value: 'ନିରାଶାବାଦ', regex: false },
{ key: 'asha', value: 'ଆଶା', regex: false },
{ key: 'sarbobhaumotto', value: 'ସାର୍ବଭୌମତ୍ୱ', regex: false },
{ key: 'mitrota', value: 'ମିତ୍ରତା', regex: false },
{ key: 'bibad', value: 'ବିବାଦ', regex: false },
{ key: 'nirapekshota', value: 'ନିରପେକ୍ଷତା', regex: false },
{ key: 'adhiptya', value: 'ଆଧିପତ୍ୟ', regex: false },
{ key: 'bhagaban', value: 'ଭଗବାନ', regex: false },
{ key: 'prarthona', value: 'ପ୍ରାର୍ଥନା', regex: false },
{ key: 'mondiro', value: 'ମନ୍ଦିର', regex: false },
{ key: 'pobitro', value: 'ପବିତ୍ର', regex: false },
{ key: 'atma', value: 'ଆତ୍ମା', regex: false },
{ key: 'dhormo', value: 'ଧର୍ମ', regex: false },
{ key: 'kormo', value: 'କର୍ମ', regex: false },
{ key: 'moksho', value: 'ମୋକ୍ଷ', regex: false },
{ key: 'puja', value: 'ପୂଜା', regex: false },
{ key: 'obotar', value: 'ଅବତାର', regex: false },
{ key: 'girja', value: 'ଗିର୍ଜା', regex: false },
{ key: 'baibol', value: 'ବାଇବଲ୍', regex: false },
{ key: 'byaptigyano', value: 'ବ୍ୟାପ୍ତିଜ୍ଞାନ', regex: false },
{ key: 'poritrano', value: 'ପରିତ୍ରାଣ', regex: false },
{ key: 'ollah', value: 'ଅଲ୍ଲାହ', regex: false },
{ key: 'mosjid', value: 'ମସଜିଦ୍', regex: false },
{ key: 'koran', value: 'କୁରାନ୍', regex: false },
{ key: 'romojan', value: 'ରମଜାନ୍', regex: false },
{ key: 'nomaj', value: 'ନମାଜ୍', regex: false },
{ key: 'buddho', value: 'ବୁଦ୍ଧ', regex: false },
{ key: 'dhyano', value: 'ଧ୍ୟାନ', regex: false },
{ key: 'guru', value: 'ଗୁରୁ', regex: false },
{ key: 'gurudwara', value: 'ଗୁରୁଦ୍ୱାରା', regex: false },
{ key: 'granth sahib', value: 'ଗ୍ରନ୍ଥ ସାହିବ୍', regex: false },
{ key: 'kirtan', value: 'କୀର୍ତନ', regex: false },
{ key: 'seba', value: 'ସେବା', regex: false },
{ key: 'tirthankaro', value: 'ତୀର୍ଥଙ୍କର', regex: false },
{ key: 'ohimsa', value: 'ଅହିଂସା', regex: false },
{ key: 'jino', value: 'ଜିନ', regex: false },
{ key: 'ullekha', value: 'ଉଲ୍ଲେଖ', regex: false },
{ key: 'chhotua', value: 'ଛତୁଆ', regex: false },
{ key: 'koron', value: 'କରଣ', regex: false },
{ key: 'chhot', value: 'ଛୋଟ', regex: false },
{ key: 'uchha', value: 'ଉଚ୍ଚ', regex: false },
{ key: 'lamba', value: 'ଲମ୍ବା', regex: false },
{ key: 'chauda', value: 'ଚଉଡ଼ା', regex: false },
{ key: 'saru', value: 'ସରୁ', regex: false },
{ key: 'mota', value: 'ମୋଟା', regex: false },
{ key: 'pathala', value: 'ପତଳା', regex: false },
{ key: 'bhari', value: 'ଭାରୀ', regex: false },
{ key: 'haluka', value: 'ହାଲୁକା', regex: false },
{ key: 'druta', value: 'ଦ୍ରୁତ', regex: false },
{ key: 'dhira', value: 'ଧୀର', regex: false },
{ key: 'garama', value: 'ଗରମ', regex: false },
{ key: 'thanda', value: 'ଥଣ୍ଡା', regex: false },
{ key: 'ushuma', value: 'ଉଷୁମ', regex: false },
{ key: 'shitala', value: 'ଶୀତଳ', regex: false },
{ key: 'nua', value: 'ନୂଆ', regex: false },
{ key: 'puruna', value: 'ପୁରୁଣା', regex: false },
{ key: 'yuba', value: 'ଯୁବା', regex: false },
{ key: 'bhala', value: 'ଭଲ', regex: false },
{ key: 'kharapa', value: 'ଖରାପ', regex: false },
{ key: 'sundar', value: 'ସୁନ୍ଦର', regex: false },
{ key: 'asundar', value: 'ଅସୁନ୍ଦର', regex: false },
{ key: 'asithil', value: 'ଆସିଥିଲ', regex: false },
{ key: 'bilati', value: 'ବିଲାତି', regex: false },
{ key: 'nachi', value: 'ନାଚି', regex: false },
{ key: 'hindu', value: 'ହିନ୍ଦୁ', regex: false },
{ key: 'christian', value: 'ଖ୍ରୀଷ୍ଟିଆନ', regex: false },
{ key: 'muslim', value: 'ମୁସଲିମ', regex: false },
{ key: 'salim', value: 'ସଲିମ', regex: false },
{ key: 'simron', value: 'ସିମ୍ରନ', regex: false },
{ key: 'kutsita', value: 'କୁତ୍ସିତ', regex: false },
{ key: 'kutschita', value: 'କୁତ୍ସିତ', regex: false },
{ key: 'skar', value: 'ଷ୍କାର', regex: false },
{ key: 'maila', value: 'ମଇଳା', regex: false },
{ key: 'durbala', value: 'ଦୁର୍ବଳ', regex: false },
{ key: 'dhani', value: 'ଧନୀ', regex: false },
{ key: 'gariba', value: 'ଗରିବ', regex: false },
{ key: 'khushi', value: 'ଖୁସି', regex: false },
{ key: 'duhkhita', value: 'ଦୁଃଖିତ', regex: false },
{ key: 'sahasi', value: 'ସାହସୀ', regex: false },
{ key: 'bhiru', value: 'ଭୀରୁ', regex: false },
{ key: 'catura', value: 'ଚତୁର', regex: false },
{ key: 'murkha', value: 'ମୂର୍ଖ', regex: false },
{ key: 'dayalu', value: 'ଦୟାଳୁ', regex: false },
{ key: 'sankramana', value: 'ସଂକ୍ରମଣ', regex: false },
{ key: 'bipada', value: 'ବିପଦ', regex: false },
{ key: 'bulu', value: 'ବୁଲୁ', regex: false },
{ key: 'kathina', value: 'କଠିନ', regex: false },
{ key: 'narama', value: 'ନରମ', regex: false },
{ key: 'mitha', value: 'ମିଠା', regex: false },
{ key: 'khata', value: 'ଖଟା', regex: false },
{ key: 'katu', value: 'କଟୁ', regex: false },
{ key: 'lunia', value: 'ଲୁଣିଆ', regex: false },
{ key: 'tikhta', value: 'ତିଖ୍ତା', regex: false },
{ key: 'sukhila', value: 'ଶୁଖିଲା', regex: false },
{ key: 'oda', value: 'ଓଦା', regex: false },
{ key: 'mahanga', value: 'ମହଙ୍ଗା', regex: false },
{ key: 'sasta', value: 'ଶସ୍ତା', regex: false },
{ key: 'noi', value: 'ନଈ', regex: false },
{ key: 'river', value: 'ନଈ', regex: false },
{ key: 'agrahya', value: 'ଅଗ୍ରାହ୍ୟ', regex: false },
{ key: 'agraha', value: 'ଆଗ୍ରହ', regex: false },
{ key: 'mamala', value: 'ମାମଲା', regex: false },
{ key: 'sambandh', value: 'ସମ୍ବନ୍ଧ', regex: false },
{ key: 'tore', value: 'ତରେ', regex: false },
{ key: 'tare', value: 'ତାରେ', regex: false },
{ key: 'soumya', value: 'ସୌମ୍ୟା', regex: false },
{ key: 'bruti', value: 'ବୃତ୍ତି', regex: false },
{ key: 'puna', value: 'ପୁନ', regex: false },
{ key: 'purusa', value: 'ପୁରୁଷ', regex: false },
{ key: 'purna', value: 'ପୂର୍ଣ୍ଣ', regex: false },
{ key: 'khali', value: 'ଖାଲି', regex: false },
{ key: 'thik', value: 'ଠିକ୍', regex: false },
{ key: 'bhul', value: 'ଭୁଲ୍', regex: false },
{ key: 'satya', value: 'ସତ୍ୟ', regex: false },
{ key: 'michha', value: 'ମିଛ', regex: false },
{ key: 'sahaja', value: 'ସହଜ', regex: false },
{ key: 'kashtakara', value: 'କଷ୍ଟକର', regex: false },
{ key: 'ujjwala', value: 'ଉଜ୍ଜ୍ୱଳ', regex: false },
{ key: 'andhakara', value: 'ଅନ୍ଧକାର', regex: false },
{ key: 'kolahalapurna', value: 'କୋଳାହଳପୂର୍ଣ୍ଣ', regex: false },
{ key: 'shant', value: 'ଶାନ୍ତ', regex: false },
{ key: 'alasua', value: 'ଆଳସୁଆ', regex: false },
{ key: 'sakriya', value: 'ସକ୍ରିୟ', regex: false },
{ key: 'sustha', value: 'ସୁସ୍ଥ', regex: false },
{ key: 'asustha', value: 'ଅସୁସ୍ଥ', regex: false },
{ key: 'khola', value: 'ଖୋଲା', regex: false },
{ key: 'banda', value: 'ବନ୍ଦ', regex: false },
{ key: 'tikshna', value: 'ତୀକ୍ଷ୍ଣ', regex: false },
{ key: 'kunthita', value: 'କୁଣ୍ଠିତ', regex: false },
{ key: 'masruna', value: 'ମସୃଣ', regex: false },
{ key: 'kharakhara', value: 'ଖରଖରା', regex: false },
{ key: 'sidha', value: 'ସିଧା', regex: false },
{ key: 'bakara', value: 'ବକ୍ର', regex: false },
{ key: 'nimna', value: 'ନିମ୍ନ', regex: false },
{ key: 'gabhira', value: 'ଗଭୀର', regex: false },
{ key: 'alpagabhira', value: 'ଅଳ୍ପଗଭୀର', regex: false },
{ key: 'aneka', value: 'ଅନେକ', regex: false },
{ key: 'kom', value: 'କମ୍', regex: false },
{ key: 'samana', value: 'ସମାନ', regex: false },
{ key: 'bhinna', value: 'ଭିନ୍ନ', regex: false },
{ key: 'prathama', value: 'ପ୍ରଥମ', regex: false },
{ key: 'shesha', value: 'ଶେଷ', regex: false },
{ key: 'parabarti', value: 'ପରବର୍ତ୍ତୀ', regex: false },
{ key: 'purbabarti', value: 'ପୂର୍ବବର୍ତ୍ତୀ', regex: false },
{ key: 'shighra', value: 'ଶୀଘ୍ର', regex: false },
{ key: 'bilamba', value: 'ବିଳମ୍ବ', regex: false },
{ key: 'sarbajanina', value: 'ସାର୍ବଜନୀନ', regex: false },
{ key: 'byaktigata', value: 'ବ୍ୟକ୍ତିଗତ', regex: false },
{ key: 'gurutwapurna', value: 'ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ', regex: false },
{ key: 'agurutwapurna', value: 'ଅଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ', regex: false },
//{ key: 'sambhaba', value: 'ସମ୍ଭବ', regex: false },
//{ key: 'asambhaba', value: 'ଅସମ୍ଭବ', regex: false },
{ key: 'prakruta', value: 'ପ୍ରକୃତ', regex: false },
{ key: 'nakali', value: 'ନକଲି', regex: false },
{ key: 'jibita', value: 'ଜୀବିତ', regex: false },
{ key: 'mruta', value: 'ମୃତ', regex: false },
{ key: 'prakrutika', value: 'ପ୍ରାକୃତିକ', regex: false },
{ key: 'krutrima', value: 'କୃତ୍ରିମ', regex: false },
{ key: 'adhunika', value: 'ଆଧୁନିକ', regex: false },
{ key: 'prachina', value: 'ପ୍ରାଚୀନ', regex: false },
{ key: 'lokapriya', value: 'ଲୋକପ୍ରିୟ', regex: false },
{ key: 'alokapriya', value: 'ଅଲୋକପ୍ରିୟ', regex: false },
{ key: 'niraapada', value: 'ନିରାପଦ', regex: false },
{ key: 'bipadajanaka', value: 'ବିପଦଜନକ', regex: false },
{ key: 'bhagyabana', value: 'ଭାଗ୍ୟବାନ', regex: false },
{ key: 'durbhagya', value: 'ଦୁର୍ଭାଗ୍ୟ', regex: false },
{ key: 'namra', value: 'ନମ୍ର', regex: false },
{ key: 'asabhya', value: 'ଅସଭ୍ୟ', regex: false },
{ key: 'dhairyashila', value: 'ଧୈର୍ଯ୍ୟଶୀଳ', regex: false },
{ key: 'adhairya', value: 'ଅଧୈର୍ଯ୍ୟ', regex: false },
{ key: 'udara', value: 'ଉଦାର', regex: false },
{ key: 'swarthapara', value: 'ସ୍ୱାର୍ଥପର', regex: false },
{ key: 'karu', value: 'କରୁ', regex: false },
{ key: 'badali', value: 'ବଦଳି', regex: false },
{ key: 'nali', value: 'ନାଲି', regex: false },
{ key: 'nila', value: 'ନୀଳ', regex: false },
{ key: 'sabuja', value: 'ସବୁଜ', regex: false },
{ key: 'haladi', value: 'ହଳଦୀ', regex: false },
{ key: 'kamala', value: 'କମଳା', regex: false },
{ key: 'baigani', value: 'ବାଇଗଣୀ', regex: false },
{ key: 'golapi', value: 'ଗୋଲାପୀ', regex: false },
{ key: 'matia', value: 'ମାଟିଆ', regex: false },
{ key: 'kala', value: 'କଳା', regex: false },
{ key: 'dhala', value: 'ଧଳା', regex: false },
{ key: 'dhusara', value: 'ଧୂସର', regex: false },
{ key: 'suneli', value: 'ସୁନେଲୀ', regex: false },
{ key: 'rupeli', value: 'ରୂପେଲୀ', regex: false },
{ key: 'phika nila', value: 'ଫିକା ନୀଳ', regex: false },
{ key: 'gadha sabuja', value: 'ଗାଢ଼ ସବୁଜ', regex: false },
{ key: 'akashi', value: 'ଆକାଶୀ', regex: false },
{ key: 'tambura', value: 'ତମ୍ବୁର', regex: false },
{ key: 'phiroja', value: 'ଫିରୋଜା', regex: false },
{ key: 'majenta', value: 'ମ୍ୟାଜେଣ୍ଟା', regex: false },
{ key: 'atinali', value: 'ଅତିନାଲି', regex: false },
{ key: 'bej', value: 'ବେଜ୍', regex: false },
{ key: 'pich', value: 'ପିଚ୍', regex: false },
{ key: 'lavendar', value: 'ଲାଭେଣ୍ଡର', regex: false },
{ key: 'nilagiri', value: 'ନୀଳଗିରି', regex: false },
{ key: 'til', value: 'ଟିଲ୍', regex: false },
{ key: 'alia', value: 'ଅଳିଆ', regex: false },
{ key: 'sarsapi', value: 'ସର୍ଷପୀ', regex: false },
{ key: 'angaria', value: 'ଅଙ୍ଗାରିଆ', regex: false },
{ key: 'hatidanti', value: 'ହାତୀଦାନ୍ତୀ', regex: false },
{ key: 'manikya', value: 'ମାଣିକ୍ୟ', regex: false },
{ key: 'pachara', value: 'ପଚରା', regex: false },
{ key: 'nilamani', value: 'ନୀଳମଣି', regex: false },
{ key: 'ambor', value: 'ଅମ୍ବର', regex: false },
{ key: 'khushi', value: 'ଖୁସି', regex: false },
{ key: 'duhkhita', value: 'ଦୁଃଖିତ', regex: false },
{ key: 'ragia', value: 'ରାଗିଆ', regex: false },
{ key: 'utsahita', value: 'ଉତ୍ସାହିତ', regex: false },
{ key: 'birakta', value: 'ବିରକ୍ତ', regex: false },
{ key: 'chintita', value: 'ଚିନ୍ତିତ', regex: false },
{ key: 'bhayabhita', value: 'ଭୟଭୀତ', regex: false },
{ key: 'ascharyachakita', value: 'ଆଶ୍ଚର୍ଯ୍ୟଚକିତ', regex: false },
{ key: 'dwandwata', value: 'ଦ୍ୱନ୍ଦ୍ୱତ', regex: false },
{ key: 'garbhita', value: 'ଗର୍ବିତ', regex: false },
{ key: 'irshalu', value: 'ଈର୍ଷାଳୁ', regex: false },
{ key: 'ekaki', value: 'ଏକାକୀ', regex: false },
{ key: 'premita', value: 'ପ୍ରେମିତ', regex: false },
{ key: 'premika', value: 'ପ୍ରେମିକ', regex: false },
{ key: 'apekhya', value: 'ଅପେକ୍ଷା', regex: false },
{ key: 'asabadi', value: 'ଆଶାବାଦୀ', regex: false },
{ key: 'nirascha', value: 'ନିରାଶ', regex: false },
{ key: 'dosi', value: 'ଦୋଷୀ', regex: false },
{ key: 'lajjasila', value: 'ଲଜ୍ଜାଶୀଳ', regex: false },
{ key: 'atmabiswasi', value: 'ଆତ୍ମବିଶ୍ୱାସୀ', regex: false },
{ key: 'snayubisrinkhala', value: 'ସ୍ନାୟୁବିଶୃଙ୍ଖଳ', regex: false },
{ key: 'kritajna', value: 'କୃତଜ୍ଞ', regex: false },
{ key: 'ghrina', value: 'ଘୃଣା', regex: false },
{ key: 'hatasa', value: 'ହତାଶ', regex: false },
{ key: 'santushta', value: 'ସନ୍ତୁଷ୍ଟ', regex: false },
{ key: 'lajjita', value: 'ଲଜ୍ଜିତ', regex: false },
{ key: 'kutuhali', value: 'କୁତୂହଳୀ', regex: false },
{ key: 'arama', value: 'ଆରାମ', regex: false },
{ key: 'atibharakranta', value: 'ଅତିଭାରାକ୍ରାନ୍ତ', regex: false },
{ key: 'chapagrastha', value: 'ଚାପଗ୍ରସ୍ତ', regex: false },
{ key: 'anandita', value: 'ଆନନ୍ଦିତ', regex: false },
{ key: 'duhkhada', value: 'ଦୁଃଖଦ', regex: false },
{ key: 'nirasabadi', value: 'ନିରାଶାବାଦୀ', regex: false },
{ key: 'udasina', value: 'ଉଦାସୀନ', regex: false },
{ key: 'hridayabidaraka', value: 'ହୃଦୟବିଦାରକ', regex: false },
{ key: 'mlana', value: 'ମ୍ଳାନ', regex: false },
{ key: 'anandamaya', value: 'ଆନନ୍ଦମୟ', regex: false },
{ key: 'bhayankara', value: 'ଭୟଙ୍କର', regex: false },
{ key: 'birasta', value: 'ବିରକ୍ତ', regex: false },
{ key: 'santusta', value: 'ସନ୍ତୁଷ୍ଟ', regex: false },
{ key: 'nirascha', value: 'ନିରାଶ', regex: false },
{ key: 'premita', value: 'ପ୍ରେମିତ', regex: false },
{ key: 'ghrinita', value: 'ଘୃଣିତ', regex: false },
{ key: 'chintita', value: 'ଚିନ୍ତିତ', regex: false },
{ key: 'shant', value: 'ଶାନ୍ତ', regex: false },
{ key: 'saktishali', value: 'ଶକ୍ତିଶାଳୀ', regex: false },
{ key: 'sateja', value: 'ସତେଜ', regex: false },
{ key: 'bodo', value: 'ବଡ଼', regex: false },
{ key: 'chota', value: 'ଛୋଟ', regex: false },
{ key: 'ucha', value: 'ଉଚ୍ଚ', regex: false },
{ key: 'lamba', value: 'ଲମ୍ବା', regex: false },
{ key: 'chauda', value: 'ଚଉଡ଼ା', regex: false },
{ key: 'saru', value: 'ସରୁ', regex: false },
{ key: 'mota', value: 'ମୋଟା', regex: false },
{ key: 'patala', value: 'ପତଳା', regex: false },
{ key: 'bhari', value: 'ଭାରୀ', regex: false },
{ key: 'haluka', value: 'ହାଲୁକା', regex: false },
{ key: 'druta', value: 'ଦ୍ରୁତ', regex: false },
{ key: 'dhira', value: 'ଧୀର', regex: false },
{ key: 'garama', value: 'ଗରମ', regex: false },
{ key: 'thanda', value: 'ଥଣ୍ଡା', regex: false },
{ key: 'ushuma', value: 'ଉଷୁମ', regex: false },
{ key: 'shitala', value: 'ଶୀତଳ', regex: false },
{ key: 'nua', value: 'ନୂଆ', regex: false },
{ key: 'puruna', value: 'ପୁରୁଣା', regex: false },
{ key: 'yuba', value: 'ଯୁବା', regex: false },
{ key: 'bhala', value: 'ଭଲ', regex: false },
{ key: 'kharapa', value: 'ଖରାପ', regex: false },
{ key: 'kutsita', value: 'କୁତ୍ସିତ', regex: false },
{ key: 'parishkara', value: 'ପରିଷ୍କାର', regex: false },
{ key: 'maila', value: 'ମଇଳା', regex: false },
{ key: 'shaktishali', value: 'ଶକ୍ତିଶାଳୀ', regex: false },
{ key: 'durbala', value: 'ଦୁର୍ବଳ', regex: false },
{ key: 'dhani', value: 'ଧନୀ', regex: false },
{ key: 'gariba', value: 'ଗରିବ', regex: false },
{ key: 'khushi', value: 'ଖୁସି', regex: false },
{ key: 'duhkhita', value: 'ଦୁଃଖିତ', regex: false },
{ key: 'sahasi', value: 'ସାହସୀ', regex: false },
{ key: 'bhiru', value: 'ଭୀରୁ', regex: false },
{ key: 'chatura', value: 'ଚତୁର', regex: false },
{ key: 'murkhya', value: 'ମୂର୍ଖ', regex: false },
{ key: 'dayalu', value: 'ଦୟାଳୁ', regex: false },
{ key: 'nishthura', value: 'ନିଷ୍ଠୁର', regex: false },
{ key: 'kathina', value: 'କଠିନ', regex: false },
{ key: 'narama', value: 'ନରମ', regex: false },
{ key: 'mitha', value: 'ମିଠା', regex: false },
{ key: 'khata', value: 'ଖଟା', regex: false },
{ key: 'katu', value: 'କଟୁ', regex: false },
{ key: 'lunia', value: 'ଲୁଣିଆ', regex: false },
{ key: 'sukhila', value: 'ଶୁଖିଲା', regex: false },
{ key: 'oda', value: 'ଓଦା', regex: false },
{ key: 'mahanga', value: 'ମହଙ୍ଗା', regex: false },
{ key: 'sasta', value: 'ସସ୍ତା', regex: false },
{ key: 'purna', value: 'ପୂର୍ଣ୍ଣ', regex: false },
{ key: 'khali', value: 'ଖାଲି', regex: false },
{ key: 'thik', value: 'ଠିକ୍', regex: false },
{ key: 'bhul', value: 'ଭୁଲ୍', regex: false },
{ key: 'satya', value: 'ସତ୍ୟ', regex: false },
{ key: 'michha', value: 'ମିଛ', regex: false },
{ key: 'sahaja', value: 'ସହଜ', regex: false },
{ key: 'kastakara', value: 'କଷ୍ଟକର', regex: false },
{ key: 'ujjwala', value: 'ଉଜ୍ଜ୍ୱଳ', regex: false },
{ key: 'andhakara', value: 'ଅନ୍ଧକାର', regex: false },
{ key: 'kolahalapurna', value: 'କୋଳାହଳପୂର୍ଣ୍ଣ', regex: false },
{ key: 'shanta', value: 'ଶାନ୍ତ', regex: false },
{ key: 'alasua', value: 'ଆଳସୁଆ', regex: false },
{ key: 'sakriya', value: 'ସକ୍ରିୟ', regex: false },
{ key: 'sustha', value: 'ସୁସ୍ଥ', regex: false },
{ key: 'asustha', value: 'ଅସୁସ୍ଥ', regex: false },
{ key: 'khola', value: 'ଖୋଲା', regex: false },
{ key: 'banda', value: 'ବନ୍ଦ', regex: false },
{ key: 'tikhna', value: 'ତୀକ୍ଷ୍ଣ', regex: false },
{ key: 'kunthita', value: 'କୁଣ୍ଠିତ', regex: false },
{ key: 'masruna', value: 'ମସୃଣ', regex: false },
{ key: 'sidha', value: 'ସିଧା', regex: false },
{ key: 'bakara', value: 'ବକ୍ର', regex: false },
{ key: 'nimna', value: 'ନିମ୍ନ', regex: false },
{ key: 'gabhira', value: 'ଗଭୀର', regex: false },
{ key: 'alpagabhira', value: 'ଅଳ୍ପଗଭୀର', regex: false },
{ key: 'aneka', value: 'ଅନେକ', regex: false },
{ key: 'samana', value: 'ସମାନ', regex: false },
{ key: 'bhinna', value: 'ଭିନ୍ନ', regex: false },
{ key: 'prathama', value: 'ପ୍ରଥମ', regex: false },
{ key: 'shesha', value: 'ଶେଷ', regex: false },
{ key: 'parabarti', value: 'ପରବର୍ତ୍ତୀ', regex: false },
{ key: 'purbabarti', value: 'ପୂର୍ବବର୍ତ୍ତୀ', regex: false },
{ key: 'sighra', value: 'ଶୀଘ୍ର', regex: false },
{ key: 'bilamba', value: 'ବିଳମ୍ବ', regex: false },
{ key: 'sarbajanina', value: 'ସାର୍ବଜନୀନ', regex: false },
{ key: 'byaktigata', value: 'ବ୍ୟକ୍ତିଗତ', regex: false },
{ key: 'gurutwapurna', value: 'ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ', regex: false },
//{ key: 'sambhaba', value: 'ସମ୍ଭବ', regex: false },
//{ key: 'asambhaba', value: 'ଅସମ୍ଭବ', regex: false },
{ key: 'prakruta', value: 'ପ୍ରକୃତ', regex: false },
{ key: 'tri', value: 'ତ୍ରି', regex: false },
{ key: 'stri', value: 'ସ୍ତ୍ରୀ', regex: false },
{ key: 'bohu', value: 'ବୋହୁ', regex: false },
{ key: 'sangata', value: 'ସଙ୍ଗାତ', regex: false },
{ key: 'mula', value: 'ମୂଳ', regex: false },
{ key: 'mulo', value: 'ମୁଲ', regex: false },
{ key: 'nakali', value: 'ନକଲି', regex: false },
{ key: 'jibita', value: 'ଜୀବିତ', regex: false },
{ key: 'mruta', value: 'ମୃତ', regex: false },
{ key: 'prakrutika', value: 'ପ୍ରାକୃତିକ', regex: false },
{ key: 'krutrima', value: 'କୃତ୍ରିମ', regex: false },
{ key: 'adhunika', value: 'ଆଧୁନିକ', regex: false },
{ key: 'prachina', value: 'ପ୍ରାଚୀନ', regex: false },
{ key: 'lokapriya', value: 'ଲୋକପ୍ରିୟ', regex: false },
{ key: 'alokapriya', value: 'ଅଲୋକପ୍ରିୟ', regex: false },
{ key: 'nirapada', value: 'ନିରାପଦ', regex: false },
{ key: 'bipadajanaka', value: 'ବିପଦଜନକ', regex: false },
{ key: 'bhagyabana', value: 'ଭାଗ୍ୟବାନ', regex: false },
{ key: 'durbhagya', value: 'ଦୁର୍ଭାଗ୍ୟ', regex: false },
{ key: 'namra', value: 'ନମ୍ର', regex: false },
{ key: 'asabhya', value: 'ଅସଭ୍ୟ', regex: false },
{ key: 'dhairyashila', value: 'ଧୈର୍ଯ୍ୟଶୀଳ', regex: false },
{ key: 'adhairya', value: 'ଅଧୈର୍ଯ୍ୟ', regex: false },
{ key: 'udara', value: 'ଉଦାର', regex: false },
//{ key: 'swarthapara', value: 'ସ୍ୱାର୍ଥପର', regex: false },
{ key: 'nali', value: 'ନାଲି', regex: false },
{ key: 'nila', value: 'ନୀଳ', regex: false },
{ key: 'sabuja', value: 'ସବୁଜ', regex: false },
{ key: 'haladi', value: 'ହଳଦୀ', regex: false },
{ key: 'kamala', value: 'କମଳା', regex: false },
{ key: 'baigani', value: 'ବାଇଗଣୀ', regex: false },
{ key: 'golapi', value: 'ଗୋଲାପୀ', regex: false },
{ key: 'matia', value: 'ମାଟିଆ', regex: false },
{ key: 'kala', value: 'କଳା', regex: false },
{ key: 'dhala', value: 'ଧଳା', regex: false },
{ key: 'dhusara', value: 'ଧୂସର', regex: false },
{ key: 'suneli', value: 'ସୁନେଲୀ', regex: false },
{ key: 'rupeli', value: 'ରୂପେଲୀ', regex: false },
{ key: 'phika nila', value: 'ଫିକା ନୀଳ', regex: false },
{ key: 'gadha sabuja', value: 'ଗାଢ଼ ସବୁଜ', regex: false },
{ key: 'akashi', value: 'ଆକାଶୀ', regex: false },
{ key: 'tambura', value: 'ତମ୍ବୁର', regex: false },
{ key: 'phiroja', value: 'ଫିରୋଜା', regex: false },
{ key: 'majenta', value: 'ମ୍ୟାଜେଣ୍ଟା', regex: false },
{ key: 'atinali', value: 'ଅତିନାଲି', regex: false },
{ key: 'bej', value: 'ବେଜ୍', regex: false },
{ key: 'pich', value: 'ପିଚ୍', regex: false },
{ key: 'lavendar', value: 'ଲାଭେଣ୍ଡର', regex: false },
{ key: 'nilagiri', value: 'ନୀଳଗିରି', regex: false },
{ key: 'til', value: 'ଟିଲ୍', regex: false },
{ key: 'alia', value: 'ଅଳିଆ', regex: false },
{ key: 'sarsapi', value: 'ସର୍ଷପୀ', regex: false },
{ key: 'angaria', value: 'ଅଙ୍ଗାରିଆ', regex: false },
{ key: 'hatidanti', value: 'ହାତୀଦାନ୍ତୀ', regex: false },
{ key: 'manikya', value: 'ମାଣିକ୍ୟ', regex: false },
{ key: 'pachara', value: 'ପଚରା', regex: false },
{ key: 'nilamani', value: 'ନୀଳମଣି', regex: false },
{ key: 'ambar', value: 'ଅମ୍ବର', regex: false },
{ key: 'ragia', value: 'ରାଗିଆ', regex: false },
{ key: 'birakta', value: 'ବିରକ୍ତ', regex: false },
{ key: 'chintita', value: 'ଚିନ୍ତିତ', regex: false },
{ key: 'bhayabhita', value: 'ଭୟଭୀତ', regex: false },
{ key: 'ascharjya', value: 'ଆଶ୍ଚର୍ଯ୍ୟ', regex: false },
{ key: 'dwandwata', value: 'ଦ୍ୱନ୍ଦ୍ୱତ', regex: false },
{ key: 'garbita', value: 'ଗର୍ବିତ', regex: false },
{ key: 'irshalu', value: 'ଈର୍ଷାଳୁ', regex: false },
{ key: 'ekaki', value: 'ଏକାକୀ', regex: false },
{ key: 'premita', value: 'ପ୍ରେମିତ', regex: false },
{ key: 'ghrinita', value: 'ଘୃଣିତ', regex: false },
{ key: 'asabadi', value: 'ଆଶାବାଦୀ', regex: false },
{ key: 'nirascha', value: 'ନିରାଶ', regex: false },
{ key: 'dosi', value: 'ଦୋଷୀ', regex: false },
{ key: 'lajjasila', value: 'ଲଜ୍ଜାଶୀଳ', regex: false },
{ key: 'atmabiswas', value: 'ଆତ୍ମବିଶ୍ୱାସ', regex: false },
{ key: 'snayu', value: 'ସ୍ନାୟୁ', regex: false },
{ key: 'bisrinkhala', value: 'ବିଶୃଙ୍ଖଳ', regex: false },
{ key: 'krutagyn', value: 'କୃତଜ୍ଞ', regex: false },
{ key: 'ghruna', value: 'ଘୃଣା', regex: false },
{ key: 'hatasa', value: 'ହତାଶ', regex: false },
{ key: 'santushta', value: 'ସନ୍ତୁଷ୍ଟ', regex: false },
{ key: 'lajjita', value: 'ଲଜ୍ଜିତ', regex: false },
{ key: 'arama', value: 'ଆରାମ', regex: false },
{ key: 'bharakranta', value: 'ଭାରାକ୍ରାନ୍ତ', regex: false },
{ key: 'chapagrastha', value: 'ଚାପଗ୍ରସ୍ତ', regex: false },
{ key: 'anandita', value: 'ଆନନ୍ଦିତ', regex: false },
{ key: 'duhkhada', value: 'ଦୁଃଖଦ', regex: false },
{ key: 'nirasabadi', value: 'ନିରାଶାବାଦୀ', regex: false },
{ key: 'utsahi', value: 'ଉତ୍ସାହୀ', regex: false },
{ key: 'udasina', value: 'ଉଦାସୀନ', regex: false },
{ key: 'hridaya', value: 'ହୃଦୟ', regex: false },
{ key: 'bidaraka', value: 'ବିଦାରକ', regex: false },
{ key: 'mlana', value: 'ମ୍ଳାନ', regex: false },
{ key: 'anandamaya', value: 'ଆନନ୍ଦମୟ', regex: false },
{ key: 'bhayankara', value: 'ଭୟଙ୍କର', regex: false },
{ key: 'klanta', value: 'କ୍ଳାନ୍ତ', regex: false },
{ key: 'sateja', value: 'ସତେଜ', regex: false },
{ key: 'prema', value: 'ପ୍ରେମ', regex: false },
{ key: 'mohita', value: 'ମୋହିତ', regex: false },
{ key: 'utkata', value: 'ଉତ୍କଟ', regex: false },
{ key: 'aradhana', value: 'ଆରାଧନା', regex: false },
{ key: 'karuthiba', value: 'କରୁଥିବ', regex: false },
{ key: 'anurakta', value: 'ଅନୁରକ୍ତ', regex: false },
{ key: 'trushna', value: 'ତୃଷ୍ଣା', regex: false },
{ key: 'sneha', value: 'ସ୍ନେହ', regex: false },
{ key: 'mugdha', value: 'ମୁଗ୍ଧ', regex: false },
{ key: 'hrudayangama', value: 'ହୃଦୟଙ୍ଗମ', regex: false },
{ key: 'romantik', value: 'ରୋମାଣ୍ଟିକ୍', regex: false },
{ key: 'mlanata', value: 'ମ୍ଳାନତା', regex: false },
{ key: 'smrutimaya', value: 'ସ୍ମୃତିମୟ', regex: false },
{ key: 'mishranubhuti', value: 'ମିଶ୍ରାନୁଭୂତି', regex: false },
{ key: 'anutapa', value: 'ଅନୁତାପ', regex: false },
{ key: 'purna', value: 'ପୂର୍ଣ୍ଣ', regex: false },
{ key: 'nirmala', value: 'ନିର୍ମଳ', regex: false },
{ key: 'antaranga', value: 'ଅନ୍ତରଙ୍ଗ', regex: false },
{ key: 'pidita', value: 'ପୀଡ଼ିତ', regex: false },
{ key: 'apratidan', value: 'ଅପ୍ରତିଦାନ', regex: false },
{ key: 'atmik', value: 'ଆତ୍ମିକ', regex: false },
{ key: 'ahladita', value: 'ଆହ୍ଲାଦିତ', regex: false },
{ key: 'tyagi', value: 'ତ୍ୟାଗୀ', regex: false },
{ key: 'shradhalu', value: 'ଶ୍ରଦ୍ଧାଳୁ', regex: false },
{ key: 'sthir', value: 'ସ୍ଥିର', regex: false },
{ key: 'bismita', value: 'ବିସ୍ମିତ', regex: false },
{ key: 'irshaparayana', value: 'ଈର୍ଷାପରାୟଣ', regex: false },
{ key: 'biswasa ghataka', value: 'ବିଶ୍ୱାସ ଘାତକ', regex: false },
{ key: 'sikar', value: 'ଶିକାର', regex: false },
{ key: 'parityakta', value: 'ପରିତ୍ୟକ୍ତ', regex: false },
{ key: 'chaplus', value: 'ଚାପଲୁସ୍', regex: false },
{ key: 'akrushta', value: 'ଆକୃଷ୍ଟ', regex: false },
{ key: 'mantramugdha', value: 'ମନ୍ତ୍ରମୁଗ୍ଧ', regex: false },
{ key: 'nisagrasta', value: 'ନିଶାଗ୍ରସ୍ତ', regex: false },
{ key: 'jnanatmak', value: 'ଜ୍ଞାନାତ୍ମକ', regex: false },
{ key: 'asangati', value: 'ଅସଙ୍ଗତି', regex: false },
{ key: 'bichedana', value: 'ବିଚ୍ଛେଦନ', regex: false },
{ key: 'truti', value: 'ତ୍ରୁଟି', regex: false },
{ key: 'dukha', value: 'ଦୁଃଖ', regex: false },
{ key: 'shudhikarana', value: 'ଶୁଦ୍ଧିକରଣ', regex: false },
{ key: 'darshan', value: 'ଦର୍ଶନ', regex: false },
{ key: 'alok', value: 'ଆଲୋକ', regex: false },
{ key: 'karuna', value: 'କରୁଣ', regex: false },
{ key: 'bayaska', value: 'ବୟସ୍କ', regex: false },
{ key: 'upanyas', value: 'ଉପନ୍ୟାସ', regex: false },
{ key: 'astitwabada', value: 'ଅସ୍ତିତ୍ୱବାଦ', regex: false },
{ key: 'arthahinabada', value: 'ଅର୍ଥହୀନବାଦ', regex: false },
{ key: 'parajan_satta', value: 'ପରଜନ ସତ୍ତା', regex: false },
{ key: 'sunyatara', value: 'ଶୂନ୍ୟତାର', regex: false },
{ key: 'bhaya', value: 'ଭୟ', regex: false },
{ key: 'nastikabada', value: 'ନାସ୍ତିକବାଦ', regex: false },
{ key: 'nibaran', value: 'ନିବାରଣ', regex: false },
{ key: 'prakhepan', value: 'ପ୍ରକ୍ଷେପଣ', regex: false },
{ key: 'sthanantarana', value: 'ସ୍ଥାନାନ୍ତରଣ', regex: false },
{ key: 'aswikara', value: 'ଅସ୍ୱୀକାର', regex: false },
{ key: 'snayu', value: 'ସ୍ନାୟୁ', regex: false },
{ key: 'durbalata', value: 'ଦୁର୍ବଳତା', regex: false },
{ key: 'bhakti', value: 'ଭକ୍ତି', regex: false },
{ key: 'dibya prema', value: 'ଦିବ୍ୟ ପ୍ରେମ', regex: false },
{ key: 'biswas', value: 'ବିଶ୍ୱାସ', regex: false },
{ key: 'atmasamarpana', value: 'ଆତ୍ମସମର୍ପଣ', regex: false },
{ key: 'shraddha', value: 'ଶ୍ରଦ୍ଧା', regex: false },
{ key: 'gyanodaya', value: 'ଜ୍ଞାନୋଦୟ', regex: false },
//{ key: 'krupa', value: 'କୃପା', regex: false },
{ key: 'atindriyata', value: 'ଅତୀନ୍ଦ୍ରିୟତା', regex: false },
{ key: 'papabodh', value: 'ପାପବୋଧ', regex: false },
{ key: 'paschatapa', value: 'ପଶ୍ଚାତାପ', regex: false },
{ key: 'mukti', value: 'ମୁକ୍ତି', regex: false },
{ key: 'tapasya', value: 'ତପସ୍ୟା', regex: false },
{ key: 'khyama', value: 'କ୍ଷମା', regex: false },
{ key: 'bhabasamadhi', value: 'ଭାବସମାଧି', regex: false },
{ key: 'adwaitabadh', value: 'ଅଦ୍ୱୈତବୋଧ', regex: false },
{ key: 'sannidhya', value: 'ସାନ୍ନିଧ୍ୟ', regex: false },
{ key: 'iswariya', value: 'ଈଶ୍ୱରୀୟ', regex: false },
{ key: 'dibya', value: 'ଦିବ୍ୟ', regex: false },
{ key: 'bisada', value: 'ବିଷାଦ', regex: false },
{ key: 'dharmika', value: 'ଧାର୍ମିକ', regex: false },
{ key: 'trushna', value: 'ତୃଷ୍ଣା', regex: false },
{ key: 'pabitrata', value: 'ପବିତ୍ରତା', regex: false },
{ key: 'tyaga', value: 'ତ୍ୟାଗ', regex: false },
{ key: 'dharmikata', value: 'ଧାର୍ମିକତା', regex: false },
{ key: 'deshaprema', value: 'ଦେଶପ୍ରେମ', regex: false },
{ key: 'jatiyatabada', value: 'ଜାତୀୟତାବାଦ', regex: false },
{ key: 'krantikari_utsaha', value: 'କ୍ରାନ୍ତିକାରୀ ଉତ୍ସାହ', regex: false },
{ key: 'nistha', value: 'ନିଷ୍ଠା', regex: false },
{ key: 'asahamati', value: 'ଅସହମତି', regex: false },
{ key: 'pradhikar', value: 'ପ୍ରାଧିକାର', regex: false },
{ key: 'durniti', value: 'ଦୁର୍ନୀତି', regex: false },
{ key: 'paradarsita', value: 'ପାରଦର୍ଶିତା', regex: false },
{ key: 'uttaradayitwa', value: 'ଉତ୍ତରଦାୟିତ୍ୱ', regex: false },
{ key: 'alpatantra', value: 'ଅଳ୍ପତନ୍ତ୍ର', regex: false },
{ key: 'nirjyatana', value: 'ନିର୍ଯାତନ', regex: false },
{ key: 'pratirodha', value: 'ପ୍ରତିରୋଧ', regex: false },
{ key: 'upanibesabad', value: 'ଉପନିବେଶବାଦ', regex: false },
{ key: 'soshana', value: 'ଶୋଷଣ', regex: false },
{ key: 'ganatantra', value: 'ଗଣତନ୍ତ୍ର', regex: false },
{ key: 'samyabada', value: 'ସାମ୍ୟବାଦ', regex: false },
{ key: 'dhanatantra', value: 'ଧନତନ୍ତ୍ର', regex: false },
{ key: 'dharmanirapekhyata', value: 'ଧର୍ମନିରପେକ୍ଷତା', regex: false },
{ key: 'abiswasa', value: 'ଅବିଶ୍ୱାସ', regex: false },
{ key: 'ekata', value: 'ଏକତା', regex: false },
{ key: 'andolana', value: 'ଆନ୍ଦୋଳନ', regex: false },
{ key: 'nirasabad', value: 'ନିରାଶାବାଦ', regex: false },
{ key: 'asa', value: 'ଆଶା', regex: false },
{ key: 'sarbabhaumatwa', value: 'ସାର୍ବଭୌମତ୍ୱ', regex: false },
{ key: 'mitrata', value: 'ମିତ୍ରତା', regex: false },
{ key: 'bibada', value: 'ବିବାଦ', regex: false },
{ key: 'nirapekhyata', value: 'ନିରପେକ୍ଷତା', regex: false },
{ key: 'adhipatya', value: 'ଆଧିପତ୍ୟ', regex: false },
{ key: 'meria', value: 'ମେରିଆ', regex: false },
{ key: 'bidroha', value: 'ବିଦ୍ରୋହ', regex: false },
{ key: 'atma', value: 'ଆତ୍ମା', regex: false },
{ key: 'dhara', value: 'ଧରା', regex: false },
{ key: 'jami', value: 'ଜମି', regex: false },
{ key: 'adhigrahana', value: 'ଅଧିଗ୍ରହଣ', regex: false },
{ key: 'niyamagiri', value: 'ନିୟମଗିରି', regex: false },
{ key: 'sampradayika', value: 'ସାମ୍ପ୍ରଦାୟିକ', regex: false },
{ key: 'hinsa', value: 'ହିଂସା', regex: false },
{ key: 'mukhastha', value: 'ମୁଖସ୍ଥ', regex: false },
{ key: 'mahakabya', value: 'ମହାକାବ୍ୟ', regex: false },
{ key: 'gacha', value: 'ଗଚ୍ଛ', regex: false },
{ key: 'manab', value: 'ମାନବ', regex: false },
{ key: 'kandha', value: 'କନ୍ଧ', regex: false },
{ key: 'bahini', value: 'ବାହିନୀ', regex: false },
{ key: 'raksha', value: 'ରକ୍ଷା', regex: false },
{ key: 'rajya', value: 'ରାଜ୍ୟ', regex: false },
{ key: 'sangh', value: 'ସଂଘ', regex: false },
{ key: 'mutha', value: 'ମୁଠା', regex: false },
{ key: 'dora', value: 'ଡୋରା', regex: false },
{ key: 'penu', value: 'ପେନୁ', regex: false },
{ key: 'mandir', value: 'ମନ୍ଦିର', regex: false },
{ key: 'kalii', value: 'କାଳୀ', regex: false },
{ key: 'jontri', value: 'ଯନ୍ତ୍ରୀ', regex: false },
{ key: 'jatri', value: 'ଯାତ୍ରୀ', regex: false },
{ key: 'bisthapita', value: 'ବିସ୍ଥାପିତ', regex: false },
{ key: 'biparjaya', value: 'ବିପର୍ଯ୍ୟୟ', regex: false },
{ key: 'horai', value: 'ହରାଇ', regex: false },
{ key: 'ebholi', value: 'ଏଭଳି', regex: false },
{ key: 'sruti', value: 'ଶୃତି', regex: false },
{ key: 'Suresh', value: 'ସୁରେଶ', regex: false },
{ key: 'pujari', value: 'ପୂଜାରୀ', regex: false },
{ key: 'mithya', value: 'ମିଥ୍ୟା', regex: false },
{ key: 'badi', value: 'ବାଦୀ', regex: false },
{ key: 'monji', value: 'ମଞ୍ଜି', regex: false },
{ key: 'jibno', value: 'ଜୀବନ', regex: false },
{ key: 'kesha', value: 'କେଶ', regex: false },
{ key: 'bhuiya', value: 'ଭୁଇଁଆ', regex: false },
{ key: 'sena', value: 'ସେନା', regex: false },
{ key: 'podu', value: 'ପୋଡୁ', regex: false },
{ key: 'gudia banija', value: 'ଗୁଡ଼ିଆ ବଣିଜ', regex: false },
{ key: 'jakeri', value: 'ଜାକେରୀ', regex: false },
{ key: 'debata', value: 'ଦେବତା', regex: false },
{ key: 'kandul', value: 'କନ୍ଦୁଲ୍', regex: false },
{ key: 'bansa', value: 'ବଂଶ', regex: false },
{ key: 'dhangada', value: 'ଢାଙ୍ଗଡ଼', regex: false },
{ key: 'khunta', value: 'ଖୁଣ୍ଟ', regex: false },
{ key: 'sisa', value: 'ସିସା', regex: false },
{ key: 'rajatwa', value: 'ରାଜତ୍ୱ', regex: false },
{ key: 'rakta', value: 'ରକ୍ତ', regex: false },
{ key: 'sandhi', value: 'ସନ୍ଧି', regex: false },
{ key: 'pahadi', value: 'ପାହାଡ଼ି', regex: false },
{ key: 'durg', value: 'ଦୁର୍ଗ', regex: false },
{ key: 'sapath', value: 'ଶପଥ', regex: false },
{ key: 'path', value: 'ପଥ', regex: false },
{ key: 'luna', value: 'ଲୁଣ', regex: false },
{ key: 'luha', value: 'ଲୁହା', regex: false },
{ key: 'sarbabhoumat', value: 'ସାର୍ବଭୌମତ', regex: false },
{ key: 'bichar', value: 'ବିଚାର', regex: false },
{ key: 'porikhya', value: 'ପରୀକ୍ଷା', regex: false },
{ key: 'pitru', value: 'ପିତୃ', regex: false },
{ key: 'nirnnaya', value: 'ନିର୍ଣ୍ଣୟ', regex: false },
{ key: 'chandra', value: 'ଚନ୍ଦ୍ର', regex: false },
{ key: 'panjika', value: 'ପଞ୍ଜିକା', regex: false },
{ key: 'abhishek', value: 'ଅଭିଷେକ', regex: false },
{ key: 'tangi', value: 'ତାଙ୍ଗି', regex: false },
{ key: 'arpan', value: 'ଅର୍ପଣ', regex: false },
{ key: 'navankura', value: 'ନବାଙ୍କୁର', regex: false },
{ key: 'pathara', value: 'ପଥର', regex: false },
{ key: 'puja', value: 'ପୂଜା', regex: false },
{ key: 'chapa', value: 'ଛାପ', regex: false },
{ key: 'yatra', value: 'ଯାତ୍ରା', regex: false },
{ key: 'rath', value: 'ରଥ', regex: false },
{ key: 'puja', value: 'ପୂଜା', regex: false },
{ key: 'purnima', value: 'ପୂର୍ଣ୍ଣିମା', regex: false },
{ key: 'kumar', value: 'କୁମାର', regex: false },
{ key: 'manabas', value: 'ମାନବସା', regex: false },
{ key: 'prathamastami', value: 'ପ୍ରଥମାଷ୍ଟମୀ', regex: false },
{ key: 'purnima', value: 'ପୂର୍ଣ୍ଣିମା', regex: false },
{ key: 'dola', value: 'ଦୋଳ', regex: false },
{ key: 'panga', value: 'ପାଙ୍ଗା', regex: false },
{ key: 'dre', value: 'ଦ୍ରେ', regex: false },
{ key: 'shi', value: 'ଷି', regex: false },
{ key: 'ngia', value: 'ଙ୍ଗିଆ', regex: false },
{ key: 'pradhan', value: 'ପ୍ରଧାନ', regex: false },
{ key: 'dash', value: 'ଦାଶ', regex: false },
{ key: 'tipidingia', value: 'ଟିପିଡ଼ିଙ୍ଗିଆ ', regex: false },
{ key: 'phasala', value: 'ଫସଲ', regex: false },
{ key: 'doudi', value: 'ଦଉଡ଼ି', regex: false },
{ key: 'bisho', value: 'ବିଷ', regex: false },
{ key: 'jothesto', value: 'ଯଥେଷ୍ଟ', regex: false },
{ key: 'rogi', value: 'ରୋଗୀ', regex: false },
{ key: 'shuna', value: 'ଶୁଣ', regex: false },
{ key: 'bichara', value: 'ବିଗ୍ଭର', regex: false },
{ key: 'boka', value: 'ବୋକା', regex: false },
{ key: 'ete', value: 'ଏତେ', regex: false },
{ key: 'lago', value: 'ଲାଗ', regex: false },
{ key: 'samagri', value: 'ସାମଗ୍ରୀ', regex: false },
{ key: 'jao', value: 'ଯାଅ', regex: false },
{ key: 'jaant', value: 'ଯାଆନ୍ତ', regex: false },
{ key: 'ant', value: 'ଆନ୍ତ', regex: false },
{ key: 'bibhakta', value: 'ବିଭକ୍ତ', regex: false },

{ key: 'tankadhara', value: 'ଟଙ୍କଧର', regex: false },
{ key: 'dharon', value: 'ଧାରଣ', regex: false },
{ key: 'doroji', value: 'ଦରଜୀ', regex: false },
{ key: 'dorodi', value: 'ଦରଦୀ', regex: false },
{ key: 'mana', value: 'ମାଣ', regex: false },
{ key: 'indra', value: 'ଇନ୍ଦ୍ର', regex: false },
{ key: 'sabha', value: 'ସଭା', regex: false },


{ key: 'chandan', value: 'ଚନ୍ଦନ', regex: false },

{ key: 'odisi', value: 'ଓଡିଶୀ', regex: false },
{ key: 'gotipua', value: 'ଗୋଟିପୁଆ', regex: false },
{ key: 'sambalpuri nrutya', value: 'ସମ୍ବଲପୁରୀ ନୃତ୍ୟ', regex: false },
{ key: 'dalkhai', value: 'ଡାଲଖାଇ', regex: false },
{ key: 'ghumura', value: 'ଘୁମୁରା', regex: false },
{ key: 'mahari', value: 'ମାହାରୀ', regex: false },
{ key: 'pala', value: 'ପାଳା', regex: false },
{ key: 'pattachitra', value: 'ପଟ୍ଟଚିତ୍ର', regex: false },
{ key: 'talopotr', value: 'ତାଳପତ୍ର', regex: false },
{ key: 'sambalpuri bandha', value: 'ସମ୍ବଲପୁରୀ ବାନ୍ଧା', regex: false },
{ key: 'silpi', value: 'ଶିଳ୍ପୀ', regex: false },
{ key: 'jhoti', value: 'ଝୋଟି', regex: false },
{ key: 'chita', value: 'ଚିତା', regex: false },
{ key: 'pakhala', value: 'ପଖାଳ', regex: false },
{ key: 'dalma', value: 'ଡାଲମା', regex: false },
{ key: 'chhena_poda', value: 'ଛେନା ପୋଡା', regex: false },
{ key: 'rasagola', value: 'ରସଗୋଲା', regex: false },
{ key: 'khaja', value: 'ଖଜା', regex: false },
{ key: 'pitha', value: 'ପିଠା', regex: false },
{ key: 'sambalpuri saree', value: 'ସମ୍ବଲପୁରୀ ଶାଢୀ', regex: false },
{ key: 'chandua', value: 'ଖନ୍ଦୁଆ', regex: false },
{ key: 'kataki', value: 'କଟକୀ', regex: false },
{ key: 'dhoti', value: 'ଧୋତି', regex: false },
{ key: 'jagannath_temple', value: 'ଜଗନ୍ନାଥ ମନ୍ଦିର', regex: false },
{ key: 'konark', value: 'କୋଣାର୍କ', regex: false },
{ key: 'lingaraj', value: 'ଲିଙ୍ଗରାଜ', regex: false },
{ key: 'khandagiri', value: 'ଖଣ୍ଡଗିରି', regex: false },
{ key: 'barabati', value: 'ବାରବାଟୀ', regex: false },
{ key: 'kui bhasa', value: 'କୁଇ ଭାଷା', regex: false },
{ key: 'dongria kondh', value: 'ଡଙ୍ଗିରିଆ କନ୍ଧ', regex: false },
{ key: 'saura painting', value: 'ସାଉରା ଚିତ୍ର', regex: false },
{ key: 'juang nruty', value: 'ଜୁଆଙ୍ଗ ନୃତ୍ୟ', regex: false },
{ key: 'jiba jagare', value: 'ଜିବ ଜଗାରେ', regex: false },
{ key: 'ghara bhitar', value: 'ଘର ଭିତର', regex: false },
{ key: 'pani', value: 'ପାଣି', regex: false },
{ key: 'gapa', value: 'ଗପ', regex: false },
{ key: 'katha', value: 'କଥା', regex: false },
{ key: 'galpa', value: 'ଗଳ୍ପ', regex: false },
{ key: 'kichi', value: 'କିଛି କଥା', regex: false },
{ key: 'khabara', value: 'ଖବର', regex: false },
{ key: 'prosidho', value: 'ପ୍ରସିଦ୍ଧ', regex: false },
{ key: 'post', value: 'ପୋଷ୍ଟ', regex: false },
{ key: 'nikata', value: 'ନିକଟ', regex: false },
{ key: 'skuti', value: 'ସ୍କୁଟି', regex: false },
{ key: 'number', value: 'ନମ୍ବର', regex: false },
{ key: 'like', value: 'ଲାଇକ୍', regex: false },
{ key: 'share', value: 'ସେୟାର୍', regex: false },
{ key: 'subscribe', value: 'ସବ୍ ସ୍କ୍ରାଇବ୍', regex: false },
{ key: 'bhuli', value: 'ଭୁଲି', regex: false },
{ key: 'tripathy', value: 'ତ୍ରିପାଠି', regex: false },



{ key: 'sochaka', value: 'ସୋଚକ', regex: false },
{ key: 'prabadana', value: 'ପ୍ରବାଦନ', regex: false },
{ key: 'prabadita', value: 'ପ୍ରବାଦିତ', regex: false },
{ key: 'bapa', 'value': 'ବାପା', regex: false },
{ key: 'mae', 'value': 'ମାଏ', regex: false },
{ key: 'bhai', 'value': 'ଭାଇ', regex: false },
{ key: 'jauchi', 'value': 'ଯାଉଛି', regex: false },
{ key: 'asichi', 'value': 'ଆସିଛି', regex: false },
{ key: 'khaichi', 'value': 'ଖାଇଛି', regex: false },
{ key: 'pichi', 'value': 'ପିଇଛି', regex: false },
{ key: 'suichi', 'value': 'ଶୁଇଛି', regex: false },
{ key: 'handa', 'value': 'ହାଣ୍ଡି', regex: false },
{ key: 'kadahi', 'value': 'କଢ଼ାଇ', regex: false },
{ key: 'chulha', 'value': 'ଚୁଲା', regex: false },
{ key: 'kula', 'value': 'କୁଳା', regex: false },
{ key: 'jhari', 'value': 'ଝରି', regex: false },
{ key: 'hal', 'value': 'ହଳ', regex: false },
{ key: 'gher', 'value': 'ଘେର', regex: false },
{ key: 'dhan', 'value': 'ଧାନ', regex: false },
{ key: 'gai', 'value': 'ଗାଈ', regex: false },
{ key: 'boli', 'value': 'ବଳି', regex: false },
{ key: 'sagada', 'value': 'ଶଗଡ଼', regex: false },
{ key: 'kukura', 'value': 'କୁକୁର', regex: false },
{ key: 'baliya', value: 'ବଳିଆ', regex: false },
{ key: 'bou', value: 'ବୋଉ', regex: false },
{ key: 'pua', value: 'ପୁଅ', regex: false },
{ key: 'jhia', value: 'ଝିଅ', regex: false },
{ key: 'nati', value: 'ନାତି', regex: false },
{ key: 'bhauja', value: 'ଭାଉଜ', regex: false },
//{ key: 'ah', value: 'ଆଃ', regex: false },
{ key: 'oh', value: 'ଓଃ', regex: false },
{ key: 'wah', value: 'ବାଃ', regex: false },


{ key: 'barsa', value: 'ବର୍ଷା', regex: false },
{ key: 'muhn', value: 'ମୁହଁ', regex: false },
{ key: 'hata', value: 'ହାତ', regex: false },

{ key: 'pet', value: 'ପେଟ', regex: false },
{ key: 'nomoskar', value: 'ନମସ୍କାର', regex: false },
{ key: 'jagannath', value: 'ଜଗନ୍ନାଥ', regex: false }, 
{ key: 'achhi', value: 'ଅଛି', regex: false } ,
{ key: 'bhai', value: 'ଭାଇ', regex: false },
{ key: 'are', value: 'ଆରେ', regex: false },

{ key: 'didi', value: 'ଦିଦି', regex: false },
{ key: 'bou', value: 'ବୋଉ', regex: false } ,
{ key: 'bapa', value: 'ବାପା', regex: false } ,
{ key: 'hay', value: 'ହାୟ', regex: false }  ,
{ key: 'go', value: 'ଗୋ', regex: false }  ,
{ key: 'wah', value: 'ବାଃ ବାଃ', regex: false }  ,
{ key: 'baat', value: 'ବାତ', regex: false } , 
{ key: 'kya', value: 'କିୟା', regex: false } , 
{ key: 'mast', value: 'ମସ୍ତ', regex: false }  ,
{ key: 'bokaa', value: 'ବୋକା', regex: false }  ,
{ key: 'chup', value: 'ଚୁପ୍', regex: false }  ,
{ key: 'pagal', value: 'ପାଗଳ', regex: false }  ,
{ key: 'budha', value: 'ବୁଢା', regex: false }  ,
{ key: 'chik', value: 'ଚିକ୍', regex: false }  ,
{ key: 'hat', value: 'ହଟ୍', regex: false }  ,
{ key: 'koron', value: 'କରଣ', regex: false },
{ key: 'prasana', value: 'ପ୍ରସନ', regex: false },
{ key: 'munji', value: 'ମୁଞ୍ଜି', regex: false },
{ key: 'biha', value: 'ବିହା', regex: false } ,
{ key: 'shradho', value: 'ଶ୍ରାଦ୍ଧ', regex: false } ,
{ key: 'khiai', value: 'ଖିଆଇ', regex: false },
{ key: 'khia', value: 'ଖିଆ', regex: false },
{ key: 'tira', value: 'ଟିର', regex: false },
{ key: 'kharch', value: 'ଖର୍ଚ୍ଚ', regex: false },
{ key: 'poduchh', value: 'ପଡୁଛି', regex: false },

{ key: 'chuda', value: 'ଚୁଡା', regex: false },
{ key: 'pitha', value: 'ପିଠା', regex: false },

{ key: 'chakuli', value: 'ଚକୁଳି', regex: false },
{ key: 'ghasa', value: 'ଘଷା', regex: false },

{ key: 'bhesha', value: 'ଭେଷ', regex: false },
{ key: 'suna', value: 'ସୁନା', regex: false },

{ key: 'bandha', value: 'ବାନ୍ଧ', regex: false },

{ key: 'dhangda mundia', value: 'ଢାଙ୍ଗଡା ମୁଣ୍ଡିଆ', regex: false },
{ key: 'kanika', value: 'କାନିକା', regex: false },
{ key: 'khichdi', value: 'ଖିଚଡି', regex: false }, 
{ key: 'arisa pitha', value: 'ଆରିସା ପିଠା', regex: false },
{ key: 'manda pitha', value: 'ମଣ୍ଡା ପିଠା', regex: false },  
{ key: 'chakuli pitha', value: 'ଚକୁଳି ପିଠା', regex: false } ,
{ key: 'khiri', value: 'ଖିରି', regex: false } ,
{ key: 'santula', value: 'ସନ୍ତୁଳା', regex: false } ,
{ key: 'chhencheda', value: 'ଛେଞ୍ଚେଡା', regex: false } ,
{ key: 'bamboo chicken', value: 'ବାଉଁଶ ଚିକେନ', regex: false } ,
{ key: 'chatani', value: 'ଚଟଣି', regex: false } ,
{ key: 'puja', value: 'ପୂଜା', regex: false },
{ key: 'bhakti', value: 'ଭକ୍ତି', regex: false },
{ key: 'dharma', value: 'ଧର୍ମ', regex: false },
{ key: 'karma', value: 'କର୍ମ', regex: false },
{ key: 'moksha', value: 'ମୋକ୍ଷ', regex: false },
{ key: 'mantra', value: 'ମନ୍ତ୍ର', regex: false },
{ key: 'jagyan', value: 'ଯଜ୍ଞ', regex: false },
{ key: 'prasad', value: 'ପ୍ରସାଦ', regex: false },
{ key: 'arati', value: 'ଆରତୀ', regex: false },
{ key: 'sadhana', value: 'ସାଧନା', regex: false },
{ key: 'guru', value: 'ଗୁରୁ', regex: false },
{ key: 'shishya', value: 'ଶିଷ୍ୟ', regex: false },
{ key: 'tirtha', value: 'ତୀର୍ଥ', regex: false },
{ key: 'vrata', value: 'ବ୍ରତ', regex: false },
{ key: 'samadhi', value: 'ସମାଧି', regex: false },
{ key: 'avatar', value: 'ଅବତାର', regex: false },
{ key: 'deva', value: 'ଦେବ', regex: false },
{ key: 'devi', value: 'ଦେବୀ', regex: false },
{ key: 'asura', value: 'ଅସୁର', regex: false },
{ key: 'pitru', value: 'ପିତୃ', regex: false },
{ key: 'pinda', value: 'ପିଣ୍ଡ', regex: false },
{ key: 'swarga', value: 'ସ୍ୱର୍ଗ', regex: false },
{ key: 'naraka', value: 'ନରକ', regex: false },
{ key: 'maya', value: 'ମାୟା', regex: false },
{ key: 'samsara', value: 'ସଂସାର', regex: false },
{ key: 'gyana', value: 'ଜ୍ଞାନ', regex: false },
{ key: 'bhajan', value: 'ଭଜନ', regex: false },
{ key: 'kirtan', value: 'କୀର୍ତନ', regex: false },
{ key: 'mandira', value: 'ମନ୍ଦିର', regex: false },
{ key: 'kataki', value: 'କଟକୀ', regex: false }  ,
{ key: 'bomkai', value: 'ବୋମ୍କାଇ', regex: false } ,
{ key: 'khandua', value: 'ଖନ୍ଦୁଆ', regex: false }  ,
{ key: 'pasapali', value: 'ପାସାପାଲି', regex: false }  ,
{ key: 'sonepuri', value: 'ସୋନପୁରୀ ', regex: false }  ,
{ key: 'berhampuri', value: 'ବ୍ରହ୍ମପୁରୀ', regex: false },  
{ key: 'saree', value: 'ଶାଢୀ', regex: false },  

{ key: 'gamucha', value: 'ଗାମୁଛା', regex: false }  ,
{ key: 'kambal', value: 'କମ୍ବଳ', regex: false }  ,
{ key: 'dress', value: 'ପୋଷାକ', regex: false }  ,
{ key: 'tribal', value: 'ଆଦିବାସୀ', regex: false }  ,

{ key: 'kandhi', value: 'କାନ୍ଧି', regex: false }  ,
{ key: 'kapada', value: 'କପଡା', regex: false }  ,

{ key: 'jhoti', value: 'ଝୋଟି', regex: false },
{ key: 'chita', value: 'ଚିତା', regex: false },

{ key: 'tie dye', value: 'ବନ୍ଧା ରଙ୍ଗ', regex: false }  ,
{ key: 'ikat pattern', value: 'ଇକଟ ଡିଜାଇନ', regex: false }  ,
{ key: 'kala parsi', value: 'କଳା ପରସି', regex: false }  ,
{ key: 'sambalpuri silk', value: 'ସମ୍ବଲପୁରୀ ରେଶମ', regex: false }  ,
{ key: 'pata saree', value: 'ପଟା ଶାଢୀ', regex: false } ,
{ key: 'grama', value: 'ଗ୍ରାମ', regex: false },
{ key: 'palli', value: 'ପଲ୍ଲୀ', regex: false },
{ key: 'sahi', value: 'ସାହି', regex: false },
{ key: 'basti', value: 'ବସ୍ତି', regex: false },
{ key: 'mouza', value: 'ମୌଜା', regex: false },
{ key: 'panchayat', value: 'ପଞ୍ଚାୟତ', regex: false },
{ key: 'chak', value: 'ଚାକ', regex: false },
{ key: 'bari', value: 'ବାରି', regex: false },
{ key: 'jola', value: 'ଜୋଳା', regex: false },
{ key: 'gola', value: 'ଗୋଲା', regex: false },
{ key: 'khalia', value: 'ଖଳିଆ', regex: false },
{ key: 'chua', value: 'ଚୁଆ', regex: false },
{ key: 'bandha', value: 'ବନ୍ଧ', regex: false },
{ key: 'dangar', value: 'ଡଙ୍ଗର', regex: false },
{ key: 'gheri', value: 'ଘେରି', regex: false },
{ key: 'kandha', value: 'କାନ୍ଧ', regex: false },
{ key: 'munda', value: 'ମୁଣ୍ଡା', regex: false },
{ key: 'tola', value: 'ଟୋଲା', regex: false },
{ key: 'bana', value: 'ବନ', regex: false },
{ key: 'biye', value: 'ବିଯେ', regex: false },
{ key: 'lagan', value: 'ଲଗନ', regex: false },
{ key: 'mangni', value: 'ମଙ୍ଗ୍ନି', regex: false },
{ key: 'barjatri', value: 'ବରଯାତ୍ରୀ', regex: false },
{ key: 'kanyadaan', value: 'କନ୍ୟାଦାନ', regex: false },
{ key: 'saptapadi', value: 'ସପ୍ତପଦୀ', regex: false },
{ key: 'pheras', value: 'ଫେରସ', regex: false },
{ key: 'gauri_puja', value: 'ଗୌରୀ ପୂଜା', regex: false },
{ key: 'gudai', value: 'ଗୁଡ଼ାଇ', regex: false },
{ key: 'dahi', value: 'ଦହି', regex: false },
{ key: 'ghanti', value: 'ଘଣ୍ଟି', regex: false },
{ key: 'hata', value: 'ହାତ', regex: false },
{ key: 'bikray', value: 'ବିକ୍ରୟ', regex: false },
{ key: 'kanya', value: 'କନ୍ୟା', regex: false },

{ key: 'mala', value: 'ମାଳା', regex: false },
{ key: 'badal', value: 'ବଦଳ', regex: false },
{ key: 'dan', value: 'ଦାନ', regex: false },
{ key: 'sindura', value: 'ସିନ୍ଦୂର', regex: false },

{ key: 'bou', value: 'ବୋଉ', regex: false },
{ key: 'bhata', value: 'ଭାତ', regex: false },

{ key: 'bidayee', value: 'ବିଦାୟୀ', regex: false },
{ key: 'bazar', value: 'ବଜାର', regex: false },
//{ key: 'hato', value: 'ହାଟ', regex: false },
{ key: 'souda', value: 'ସୌଦା', regex: false },
{ key: 'byabasaya', value: 'ବ୍ୟବସାୟ', regex: false },
{ key: 'bikri', value: 'ବିକ୍ରି', regex: false },
{ key: 'kraya', value: 'କ୍ରୟ', regex: false },
{ key: 'dalal', value: 'ଦଳାଲ', regex: false },
{ key: 'theka', value: 'ଠେକା', regex: false },
{ key: 'mudra', value: 'ମୁଦ୍ରା', regex: false },
{ key: 'dam', value: 'ଦାମ', regex: false },
{ key: 'mol', value: 'ମୋଲ', regex: false },
//{ key: 'sasti', value: 'ସସ୍ତି', regex: false },
{ key: 'mahanga', value: 'ମହଙ୍ଗା', regex: false },
{ key: 'mapa', value: 'ମାପ', regex: false },
{ key: 'taraju', value: 'ତରାଜୁ', regex: false },
{ key: 'guna', value: 'ଗୁଣ', regex: false },
{ key: 'jasta', value: 'ଜାସ୍ତ', regex: false },
{ key: 'souda', value: 'ସୌଦା', regex: false },
{ key: 'hisab', value: 'ହିସାବ', regex: false },
{ key: 'udhar', value: 'ଉଧାର', regex: false },
{ key: 'baki', value: 'ବାକି', regex: false },
{ key: 'labha', value: 'ଲାଭ', regex: false },
{ key: 'byapari', value: 'ବ୍ୟାପାରୀ', regex: false },
{ key: 'gadidar', value: 'ଗଡିଦାର', regex: false },
{ key: 'pheriwala', value: 'ଫେରିବାଲା', regex: false },
{ key: 'sahukar', value: 'ସାହୁକାର', regex: false },
{ key: 'mahajan', value: 'ମହାଜନ', regex: false },
{ key: 'aroti', value: 'ଆରତି', regex: false },
{ key: 'sagai', value: 'ସଗାଇ', regex: false },
{ key: 'sankhy', value: 'ସଂଖ୍ୟ', regex: false },
{ key: 'pariman', value: 'ପରିମାଣ', regex: false },
{ key: 'praman', value: 'ପ୍ରମାଣ', regex: false },
{ key: 'chhapa', value: 'ଛାପ', regex: false },
{ key: 'praman', value: 'ପ୍ରମାଣ', regex: false },
{ key: 'potro', value: 'ପତ୍ର', regex: false },

{ key: 'byabasayi', value: 'ବ୍ୟବସାୟୀ', regex: false },
{ key: 'byabasayi sangha', value: 'ବ୍ୟବସାୟୀ ସଂଘ', regex: false },
{ key: 'sarkari bazara', value: 'ସରକାରୀ ବଜାର', regex: false },
{ key: 'krushak hata', value: 'କୃଷକ ହାଟ', regex: false },
{ key: 'mela', value: 'ମେଳା', regex: false },
{ key: 'pauti', value: 'ପାଉଟି', regex: false },
{ key: 'kraya', value: 'କ୍ରୟ', regex: false },
{ key: 'byabasaye', value: 'ବ୍ୟବସାୟୀ', regex: false },
{ key: 'license', value: 'ଲାଇସେନ୍ସ', regex: false },
{ key: 'koro', value: 'କର', regex: false },
{ key: 'chukti', value: 'ଚୁକ୍ତି', regex: false },
{ key: 'mano', value: 'ମଣ', regex: false },
{ key: 'card', value: 'କାର୍ଡ଼', regex: false },

{ key: 'sero', value: 'ସେର', regex: false },
{ key: 'adha', value: 'ଅଧା', regex: false },
{ key: 'pauni', value: 'ପାଉଣି', regex: false },
{ key: 'kuncha', value: 'କୁଞ୍ଚା', regex: false },
{ key: 'muthi', value: 'ମୁଠି', regex: false },
{ key: 'ona', value: 'ଅଣା', regex: false },
{ key: 'gada', value: 'ଗଦା', regex: false },
{ key: 'droni', value: 'ଦ୍ରୋଣୀ', regex: false },
{ key: 'khondi', value: 'ଖଣ୍ଡି', regex: false },
{ key: 'tula', value: 'ତୁଳା', regex: false },
{ key: 'bhari', value: 'ଭାରି', regex: false },
{ key: 'patha', value: 'ପାଠା', regex: false },
{ key: 'kudaba', value: 'କୁଡ଼ବ', regex: false },
{ key: 'prastha', value: 'ପ୍ରସ୍ଥ', regex: false },
{ key: 'nali', value: 'ନାଳି', regex: false },
{ key: 'krosa', value: 'କ୍ରୋଶ', regex: false },
{ key: 'danda', value: 'ଦଣ୍ଡ', regex: false },

{ key: 'lobha', value: 'ଲୋଭ', regex: false },
{ key: 'bipod', value: 'ବିପଦ', regex: false },
{ key: 'bhoji', value: 'ଭୋଜି', regex: false },
{ key: 'oti', value: 'ଅତି', regex: false },

{ key: 'dui', value: 'ଦୁଇ', regex: false },
{ key: 'tini', value: 'ତିନି', regex: false },
{ key: 'chari', value: 'ଚାରି', regex: false },
{ key: 'pancha', value: 'ପାଞ୍ଚ', regex: false },
{ key: 'chho', value: 'ଛଅ', regex: false },
{ key: 'sata', value: 'ସାତ', regex: false },
{ key: 'atho', value: 'ଆଠ', regex: false },
{ key: 'noa', value: 'ନଅ', regex: false },
{ key: 'dasa', value: 'ଦଶ', regex: false },
{ key: 'egara', value: 'ଏଗାର', regex: false },
{ key: 'baara', value: 'ବାର', regex: false },
{ key: 'tera', value: 'ତେର', regex: false },
{ key: 'chaudo', value: 'ଚଉଦ', regex: false },
{ key: 'pondor', value: 'ପନ୍ଦର', regex: false },
{ key: 'sohola', value: 'ଷୋହଳ', regex: false },
{ key: 'sator', value: 'ସତର', regex: false },
{ key: 'athara', value: 'ଅଠର', regex: false },
{ key: 'uneisi', value: 'ଉଣେଇଶି', regex: false },
{ key: 'kodie', value: 'କୋଡ଼ିଏ', regex: false },
{ key: 'ekoisi', value: 'ଏକୋଇଶି', regex: false },
{ key: 'baisi', value: 'ବାଇଶି', regex: false },
{ key: 'teisi', value: 'ତେଇଶି', regex: false },
{ key: 'chabisi', value: 'ଚବିଶି', regex: false },
{ key: 'pochisi', value: 'ପଚିଶି', regex: false },
{ key: 'chhobisi', value: 'ଛବିଶି', regex: false },
{ key: 'sotaisi', value: 'ସତାଇଶି', regex: false },
{ key: 'athaisi', value: 'ଅଠାଇଶି', regex: false },
{ key: 'unatirisi', value: 'ଅଣତିରିଶି', regex: false },
{ key: 'tirisi', value: 'ତିରିଶି', regex: false },
{ key: 'ektirisi', value: 'ଏକତିରିଶି', regex: false },
{ key: 'botisi', value: 'ବତିଶି', regex: false },
{ key: 'tetisi', value: 'ତେତିଶି', regex: false },
{ key: 'chautirisi', value: 'ଚଉତିରିଶି', regex: false },
{ key: 'ponchatirisi', value: 'ପଞ୍ଚତିରିଶି', regex: false },
{ key: 'chhotisi', value: 'ଛତିଶି', regex: false },
{ key: 'saintirisi', value: 'ସଇଁତିରିଶି', regex: false },
{ key: 'athatirisi', value: 'ଅଠତିରିଶି', regex: false },
{ key: 'unachalisi', value: 'ଉଣଚାଳିଶି', regex: false },
{ key: 'chalisi', value: 'ଚାଳିଶି', regex: false },
{ key: 'ekachalisi', value: 'ଏକଚାଳିଶି', regex: false },
{ key: 'bayalisi', value: 'ବୟାଳିଶି', regex: false },
{ key: 'teyalisi', value: 'ତେୟାଳିଶି', regex: false },
{ key: 'chauralisi', value: 'ଚଉରାଳିଶି', regex: false },
{ key: 'ponchalisi', value: 'ପଞ୍ଚଚାଳିଶି', regex: false },
{ key: 'chayalisi', value: 'ଛୟାଳିଶି', regex: false },
{ key: 'sotochalisi', value: 'ସତଚାଳିଶି ', regex: false },
{ key: 'athachalisi', value: 'ଅଠଚାଳିଶି ', regex: false },
{ key: 'unachaso', value: 'ଅଣଚାଶ', regex: false },
{ key: 'pochaso', value: 'ପଚାଶ', regex: false },
{ key: 'ekabana', value: 'ଏକାବନ', regex: false },
{ key: 'babana', value: 'ବାବନ', regex: false },
{ key: 'tepana', value: 'ତେପନ', regex: false },
{ key: 'chaubana', value: 'ଚଉବନ', regex: false },
{ key: 'pochabana', value: 'ପଞ୍ଚାବନ', regex: false },
{ key: 'chhopana', value: 'ଛପନ', regex: false },
{ key: 'sotabona', value: 'ସତାବନ', regex: false },
{ key: 'athabana', value: 'ଅଠାବନ', regex: false },
{ key: 'unasathi', value: 'ଅଣଷଠି', regex: false },
{ key: 'sathie', value: 'ଷାଠିଏ', regex: false },
{ key: 'ekosothi', value: 'ଏକଷଠି', regex: false },
{ key: 'basothi', value: 'ବାଷଠି', regex: false },
{ key: 'tesothi', value: 'ତେଷଠି', regex: false },
{ key: 'chousothi', value: 'ଚଉଷଠି', regex: false },
{ key: 'ponchasothi', value: 'ପଞ୍ଚଷଠି', regex: false },
{ key: 'chhasothi', value: 'ଛଅଷଠି ', regex: false },
{ key: 'sotosothi', value: 'ସତଷଠି ', regex: false },
{ key: 'athasathi', value: 'ଅଠଷଠି ', regex: false },
{ key: 'unastari', value: 'ଅଣସ୍ତରି', regex: false },
{ key: 'saturi', value: 'ସତୁରି', regex: false },
{ key: 'ekostari', value: 'ଏକସ୍ତରି', regex: false },
{ key: 'bastari', value: 'ବାସ୍ତରି', regex: false },
{ key: 'testari', value: 'ତେସ୍ତରି', regex: false },
{ key: 'chaustari', value: 'ଚଉସ୍ତରି', regex: false },
{ key: 'ponchstari', value: 'ପଞ୍ଚସ୍ତରି', regex: false },
{ key: 'chhostari', value: 'ଛସ୍ତରି', regex: false },
{ key: 'satastari', value: 'ସତସ୍ତରି', regex: false },
{ key: 'athostori', value: 'ଅଠସ୍ତରି', regex: false },
{ key: 'anaasi', value: 'ଅଣାଅଶୀ', regex: false },
{ key: 'ashii', value: 'ଅଶୀ', regex: false },
{ key: 'ekaashi', value: 'ଏକାଅଶୀ', regex: false },
{ key: 'bayaashi', value: 'ବୟାଅଶୀ', regex: false },
{ key: 'teyaashi', value: 'ତେୟାଅଶୀ', regex: false },
{ key: 'chauraashi', value: 'ଚୌରାଅଶୀ', regex: false },
{ key: 'ponchaashi', value: 'ପଞ୍ଚାଅଶୀ', regex: false },
{ key: 'chhayaashi', value: 'ଛୟାଅଶୀ', regex: false },
{ key: 'sotaashi', value: 'ସତାଅଶୀ', regex: false },
{ key: 'othaashi', value: 'ଅଠାଅଶୀ', regex: false },
{ key: 'ananobe', value: 'ଅଣାନବେ', regex: false },
{ key: 'nobe', value: 'ନବେ', regex: false },
{ key: 'ekanobe', value: 'ଏକାନବେ', regex: false },
{ key: 'bayanobe', value: 'ବୟାନବେ', regex: false },
{ key: 'teyanobe', value: 'ତେୟାନବେ', regex: false },
{ key: 'chauranobe', value: 'ଚଉରାନବେ', regex: false },
{ key: 'panchanobe', value: 'ପଞ୍ଚାନବେ', regex: false },
{ key: 'chhayanobe', value: 'ଛୟାନବେ', regex: false },
{ key: 'satanobe', value: 'ସତାନବେ', regex: false },
{ key: 'athanobe', value: 'ଅଠାନବେ', regex: false },
{ key: 'aneswota', value: 'ଅନେଶ୍ବତ', regex: false },
{ key: 'sohe', value: 'ଶହେ', regex: false },
{ key: 'puri', value: 'ପୁରୀ', regex: false },
{ key: 'jagannath', value: 'ଜଗନ୍ନାଥ', regex: false },
{ key: 'subhadra', value: 'ସୁଭଦ୍ରା', regex: false },

{ key: 'balabhadra', value: 'ବଳଭଦ୍ର', regex: false },
{ key: 'geeta', value: 'ଗୀତା', regex: false },
{ key: 'ramayana', value: 'ରାମାୟଣ', regex: false },
{ key: 'mahabharata', value: 'ମହାଭାରତ', regex: false },
{ key: 'bhagabad', value: 'ଭଗବଦ୍', regex: false },
{ key: 'sanskrit', value: 'ସଂସ୍କୃତ', regex: false },
{ key: 'odia', value: 'ଓଡ଼ିଆ', regex: false },
{ key: 'bhasha', value: 'ଭାଷା', regex: false },
{ key: 'lipi', value: 'ଲିପି', regex: false },
{ key: 'kabi', value: 'କବି', regex: false },
{ key: 'kavita', value: 'କବିତା', regex: false },
{ key: 'gana', value: 'ଗାନ', regex: false },
{ key: 'nrutya', value: 'ନୃତ୍ୟ', regex: false },
{ key: 'nrutya', value: 'ନୃତ୍ୟ', regex: false },
//{ key: 'phone', value: 'ଫୋନେ', regex: false },
//{ key: 'tic', value: 'ଟିକ', regex: false },

{ key: 'nataka', value: 'ନାଟକ', regex: false },
{ key: 'abhinaya', value: 'ଅଭିନୟ', regex: false },
{ key: 'chitra', value: 'ଚିତ୍ର', regex: false },
{ key: 'kalā', value: 'କଳା', regex: false },
{ key: 'shilpa', value: 'ଶିଳ୍ପ', regex: false },
{ key: 'murti', value: 'ମୂର୍ତି', regex: false },
{ key: 'pratima', value: 'ପ୍ରତିମା', regex: false },
{ key: 'utsava', value: 'ଉତ୍ସବ', regex: false },
{ key: 'parba', value: 'ପର୍ବ', regex: false },
{ key: 'dola', value: 'ଦୋଳ', regex: false },
{ key: 'holi', value: 'ହୋଳୀ', regex: false },
{ key: 'diwali', value: 'ଦିବାଳୀ', regex: false },
{ key: 'dussehra', value: 'ଦଶହରା', regex: false },
{ key: 'saraswati', value: 'ସରସ୍ଵତୀ', regex: false },
{ key: 'laxmi', value: 'ଲକ୍ଷ୍ମୀ', regex: false },
{ key: 'siva', value: 'ଶିବ', regex: false },


{ key: 'brahma', value: 'ବ୍ରହ୍ମା', regex: false },
{ key: 'hanuman', value: 'ହନୁମାନ', regex: false },
{ key: 'rama', value: 'ରାମ', regex: false },
{ key: 'krishna', value: 'କୃଷ୍ଣ', regex: false },
{ key: 'buddha', value: 'ବୁଦ୍ଧ', regex: false },
{ key: 'joina', value: 'ଜୖେନ', regex: false },
{ key: 'mahavira', value: 'ମହାବୀର', regex: false },
{ key: 'sikh', value: 'ଶିଖ', regex: false },
{ key: 'jesus', value: 'ଯୀଶୁ', regex: false },
{ key: 'islam', value: 'ଇସ୍-ଲାମ୍', regex: false },
{ key: 'quran', value: 'କୋରାନ', regex: false },
{ key: 'allah', value: 'ଅଲ୍ଲାହ', regex: false },
{ key: 'typing', value: 'ଟାଇପିଙ୍ଗ୍', regex: false },
{ key: 'pastor', value: 'ପାଷ୍ଟର୍', regex: false },
{ key: 'tora', value: 'ତୋର', regex: false },
//{ key: 'st', value: 'ଷ୍ଟ', regex: false },
{ key: 'biscute', value: 'ବିସ୍କୁଟ୍', regex: false },
{ key: 'masiha', value: 'ମସିହା', regex: false },
{ key: 'company', value: 'କମ୍ପାନୀ', regex: false },
{ key: 'east', value: 'ଇଷ୍ଟ', regex: false },
{ key: 'odisha', value: 'ଓଡ଼ିଶା', regex: false },
{ key: 'Esti', value: 'ଇଷ୍ଟି', regex: false },
{ key: 'bhasa', value: 'ଭାଷା', regex: false },
{ key: 'bhasi', value: 'ଭାଷୀ', regex: false },
{ key: 'bhitika', value: 'ଭିତ୍ତିକ', regex: false },
{ key: 'pradesh', value: 'ପ୍ରଦେଶ', regex: false },
{ key: 'nathila', value: 'ନଥିଲା', regex: false },
{ key: 'misai', value: 'ମିଶାଇ', regex: false },
{ key: 'gotie', value: 'ଗୋଟିଏ', regex: false },
{ key: 'gotei', value: 'ଗୋଟେଇ', regex: false },
{ key: 'presidency', value: 'ପ୍ରେସିଡେନ୍ସି', regex: false },
{ key: 'misi', value: 'ମିଶି', regex: false },
{ key: 'gale', value: 'ଗଲେ', regex: false },
{ key: 'rakhuchi', value: 'ରଖୁଛି', regex: false },
{ key: 'jatha', value: 'ଯଥା', regex: false },
{ key: 'adi', value: 'ଆଦି', regex: false },
{ key: 'rahila', value: 'ରହିଲା', regex: false },
{ key: 'belaku', value: 'ବେଳକୁ', regex: false },
{ key: 'social', value: 'ସୋସିଆଲ୍', regex: false },
{ key: 'media', value: 'ମିଡିଆ', regex: false },
{ key: 'rajadhani', value: 'ରାଜଧାନି', regex: false },
{ key: 'collage', value: 'କଲେଜ', regex: false },
{ key: 'jeevan', value: 'ଜୀବନ', regex: false },
{ key: 'kandhuni', value: 'କନ୍ଧୁଣୀ', regex: false },
{ key: 'tadrupa', value: 'ତଦ୍ରୁପ', regex: false },


{ key: 'communication', value: 'କମ୍ୟୁନିକେସନ୍', regex: false },
{ key: 'kalia', value: 'କାଳିଆ', regex: false },
{ key: 'balmiki', value: 'ବାଲ୍ମୀକି', regex: false },
{ key: 'rabana', value: 'ରାବଣ', regex: false },
{ key: 'laxman', value: 'ଲକ୍ଷ୍ମଣ', regex: false },
{ key: 'sita', value: 'ସୀତା', regex: false },
{ key: 'alu', value: 'ଆଳୁ', regex: false },
{ key: 'tahinre', value: 'ତାହିଁରେ', regex: false },
{ key: 'pod', value: 'ପଡ଼', regex: false },
{ key: 'uparistha', value: 'ଉପରିସ୍ଥ', regex: false },
{ key: 'urmila', value: 'ଊର୍ମିଳା', regex: false },
{ key: 'likhit', value: 'ଲିଖିତ', regex: false },
{ key: 'ullikhit', value: 'ଉଲ୍ଲିଖିତ', regex: false },
{ key: 'unnit', value: 'ଉନ୍ନୀତ', regex: false },
{ key: 'udhrut', value: 'ଉଦ୍ଧୃତ', regex: false },

{ key: 'padil', value: 'ପଡ଼ିଲ', regex: false },

{ key: 'podib', value: 'ପଡ଼ିବ', regex: false },
{ key: 'had', value: 'ହାଡ଼', regex: false },
{ key: 'khaila', value: 'ଖାଇଲା', regex: false },
{ key: 'pado', value: 'ପାଡ଼', regex: false },
{ key: 'dhain', value: 'ଧାଇଁ', regex: false },
{ key: 'dekhi', value: 'ଦେଖି', regex: false },
{ key: 'megha', value: 'ମେଘ', regex: false },
{ key: 'samaya', value: 'ସମୟ', regex: false },
{ key: 'salu', value: 'ସାଲୁ', regex: false },
{ key: 'hoithila', value: 'ହୋଇଥିଲା', regex: false },
{ key: 'mandraj', value: 'ମାନ୍ଦ୍ରାଜ୍', regex: false },
{ key: 'kaniganthi', value: 'କାନିଗଣ୍ଠି', regex: false },
//{ key: 'ehibhali', value: 'ଏହିଭଳି', regex: false },
{ key: 'ehi', value: 'ଏହି', regex: false },
{ key: 'khandita', value: 'ଖଣ୍ଡିତ', regex: false },
{ key: 'bikhandita', value: 'ବିଖଣ୍ଡିତ', regex: false },
{ key: 'tinoti', value: 'ତିନୋଟି', regex: false },
{ key: 'simabadha', value: 'ସିମାବଦ୍ଧ', regex: false },
{ key: 'sampurna', value: 'ସମ୍ପୂର୍ଣ୍ଣ', regex: false },
{ key: 'poradhina', value: 'ପରାଧୀନ', regex: false },
{ key: 'rahile', value: 'ରହିଲେ', regex: false },
{ key: 'bangala', value: 'ବଙ୍ଗଳା', regex: false },
{ key: 'rajaswa', value: 'ରାଜସ୍ୱ', regex: false },
{ key: 'hela', value: 'ହେଲା', regex: false },
{ key: 'sasita', value: 'ଶାସିତ', regex: false },
{ key: 'settlement', value: 'ସେଟେଲ୍ ମେଣ୍ଟ୍', regex: false },
{ key: 'cholai', value: 'ଚଳାଇ', regex: false },
{ key: 'krama', value: 'କ୍ରମ', regex: false },
{ key: 'bardhita', value: 'ବର୍ଦ୍ଧିତ', regex: false },
{ key: 'talitalanta', value: 'ତଳିତଳାନ୍ତ', regex: false },
{ key: 'dela', value: 'ଦେଲା', regex: false },
{ key: 'manadanda', value: 'ମାନଦଣ୍ଡ', regex: false },
{ key: 'sthala', value: 'ସ୍ଥଳ', regex: false },
{ key: 'sudura', value: 'ସୁଦୂର', regex: false },
{ key: 'saahitya', value: 'ସାହିତ୍ୟ', regex: false },
{ key: 'sohita', value: 'ସହିତ', regex: false },
{ key: 'kaha', value: 'କାହା', regex: false },
{ key: 'prustha', value: 'ପୃଷ୍ଠା', regex: false },
{ key: 'kali', value: 'କାଲି', regex: false },
{ key: 'kehi', value: 'କେହି', regex: false },

{ key: 'nahanti', value: 'ନାହାଁନ୍ତି', regex: false },
{ key: 'koutuka', value: 'କୌତୁକ', regex: false },
{ key: 'kailash', value: 'କୌଳାଶ', regex: false },
{ key: 'bikram', value: 'ବିକ୍ରମ', regex: false },
{ key: 'utara', value: 'ଉତ୍ତରା', regex: false },
{ key: 'aji', value: 'ଆଜି', regex: false },
{ key: 'janamile', value: 'ଜନମିଲେ', regex: false },
{ key: 'mone', value: 'ମନେ', regex: false },
{ key: 'ajaya', value: 'ଅଜୟ', regex: false },
{ key: 'singh', value: 'ସିଂ', regex: false },
{ key: 'manisha', value: 'ମଣିଷ', regex: false },
{ key: 'ethi', value: 'ଏଠି', regex: false },
{ key: 'pora', value: 'ପରା', regex: false },
{ key: 'baharichu', value: 'ବାହାରିଛୁ', regex: false },
{ key: 'baharibu', value: 'ବାହାରିବୁ', regex: false },
{ key: 'prastuta', value: 'ପ୍ରସ୍ତୁତ', regex: false },
{ key: 'nuhanti', value: 'ନୁହଁନ୍ତି', regex: false },
{ key: 'sugam', value: 'ସୁଗମ', regex: false },
{ key: 'thila', value: 'ଥିଲା', regex: false },
{ key: 'sohita', value: 'ସହିତ', regex: false },
{ key: 'bhubaneswar', value: 'ଭୁବନେଶ୍ବର', regex: false },
{ key: 'kamo', value: ' କାମ', regex: false },
{ key: 'sukho', value: 'ସୁଖ', regex: false },
{ key: 'tahara', value: 'ତାହାର', regex: false },
{ key: 'jahara', value: 'ଯାହାର ', regex: false },
{ key: 'jogauchi', value: 'ଯୋଗାଉଛି', regex: false },
{ key: 'dainika', value: 'ଦୌନିକ', regex: false },
{ key: 'tahia', value: 'ଟାହିଆ', regex: false },
{ key: 'noanka', value: 'ନଅଙ୍କ ', regex: false },
{ key: 'durbhikhya', value: 'ଦୁର୍ଭିକ୍ଷ', regex: false },
{ key: 'chorama', value: 'ଚରମ', regex: false },
{ key: 'boram', value: 'ବରଂ', regex: false },
{ key: 'sasana', value: 'ଶାସନ', regex: false },
{ key: 'tumbhe', value: 'ତୁମ୍ଭେ', regex: false },
{ key: 'khojucha', value: 'ଖୋଜୁଛ', regex: false },
{ key: 'nirmama', value: 'ନିର୍ମମ', regex: false },
{ key: 'jogun', value: 'ଯୋଗୁଁ', regex: false },
{ key: 'masani', value: 'ମଶାଣି', regex: false },
{ key: 'poda', value: 'ପଦା', regex: false },
{ key: 'porinata', value: 'ପରିଣତ', regex: false },
{ key: 'bonde', value: 'ବନ୍ଦେ', regex: false },
{ key: 'grosto', value: 'ଗ୍ରସ୍ତ', regex: false },
{ key: 'kranto', value: 'କ୍ରାନ୍ତ', regex: false },
{ key: 'bondai', value: 'ବନ୍ଦଇ', regex: false },
{ key: 'kanto', value: 'କାନ୍ତ', regex: false },
{ key: 'abhayabara', value: 'ଅଭୟବର', regex: false },
{ key: 'masa', value: 'ମାସ', regex: false },
{ key: 'dyantu', value: 'ଦ୍ୟନ୍ତୁ', regex: false },
{ key: 'kumor', value: 'କୁମର', regex: false },
{ key: 'madhye', value: 'ମଧ୍ୟେ', regex: false },
{ key: 'madhy', value: 'ମଧ୍ୟ', regex: false },
{ key: 'atai', value: 'ଅଟଇ', regex: false },
{ key: 'baharo', value: 'ବାହାର', regex: false },
{ key: 'baha', value: 'ବାହା', regex: false },
{ key: 'nuhe', value: 'ନୁହେଁ', regex: false },
{ key: 'bali', value: 'ବାଲି', regex: false },
{ key: 'hoi', value: 'ହୋଇ', regex: false },
{ key: 'bosanta', value: 'ବସନ୍ତ', regex: false },
{ key: 'ponchomi', value: 'ପଞ୍ଚମୀ', regex: false },
{ key: 'bolai', value: 'ବୋଲାଇ', regex: false },
{ key: 'balaban', value:'ବଳବାନ', regex: false },
{ key: 'miligram', value:'ମିଲିଗ୍ରାମ୍', regex: false },
{ key: 'gram', value:'ଗ୍ରାମ୍', regex: false },
{ key: 'sentigram', value:'ସେଣ୍ଟିଗ୍ରାମ୍', regex: false },
{ key: 'dokagram', value:'ଡ଼ୋକାଗ୍ରାମ୍', regex: false },
{ key: 'hectogram', value:'ହେକ୍ଟୋଗ୍ରାମ୍', regex: false },
{ key: 'kilogram', value:'କିଲୋଗ୍ରାମ୍', regex: false },
{ key: 'miriagram', value:'ମିରିଆଗ୍ରାମ୍', regex: false },
{ key: 'quintal', value:'କୁଇଣ୍ଟାଲ୍', regex: false },
{ key: 'sahasra', value:'ସହସ୍ର', regex: false },
{ key: 'ayuta', value:'ଅୟୁତ', regex: false },
{ key: 'koti', value:'କୋଟି', regex: false },
{ key: 'arbuda', value:'ଅର୍ବୁଦ', regex: false },
{ key: 'brunda', value:'ବୃନ୍ଦ', regex: false },
{ key: 'kharba', value:'ଖର୍ବ', regex: false },
{ key: 'sankha', value:'ଶଙ୍ଖ', regex: false },
{ key: 'sankhe', value:'ଶଙ୍ଖେ', regex: false },
{ key: 'podmo', value:'ପଦ୍ମ', regex: false },
{ key: 'sagar', value:'ସାଗର', regex: false },
{ key: 'anta', value:'ଅନ୍ତ', regex: false },
{ key: 'mahatma', value:'ମହାତ୍ମା', regex: false },
{ key: 'gandhi', value:'ଗାନ୍ଧୀ', regex: false },
{ key: 'priyanka', value:'ପ୍ରିୟଙ୍କା', regex: false },
{ key: 'th', value:'ଥ', regex: false },
{ key: 'thamas', value:'ଥମାସ ', regex: false },
{ key: 'rajanaitika', value:'ରାଜନୖତିକ', regex: false },
{ key: 'parti', value:'ପାର୍ଟି', regex: false },
{ key: 'bonti', value:'ବଣ୍ଟି', regex: false },
{ key: 'bhoka', value:'ଭୋକ', regex: false },

{ key: 'october', value:'ଅକ୍ଟୋବର', regex: false },
{ key: 'november', value:'ନଭେମ୍ବର', regex: false },
{ key: 'may', value:'ମଇ', regex: false },
{ key: 'sampati', value:'ସମ୍ପତ୍ତି', regex: false },
{ key: 'tarikha', value:'ତାରିଖ', regex: false },
{ key: 'gujurat', value:'ଗୁଜୁରାଟ', regex: false },
{ key: 'poro', value:'ପୋର', regex: false },
{ key: 'bandar', value:'ବନ୍ଦର', regex: false },
{ key: 'thile', value:'ଥିଲେ', regex: false },
{ key: 'chand', value:'ଚାନ୍ଦ', regex: false },
{ key: 'mohan', value:'ମୋହନ', regex: false },
{ key: 'tapore', value:'ତାପରେ', regex: false },
{ key: 'ade', value:'ଆଡ଼େ', regex: false },
{ key: 'sunib', value:'ଶୁଣିବ', regex: false },
{ key: 'bilata', value:'ବିଲାତ', regex: false },
{ key: 'sachiba', value:' ସଚିବ', regex: false },
{ key: 'north', value:'ନର୍ଥ', regex: false },
{ key: 'kote', value:'କୋଟ୍', regex: false },
{ key: 'anka', value:'ଅଙ୍କ', regex: false },
{ key: 'kolikota', value:'କାଲିକତା', regex: false },
{ key: 'janile', value:'ଜାଣିଲେ', regex: false },
{ key: 'samasya', value:'ସମସ୍ୟା', regex: false },
{ key: 'sankata', value:'ସଙ୍କଟ', regex: false },
{ key: 'prati', value:'ପ୍ରତି', regex: false },
{ key: 'drusti', value:'ଦୃଷ୍ଟି', regex: false },
{ key: 'khy', value:'କ୍ଷ', regex: false },
{ key: 'aii', value:'ଆଈ', regex: false },
{ key: 'iso', value:'ଈଶ', regex: false },
{ key: 'eko', value:'ଏକ', regex: false },
{ key: 'oto', value:'ଓଟ', regex: false },
{ key: 'ghoto', value:'ଘଟ', regex: false },
{ key: 'pocho', value:'ପଛ', regex: false },
{ key: 'ago', value:'ଆଗ', regex: false },
{ key: 'chaka', value:'ଚକ', regex: false },
{ key: 'chhaka', value:'ଛକ', regex: false },
{ key: 'jolo', value:'ଜଳ', regex: false },
{ key: 'sayana', value:'ଶୟନ', regex: false },
{ key: 'dhana', value:'ଧାନ', regex: false },
{ key: 'dhon', value:'ଧନ', regex: false },
{ key: 'dhoro', value:'ଧର', regex: false },
{ key: 'holo', value:'ହଳ', regex: false },
{ key: 'pilati', value:'ପିଲା', regex: false },
{ key: 'hoso', value:'ହସ', regex: false },
{ key: 'jede', value:'ଯେଡ଼େ', regex: false },
{ key: 'tede', value:'ତେଡ଼େ', regex: false },
{ key: 'sede', value:'ସେଡ଼େ', regex: false },
{ key: 'baunsha', value:'ବାଉଁଶ', regex: false },
{ key: 'pol', value:'ପୋଲ', regex: false },

{ key: 'Balliguda', value:'ବାଲିଗୁଡ଼ା', regex: false },
{ key: 'Jamajhari', value:'ଜମଝରି', regex: false },
{ key: 'total', value:'ମୋଟ', regex: false },
{ key: 'Khajuri', value:'ଖଜୁରୀ', regex: false },
{ key: 'pada', value:'ପଡ଼ା', regex: false },

{ key: 'mlahupanga', value:'ମ୍ଳାହୁପାଙ୍ଗା', regex: false },
{ key: 'abhinas', value:'ଅଭିନାଶ', regex: false },
{ key: 'manas', value:'ମାନସ', regex: false },
{ key: 'banita', value:'ବନିତା', regex: false },
{ key: 'sambidhana', value:'ସମ୍ବିଧାନ', regex: false },
{ key: 'uddhara', value:'ଉଦ୍ଧାର', regex: false },
{ key: 'sudhari', value:'ସୁଧାରି', regex: false },
{ key: 'pheria', value:'ଫେରିଆ', regex: false },
{ key: 'doya', value:'ଦୟା', regex: false },
{ key: 'dhoi', value:'ଧୋଇ', regex: false },
{ key: 'photoka', value:'ଫୋଟକା', regex: false },
{ key: 'pataka', value:'ପତକା', regex: false },
{ key: 'accepted', value: 'ଗ୍ରହଣ କଲା', regex: false },
{ key: 'dharitri', value: 'ଧରିତ୍ରୀ', regex: false },
{ key: 'praja', value: 'ପ୍ରଜା', regex: false },
{ key: 'premeya', value: 'ପ୍ରମେୟ', regex: false },
{ key: 'premeya', value: 'ପ୍ରମେୟ', regex: false },
{ key: 'sambad', value: 'ସମ୍ବାଦ', regex: false },
{ key: 'pragativadi', value: 'ପ୍ରଗତିବାଦୀ', regex: false },
{ key: 'express', value: 'ଏକ୍ସପ୍ରେସ୍', regex: false },
{ key: 'bhaskar', value: 'ଭାଷ୍କର', regex: false },
{ key: 'surya', value: 'ସୂର୍ଯ୍ୟ', regex: false },
{ key: 'surjya', value: 'ସୂର୍ଯ୍ୟ', regex: false },

{ key: 'prabha', value: 'ପ୍ରଭା', regex: false },
{ key: 'pratidin', value: 'ପ୍ରତିଦିନ', regex: false },
{ key: 'dinalipi', value: 'ଦିନଲିପି', regex: false },
{ key: 'anupam', value: 'ଅନୁପମ', regex: false },
{ key: 'orissa', value: ' ଓଡ଼ିଶା', regex: false },
{ key: 'times', value: 'ଟାଇମସ', regex: false },
{ key: 'khabar', value: 'ଖବର', regex: false },
{ key: 'dansana', value: 'ଦଂଶନ', regex: false },
{ key: 'teerth', value: 'ତୀର୍ଥ', regex: false },
{ key: 'khetra', value: 'କ୍ଷେତ୍ର', regex: false },
{ key: 'samachar', value: 'ସାମାଗ୍ଭର', regex: false },
{ key: 'tanki', value: 'ଟାଙ୍କି', regex: false },

{ key: 'tonka', value: 'ଟଙ୍କା', regex: false },

{ key: 'shramika', value: 'ଶ୍ରମିକ', regex: false },
{ key: 'samrat', value: 'ସମ୍ରାଟ', regex: false },
{ key: 'padma', value: 'ପଦ୍ମ', regex: false },
{ key: 'smarana', value: 'ସ୍ମରଣ', regex: false },
{ key: 'smaranika', value: 'ସ୍ମରଣୀକା', regex: false },
{ key: 'chadma', value: 'ଛଦ୍ମ', regex: false },
{ key: 'usma', value: 'ଉଷ୍ମ', regex: false },
{ key: 'smasana', value: 'ଶ୍ମଶାନ', regex: false },
//{ key: 'brahmana', value: 'ବ୍ରାହ୍ମଣ', regex: false },
{ key: 'sammati', value: 'ସମ୍ମତି', regex: false },
{ key: 'akasmat', value: 'ଆକସ୍ମାତ', regex: false },
{ key: 'rashmi', value: 'ରଶ୍ମି', regex: false },
{ key: 'murkha', value: 'ମୁର୍ଖ', regex: false },
{ key: 'karkash', value: 'କର୍କଶ', regex: false },
{ key: 'karpura', value: 'କର୍ପୁର', regex: false },
{ key: 'karpura', value: 'କର୍ପୁର', regex: false },
{ key: 'durjana', value: 'ଦୁର୍ଜନ', regex: false },
{ key: 'durnama', value: 'ଦୁର୍ନାମ', regex: false },
{ key: 'byarth', value: 'ବ୍ୟର୍ଥ', regex: false },
{ key: 'garjan', value: 'ଗର୍ଜନ', regex: false },
{ key: 'tark', value: 'ତର୍କ', regex: false },
{ key: 'barsika', value: 'ବାର୍ଷିକ', regex: false },
{ key: 'chuti', value: ' ଛୁଟି', regex: false },
{ key: 'nirjan', value: 'ନିର୍ଜନ', regex: false },
{ key: 'durjan', value: 'ଦୁର୍ଜନ', regex: false },
{ key: 'darpa', value: 'ଦର୍ପ', regex: false },
{ key: 'jibo', value: 'ଯିବ', regex: false },



//{ key: 'nta', value: 'ନ୍ତ', regex: false },

//{ key: 'nk', value: 'ଙ୍କ', regex: false },
//{ key: 'nkho', value: 'ଙ୍ଖ', regex: false },
//{ key: 'ng', value: 'ଙ୍ଗ', regex: false },
// { key: 'ngho', value: 'ଙ୍ଘ', regex: false },
//{ key: 'nj', value: 'ଞ୍ଜ', regex: false },
//{ key: 'njho', value: 'ଞ୍ଝ', regex: false },
//{ key: 'nch', value: 'ଞ୍ଚ', regex: false },

//{ key: 'nt', value: 'ଣ୍ଟ', regex: false },
//{ key: 'rsh', value: 'ର୍ଶ', regex: false },




//{ key: 'mananka', value: 'ମାନଙ୍କ', regex: false },

//{ key: 'kr', value: 'କ୍ର', regex: false },
//{ key: 'khr', value: 'ଖ୍ର', regex: false },
//{ key: 'gr', value: 'ଗ୍ର', regex: false },
//{ key: 'ghr', value: 'ଘ୍ର', regex: false },
//{ key: 'chr', value: 'ଚ୍ର', regex: false },
//{ key: 'chhr', value: 'ଛ୍ର', regex: false },
//{ key: 'jr', value: 'ଜ୍ର', regex: false },
//{ key: 'jhr', value: 'ଝ୍ର', regex: false },
//{ key: 'tr', value: 'ତ୍ର', regex: false },
//{ key: 'thr', value: 'ଥ୍ର', regex: false },
//{ key: 'dr', value: 'ଦ୍ର', regex: false },
//{ key: 'dhr', value: 'ଧ୍ର', regex: false },
//{ key: 'nr', value: 'ନ୍ର', regex: false },
//{ key: 'pr', value: 'ପ୍ର', regex: false },
//{ key: 'phr', value: 'ଫ୍ର', regex: false },
//{ key: 'br', value: 'ବ୍ର', regex: false },
//{ key: 'bhr', value: 'ଭ୍ର', regex: false },
//{ key: 'mr', value: 'ମ୍ର', regex: false },
//{ key: 'sr', value: 'ସ୍ର', regex: false },
//{ key: 'shr', value: 'ଶ୍ର', regex: false },


//{ key: 'kru', value: 'କୃ', regex: false },
//{ key: 'khru', value: 'ଖୃ', regex: false },
//{ key: 'gru', value: 'ଗୃ', regex: false },
//{ key: 'ghru', value: 'ଘୃ', regex: false },
//{ key: 'chru', value: '', regex: false },
//{ key: 'chhru', value: 'ଛ୍ର', regex: false },
//{ key: 'jru', value: 'ଯୄ', regex: false },
//{ key: 'jhru', value: 'ଝ୍ର', regex: false },
//{ key: 'tru', value: 'ତୃ', regex: false },
//{ key: 'thru', value: 'ଥ୍ର', regex: false },
//{ key: 'dru', value: 'ଦ୍ଦୃ', regex: false },
//{ key: 'dhru', value: 'ଧୃ', regex: false },
//{ key: 'nru', value: 'ନୃ', regex: false },
//{ key: 'pru', value: 'ପୃ', regex: false },
//{ key: 'phru', value: 'ଫ୍ର', regex: false },
//{ key: 'bru', value: 'ବୃ', regex: false },
{ key: 'bhru', value: 'ଭୃ', regex: false },
{ key: 'mru', value: 'ମୃ', regex: false },
//{ key: 'sru', value: 'ସୃ', regex: false },
//{ key: 'shru', value: 'ଶୃ', regex: false },

//{ key: 'shru', value: 'ଶ୍ର', regex: false },
{ key: 'bh', value: 'ଭ', regex: false },
{ key: 'saga', value: 'ଶାଗ', regex: false },
{ key: 'shrusti', value: 'ଶୃଷ୍ଟି', regex: false },
{ key: 'ponos', value: 'ପଣସ', regex: false },


//{ key: 'kn', value: '', regex: false },
//{ key: 'khn', value: 'ଖ୍ର', regex: false },
//{ key: 'gn', value: 'ଗ୍ର', regex: false },
//{ key: 'ghn', value: 'ଘ୍ର', regex: false },
//{ key: 'chn', value: 'ଚ୍ର', regex: false },
//{ key: 'chhn', value: 'ଛ୍ର', regex: false },
//{ key: 'jn', value: 'ଜ୍ର', regex: false },
//key: 'jhn', value: 'ଝ୍ର', regex: false },
//{ key: 'tn', value: 'ତ୍ର', regex: false },
//{ key: 'thn', value: 'ଥ୍ର', regex: false },
//{ key: 'dn', value: 'ଦ୍ର', regex: false },
//{ key: 'dhn', value: 'ଧ୍ର', regex: false },
//{ key: 'nn', value: 'ନ୍ର', regex: false },
//{ key: 'pn', value: 'ପ୍ର', regex: false },
//{ key: 'phn', value: 'ଫ୍ର', regex: false },
//{ key: 'bn', value: 'ବ୍ର', regex: false },
//{ key: 'bhn', value: 'ଭ୍ର', regex: false },
//{ key: 'mn', value: 'ମ୍ର', regex: false },
//{ key: 'sn', value: 'ସ୍ର', regex: false },
//{ key: 'shn', value: 'ଶ୍ର', regex: false },




//{ key: 'kn', value: 'କ୍ନ', regex: false },
//{ key: 'khn', value: 'ଖ୍ନ', regex: false },
//{ key: 'gn', value: 'ଗ୍ନ', regex: false },
//{ key: 'ghn', value: 'ଘ୍ନ', regex: false },
////{ key: 'chn', value: 'ଚ୍ନ', regex: false },
//{ key: 'chhn', value: 'ଛ୍ନ', regex: false },
//{ key: 'jn', value: 'ଜ୍ନ', regex: false },
//key: 'jhn', value: 'ଝ୍ନ', regex: false },
//{ key: 'tn', value: 'ତ୍ନ', regex: false },
//{ key: 'thn', value: 'ଥ୍ନ', regex: false },
//{ key: 'dn', value: 'ଦ୍ନ', regex: false },
//{ key: 'dhn', value: ' ଧ୍ନ', regex: false },
//{ key: 'nn', value: ' ନ୍ନ', regex: false },
//{ key: 'pn', value: 'ପ୍ନ', regex: false },
//{ key: 'phn', value: 'ଫ୍ନ', regex: false },
//{ key: 'bn', value: 'ବ୍ନ', regex: false },
//{ key: 'bhn', value: 'ଭ୍ନ', regex: false },
//{ key: 'mn', value: 'ମ୍ନ', regex: false },
//{ key: 'sn', value: 'ସ୍ନ', regex: false },
//{ key:'shn', value:'ଶ୍ନ', regex: false },
//{ key:'prashna', value:'ପ୍ରଶ୍ନ', regex: false },





//{ key: 'klo', value: 'କ୍ଳ', regex: false },
//{ key: 'khlo', value: 'ଖ୍ଳ', regex: false },
//{ key: 'glo', value: 'ଗ୍ଳ', regex: false },
//{ key: 'ghlo', value: 'ଘ୍ଳ', regex: false },
//{ key: 'chlo', value: 'ଚ୍ଳ', regex: false },
//{ key: 'chhlo', value: 'ଛ୍ଳ', regex: false },
//{ key: 'jlo', value: 'ଜ୍ଳ', regex: false },
//{ key: 'jhlo', value: 'ଝ୍ଳ', regex: false },
//{ key: 'tlo', value: 'ତ୍ଳ', regex: false },
//{ key: 'thlo', value: 'ଥ୍ଳ', regex: false },
//{ key: 'dlo', value: 'ଦ୍ଳ', regex: false },
//{ key: 'dhlo', value: 'ଧ୍ଳ', regex: false },
//{ key: 'nlo', value: 'ନ୍ଳ', regex: false },
//{ key: 'plo', value: 'ପ୍ଳ', regex: false },
//{ key: 'phlo', value: 'ଫ୍ଳ', regex: false },
//{ key: 'blo', value: 'ବ୍ଳ', regex: false },
//{ key: 'bhlo', value: 'ଭ୍ଳ', regex: false },
//{ key: 'mlo', value: 'ମ୍ଳ', regex: false },
//{ key: 'slo', value: 'ସ୍ଳ', regex: false },
//{ key: 'shlo', value: 'ଶ୍ଳ', regex: false },



//{ key: 'kn', value: '', regex: false },
//{ key: 'khn', value: 'ଖ୍ର', regex: false },
//{ key: 'gn', value: 'ଗ୍ର', regex: false },
//{ key: 'ghn', value: 'ଘ୍ର', regex: false },
//{ key: 'chn', value: 'ଚ୍ର', regex: false },
//{ key: 'chhn', value: 'ଛ୍ର', regex: false },
//{ key: 'jn', value: 'ଜ୍ର', regex: false },
//{ key: 'jhn', value: 'ଝ୍ର', regex: false },
//{ key: 'tn', value: 'ତ୍ର', regex: false },
//{ key: 'thn', value: 'ଥ୍ର', regex: false },
//{ key: 'dn', value: 'ଦ୍ର', regex: false },
//{ key: 'dhn', value: 'ଧ୍ର', regex: false },
//{ key: 'nn', value: 'ନ୍ର', regex: false },
//{ key: 'pn', value: 'ପ୍ର', regex: false },
//{ key: 'phn', value: 'ଫ୍ର', regex: false },
//{ key: 'bn', value: 'ବ୍ର', regex: false },
//{ key: 'bhn', value: 'ଭ୍ର', regex: false },
//{ key: 'mn', value: 'ମ୍ର', regex: false },
//{ key: 'sn', value: 'ସ୍ର', regex: false },
//{ key: 'shn', value: 'ଶ୍ର', regex: false },


//{ key: 'kl', value: 'କ୍ଲ', regex: false },
//{ key: 'khl', value: 'ଖ୍ଲ', regex: false },
//{ key: 'gl', value: 'ଗ୍ଲ', regex: false },
//{ key: 'ghl', value: 'ଘ୍ଲ', regex: false },
//{ key: 'chl', value: 'ଚ୍ଲ', regex: false },
//{ key: 'chhl', value: 'ଛ୍ଲ', regex: false },
//{ key: 'jl', value: 'ଜ୍ଲ', regex: false },
//{ key: 'jhl', value: 'ଝ୍ଲ', regex: false },
//{ key: 'tl', value: 'ତ୍ଲ', regex: false },
//{ key: 'thl', value: 'ଥ୍ଲ', regex: false },
//{ key: 'dl', value: 'ଦ୍ଲ', regex: false },
//{ key: 'dhl', value: 'ଧ୍ଲ', regex: false },
//{ key: 'nl', value: 'ନ୍ଲ', regex: false },
//{ key: 'pl', value: 'ପ୍ଲ', regex: false },
//{ key: 'phl', value: 'ଫ୍ଲ', regex: false },
//{ key: 'bl', value: 'ବ୍ଲ', regex: false },
//{ key: 'bhl', value: 'ଭ୍ଲ', regex: false },
//{ key: 'ml', value: 'ମ୍ଲ', regex: false },
//{ key: 'sl', value: 'ସ୍ଲ', regex: false },
//{ key: 'shl', value: 'ଶ୍ଲ', regex: false },
//{ key: 'bird', value: 'ବାର୍ଡ', regex: false },




//{ key: 'kd', value: 'କ୍ଡ', regex: false },
//{ key: 'khd', value: 'ଖ୍ଡ', regex: false },
//{ key: 'gd', value: 'ଗ୍ଡ', regex: false },
//{ key: 'ghd', value: 'ଘ୍ଡ', regex: false },
//{ key: 'chd', value: 'ଚ୍ଡ', regex: false },
//{ key: 'chhd', value: 'ଛ୍ଡ', regex: false },
//{ key: 'jd', value: 'ଜ୍ଡ', regex: false },
//{ key: 'jhd', value: 'ଝ୍ଡ', regex: false },
//{ key: 'td', value: 'ତ୍ଡ', regex: false },
//{ key: 'thd', value: 'ଥ୍ଡ', regex: false },
//{ key: 'dd', value: 'ଦ୍ଡ', regex: false },
//{ key: 'dhd', value: 'ଧ୍ଡ', regex: false },
//{ key: 'nd', value: 'ନ୍ଡ', regex: false },
//{ key: 'pd', value: 'ପ୍ଡ', regex: false },
//{ key: 'phd', value: 'ଫ୍ଡ', regex: false },
//{ key: 'bd', value: 'ବ୍ଡ', regex: false },
//{ key: 'bhd', value: 'ଭ୍ଡ', regex: false },
//{ key: 'md', value: 'ମ୍ଡ', regex: false },
//{ key: 'sd', value: 'ସ୍ଡ', regex: false },
//{ key: 'shd', value: 'ଶ୍ଡ', regex: false },

//{ key: 'lakhman', value: 'ଲକ୍ଷ୍ମଣ', regex: false },
//{ key: 'bindhani', value: 'ବିନ୍ଧାଣୀ', regex: false },

//{ key: 'km', value: 'କ୍ମ', regex: false },
//{ key: 'khm', value: 'କ୍ଷ୍ମ', regex: false },
//{ key: 'gm', value: 'ଗ୍ମ', regex: false },
//{ key: 'ghm', value: 'ଘ୍ମ', regex: false },
//{ key: 'chm', value: 'ଚ୍ମ', regex: false },
//{ key: 'chhm', value: 'ଛ୍ମ', regex: false },
//{ key: 'jm', value: 'ଜ୍ମ', regex: false },
//{ key: 'jhm', value: 'ଝ୍ମ', regex: false },
//{ key: 'tm', value: 'ତ୍ମ', regex: false },
//{ key: 'thm', value: 'ଥ୍ମ', regex: false },
//{ key: 'dm', value: 'ଦ୍ମ', regex: false },
//{ key: 'dhm', value: 'ଧ୍ମ', regex: false },
//{ key: 'nm', value: 'ନ୍ମ', regex: false },
//{ key: 'pm', value: 'ପ୍ମ', regex: false },
//{ key: 'phm', value: 'ଫ୍ମ', regex: false },
//{ key: 'bm', value: 'ବ୍ମ', regex: false },
//{ key: 'bhm', value: 'ଭ୍ମ', regex: false },
//{ key: 'mm', value: 'ମ୍ମ', regex: false },
//{ key: 'sm', value: 'ସ୍ମ', regex: false },
//{ key: 'shm', value: 'ଶ୍ମ', regex: false },
//{ key: 'hm', value: 'ହ୍ମ', regex: false },

//{ key: 'nd', value: 'ଣ୍ଡ', regex: false },
//{ key: 'ndh', value: 'ଣ୍ଢ', regex: false },
//{ key: 'nth', value: 'ଣ୍ଠ', regex: false },
{ key: 'chanti', value: 'ଛନ୍ତି', regex: false },
{ key: 'chanhu', value: 'ଚାହୁଁ', regex: false },



//{ key: 'rk', value: 'ର୍କ', regex: false },
//{ key: 'rkh', value: 'ର୍ଖ', regex: false },
//{ key: 'rg', value: 'ର୍ଗ', regex: false },
//{ key: 'rgh', value: 'ର୍ଘ', regex: false },
//{ key: 'rch', value: 'ର୍ଚ୍ଚ', regex: false },
//{ key: 'rchh', value: 'ର୍ଛ', regex: false },
//{ key: 'rj', value: 'ର୍ଜ', regex: false },
//{ key: 'rjh', value: 'ର୍ଝ', regex: false },
//{ key: 'rt', value: 'ର୍ତ୍ତ', regex: false },
//{ key: 'rth', value: 'ର୍ଥ', regex: false },
//{ key: 'rd', value: 'ର୍ଦ', regex: false },
//{ key: 'rdh', value: 'ର୍ଧ', regex: false },
//{ key: 'rn', value: 'ର୍ନ', regex: false },
//{ key: 'rp', value: 'ର୍ପ', regex: false },
//{ key: 'rph', value: 'ର୍ଫ', regex: false },
//{ key: 'rb', value: 'ର୍ବ', regex: false },

//{ key: 'rm', value: 'ର୍ମ', regex: false },
//{ key: 'rs', value: 'ର୍ସ', regex: false },
//{ key: 'rsh', value: 'ର୍ଶ', regex: false },
//{ key: 'rh', value: 'ର୍ହ', regex: false },

{ key: 'smruti', value: 'ସ୍ମତି', regex: false },
{ key: 'bhasma', value: 'ଭସ୍ମ', regex: false },
{ key: 'bhasma', value: 'ଭସ୍ମ', regex: false },
{ key: 'garbha', value: 'ଗର୍ଭ', regex: false },

//{ key: 'brahmo', value: 'ବ୍ରହ୍ମ', regex: false },


//{ key: 'kn', value: 'କ୍ନ', regex: false },
//{ key: 'khn', value: 'କ୍ଷ୍ନ', regex: false },
//{ key: 'gn', value: 'ଗ୍ନ', regex: false },
//{ key: 'ghn', value: 'ଘ୍ନ', regex: false },
//{ key: 'chn', value: 'ଚ୍ନ', regex: false },
//{ key: 'chhn', value: 'ଛ୍ମ', regex: false },
//{ key: 'jn', value: 'ଯ୍ନ', regex: false },
//{ key: 'jhn', value: 'ଝ୍ନ', regex: false },
//{ key: 'tn', value: 'ତ୍ନ', regex: false },
//{ key: 'thn', value: 'ଥ୍ନ', regex: false },
//{ key: 'dn', value: 'ଦ୍ନ', regex: false },
//{ key: 'dhn', value: 'ଧ୍ନ', regex: false },
//{ key: 'nn', value: 'ନ୍ନ', regex: false },
//{ key: 'pn', value: 'ପ୍ନ', regex: false },
//{ key: 'phn', value: 'ଫ୍ନ', regex: false },
//{ key: 'bn', value: 'ବ୍ନ', regex: false },
//{ key: 'bhn', value: 'ଭ୍ନ', regex: false },
//{ key: 'mn', value: 'ମ୍ନ', regex: false },
//{ key: 'sn', value: 'ସ୍ନ', regex: false },
//{ key: 'shn', value: 'ଶ୍ନ', regex: false },
//{ key: 'hn', value: 'ହ୍ନ', regex: false },

{ key: 'bhagna', value: 'ଭଗ୍ନ', regex: false },
{ key: 'magna', value: 'ମଗ୍ନ', regex: false },
{ key: 'bhinna', value: 'ଭିନ୍ନ', regex: false },
{ key: 'chhinn', value: 'ଛିନ୍ନ', regex: false },
{ key: 'chinh', value: 'ଚିହ୍ନ', regex: false },
{ key: 'nabha', value: 'ନାଭ', regex: false },
{ key: 'shraban', value: 'ଶ୍ରାବଣ', regex: false },
{ key: 'shroban', value: 'ଶ୍ରବଣ', regex: false },
{ key: 'achhi', value: 'ଅଛି', regex: false },
{ key: 'kashmir', value: 'କଶ୍ମୀର୍', regex: false },
{ key: 'anya', value: 'ଅନ୍ୟ', regex: false },
{ key: 'tomo', value: 'ତ୍ତମ', regex: false },
{ key: 'prakasa', value: 'ପ୍ରକାଶ', regex: false },
{ key: 'thau', value: 'ଥାଉ', regex: false },
{ key: 'subarna', value: 'ସୁବର୍ଣ୍ଣ', regex: false },
{ key: 'baitarani', value: 'ବୈତରଣୀ', regex: false },
{ key: 'banya', value: 'ବନ୍ୟା', regex: false },
{ key: 'badhuchi', value: 'ବଢ଼ୁଛି', regex: false },
{ key: 'upuji', value: 'ଉପୁଜି', regex: false },
{ key: 'kendujhara', value: 'କେନ୍ଦୁଝର', regex: false },
{ key: 'asonka', value: 'ଆଶଙ୍କା', regex: false },
{ key: 'mahanadi', value: 'ମହାନଦୀ', regex: false },
{ key: 'sthiti', value: 'ସ୍ଥିତି', regex: false },
{ key: 'lokanka', value: 'ଲୋକଙ୍କ', regex: false },
{ key: 'dio', value: 'ଦିଅ', regex: false },
{ key: 'madi', value: 'ମାଡ଼ି', regex: false },
{ key: 'rokhe', value: 'ରଖେ', regex: false },
{ key: 'bandhi', value: 'ବାନ୍ଧି', regex: false },
{ key: 'bhoji', value: 'ଭୋଜି', regex: false },
{ key: 'sorbahari', value: 'ସର୍ବାହାରି', regex: false },
{ key: 'mansahari', value: 'ମାଂସାହାରି', regex: false },
{ key: 'paniyo jolo', value: 'ପାନୀୟ ଜଳ', regex: false },
{ key: 'sthaniya', value: 'ସ୍ଥାନୀୟ', regex: false },
//{ key: 'adalat', value: 'ଅଦାଲତ', regex: false },
{ key: 'karuchanti', value: 'କରୁଛନ୍ତି', regex: false },
{ key: 'akranta', value: 'ଆକ୍ରାନ୍ତ', regex: false },
{ key: 'rogo', value: 'ରୋଗ', regex: false },
{ key: 'mukhya', value: 'ମୁଖ୍ୟ', regex: false },
{ key: 'abhijukta', value: 'ଅଭିଯୁକ୍ତ', regex: false },
{ key: 'samanta', value: 'ସାମନ୍ତ', regex: false },
{ key: 'lipta', value: 'ଲିପ୍ତ', regex: false },
{ key: 'thakura', value: 'ଠାକୁର', regex: false },
{ key: 'nka', value: 'ଙ୍କ', regex: false },
{ key: 'nto', value: 'ଣ୍ଟ', regex: false },
{ key: 'anto', value: 'ଆଣ୍ଟ', regex: false },
{ key: 'ncha', value: 'ଞ୍ଚ', regex: false },
{ key: 'manmath', value: 'ମନ୍ମଥ', regex: false },
{ key: 'manosik', value: 'ମାନସିକ', regex: false },
{ key: 'anshu', value: 'ଅଂଶୁ', regex: false },
{ key: 'isho', value: 'ଈଶ', regex: false },

{ key: 'akra', value: 'ଆକ୍ରା', regex: false },
{ key: 'lakra', value: 'ଲାକ୍ରା', regex: false },
{ key: 'tatha', value: 'ତଥା', regex: false },
{ key: 'chhada', value: 'ଛଡ଼ା', regex: false },
{ key: 'pahanchi', value: 'ପହଞ୍ଚି', regex: false },
{ key: 'bonai', value: 'ବଣାଇ', regex: false },
{ key: 'mumbai', value: 'ମୁମ୍ବାଇ', regex: false },
{ key: 'delhi', value: 'ଦିଲ୍ଲୀ', regex: false },
{ key: 'surat', value: 'ସୁରାଟ', regex: false },
{ key: 'ahamadabad', value: 'ଅହମଦାବାଦ୍', regex: false },
{ key: 'hyderabad', value: 'ହାଇଦ୍ରାବାଦ୍', regex: false },
{ key: 'chennai', value: 'ଚେନ୍ନାଇ', regex: false },
{ key: 'bangalore', value: 'ବାଙ୍ଗାଲୋର୍', regex: false },
{ key: 'kolkata', value: 'କଲିକତା', regex: false },
{ key: 'sahara', value: 'ସାହାରା', regex: false },
{ key: 'sohoro', value: 'ସହର', regex: false },
{ key: 'jaithila', value: 'ଯାଇଥିଲା', regex: false },
{ key: 'sansada', value: 'ସାଂସଦ', regex: false },
{ key: 'sadhwi', value: 'ସାଧ୍ୱୀ', regex: false },
{ key: 'pragya', value: 'ପ୍ରଜ୍ଞା', regex: false },
{ key: 'kadambini', value: 'କାଦମ୍ବିନୀ', regex: false },
{ key: 'bicharopoti', value: 'ବିଚାରପତି ', regex: false },
{ key: 'koli', value: 'କୋଳି', regex: false },
{ key: 'dala', value: 'ଦଳ', regex: false },
{ key: 'sangathonika', value: 'ସାଙ୍ଗଠନିକ', regex: false },
{ key: 'chiduni', value: 'ଛିଡୁନି', regex: false },
{ key: 'sadharana', value: 'ସାଧାରଣ', regex: false },
{ key: 'nirbachan', value: 'ନିର୍ବାଚନ', regex: false },
{ key: 'parajaya', value: 'ପରାଜୟ', regex: false },
{ key: 'pore', value: 'ପରେ', regex: false },
{ key: 'stara', value: 'ସ୍ତର', regex: false },
{ key: 'borton', value: 'ବର୍ତ୍ତନ', regex: false },
{ key: 'byabadhan', value: 'ବ୍ୟବଧାନ', regex: false },
{ key: 'punarbara', value: 'ପୁନର୍ବାର', regex: false },
{ key: 'punh', value: 'ପୁନଃ', regex: false },
{ key: 'binyasa', value: 'ବିନ୍ୟାସ', regex: false },
{ key: 'committee', value: 'କମିଟି', regex: false },
{ key: 'pheri', value: 'ଫେରି', regex: false },
{ key: 'matro', value: 'ମାତ୍ର', regex: false },
{ key: 'matra', value: 'ମାତ୍ରା', regex: false },
{ key: 'mora', value: 'ମୋର', regex: false },
{ key: 'kono', value: 'କଣ', regex: false },
{ key: 'karuchha', value: 'କରୁଛ', regex: false },
{ key: 'balanga', value: 'ବଳଙ୍ଗା', regex: false },
{ key: 'nga', value: 'ଙ୍ଗ', regex: false },
{ key: 'zilla', value: 'ଜିଲ୍ଲା', regex: false },
{ key: 'kondol', value: 'କନ୍ଦଳ', regex: false },
{ key: 'prathame', value: 'ପ୍ରଥମେ', regex: false },
{ key: 'kortobya', value: 'କର୍ତ୍ତବ୍ୟ', regex: false },
{ key: 'trutiya', value: 'ତୃତୀୟ', regex: false },
{ key: 'abhijana', value: 'ଅଭିଯାନ', regex: false },
{ key: 'sarila', value: 'ସରିଲା', regex: false },
{ key: 'pakhei', value: 'ପାଖେଇ', regex: false },
{ key: 'suchi', value: 'ସୁଚି', regex: false },
{ key: 'ghatana', value: 'ଘଟଣା', regex: false },
{ key: 'bayan', value: 'ବୟାନ', regex: false },
{ key: 'prakriya', value: 'ପ୍ରକ୍ରିୟା', regex: false },
{ key: 'prakar', value: 'ପ୍ରକାର', regex: false },
{ key: 'purba', value: 'ପୂର୍ବ', regex: false },
{ key: 'prarthana', value: 'ପ୍ରାର୍ଥନା', regex: false },
{ key: 'nachet', value: 'ନଚେତ୍', regex: false },
{ key: 'adhura', value: 'ଅଧୁରା', regex: false },
{ key: 'lancha', value: 'ଲାଞ୍ଚ', regex: false },
{ key: 'lanchhana', value: 'ଲାଞ୍ଛନା', regex: false },
{ key: 'sabda', value: 'ଶବ୍ଦ', regex: false },
{ key: 'prakash', value: 'ପ୍ରକାଶ', regex: false },
{ key: 'prati', value: 'ପ୍ରତି', regex: false },
{ key: 'pratyakhya', value: 'ପ୍ରତ୍ୟକ୍ଷ', regex: false },
{ key: 'pratyeka', value: 'ପ୍ରତ୍ୟେକ', regex: false },
{ key: 'santana', value: 'ସନ୍ତାନ', regex: false },
{ key: 'debota', value: 'ଦେବତା', regex: false },
{ key: 'atanti', value: 'ଅଟନ୍ତି', regex: false },
{ key: 'bhonga', value: 'ଭଙ୍ଗ', regex: false },
{ key: 'ngo', value: 'ଙ୍ଗ', regex: false },

{ key: 'nidhi', value: 'ନିଧି', regex: false },
{ key: 'phala', value: 'ଫଳ', regex: false },
{ key: 'sorbadhika', value: 'ସର୍ବାଧିକ', regex: false },
{ key: 'deya', value: 'ଦେୟ', regex: false },
{ key: 'account', value: 'ଆକାଉଣ୍ଟ', regex: false },
{ key: 'acaunt', value: 'ଆକାଉଣ୍ଟ', regex: false },
{ key: 'nikatastha', value: 'ନିକଟସ୍ଥ', regex: false },
{ key: 'ntu', value: 'ନ୍ତୁ', regex: false },
{ key: 'shesa', value: 'ଶେଷ', regex: false },
{ key: 'khotian', value: 'ଖତିଆନ', regex: false },
{ key: 'office', value: 'ଅଫିସ', regex: false },
{ key: 'poncha', value: 'ପଞ୍ଚ', regex: false },
{ key: 'trump', value: 'ଟ୍ରମ୍ପ', regex: false },
{ key: 'bachalami', value: 'ବାଚାଳାମି', regex: false },
{ key: 'amerika', value: 'ଆମେରିକା', regex: false },
{ key: 'banijya', value: 'ବାଣିଜ୍ୟ', regex: false },
{ key: 'hakdar', value: 'ହକଦାର', regex: false },
{ key: 'swa', value: 'ସ୍ୱା', regex: false },
{ key: 'rth', value: 'ର୍ଥ', regex: false },
{ key: 'dhoneswar', value: 'ଧନେଶ୍ୱର', regex: false },
{ key: 'shwar', value: 'ଶ୍ୱର', regex: false },
{ key: 'daka', value: 'ଡ଼ାକ', regex: false },



{ key: 'madhu', value: 'ମଧୁ', regex: false },
{ key: 'smita', value: 'ସ୍ମିତା', regex: false },
{ key: 'chetabani', value: 'ଚେତାବନୀ', regex: false },
{ key: 'prashasana', value: 'ପ୍ରଶାସନ', regex: false },
{ key: 'agare', value: 'ଆଗରେ', regex: false },
{ key: 'puni', value: 'ପୁଣି', regex: false },
{ key: 'dhori', value: 'ଧରି', regex: false },
{ key: 'pruthak', value: 'ପୃଥକ', regex: false },
{ key: 'sangya', value: 'ସଂଜ୍ଞା', regex: false },
{ key: 'darshai', value: 'ଦର୍ଶାଇ', regex: false },
{ key: 'alore', value: 'ଆଳରେ', regex: false },
{ key: 'chhado', value: 'ଛାଡ଼', regex: false },
{ key: 'bortaman', value: 'ବର୍ତ୍ତମାନ', regex: false },
{ key: 'sohit', value: 'ସହିତ', regex: false },
{ key: 'kotha', value: 'କଥା', regex: false },
{ key: 'ambulance', value: 'ଆମ୍ବୁଲେନ୍ସ', regex: false },
{ key: 'prathomika', value: 'ପ୍ରାଥମିକ', regex: false },
{ key: 'medicle', value: 'ମେଡ଼ିକାଲ୍', regex: false },
{ key: 'sukhma', value: 'ସୂକ୍ଷ୍ମ', regex: false },
{ key: 'lakhmi', value: 'ଲକ୍ଷ୍ମୀ', regex: false },
{ key: 'subhakankhi', value: 'ଶୁଭାକାଂକ୍ଷୀ', regex: false },
{ key: 'somosti', value: 'ସମଷ୍ଟି', regex: false },
{ key: 'rakhi', value: 'ରାକ୍ଷୀ', regex: false },
{ key: 'indriya', value: 'ଇନ୍ଦ୍ରିୟ', regex: false },
{ key: 'sanyasi', value: 'ସନ୍ନ୍ୟାସୀ', regex: false },
{ key: 'lajya', value: 'ଲଜ୍ଜା', regex: false },
{ key: 'jagya', value: 'ଯଜ୍ଞ୍ୟ', regex: false },


{ key: 'shodha', value: 'ଶୋଧ', regex: false },
{ key: 'pratikara', value: 'ପ୍ରତିକାର', regex: false },
{ key: 'rastra', value: 'ରାଷ୍ଟ୍ର', regex: false },
//{ key: 'sahitya', value: 'ସାହିତ୍ୟ', regex: false },

{ key: 'nchh', value: 'ଞ୍ଛ', regex: false },
{ key: 'ty', value: 'ତ୍ୟ', regex: false },

{ key: 'kh', value: 'ଖ', regex: false },
{ key: 'chh', value: 'ଛ', regex: false },
{ key: 'ch', value: 'ଚ', regex: false },
{ key: 'nch', value: 'ଞ୍ଚ', regex: false },
{ key: 'gh', value: 'ଘ', regex: false },
{ key: 'jh', value: 'ଝ', regex: false },
{ key: 'njh', value: 'ଞ୍ଝ', regex: false },
{ key: 'nd', value: 'ଣ୍ଡ', regex: false },
{ key: 'bondh', value: 'ବନ୍ଧ', regex: false },
{ key: 'daitya', value: 'ଦାୟୀତ୍ବ', regex: false },

//{ key: 'nt', value: 'ଣ୍ଟ', regex: false },

{ key: 'samudra', value: 'ସମୁଦ୍ର', regex: false },
{ key: 'dhangidi', value: 'ଧାଙ୍ଗିଡ଼ି', regex: false },
{ key: 'anichhi', value: 'ଆଣିଛି', regex: false },
{ key: 'anha', value: 'ଅହ୍ନ', regex: false },
{ key: 'abhiyan', value: 'ଅଭିଯାନ', regex: false },
{ key: 'upaya', value: 'ଉପାୟ', regex: false },
{ key: 'tana', value: 'ତନ', regex: false },
{ key: 'sabhapati', value: 'ସଭାପତି', regex: false },
{ key: 'rajendra', value: 'ରାଜେନ୍ଦ୍ର', regex: false },
{ key: 'bidhayak', value: 'ବିଧାୟକ', regex: false },
{ key: 'balabanta', value: 'ବଳବନ୍ତ', regex: false },
{ key: 'panjha', value: 'ପଞ୍ଝା', regex: false },
{ key: 'anurupa', value: 'ଅନୁରୂପ', regex: false },
{ key: 'mananka', value: 'ମାନଙ୍କ', regex: false },
{ key: 'mananku', value: 'ମାନଙ୍କୁ', regex: false },
{ key: 'nku', value: 'ଙ୍କୁ', regex: false },

{ key: 'bonda', value: 'ବଣ୍ଡା ', regex: false },
{ key: 'pipili', value: 'ପିପିଲି', regex: false },
{ key: 'adimo', value: 'ଆଦିମ', regex: false },
{ key: 'adhibasi', value: 'ଅଧିବାସୀ', regex: false },
{ key: 'tanta', value: 'ତନ୍ତ', regex: false },
{ key: 'sutra', value: 'ସୂତ୍ର', regex: false },
{ key: 'janata', value: 'ଜନତା', regex: false },
{ key: 'pradip', value: 'ପ୍ରଦିପ', regex: false },
{ key: 'kamalini', value: 'କମଳିନୀ', regex: false },
{ key: 'jayanti', value: 'ଜୟନ୍ତୀ', regex: false },
{ key: 'byanjana', value: 'ବ୍ୟଞ୍ଜନ', regex: false },
{ key: 'sanskrutika', value: 'ସାଂସ୍କୃତିକ', regex: false },
{ key: 'sandhya', value: 'ସନ୍ଧ୍ୟା', regex: false },
{ key: 'sakala', value: 'ସକାଳ', regex: false },
{ key: 'show', value: 'ଶୋ', regex: false },
{ key: 'upa', value: 'ଉପ', regex: false },
{ key: 'pradarshana', value: 'ପ୍ରଦର୍ଶନ', regex: false },
{ key: 'pradan', value: 'ପ୍ରଦାନ', regex: false },
{ key: 'adhibesan', value: 'ଅଧିବେଶନ', regex: false },
{ key: 'sanstha', value: 'ସଂସ୍ଥା', regex: false },
{ key: 'laya', value: 'ଳୟ', regex: false },
{ key: 'bori', value: 'ବରି', regex: false },
{ key: 'stho', value: 'ଷ୍ଠ', regex: false },
{ key: 'prafulla', value: 'ପ୍ରଫୁଲ୍ଲ', regex: false },
{ key: 'tuma', value: 'ତୁମ', regex: false },
{ key: 'mo', value: 'ମୋ', regex: false },
{ key: 'kanduchi', value: 'କାନ୍ଦୁଛି', regex: false },
{ key: 'priya', value: 'ପ୍ରିୟ', regex: false },
{ key: 'nahu', value: 'ନାହୁଁ', regex: false },
{ key: 'bada', value: 'ବଡ଼', regex: false },
{ key: 'Sundargarh', value: 'ସୁନ୍ଦରଗଡ଼', regex: false },
{ key: 'konda', value: 'କୋଣ୍ଡା', regex: false },
{ key: 'hero honda', value: 'ହିରୋ ହୋଣ୍ଡା', regex: false },
{ key: 'pottangi', value: 'ପୋଟଙ୍ଗି', regex: false },
{ key: 'kotpad', value: 'କୋଟପଡ଼', regex: false },
{ key: 'bissam', value: 'ବିସମ', regex: false },
{ key: 'gunupur', value: 'ଗୁଣୁପୁର', regex: false },
{ key: 'hebe', value: 'ହେବେ', regex: false },
{ key: 'nihati', value: 'ନିହାତି', regex: false },
{ key: 'nabin', value: 'ନବୀନ', regex: false },
{ key: 'nirbodh', value: 'ନିର୍ବୋଧ', regex: false },



{ key: 'aska', value: 'ଆସ୍କା', regex: false },
{ key: 'balasore', value: 'ବାଲେଶ୍ୱର', regex: false },
{ key: 'ngir', value: 'ଙ୍ଗିର', regex: false },
{ key: 'bala', value: 'ବଲା', regex: false },
{ key: 'titlagarh', value: 'ଟିଟଲାଗଡ଼', regex: false },
{ key: 'banji', value: 'ବାଞ୍ଜୀ', regex: false },
{ key: 'umerkote', value: 'ଉମରକୋଟ', regex: false },
{ key: 'jharigam', value: 'ଝରିଗାଁ', regex: false },
{ key: 'malkanagiri', value: 'ମାଲକାନଗିରି', regex: false },
{ key: 'arakhya', value: 'ଆରକ୍ଷ', regex: false },
{ key: 'jila', value: 'ଜିଲ୍ଲା', regex: false },
{ key: 'jee', value: 'ଯେ', regex: false },
{ key: 'partma', value: 'ପର୍ତ୍ତମା', regex: false },
{ key: 'kanha', value: 'କାହ୍ନା', regex: false },
{ key: 'finance', value: 'ଫାଇନାନ୍ସ', regex: false },
{ key: 'runo', value: 'ଋଣ', regex: false },
{ key: 'ukta', value: 'ଉକ୍ତ', regex: false },
{ key: 'adaya', value: 'ଆଦାୟ', regex: false },
{ key: 'pratyak', value: 'ପ୍ରତ୍ୟେକ', regex: false },
{ key: 'foundation', value: 'ଫାଉଣ୍ଡେସନ୍', regex: false },
{ key: 'prolobhon', value: 'ପ୍ରଲୋଭନ', regex: false },
{ key: 'bhoda', value: 'ଭଡ଼ା', regex: false },
{ key: 'pranjala', value: 'ପ୍ରାଞ୍ଜଳ', regex: false },
{ key: 'pratigya', value: 'ପ୍ରତିଜ୍ଞା', regex: false },

{ key: 'dhenkanal', value: 'ଢେଙ୍କାନାଳ', regex: false },
{ key: 'Keonjhar', value: 'କେନ୍ଦୁଝର', regex: false },
{ key: 'nabarangpur', value: 'ନବରଙ୍ଗପୁର', regex: false },
{ key: 'padampur', value: 'ପଦମପୁର', regex: false },
{ key: 'barapali', value: 'ବରପାଲି', regex: false },
//{ key: 'Brahmagiri', value: 'ବ୍ରହ୍ମଗିରି', regex: false },


{ key: 'damodar', value: 'ଦାମୋଦର', regex: false },
{ key: 'dara', value: 'ଦର', regex: false },









//{ key: 'balanku', value: 'ବାଲାଙ୍କୁ', regex: false },











    // Add up to 5000+ mappings here

  ];

  useEffect(() => {
    setSpecialWords(defaultSpecialWords);
    // eslint-disable-next-line
  }, []);

  // Do not render any UI for special word mappings
  return null;
}





